
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("7k8Uw", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");





var $42omo = parcelRequire("42omo");


var $jJf3a = parcelRequire("jJf3a");


var $hwNSM = parcelRequire("hwNSM");


var $iudHJ = parcelRequire("iudHJ");


var $kFwgS = parcelRequire("kFwgS");


var $8C5kA = parcelRequire("8C5kA");


var $dh538 = parcelRequire("dh538");

const $186cb535f1e2b2f1$var$EDIT_PAGE_CLOSE = 'edit-page/close';
const $186cb535f1e2b2f1$var$EDIT_PAGE_PUBLISH = 'edit-page/publish';
const $186cb535f1e2b2f1$export$6955bcca4cd3539f = (props)=>{
    const { viewComponent: ViewComponent, editComponent: EditComponent } = props;
    const { mode: mode, allowedFeatures: allowedFeatures, draftShareId: draftShareId, navigationPolicy: navigationPolicy, spaceKey: spaceKey, showFooter: showFooter, ...passThroughProps } = (0, $hwNSM.parsePageProps)(props);
    const { onModeChange: onModeChange } = props;
    const [currentMode, setCurrentMode] = (0, $42omo.useState)(mode);
    (0, $42omo.useEffect)(()=>{
        setCurrentMode(mode);
    }, [
        mode
    ]);
    const [currentSpaceKey, setCurrentSpaceKey] = (0, $42omo.useState)(spaceKey);
    const switchToViewPage = (0, $42omo.useCallback)(()=>{
        setCurrentMode((0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE);
    }, [
        setCurrentMode
    ]);
    const pageNavigationPolicy = (0, $42omo.useMemo)(()=>({
            navigate (url, modifiers, defaultNavigate) {
                /**
       * Below is for switching from View to Edit and we assume parent product doesn't have this situation in their navigationPolicy.
       */ if (currentMode === (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE && (modifiers.routeName === 'EDIT_PAGE_EMBED' || url?.includes('/edit-embed/') && passThroughProps.contentId === modifiers.contentId) && ((0, $dh538.fg)('platform_deprecate_lp_cc_embed') ? passThroughProps.contentId === modifiers.contentId : true)) {
                    setCurrentMode((0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
                    onModeChange?.((0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE);
                    return;
                }
                return navigationPolicy?.navigate ? navigationPolicy.navigate(url, modifiers, defaultNavigate) : defaultNavigate(url, modifiers);
            },
            shimUrl: navigationPolicy?.shimUrl,
            domainNamesToReplace: navigationPolicy?.domainNamesToReplace,
            spaceKeyFilter: navigationPolicy?.spaceKeyFilter
        }), [
        currentMode,
        passThroughProps.contentId,
        navigationPolicy,
        onModeChange
    ]);
    const experienceTracker = (0, $iudHJ.useExperienceTracker)();
    (0, $42omo.useEffect)(()=>experienceTracker.subscribe((event)=>{
            const { name: name, action: action, attributes: attributes } = event;
            /**
     * Using experienceTracker, we can switch from Edit to View page.
     * 1. When the user clicks the Publish button and task success, it can switch to the View page.
     *    a. If the `publish-modal` is added to the allowedFeatures, the Publish Modal may be used to
     *          change the spaceKey during publish.
     *          In that case, a new spaceKey will be added to the success event and tracked here.
     * 2. If the page is not unpublished draft, when the user clicks Close button and task success, it can switch to the View page.
     */ const isClosingPublishedEditPage = !draftShareId && name === $186cb535f1e2b2f1$var$EDIT_PAGE_CLOSE;
            const isPublishingDraft = name === $186cb535f1e2b2f1$var$EDIT_PAGE_PUBLISH;
            if (action === 'taskSuccess' && (isClosingPublishedEditPage || isPublishingDraft)) {
                if (allowedFeatures.edit?.includes('publish-modal')) {
                    const newSpaceKey = attributes?.newSpaceKey;
                    setCurrentSpaceKey(newSpaceKey || spaceKey);
                }
                switchToViewPage();
            }
        }), [
        draftShareId,
        experienceTracker,
        switchToViewPage,
        allowedFeatures.edit,
        spaceKey
    ]);
    const { locale: locale } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jJf3a.ExperienceTrackerContext).Provider, {
        value: experienceTracker,
        children: currentMode === (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE ? /*#__PURE__*/ (0, $l998X.jsx)(ViewComponent, {
            navigationPolicy: pageNavigationPolicy,
            allowedFeatures: allowedFeatures.view,
            locale: locale,
            spaceKey: currentSpaceKey,
            showFooter: showFooter,
            ...passThroughProps
        }) : currentMode === (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE ? /*#__PURE__*/ (0, $l998X.jsx)(EditComponent, {
            navigationPolicy: pageNavigationPolicy,
            allowedFeatures: allowedFeatures.edit,
            draftShareId: draftShareId,
            locale: locale,
            spaceKey: currentSpaceKey,
            ...passThroughProps
        }) : null
    });
};



var $elkSx = parcelRequire("elkSx");


var $I1nNR = parcelRequire("I1nNR");


var $gt5FF = parcelRequire("gt5FF");

const $9ced22d459d44e84$export$6955bcca4cd3539f = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $gt5FF.default),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $elkSx.PageNotFoundEmptyState), {}),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $186cb535f1e2b2f1$export$6955bcca4cd3539f), {
                ...props
            })
        })
    });
module.exports["Page"] = $9ced22d459d44e84$export$6955bcca4cd3539f;

});

parcelRegister("jJf3a", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $519cb1da41ed4097$export$a7b0697657ed8bd0 = (0, $42omo.createContext)({
    abort () {},
    fail () {},
    start () {},
    succeed () {},
    stopOnError () {},
    subscribe () {
        return ()=>{};
    }
});
module.exports["ExperienceTrackerContext"] = $519cb1da41ed4097$export$a7b0697657ed8bd0;

});

parcelRegister("hwNSM", function(module, exports) {


/**
 * React Router v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $42omo = parcelRequire("42omo");


var $8ce0W = parcelRequire("8ce0W");

function $da171e7c81d66b36$var$_extends() {
    $da171e7c81d66b36$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $da171e7c81d66b36$var$_extends.apply(this, arguments);
} // Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $da171e7c81d66b36$export$3add0d5dce533e2e = /*#__PURE__*/ $42omo.createContext(null);
const $da171e7c81d66b36$export$145dfa71566a64dc = /*#__PURE__*/ $42omo.createContext(null);
const $da171e7c81d66b36$var$AwaitContext = /*#__PURE__*/ $42omo.createContext(null);
const $da171e7c81d66b36$export$26749e8557646306 = /*#__PURE__*/ $42omo.createContext(null);
const $da171e7c81d66b36$export$c7914228fb69b0f5 = /*#__PURE__*/ $42omo.createContext(null);
const $da171e7c81d66b36$export$9072aa6dd1f93057 = /*#__PURE__*/ $42omo.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $da171e7c81d66b36$var$RouteErrorContext = /*#__PURE__*/ $42omo.createContext(null);
function $da171e7c81d66b36$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$da171e7c81d66b36$export$9c954a9d03d32f4a() && (0, $8ce0W.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $42omo.useContext($da171e7c81d66b36$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $da171e7c81d66b36$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $8ce0W.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $da171e7c81d66b36$export$9c954a9d03d32f4a() {
    return $42omo.useContext($da171e7c81d66b36$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $da171e7c81d66b36$export$45d76561a5302f2b() {
    !$da171e7c81d66b36$export$9c954a9d03d32f4a() && (0, $8ce0W.UNSAFE_invariant)(false);
    return $42omo.useContext($da171e7c81d66b36$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $da171e7c81d66b36$export$1b3f31771c5d07c() {
    return $42omo.useContext($da171e7c81d66b36$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $da171e7c81d66b36$export$6c330e8992e8a295(pattern) {
    !$da171e7c81d66b36$export$9c954a9d03d32f4a() && (0, $8ce0W.UNSAFE_invariant)(false);
    let { pathname: pathname } = $da171e7c81d66b36$export$45d76561a5302f2b();
    return $42omo.useMemo(()=>(0, $8ce0W.matchPath)(pattern, (0, $8ce0W.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $da171e7c81d66b36$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $da171e7c81d66b36$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $42omo.useContext($da171e7c81d66b36$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $42omo.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $da171e7c81d66b36$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $42omo.useContext($da171e7c81d66b36$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $da171e7c81d66b36$var$useNavigateStable() : $da171e7c81d66b36$var$useNavigateUnstable();
}
function $da171e7c81d66b36$var$useNavigateUnstable() {
    !$da171e7c81d66b36$export$9c954a9d03d32f4a() && (0, $8ce0W.UNSAFE_invariant)(false);
    let dataRouterContext = $42omo.useContext($da171e7c81d66b36$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $42omo.useContext($da171e7c81d66b36$export$26749e8557646306);
    let { matches: matches } = $42omo.useContext($da171e7c81d66b36$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $da171e7c81d66b36$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $8ce0W.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $42omo.useRef(false);
    $da171e7c81d66b36$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $42omo.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $8ce0W.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $8ce0W.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $da171e7c81d66b36$var$OutletContext = /*#__PURE__*/ $42omo.createContext(null); /**
                            * Returns the context (if provided) for the child route at this level of the route
                            * hierarchy.
                            * @see https://reactrouter.com/v6/hooks/use-outlet-context
                            */ 
function $da171e7c81d66b36$export$4138103a3ae699cc() {
    return $42omo.useContext($da171e7c81d66b36$var$OutletContext);
} /**
   * Returns the element for the child route at this level of the route
   * hierarchy. Used internally by `<Outlet>` to render child routes.
   *
   * @see https://reactrouter.com/v6/hooks/use-outlet
   */ 
function $da171e7c81d66b36$export$a3be3530d8e40d0b(context) {
    let outlet = $42omo.useContext($da171e7c81d66b36$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
} /**
   * Returns an object of key/value pairs of the dynamic params from the current
   * URL that were matched by the route path.
   *
   * @see https://reactrouter.com/v6/hooks/use-params
   */ 
function $da171e7c81d66b36$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $42omo.useContext($da171e7c81d66b36$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
} /**
   * Resolves the pathname of the given `to` value against the current location.
   *
   * @see https://reactrouter.com/v6/hooks/use-resolved-path
   */ 
function $da171e7c81d66b36$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $42omo.useContext($da171e7c81d66b36$export$26749e8557646306);
    let { matches: matches } = $42omo.useContext($da171e7c81d66b36$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $da171e7c81d66b36$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $8ce0W.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $42omo.useMemo(()=>(0, $8ce0W.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $da171e7c81d66b36$export$5d3fca4a98652595(routes, locationArg) {
    return $da171e7c81d66b36$export$5fcee62552a12fbf(routes, locationArg);
} // Internal implementation with accept optional param for RouterProvider usage
function $da171e7c81d66b36$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$da171e7c81d66b36$export$9c954a9d03d32f4a() && (0, $8ce0W.UNSAFE_invariant)(false);
    let { navigator: navigator } = $42omo.useContext($da171e7c81d66b36$export$26749e8557646306);
    let { matches: parentMatches } = $42omo.useContext($da171e7c81d66b36$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $da171e7c81d66b36$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $8ce0W.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $8ce0W.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $8ce0W.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $da171e7c81d66b36$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $8ce0W.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $8ce0W.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future); // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $da171e7c81d66b36$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $8ce0W.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $da171e7c81d66b36$var$DefaultErrorComponent() {
    let error = $da171e7c81d66b36$export$ed527bf60f6e05f2();
    let message = (0, $8ce0W.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, /*#__PURE__*/ $42omo.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $42omo.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $42omo.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $da171e7c81d66b36$var$defaultErrorElement = /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$var$DefaultErrorComponent, null);
class $da171e7c81d66b36$var$RenderErrorBoundary extends $42omo.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
         // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $da171e7c81d66b36$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $42omo.useContext($da171e7c81d66b36$export$3add0d5dce533e2e); // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $da171e7c81d66b36$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches; // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $8ce0W.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    } // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i]; // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $da171e7c81d66b36$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $da171e7c81d66b36$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $42omo.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        }; // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $da171e7c81d66b36$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($da171e7c81d66b36$var$DataRouterHook || {});
var $da171e7c81d66b36$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($da171e7c81d66b36$var$DataRouterStateHook || {});
function $da171e7c81d66b36$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $da171e7c81d66b36$var$useDataRouterContext(hookName) {
    let ctx = $42omo.useContext($da171e7c81d66b36$export$3add0d5dce533e2e);
    !ctx && (0, $8ce0W.UNSAFE_invariant)(false);
    return ctx;
}
function $da171e7c81d66b36$var$useDataRouterState(hookName) {
    let state = $42omo.useContext($da171e7c81d66b36$export$145dfa71566a64dc);
    !state && (0, $8ce0W.UNSAFE_invariant)(false);
    return state;
}
function $da171e7c81d66b36$var$useRouteContext(hookName) {
    let route = $42omo.useContext($da171e7c81d66b36$export$9072aa6dd1f93057);
    !route && (0, $8ce0W.UNSAFE_invariant)(false);
    return route;
} // Internal version with hookName-aware debugging
function $da171e7c81d66b36$var$useCurrentRouteId(hookName) {
    let route = $da171e7c81d66b36$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $8ce0W.UNSAFE_invariant)(false);
    return thisRoute.route.id;
} /**
   * Returns the ID for the nearest contextual route
   */ 
function $da171e7c81d66b36$export$5fc8298006ad9e58() {
    return $da171e7c81d66b36$var$useCurrentRouteId($da171e7c81d66b36$var$DataRouterStateHook.UseRouteId);
} /**
   * Returns the current navigation, defaulting to an "idle" navigation when
   * no navigation is in progress
   */ 
function $da171e7c81d66b36$export$d0fd4b7106de2769() {
    let state = $da171e7c81d66b36$var$useDataRouterState($da171e7c81d66b36$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
} /**
   * Returns a revalidate function for manually triggering revalidation, as well
   * as the current state of any manual revalidations
   */ 
function $da171e7c81d66b36$export$600dc272ed516c15() {
    let dataRouterContext = $da171e7c81d66b36$var$useDataRouterContext($da171e7c81d66b36$var$DataRouterHook.UseRevalidator);
    let state = $da171e7c81d66b36$var$useDataRouterState($da171e7c81d66b36$var$DataRouterStateHook.UseRevalidator);
    return $42omo.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
} /**
   * Returns the active route matches, useful for accessing loaderData for
   * parent/child routes or the route "handle" property
   */ 
function $da171e7c81d66b36$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $da171e7c81d66b36$var$useDataRouterState($da171e7c81d66b36$var$DataRouterStateHook.UseMatches);
    return $42omo.useMemo(()=>matches.map((m)=>(0, $8ce0W.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
} /**
   * Returns the loader data for the nearest ancestor Route loader
   */ 
function $da171e7c81d66b36$export$1448a5050d252c4d() {
    let state = $da171e7c81d66b36$var$useDataRouterState($da171e7c81d66b36$var$DataRouterStateHook.UseLoaderData);
    let routeId = $da171e7c81d66b36$var$useCurrentRouteId($da171e7c81d66b36$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
} /**
   * Returns the loaderData for the given routeId
   */ 
function $da171e7c81d66b36$export$fd5d37484eab868d(routeId) {
    let state = $da171e7c81d66b36$var$useDataRouterState($da171e7c81d66b36$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
} /**
   * Returns the action data for the nearest ancestor Route action
   */ 
function $da171e7c81d66b36$export$fdc00f3f26066d5e() {
    let state = $da171e7c81d66b36$var$useDataRouterState($da171e7c81d66b36$var$DataRouterStateHook.UseActionData);
    let routeId = $da171e7c81d66b36$var$useCurrentRouteId($da171e7c81d66b36$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
} /**
   * Returns the nearest ancestor Route error, which could be a loader/action
   * error or a render error.  This is intended to be called from your
   * ErrorBoundary/errorElement to display a proper error message.
   */ 
function $da171e7c81d66b36$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $42omo.useContext($da171e7c81d66b36$var$RouteErrorContext);
    let state = $da171e7c81d66b36$var$useDataRouterState($da171e7c81d66b36$var$DataRouterStateHook.UseRouteError);
    let routeId = $da171e7c81d66b36$var$useCurrentRouteId($da171e7c81d66b36$var$DataRouterStateHook.UseRouteError); // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
     // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
} /**
   * Returns the happy-path data from the nearest ancestor `<Await />` value
   */ 
function $da171e7c81d66b36$export$78a72ddb39bdd145() {
    let value = $42omo.useContext($da171e7c81d66b36$var$AwaitContext);
    return value == null ? void 0 : value._data;
} /**
   * Returns the error from the nearest ancestor `<Await />` value
   */ 
function $da171e7c81d66b36$export$17f53340677d5831() {
    let value = $42omo.useContext($da171e7c81d66b36$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $da171e7c81d66b36$var$blockerId = 0; /**
                    * Allow the application to block navigations within the SPA and present the
                    * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
                    * using half-filled form data.  This does not handle hard-reloads or
                    * cross-origin navigations.
                    */ 
function $da171e7c81d66b36$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $da171e7c81d66b36$var$useDataRouterContext($da171e7c81d66b36$var$DataRouterHook.UseBlocker);
    let state = $da171e7c81d66b36$var$useDataRouterState($da171e7c81d66b36$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $42omo.useState("");
    let blockerFunction = $42omo.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
         // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $da171e7c81d66b36$var$_extends({}, currentLocation, {
                pathname: (0, $8ce0W.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $da171e7c81d66b36$var$_extends({}, nextLocation, {
                pathname: (0, $8ce0W.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]); // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $42omo.useEffect(()=>{
        let key = String(++$da171e7c81d66b36$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]); // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $42omo.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]); // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $8ce0W.IDLE_BLOCKER);
} /**
   * Stable version of useNavigate that is used when we are in the context of
   * a RouterProvider.
   */ 
function $da171e7c81d66b36$var$useNavigateStable() {
    let { router: router } = $da171e7c81d66b36$var$useDataRouterContext($da171e7c81d66b36$var$DataRouterHook.UseNavigateStable);
    let id = $da171e7c81d66b36$var$useCurrentRouteId($da171e7c81d66b36$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $42omo.useRef(false);
    $da171e7c81d66b36$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $42omo.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $da171e7c81d66b36$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $da171e7c81d66b36$var$alreadyWarned$1 = {};
function $da171e7c81d66b36$var$warningOnce(key, cond, message) {
    if (!cond && !$da171e7c81d66b36$var$alreadyWarned$1[key]) $da171e7c81d66b36$var$alreadyWarned$1[key] = true;
}
const $da171e7c81d66b36$var$alreadyWarned = {};
function $da171e7c81d66b36$var$warnOnce(key, message) {}
const $da171e7c81d66b36$var$logDeprecation = (flag, msg, link)=>$da171e7c81d66b36$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $da171e7c81d66b36$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $da171e7c81d66b36$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $da171e7c81d66b36$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $da171e7c81d66b36$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $da171e7c81d66b36$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $da171e7c81d66b36$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $da171e7c81d66b36$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $da171e7c81d66b36$var$START_TRANSITION = "startTransition";
const $da171e7c81d66b36$var$startTransitionImpl = $42omo[$da171e7c81d66b36$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $da171e7c81d66b36$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $42omo.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $42omo.useCallback((newState)=>{
        if (v7_startTransition && $da171e7c81d66b36$var$startTransitionImpl) $da171e7c81d66b36$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $42omo.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $42omo.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $42omo.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $42omo.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $42omo.useEffect(()=>$da171e7c81d66b36$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $da171e7c81d66b36$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $da171e7c81d66b36$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $da171e7c81d66b36$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $42omo.useRef();
    if (historyRef.current == null) historyRef.current = (0, $8ce0W.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $42omo.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $42omo.useCallback((newState)=>{
        v7_startTransition && $da171e7c81d66b36$var$startTransitionImpl ? $da171e7c81d66b36$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $42omo.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $42omo.useEffect(()=>$da171e7c81d66b36$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $da171e7c81d66b36$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$da171e7c81d66b36$export$9c954a9d03d32f4a() && (0, $8ce0W.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $42omo.useContext($da171e7c81d66b36$export$26749e8557646306);
    let { matches: matches } = $42omo.useContext($da171e7c81d66b36$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $da171e7c81d66b36$export$45d76561a5302f2b();
    let navigate = $da171e7c81d66b36$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $8ce0W.resolveTo)(to, (0, $8ce0W.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $42omo.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $da171e7c81d66b36$export$910ae8079b2c2852(props) {
    return $da171e7c81d66b36$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $da171e7c81d66b36$export$e7b0ac011bb776c6(_props) {
    (0, $8ce0W.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $da171e7c81d66b36$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $8ce0W.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$da171e7c81d66b36$export$9c954a9d03d32f4a() && (0, $8ce0W.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $42omo.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $da171e7c81d66b36$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $8ce0W.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $42omo.useMemo(()=>{
        let trailingPathname = (0, $8ce0W.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $da171e7c81d66b36$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $da171e7c81d66b36$export$5d3fca4a98652595($da171e7c81d66b36$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $da171e7c81d66b36$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$var$ResolveAwait, null, children));
}
var $da171e7c81d66b36$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($da171e7c81d66b36$var$AwaitRenderStatus || {});
const $da171e7c81d66b36$var$neverSettledPromise = new Promise(()=>{});
class $da171e7c81d66b36$var$AwaitErrorBoundary extends $42omo.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $da171e7c81d66b36$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $da171e7c81d66b36$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $da171e7c81d66b36$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $da171e7c81d66b36$var$AwaitRenderStatus.error : "_data" in promise ? $da171e7c81d66b36$var$AwaitRenderStatus.success : $da171e7c81d66b36$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $da171e7c81d66b36$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $da171e7c81d66b36$var$AwaitRenderStatus.error && promise._error instanceof (0, $8ce0W.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $da171e7c81d66b36$var$neverSettledPromise;
        if (status === $da171e7c81d66b36$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $da171e7c81d66b36$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $da171e7c81d66b36$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $42omo.createElement($da171e7c81d66b36$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $da171e7c81d66b36$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $da171e7c81d66b36$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $42omo.createElement($42omo.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $da171e7c81d66b36$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $42omo.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $42omo.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $42omo.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $da171e7c81d66b36$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $da171e7c81d66b36$export$e7b0ac011bb776c6) && (0, $8ce0W.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $8ce0W.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $da171e7c81d66b36$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $da171e7c81d66b36$export$daf73786167a7f72(matches) {
    return $da171e7c81d66b36$var$_renderMatches(matches);
}
function $da171e7c81d66b36$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $42omo.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $42omo.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $42omo.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $da171e7c81d66b36$export$f30f7e456d254e83(routes, opts) {
    return (0, $8ce0W.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $da171e7c81d66b36$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $8ce0W.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $da171e7c81d66b36$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



var $j6S25 = parcelRequire("j6S25");


var $hpNab = parcelRequire("hpNab");


var $kFwgS = parcelRequire("kFwgS");


var $jNfGN = parcelRequire("jNfGN");

function $fcb425ff61c316c2$export$41eb0a358b69a9df(props) {
    let { contentId: contentId = '', hostname: hostname, parentProduct: parentProduct = '', spaceKey: spaceKey, url: url, allowedFeatures: allowedFeatures, mode: mode, draftShareId: draftShareId, hash: hash, themeState: themeState, showFooter: showFooter, ...passThroughProps } = props;
    const parsedAllowedFeatures = $fcb425ff61c316c2$export$350c411f568eceb9(allowedFeatures);
    if (!url) return {
        contentId: contentId,
        hostname: hostname,
        parentProduct: parentProduct,
        spaceKey: spaceKey,
        protocol: 'https:',
        mode: mode ?? (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        showFooter: showFooter,
        ...passThroughProps
    };
    const parsedProps = $fcb425ff61c316c2$export$7a5253c0f62e0150(url);
    if (!parsedProps) return {
        hostname: hostname,
        contentId: contentId,
        spaceKey: spaceKey,
        parentProduct: parentProduct,
        mode: mode,
        protocol: 'https:',
        allowedFeatures: parsedAllowedFeatures,
        draftShareId: draftShareId,
        hash: hash,
        themeState: themeState,
        showFooter: showFooter,
        ...passThroughProps
    };
    const themeStateParsedObject = parsedProps.themeState ? (0, $j6S25.themeStringToObject)(decodeURIComponent(parsedProps.themeState)) : undefined;
    const previewPanels = $fcb425ff61c316c2$var$parseQueryParam(parsedProps.query, 'previewPanels');
    // Override with URL-extracted props
    contentId = contentId || parsedProps.contentId;
    parentProduct = parentProduct || parsedProps.parentProduct || '';
    hostname = hostname || parsedProps.hostname || window.location.hostname;
    spaceKey = spaceKey || parsedProps.spaceKey;
    draftShareId = draftShareId || parsedProps.draftShareId;
    hash = hash || parsedProps.hash;
    themeState = themeState || themeStateParsedObject;
    let modeFromUrl;
    switch(parsedProps.route){
        case (0, $jNfGN.VIEW_PAGE).name:
        case (0, $jNfGN.VIEW_BLOG).name:
        case (0, $jNfGN.VIEW_BLOG_DATE_LEGACY).name:
            modeFromUrl = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE;
            break;
        case (0, $jNfGN.EDIT_PAGE_EMBED).name:
        case (0, $jNfGN.EDIT_PAGE_V2).name:
            modeFromUrl = (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE;
            break;
        case (0, $jNfGN.WHITEBOARD).name:
    }
    const contentSlug = parsedProps.route === (0, $jNfGN.VIEW_BLOG_DATE_LEGACY).name ? undefined : parsedProps.contentSlug;
    return {
        allowedFeatures: parsedAllowedFeatures,
        contentId: contentId,
        draftShareId: draftShareId,
        hash: hash,
        hostname: hostname,
        mode: mode || modeFromUrl,
        parentProduct: parentProduct,
        protocol: parsedProps.protocol,
        spaceKey: spaceKey,
        themeState: themeState,
        contentSlug: contentSlug,
        showFooter: showFooter,
        previewPanels: previewPanels,
        ...passThroughProps
    };
}
function $fcb425ff61c316c2$export$7a5253c0f62e0150(url) {
    if (!url) return null;
    const matchedRoute = $fcb425ff61c316c2$var$findAndMatchRoute((0, $jNfGN.namedRoutes), url);
    if (!matchedRoute) return null;
    const { routeName: routeName, ...match } = matchedRoute;
    const { year: year, month: month, day: day, contentId: contentId } = match.params;
    // Validate date parameters
    const isValidYear = /^\d+$/.test(year || '');
    const isValidMonth = /^\d+$/.test(month || '');
    const isValidDay = /^\d+$/.test(day || '');
    const isValidContentId = /^\d+$/.test(contentId || '');
    // If route requires validation, and any parameter is invalid, return null
    if (routeName === (0, $jNfGN.VIEW_BLOG_DATE_LEGACY).name && (!isValidYear || !isValidMonth || !isValidDay || !isValidContentId)) return null;
    return {
        route: routeName,
        hostname: match.host,
        protocol: match.protocol,
        contentId: contentId || '',
        spaceKey: match.params.spaceKey || '',
        hash: match.hash || '',
        // EP currently supports only 1 parent product, no more than 1 parent product should be passed in
        parentProduct: Array.isArray(match.query.parentProduct) ? match.query.parentProduct[0] : match.query.parentProduct || '',
        draftShareId: Array.isArray(match.query.draftShareId) ? match.query.draftShareId[0] : match.query.draftShareId,
        themeState: match.query.themeState,
        contentSlug: match.params.contentSlug || undefined,
        query: match.query
    };
}
function $fcb425ff61c316c2$var$findAndMatchRoute(routes, url) {
    for (const routeKey of Object.keys(routes)){
        const route = routes[routeKey];
        const match = $fcb425ff61c316c2$var$matchUrl(route.pattern, url);
        if (match) return {
            routeName: route.name,
            ...match
        };
    }
    return null;
}
function $fcb425ff61c316c2$var$isValidURL(url) {
    try {
        new URL(url, window.location.origin);
        return true;
    } catch  {
        return false;
    }
}
function $fcb425ff61c316c2$var$matchUrl(pattern, url) {
    if (!$fcb425ff61c316c2$var$isValidURL(url)) return null;
    const parsed = new URL(url, window.location.origin);
    const pathname = parsed.pathname || '';
    const search = parsed.search || '';
    let match = (0, $8ce0W.matchPath)({
        path: pattern,
        end: true
    }, pathname);
    // If initial match fails and the route requires query parameters, attempt to match including search
    // some of our routes need query params to match
    if (!match && search) match = (0, $8ce0W.matchPath)({
        path: pattern,
        end: true
    }, `${pathname}${search}`);
    if (!match) return null;
    // URI decode params
    const decodedParams = {};
    if (match.params) {
        for (const [key, value] of Object.entries(match.params))if (value !== undefined) decodedParams[key] = value;
    }
    return {
        url: url,
        protocol: parsed.protocol,
        host: parsed.host,
        pathname: pathname,
        search: parsed.search,
        hash: parsed.hash,
        pattern: pattern,
        params: decodedParams,
        query: Object.fromEntries(parsed.searchParams.entries())
    };
}
function $fcb425ff61c316c2$export$350c411f568eceb9(allowedFeatures) {
    let parsedAllowedFeatures = {
        view: allowedFeatures?.view,
        edit: allowedFeatures?.edit
    };
    if (!allowedFeatures?.view) parsedAllowedFeatures.view = [
        ...(0, $hpNab.DEFAULT_ALLOWED_FEATURES).view,
        'edit'
    ];
    else if (Array.isArray(allowedFeatures.view)) parsedAllowedFeatures.view = [
        ...allowedFeatures.view,
        'edit'
    ];
    return parsedAllowedFeatures;
}
function $fcb425ff61c316c2$var$parseQueryParam(query, keyName) {
    for (const [key, value] of Object.entries(query)){
        if (key === keyName) return Array.isArray(value) ? value.join(',') : value;
    }
    return undefined;
}
module.exports["parsePageProps"] = $fcb425ff61c316c2$export$41eb0a358b69a9df;
module.exports["parseUrl"] = $fcb425ff61c316c2$export$7a5253c0f62e0150;

});

parcelRegister("iudHJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9tntP = parcelRequire("9tntP");

var $jJf3a = parcelRequire("jJf3a");


var $j2dMW = parcelRequire("j2dMW");

function $050604c2cae7bb2b$export$7ecf150f65423c3f(fromExperienceTracker, toExperienceTracker) {
    if (!fromExperienceTracker || !toExperienceTracker) return;
    const cancelExperiencesForwarding = fromExperienceTracker.subscribe(({ action: action, ...options })=>{
        switch(action){
            case 'taskAbort':
                toExperienceTracker.abort({
                    ...options,
                    checkForTimeout: false
                });
                break;
            case 'taskFail':
                toExperienceTracker.fail(options);
                break;
            case 'taskStart':
                toExperienceTracker.start(options);
                break;
            case 'taskSuccess':
                toExperienceTracker.succeed(options);
                break;
        }
    });
    return cancelExperiencesForwarding;
}


function $a32c46ee326387bc$export$cdefb2a8b53f879f() {
    const embeddedConfluenceETRef = (0, $42omo.useRef)();
    if (!embeddedConfluenceETRef.current) embeddedConfluenceETRef.current = new (0, $9tntP.ExperienceTracker)();
    (0, $j2dMW.useAnalytics)(embeddedConfluenceETRef.current);
    $a32c46ee326387bc$var$useExperiencesForwarding(embeddedConfluenceETRef.current);
    return embeddedConfluenceETRef.current;
}
const $a32c46ee326387bc$var$useExperiencesForwarding = (experienceTracker)=>{
    const unsubscribeRef = (0, $42omo.useRef)();
    // Make sure the Embeddable Pages ExperienceTrackerAPI instance forwards experence events to the embedding product.
    const embeddingProductETRef = (0, $42omo.useRef)();
    const embeddingProductET = (0, $42omo.useContext)((0, $jJf3a.ExperienceTrackerContext));
    if (embeddingProductETRef.current !== embeddingProductET) {
        // Cancel the old forwarding on embedding product ExperienceTrackerAPI instance change.
        if (unsubscribeRef.current) unsubscribeRef.current();
        embeddingProductETRef.current = embeddingProductET;
        // Set the new forwarding up.
        unsubscribeRef.current = (0, $050604c2cae7bb2b$export$7ecf150f65423c3f)(experienceTracker, embeddingProductETRef.current);
    }
    // Cancel the forwarding on unmount.
    (0, $42omo.useEffect)(()=>unsubscribeRef.current, []);
};
module.exports["useExperienceTracker"] = $a32c46ee326387bc$export$cdefb2a8b53f879f;

});

parcelRegister("7pThu", function(module, exports) {
const $21fcdb9e1f147260$export$b9fadc635fed6276 = 'embedded-confluence/';
var $21fcdb9e1f147260$export$312b1a9f1141bdaa = /*#__PURE__*/ function(ExperienceNames) {
    ExperienceNames["VIEW_PAGE"] = "embedded-confluence/view-page";
    ExperienceNames["CC_VIEW_PAGE"] = "view-page";
    ExperienceNames["EDIT_PAGE"] = "embedded-confluence/edit-page";
    ExperienceNames["CC_EDIT_PAGE_EMBED"] = "edit-page-embed";
    ExperienceNames["WHITEBOARD"] = "embedded-confluence/whiteboard";
    ExperienceNames["CC_WHITEBOARD"] = "whiteboard-page";
    ExperienceNames["LOGIN_PAGE"] = "embedded-confluence/login-page";
    ExperienceNames["STORAGE_ACCESS_PAGE"] = "embedded-confluence/storage-access-page";
    ExperienceNames["PAGE_NOT_FOUND"] = "not-found";
    return ExperienceNames;
}({});
var $21fcdb9e1f147260$export$db5add30a8721c38 = /*#__PURE__*/ function(ExperienceReasons) {
    ExperienceReasons["UNABLE_TO_DISPLAY_CONTENT"] = "Unable to display page content";
    ExperienceReasons["STORAGE_ACCESS_ERROR"] = "Error when obtaining Storage access";
    ExperienceReasons["STORAGE_ACCESS_NOT_SUPPORTED"] = "Storage access API is not supported";
    ExperienceReasons["STORAGE_ACCESS_REJECTED"] = "Storage access is rejected";
    return ExperienceReasons;
}({});
var $21fcdb9e1f147260$export$ce9b20b2ad3e7bc6 = /*#__PURE__*/ function(SupportedExperienceNames) {
    SupportedExperienceNames["ADD_COMMENT"] = "add-page-comment";
    SupportedExperienceNames["DELETE_COMMENT"] = "delete-page-comment";
    SupportedExperienceNames["DELETE_PAGE"] = "delete-page";
    SupportedExperienceNames["DELETE_DRAFT"] = "edit-page/revert-draft";
    SupportedExperienceNames["EDIT_CLOSE"] = "edit-page/close";
    SupportedExperienceNames["EDIT_LOAD"] = "edit-page/load";
    SupportedExperienceNames["EDIT_PAGE_EMBED"] = "embedded-confluence/edit-page";
    SupportedExperienceNames["EDIT_PUBLISH"] = "edit-page/publish";
    SupportedExperienceNames["LOGIN_PAGE"] = "embedded-confluence/login-page";
    SupportedExperienceNames["STORAGE_ACCESS_PAGE"] = "embedded-confluence/storage-access-page";
    SupportedExperienceNames["VIEW_CONTENT"] = "view-content";
    SupportedExperienceNames["VIEW_EDIT"] = "view-page/edit";
    SupportedExperienceNames["VIEW_PAGE"] = "embedded-confluence/view-page";
    return SupportedExperienceNames;
}({});
module.exports["EXPERIENCE_NAME_PREFIX"] = $21fcdb9e1f147260$export$b9fadc635fed6276;
module.exports["ExperienceNames"] = $21fcdb9e1f147260$export$312b1a9f1141bdaa;
module.exports["ExperienceReasons"] = $21fcdb9e1f147260$export$db5add30a8721c38;

});

parcelRegister("elkSx", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $abC4X = parcelRequire("abC4X");


var $gdv5Z = parcelRequire("gdv5Z");


var $cgtv4 = parcelRequire("cgtv4");

const $130194087263f90e$var$messages = (0, $cgtv4.defineMessages)({
    emptyStateHeader: {
        defaultMessage: "We couldn't find what you're looking for",
        id: "embedded-confluence-common.src.content.empty-state-header"
    },
    emptyStateDescription: {
        defaultMessage: "We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09",
        id: "embedded-confluence-common.src.content.empty-state-description"
    }
});
var $130194087263f90e$export$2e2bcd8739ae039 = $130194087263f90e$var$messages;





parcelRequire("42omo");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $2fe8a6927c240794$var$styles = `{
  cls4: { fill: '#b3f5ff' },
  cls50: { fill: '#79e2f2' },
  cls228: { fill: 'url(#radial-gradient-7)' },
  cls230: { fill: 'url(#radial-gradient-9)' },
  cls240: { fill: '#c1c7d0' },
  cls242: { fill: '#dfe1e5' },
  cls245: { fill: '#172b4d' },
  cls247: { fill: '#00c7e5' },
  cls249: { fill: 'none' },
  cls250: { fill: '#72594b' },
  cls261: { opacity: 0.6 },
  cls262: { fill: '#ff8b00' },
  cls263: { fill: '#ecc19c' },
}`;
const $2fe8a6927c240794$export$7cd49dc959d58823 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "476.06",
        height: "482.63",
        viewBox: "0 0 476.06 482.63",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "linear-gradient",
                        x1: "319.98",
                        y1: "322.55",
                        x2: "426.85",
                        y2: "215.68",
                        gradientTransform: "translate(-227.29)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3f5ff",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".06",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".1"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".27",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".42"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".45",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".67"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".6",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".85"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".72",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".96"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#b3f5ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-2",
                        x1: "7261.66",
                        y1: "168.49",
                        x2: "7391.94",
                        y2: "38.21",
                        gradientTransform: "matrix(-1 0 0 1 7632.29 0)",
                        xlinkHref: "#linear-gradient"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "linear-gradient-3",
                        x1: "146.17",
                        y1: "164.89",
                        x2: "239.99",
                        y2: "71.07",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0",
                                stopColor: "#00c7e5"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "#b3f5ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "linear-gradient-4",
                        x1: "782.51",
                        y1: "-1187.31",
                        x2: "790.62",
                        y2: "-1204.87",
                        gradientTransform: "rotate(-24.78 3495.39 868.508)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".25",
                                stopColor: "#00b8d9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "#79e2f2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "linear-gradient-5",
                        x1: "5.81",
                        y1: "472.52",
                        x2: "5.81",
                        y2: "284.67",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".43",
                                stopColor: "#b3f5ff"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "#79e2f2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-6",
                        x1: "8.47",
                        y1: "472.52",
                        x2: "8.47",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-7",
                        x1: "69.15",
                        y1: "472.52",
                        x2: "69.15",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-8",
                        x1: "63.61",
                        y1: "472.52",
                        x2: "63.61",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-9",
                        x1: "67.33",
                        y1: "472.52",
                        x2: "67.33",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-10",
                        x1: "68.21",
                        y1: "472.52",
                        x2: "68.21",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-11",
                        x1: "68.78",
                        y1: "472.52",
                        x2: "68.78",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-12",
                        x1: "69.36",
                        y1: "472.52",
                        x2: "69.36",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-13",
                        x1: "52.51",
                        y1: "472.52",
                        x2: "52.51",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-14",
                        x1: "56.67",
                        y1: "472.52",
                        x2: "56.67",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-15",
                        x1: "54.47",
                        y1: "472.52",
                        x2: "54.47",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-16",
                        x1: "60.3",
                        y1: "472.52",
                        x2: "60.3",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-17",
                        x1: "62.16",
                        y1: "472.52",
                        x2: "62.16",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-18",
                        x1: "58.5",
                        y1: "472.52",
                        x2: "58.5",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-19",
                        x1: "66.35",
                        y1: "472.52",
                        x2: "66.35",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-20",
                        x1: "3.23",
                        y1: "472.52",
                        x2: "3.23",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-21",
                        x1: "160.2",
                        y1: "472.52",
                        x2: "160.2",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-22",
                        x1: "71.2",
                        y1: "472.52",
                        x2: "71.2",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-23",
                        x1: "271.02",
                        y1: "472.52",
                        x2: "271.02",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-24",
                        x1: "4.82",
                        y1: "472.52",
                        x2: "4.82",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-25",
                        x1: "69.36",
                        y1: "472.52",
                        x2: "69.36",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-26",
                        x1: "195.3",
                        y1: "472.52",
                        x2: "195.3",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-27",
                        x1: "3.53",
                        y1: "472.52",
                        x2: "3.53",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-28",
                        x1: "3.37",
                        y1: "472.52",
                        x2: "3.37",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-29",
                        x1: "4.07",
                        y1: "472.52",
                        x2: "4.07",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-30",
                        x1: "273.13",
                        y1: "472.52",
                        x2: "273.13",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "linear-gradient-31",
                        x1: "273.13",
                        y1: "462.4",
                        x2: "273.13",
                        y2: "337.02",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".31",
                                stopColor: "#b3f5ff"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#79e2f2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-32",
                        x1: "220.7",
                        y1: "472.52",
                        x2: "220.7",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-33",
                        x1: "220.7",
                        y1: "462.4",
                        x2: "220.7",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-34",
                        x1: "185.46",
                        y1: "472.52",
                        x2: "185.46",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "linear-gradient-35",
                        x1: "185.46",
                        y1: "402.18",
                        x2: "185.46",
                        y2: "337.02",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3f5ff"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".05",
                                stopColor: "#abf2fd"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".22",
                                stopColor: "#95ebf8"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".4",
                                stopColor: "#85e6f5"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".61",
                                stopColor: "#7ce3f3"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".91",
                                stopColor: "#79e2f2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-36",
                        x1: "148.26",
                        y1: "472.52",
                        x2: "148.26",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-37",
                        x1: "148.26",
                        y1: "402.18",
                        x2: "148.26",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-38",
                        x1: "186.02",
                        y1: "472.52",
                        x2: "186.02",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-39",
                        x1: "186.02",
                        y1: "462.4",
                        x2: "186.02",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-40",
                        x1: "186.02",
                        y1: "402.18",
                        x2: "186.02",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-41",
                        x1: "214.14",
                        y1: "472.52",
                        x2: "214.14",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-42",
                        x1: "214.14",
                        y1: "462.4",
                        x2: "214.14",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-43",
                        x1: "214.14",
                        y1: "402.18",
                        x2: "214.14",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-44",
                        x1: "185.54",
                        y1: "402.18",
                        x2: "185.54",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-45",
                        x1: "338.36",
                        y1: "472.52",
                        x2: "338.36",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-46",
                        x1: "338.36",
                        y1: "402.18",
                        x2: "338.36",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-47",
                        x1: "283.93",
                        y1: "472.52",
                        x2: "283.93",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-48",
                        x1: "283.93",
                        y1: "462.4",
                        x2: "283.93",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-49",
                        x1: "283.93",
                        y1: "402.18",
                        x2: "283.93",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-50",
                        x1: "403.38",
                        y1: "472.52",
                        x2: "403.38",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "linear-gradient-51",
                        x1: "396.98",
                        y1: "411.33",
                        x2: "409.97",
                        y2: "305.52",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3f5ff"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".96"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".02",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".78"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".05",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".61"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".07",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".47"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".1",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".34"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".13",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".23"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".17",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".15"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".21",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".08"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".26",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".03"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".33",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".01"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".52",
                                stopColor: "#b3f5ff",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".67",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".01"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".74",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".04"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".09"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".83",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".16"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".86",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".25"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".9",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".36"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".93",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".49"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".95",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".65"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".98",
                                stopColor: "#b3f5ff",
                                stopOpacity: ".82"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "#b3f5ff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-52",
                        x1: "2.42",
                        y1: "362.88",
                        x2: "15.41",
                        y2: "257.07",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-53",
                        x1: "3.3",
                        y1: "362.99",
                        x2: "16.29",
                        y2: "257.18",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-54",
                        x1: "4.38",
                        y1: "363.12",
                        x2: "17.37",
                        y2: "257.31",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-55",
                        x1: "1.14",
                        y1: "362.72",
                        x2: "14.13",
                        y2: "256.91",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-56",
                        x1: "5.69",
                        y1: "363.28",
                        x2: "18.68",
                        y2: "257.47",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-57",
                        x1: "1.05",
                        y1: "362.71",
                        x2: "14.04",
                        y2: "256.9",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-58",
                        x1: "10.57",
                        y1: "363.88",
                        x2: "11.95",
                        y2: "352.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-59",
                        x1: "1.74",
                        y1: "362.79",
                        x2: "14.73",
                        y2: "256.99",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-60",
                        x1: "171.14",
                        y1: "472.52",
                        x2: "171.14",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-61",
                        x1: "165.11",
                        y1: "382.85",
                        x2: "178.1",
                        y2: "277.05",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-62",
                        x1: "251.72",
                        y1: "472.52",
                        x2: "251.72",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-63",
                        x1: "251.72",
                        y1: "462.4",
                        x2: "251.72",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-64",
                        x1: "249.31",
                        y1: "393.2",
                        x2: "262.3",
                        y2: "287.39",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-65",
                        x1: "237.87",
                        y1: "472.52",
                        x2: "237.87",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-66",
                        x1: "237.87",
                        y1: "462.4",
                        x2: "237.87",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-67",
                        x1: "235.86",
                        y1: "391.55",
                        x2: "248.85",
                        y2: "285.74",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-68",
                        x1: "153.84",
                        y1: "472.52",
                        x2: "153.84",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-69",
                        x1: "153.84",
                        y1: "402.18",
                        x2: "153.84",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-70",
                        x1: "152.5",
                        y1: "381.31",
                        x2: "165.5",
                        y2: "275.5",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-71",
                        x1: "172.27",
                        y1: "472.52",
                        x2: "172.27",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-72",
                        x1: "172.27",
                        y1: "462.4",
                        x2: "172.27",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-73",
                        x1: "172.27",
                        y1: "402.18",
                        x2: "172.27",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-74",
                        x1: "168.95",
                        y1: "383.33",
                        x2: "181.94",
                        y2: "277.52",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-75",
                        x1: "221.37",
                        y1: "472.52",
                        x2: "221.37",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-76",
                        x1: "221.37",
                        y1: "462.4",
                        x2: "221.37",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-77",
                        x1: "221.37",
                        y1: "402.18",
                        x2: "221.37",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-78",
                        x1: "218.94",
                        y1: "389.47",
                        x2: "231.93",
                        y2: "283.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-79",
                        x1: "187.52",
                        y1: "472.52",
                        x2: "187.52",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-80",
                        x1: "187.52",
                        y1: "462.4",
                        x2: "187.52",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-81",
                        x1: "187.52",
                        y1: "402.18",
                        x2: "187.52",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-82",
                        x1: "184.77",
                        y1: "385.27",
                        x2: "197.76",
                        y2: "279.47",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-83",
                        x1: "180.43",
                        y1: "402.18",
                        x2: "180.43",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-84",
                        x1: "178.58",
                        y1: "384.51",
                        x2: "191.57",
                        y2: "278.7",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-85",
                        x1: "193.4",
                        y1: "402.18",
                        x2: "193.4",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-86",
                        x1: "191.37",
                        y1: "386.08",
                        x2: "204.37",
                        y2: "280.28",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-87",
                        x1: "240.98",
                        y1: "392.17",
                        x2: "253.97",
                        y2: "286.37",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-88",
                        x1: "333.44",
                        y1: "472.52",
                        x2: "333.44",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-89",
                        x1: "333.44",
                        y1: "402.18",
                        x2: "333.44",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-90",
                        x1: "329.79",
                        y1: "403.08",
                        x2: "342.78",
                        y2: "297.27",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-91",
                        x1: "283.96",
                        y1: "472.52",
                        x2: "283.96",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-92",
                        x1: "283.96",
                        y1: "462.4",
                        x2: "283.96",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-93",
                        x1: "283.96",
                        y1: "402.18",
                        x2: "283.96",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-94",
                        x1: "279.87",
                        y1: "396.95",
                        x2: "292.86",
                        y2: "291.14",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-95",
                        x1: "204.11",
                        y1: "472.52",
                        x2: "204.11",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-96",
                        x1: "184.3",
                        y1: "387.71",
                        x2: "228.81",
                        y2: "265.4",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-97",
                        x1: "197.55",
                        y1: "386.84",
                        x2: "210.54",
                        y2: "281.03",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-98",
                        x1: "375.18",
                        y1: "472.52",
                        x2: "375.18",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-99",
                        x1: "339.82",
                        y1: "444.31",
                        x2: "384.34",
                        y2: "322.01",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-100",
                        x1: "367.74",
                        y1: "407.74",
                        x2: "380.74",
                        y2: "301.93",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-101",
                        x1: "154.96",
                        y1: "472.52",
                        x2: "154.96",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-102",
                        x1: "154.96",
                        y1: "402.18",
                        x2: "154.96",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-103",
                        x1: "148.01",
                        y1: "374.5",
                        x2: "192.52",
                        y2: "252.19",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-104",
                        x1: "151.79",
                        y1: "381.22",
                        x2: "164.78",
                        y2: "275.42",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-105",
                        x1: "202.83",
                        y1: "472.52",
                        x2: "202.83",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-106",
                        x1: "202.83",
                        y1: "462.4",
                        x2: "202.83",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-107",
                        x1: "202.83",
                        y1: "402.18",
                        x2: "202.83",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-108",
                        x1: "190.53",
                        y1: "389.97",
                        x2: "235.04",
                        y2: "267.67",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-109",
                        x1: "199.1",
                        y1: "387.03",
                        x2: "212.09",
                        y2: "281.22",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-110",
                        x1: "170.79",
                        y1: "472.52",
                        x2: "170.79",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-111",
                        x1: "170.79",
                        y1: "462.4",
                        x2: "170.79",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-112",
                        x1: "170.79",
                        y1: "402.18",
                        x2: "170.79",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-113",
                        x1: "161.27",
                        y1: "379.33",
                        x2: "205.79",
                        y2: "257.02",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-114",
                        x1: "166.95",
                        y1: "383.08",
                        x2: "179.94",
                        y2: "277.28",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-115",
                        x1: "188.51",
                        y1: "472.52",
                        x2: "188.51",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-116",
                        x1: "188.51",
                        y1: "462.4",
                        x2: "188.51",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-117",
                        x1: "188.51",
                        y1: "402.18",
                        x2: "188.51",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-118",
                        x1: "177.1",
                        y1: "385.09",
                        x2: "221.61",
                        y2: "262.78",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-119",
                        x1: "184.49",
                        y1: "385.24",
                        x2: "197.49",
                        y2: "279.43",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-120",
                        x1: "181.55",
                        y1: "402.18",
                        x2: "181.55",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-121",
                        x1: "171.4",
                        y1: "383.01",
                        x2: "215.92",
                        y2: "260.71",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-122",
                        x1: "178.12",
                        y1: "384.46",
                        x2: "191.11",
                        y2: "278.65",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-123",
                        x1: "195.05",
                        y1: "402.18",
                        x2: "195.05",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-124",
                        x1: "183.47",
                        y1: "387.41",
                        x2: "227.99",
                        y2: "265.1",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-125",
                        x1: "191.39",
                        y1: "386.09",
                        x2: "204.38",
                        y2: "280.28",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-126",
                        x1: "227.14",
                        y1: "403.3",
                        x2: "271.66",
                        y2: "281",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-127",
                        x1: "240.77",
                        y1: "392.15",
                        x2: "253.76",
                        y2: "286.34",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-128",
                        x1: "334.77",
                        y1: "472.52",
                        x2: "334.77",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-129",
                        x1: "334.77",
                        y1: "402.18",
                        x2: "334.77",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-130",
                        x1: "306.53",
                        y1: "432.19",
                        x2: "351.04",
                        y2: "309.89",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-131",
                        x1: "328.83",
                        y1: "402.96",
                        x2: "341.82",
                        y2: "297.15",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-132",
                        x1: "305.41",
                        y1: "472.52",
                        x2: "305.41",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-133",
                        x1: "305.41",
                        y1: "462.4",
                        x2: "305.41",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-134",
                        x1: "305.41",
                        y1: "402.18",
                        x2: "305.41",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-135",
                        x1: "280.29",
                        y1: "422.65",
                        x2: "324.81",
                        y2: "300.34",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-136",
                        x1: "299.79",
                        y1: "399.4",
                        x2: "312.78",
                        y2: "293.59",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-137",
                        x1: "237.39",
                        y1: "472.52",
                        x2: "237.39",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-138",
                        x1: "94.24",
                        y1: "336.36",
                        x2: "382.66",
                        y2: "336.36",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-139",
                        x1: "215.63",
                        y1: "399.11",
                        x2: "260.14",
                        y2: "276.81",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-140",
                        x1: "231.06",
                        y1: "390.96",
                        x2: "244.05",
                        y2: "285.15",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-141",
                        x1: "154.66",
                        y1: "472.52",
                        x2: "154.66",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-142",
                        x1: "154.66",
                        y1: "402.18",
                        x2: "154.66",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-143",
                        x1: "94.24",
                        y1: "347.55",
                        x2: "382.66",
                        y2: "347.55",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-144",
                        x1: "146.2",
                        y1: "373.84",
                        x2: "190.71",
                        y2: "251.53",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-145",
                        x1: "150.91",
                        y1: "381.12",
                        x2: "163.9",
                        y2: "275.31",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-146",
                        x1: "168.62",
                        y1: "472.52",
                        x2: "168.62",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-147",
                        x1: "168.62",
                        y1: "462.4",
                        x2: "168.62",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-148",
                        x1: "168.62",
                        y1: "402.18",
                        x2: "168.62",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-149",
                        x1: "94.24",
                        y1: "348.31",
                        x2: "382.66",
                        y2: "348.31",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-150",
                        x1: "157.53",
                        y1: "377.96",
                        x2: "202.04",
                        y2: "255.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-151",
                        x1: "164.09",
                        y1: "382.73",
                        x2: "177.09",
                        y2: "276.93",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-152",
                        x1: "188.58",
                        y1: "472.52",
                        x2: "188.58",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-153",
                        x1: "188.58",
                        y1: "462.4",
                        x2: "188.58",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-154",
                        x1: "188.58",
                        y1: "402.18",
                        x2: "188.58",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-155",
                        x1: "94.24",
                        y1: "350.99",
                        x2: "382.66",
                        y2: "350.99",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-156",
                        x1: "176.21",
                        y1: "384.76",
                        x2: "220.72",
                        y2: "262.46",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-157",
                        x1: "184.32",
                        y1: "385.22",
                        x2: "197.31",
                        y2: "279.41",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-158",
                        x1: "181.71",
                        y1: "402.18",
                        x2: "181.71",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-159",
                        x1: "94.24",
                        y1: "349.53",
                        x2: "382.66",
                        y2: "349.53",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-160",
                        x1: "170.01",
                        y1: "382.51",
                        x2: "214.52",
                        y2: "260.2",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-161",
                        x1: "177.73",
                        y1: "384.41",
                        x2: "190.72",
                        y2: "278.6",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-162",
                        x1: "193.08",
                        y1: "402.18",
                        x2: "193.08",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-163",
                        x1: "94.24",
                        y1: "352.21",
                        x2: "382.66",
                        y2: "352.21",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-164",
                        x1: "180.71",
                        y1: "386.4",
                        x2: "225.23",
                        y2: "264.1",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-165",
                        x1: "189.02",
                        y1: "385.79",
                        x2: "202.01",
                        y2: "279.99",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-166",
                        x1: "94.24",
                        y1: "349.07",
                        x2: "382.66",
                        y2: "349.07",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-167",
                        x1: "225.04",
                        y1: "402.53",
                        x2: "269.55",
                        y2: "280.23",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-168",
                        x1: "240.19",
                        y1: "392.08",
                        x2: "253.18",
                        y2: "286.27",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-169",
                        x1: "335.09",
                        y1: "472.52",
                        x2: "335.09",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-170",
                        x1: "335.09",
                        y1: "402.18",
                        x2: "335.09",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-171",
                        x1: "94.24",
                        y1: "346.43",
                        x2: "382.66",
                        y2: "346.43",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-172",
                        x1: "305.17",
                        y1: "431.7",
                        x2: "349.68",
                        y2: "309.4",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-173",
                        x1: "328.53",
                        y1: "402.92",
                        x2: "341.52",
                        y2: "297.12",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-174",
                        x1: "314.18",
                        y1: "472.52",
                        x2: "314.18",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-175",
                        x1: "314.18",
                        y1: "462.4",
                        x2: "314.18",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-176",
                        x1: "314.18",
                        y1: "402.18",
                        x2: "314.18",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-177",
                        x1: "94.24",
                        y1: "347.82",
                        x2: "382.66",
                        y2: "347.82",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-178",
                        x1: "286.17",
                        y1: "424.78",
                        x2: "330.68",
                        y2: "302.48",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-179",
                        x1: "307.73",
                        y1: "400.37",
                        x2: "320.72",
                        y2: "294.56",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-180",
                        x1: "238.45",
                        y1: "472.52",
                        x2: "238.45",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-181",
                        x1: "94.24",
                        y1: "336.66",
                        x2: "382.66",
                        y2: "336.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-182",
                        x1: "120.57",
                        y1: "336.66",
                        x2: "356.32",
                        y2: "336.66",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-183",
                        x1: "216.19",
                        y1: "399.31",
                        x2: "260.7",
                        y2: "277.01",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-184",
                        x1: "231.95",
                        y1: "391.07",
                        x2: "244.94",
                        y2: "285.26",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-185",
                        x1: "154.01",
                        y1: "472.52",
                        x2: "154.01",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-186",
                        x1: "154.01",
                        y1: "402.18",
                        x2: "154.01",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-187",
                        x1: "94.24",
                        y1: "340.77",
                        x2: "382.66",
                        y2: "340.77",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-188",
                        x1: "120.57",
                        y1: "340.77",
                        x2: "356.32",
                        y2: "340.77",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-189",
                        x1: "143.55",
                        y1: "372.88",
                        x2: "188.07",
                        y2: "250.57",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-190",
                        x1: "149.49",
                        y1: "380.94",
                        x2: "162.48",
                        y2: "275.13",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-191",
                        x1: "164.37",
                        y1: "472.52",
                        x2: "164.37",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-192",
                        x1: "164.37",
                        y1: "462.4",
                        x2: "164.37",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-193",
                        x1: "164.37",
                        y1: "402.18",
                        x2: "164.37",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-194",
                        x1: "94.24",
                        y1: "341.24",
                        x2: "382.66",
                        y2: "341.24",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-195",
                        x1: "120.57",
                        y1: "341.24",
                        x2: "356.32",
                        y2: "341.24",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-196",
                        x1: "151.77",
                        y1: "375.87",
                        x2: "196.28",
                        y2: "253.56",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-197",
                        x1: "159.34",
                        y1: "382.15",
                        x2: "172.34",
                        y2: "276.34",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-198",
                        x1: "94.24",
                        y1: "341.91",
                        x2: "382.66",
                        y2: "341.91",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-199",
                        x1: "120.57",
                        y1: "341.91",
                        x2: "356.32",
                        y2: "341.91",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-200",
                        x1: "221.5",
                        y1: "401.25",
                        x2: "266.01",
                        y2: "278.94",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-201",
                        x1: "238.15",
                        y1: "391.83",
                        x2: "251.14",
                        y2: "286.02",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-202",
                        x1: "335.78",
                        y1: "472.52",
                        x2: "335.78",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-203",
                        x1: "335.78",
                        y1: "402.18",
                        x2: "335.78",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-204",
                        x1: "94.24",
                        y1: "340.23",
                        x2: "382.66",
                        y2: "340.23",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-205",
                        x1: "120.57",
                        y1: "340.23",
                        x2: "356.32",
                        y2: "340.23",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-206",
                        x1: "303.69",
                        y1: "431.16",
                        x2: "348.2",
                        y2: "308.86",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-207",
                        x1: "328.42",
                        y1: "402.91",
                        x2: "341.41",
                        y2: "297.1",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-208",
                        x1: "326.47",
                        y1: "472.52",
                        x2: "326.47",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-209",
                        x1: "326.47",
                        y1: "462.4",
                        x2: "326.47",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-31"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-210",
                        x1: "326.47",
                        y1: "402.18",
                        x2: "326.47",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-211",
                        x1: "94.24",
                        y1: "340.83",
                        x2: "382.66",
                        y2: "340.83",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-212",
                        x1: "120.57",
                        y1: "340.83",
                        x2: "356.32",
                        y2: "340.83",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-213",
                        x1: "294.77",
                        y1: "427.92",
                        x2: "339.28",
                        y2: "305.61",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-214",
                        x1: "318.99",
                        y1: "401.75",
                        x2: "331.98",
                        y2: "295.94",
                        xlinkHref: "#linear-gradient-51"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-215",
                        x1: "105.04",
                        y1: "472.52",
                        x2: "105.04",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-216",
                        x1: "134.74",
                        y1: "472.52",
                        x2: "134.74",
                        y2: "284.67",
                        xlinkHref: "#linear-gradient-5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-217",
                        x1: "134.74",
                        y1: "402.18",
                        x2: "134.74",
                        y2: "337.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "linear-gradient-218",
                        x1: "115.09",
                        y1: "282.96",
                        x2: "376",
                        y2: "282.96",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0",
                                stopColor: "#b3bac5"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".85",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".95",
                                stopColor: "#edeef1"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".98",
                                stopColor: "#f4f5f7"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "#fafbfc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "linear-gradient-219",
                        x1: "163.83",
                        y1: "347.6",
                        x2: "279.38",
                        y2: "232.05",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0",
                                stopColor: "#c1c7d0"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".14",
                                stopColor: "#c9ced6"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".68",
                                stopColor: "#e2e4e9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "#ebecf0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "linear-gradient-220",
                        x1: "291.34",
                        y1: "337.73",
                        x2: "291.34",
                        y2: "198.21",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".21",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "#fafbfc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "linear-gradient-221",
                        x1: "219.34",
                        y1: "215.53",
                        x2: "331.33",
                        y2: "215.53",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0",
                                stopColor: "#091e42"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".18",
                                stopColor: "#091e42",
                                stopOpacity: ".85"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".5",
                                stopColor: "#091e42",
                                stopOpacity: ".45"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".66",
                                stopColor: "#091e42",
                                stopOpacity: ".2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "linear-gradient-222",
                        x1: "4697.25",
                        y1: "308.96",
                        x2: "4793.78",
                        y2: "308.96",
                        gradientTransform: "matrix(-1 0 0 1 4935.69 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0",
                                stopColor: "#091e42",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".88",
                                stopColor: "#091e42"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "linear-gradient-223",
                        x1: "-10103.77",
                        y1: "-1179.29",
                        x2: "-10103.77",
                        y2: "-1247.52",
                        gradientTransform: "matrix(.99 -.11 .11 .99 10362.66 390.81)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".37",
                                stopColor: "#00a3bf"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".88",
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "linear-gradient-224",
                        x1: "197.02",
                        y1: "184.01",
                        x2: "293.47",
                        y2: "87.57",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0",
                                stopColor: "#091e42"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".13",
                                stopColor: "#091e42",
                                stopOpacity: ".85"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".36",
                                stopColor: "#091e42",
                                stopOpacity: ".45"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".48",
                                stopColor: "#091e42",
                                stopOpacity: ".2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "linear-gradient-225",
                        x1: "294.7",
                        y1: "238.16",
                        x2: "334.79",
                        y2: "238.16",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0",
                                stopColor: "#0065ff"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".12",
                                stopColor: "#0d6eff"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".49",
                                stopColor: "#2f86ff"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".8",
                                stopColor: "#4495ff"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "#4c9aff"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "linear-gradient-226",
                        x1: "245.55",
                        y1: "299.49",
                        x2: "376",
                        y2: "299.49",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".47",
                                stopColor: "#f5f6f8"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "#fafbfc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "linear-gradient-227",
                        x1: "153.96",
                        y1: "321.19",
                        x2: "337.13",
                        y2: "321.19",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "#dfe1e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "linear-gradient-228",
                        x1: "115.09",
                        y1: "299.49",
                        x2: "245.55",
                        y2: "299.49",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0",
                                stopColor: "#ebecf0"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".66",
                                stopColor: "#edeef1"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".9",
                                stopColor: "#f4f5f7"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "#fafbfc"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "linear-gradient-229",
                        x1: "251.12",
                        y1: "196.75",
                        x2: "347.56",
                        y2: "100.3",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0",
                                stopColor: "#ff991f"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".08",
                                stopColor: "#ffa219"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".33",
                                stopColor: "#ffbb07"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".48",
                                stopColor: "#ffc400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "linear-gradient-230",
                        x1: "-2946.9",
                        y1: "-501.86",
                        x2: "-2929.95",
                        y2: "-501.86",
                        gradientTransform: "matrix(-.75 .66 .66 .75 -1698.92 2528.01)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".54",
                                stopColor: "#00b8d9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".66",
                                stopColor: "#00bddd"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "linear-gradient-231",
                        x1: "913.18",
                        y1: "236.51",
                        x2: "936.34",
                        y2: "213.36",
                        gradientTransform: "matrix(-1 0 0 1 1111.25 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0",
                                stopColor: "#00a3bf"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".62",
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "linear-gradient-232",
                        x1: "2869.84",
                        y1: "1497.87",
                        x2: "2882.64",
                        y2: "1491.62",
                        gradientTransform: "matrix(-.9 -.43 -.43 .9 3435.48 110.98)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0",
                                stopColor: "#00a3bf"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".26",
                                stopColor: "#00a8c5"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".6",
                                stopColor: "#00b8d5"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".84",
                                stopColor: "#00c7e5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "New_Gradient_Swatch_13",
                        x1: "-6136.21",
                        y1: "5146.38",
                        x2: "-6130.92",
                        y2: "5141.09",
                        gradientTransform: "matrix(1 0 0 1.52 6291.96 -7637.21)",
                        xlinkHref: "#linear-gradient-3"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "New_Gradient_Swatch_13-2",
                        x1: "-6135.75",
                        y1: "5139.64",
                        x2: "-6131.37",
                        y2: "5135.26",
                        gradientTransform: "matrix(1 0 0 1.52 6301.53 -7627.42)",
                        xlinkHref: "#linear-gradient-3"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "New_Gradient_Swatch_13-3",
                        x1: "-6135.24",
                        y1: "5133.66",
                        x2: "-6131.89",
                        y2: "5130.31",
                        gradientTransform: "matrix(1 0 0 1.52 6309.67 -7619.1)",
                        xlinkHref: "#linear-gradient-3"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "linear-gradient-233",
                        x1: "177.32",
                        y1: "462.13",
                        x2: "177.32",
                        y2: "382.62",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".31",
                                stopColor: "#79e2f2",
                                stopOpacity: ".3"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#79e2f2",
                                stopOpacity: ".6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("linearGradient", {
                        id: "linear-gradient-234",
                        x1: "303.59",
                        y1: "388.02",
                        x2: "303.59",
                        y2: "380.02",
                        xlinkHref: "#linear-gradient-35"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "linear-gradient-235",
                        x1: "310.94",
                        y1: "133.6",
                        x2: "337.06",
                        y2: "186.14",
                        gradientTransform: "matrix(1 0 0 -1 0 582.59)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".31",
                                stopColor: "#79e2f2",
                                stopOpacity: ".2"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".79",
                                stopColor: "#79e2f2",
                                stopOpacity: ".6"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("radialGradient", {
                        id: "radial-gradient",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        gradientTransform: "matrix(1 0 0 .19 0 315.55)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".11",
                                stopColor: "#e6fcff"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".31",
                                stopColor: "#e6fcff",
                                stopOpacity: ".73"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".56",
                                stopColor: "#e6fcff",
                                stopOpacity: ".42"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".77",
                                stopColor: "#e6fcff",
                                stopOpacity: ".19"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: ".92",
                                stopColor: "#e6fcff",
                                stopOpacity: ".05"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "#e6fcff",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("radialGradient", {
                        id: "radial-gradient-2",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("radialGradient", {
                        id: "radial-gradient-3",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("radialGradient", {
                        id: "radial-gradient-4",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("radialGradient", {
                        id: "radial-gradient-5",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("radialGradient", {
                        id: "radial-gradient-6",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("radialGradient", {
                        id: "radial-gradient-7",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("radialGradient", {
                        id: "radial-gradient-8",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("radialGradient", {
                        id: "radial-gradient-9",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("radialGradient", {
                        id: "radial-gradient-10",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("radialGradient", {
                        id: "radial-gradient-12",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("radialGradient", {
                        id: "radial-gradient-13",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("radialGradient", {
                        id: "radial-gradient-15",
                        cx: "56.34",
                        cy: "388.26",
                        r: "81.68",
                        xlinkHref: "#radial-gradient"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("style", {
                        children: $2fe8a6927c240794$var$styles
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                style: {
                    isolation: 'isolate'
                },
                children: /*#__PURE__*/ (0, $l998X.jsx)("g", {
                    id: "Layer_2",
                    "data-name": "Layer 2",
                    children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                        id: "Layer_1-2",
                        "data-name": "Layer 1",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M166.11 212.89a42.69 42.69 0 00-23.17 17.18 32 32 0 00-19.06 0c-12.17 3.89-17.61 14-18.68 16.07a27.91 27.91 0 00-12.7-.75c-11.75 2.16-15.82 11.61-28.77 19.43a62.31 62.31 0 01-20.93 7.85h199.54c.21-1.14 2-11.54-5.62-19.8-8.13-8.86-19.65-7.25-20.55-7.1-.24-2.07-2.67-20.34-19.14-29.79-13.75-7.89-27.59-4.07-30.92-3.09z",
                                fill: "url(#linear-gradient)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M281.14 34.8a52.1 52.1 0 0128.24 21 39 39 0 0123.23 0c14.84 4.75 21.47 17 22.77 19.59a34 34 0 0115.49-.91c14.31 2.63 19.27 14.11 35.07 23.68a75.76 75.76 0 0025.5 9.57H188.21c-.26-1.39-2.41-14.07 6.84-24.14 9.92-10.8 24-8.83 25-8.66.3-2.52 3.26-24.78 23.34-36.3 16.82-9.63 33.68-5.02 37.75-3.83z",
                                fill: "url(#linear-gradient-2)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-4",
                                d: "M118.71 264.49l-2.65-2.66a509.36 509.36 0 0070.25-87.4 509.23 509.23 0 0057.44-125.07l3.6 1.1a513.26 513.26 0 01-57.87 126 513.28 513.28 0 01-70.77 88.03z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M238.24 165.66l-88.64.34a6.53 6.53 0 01-5.13-3.07 91.69 91.69 0 01-.57-89.34 6.53 6.53 0 015.1-3.1l89.05-.34c1.84 0 2.49 1.36 1.53 3.07a91.74 91.74 0 00.16 89.34c.97 1.72.33 3.1-1.5 3.1z",
                                fill: "url(#linear-gradient-3)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M149.52 159.55a91.75 91.75 0 01-.5-82.63l81.91-.32a91.72 91.72 0 00.17 82.63z",
                                fill: "#e6fcff"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M152 139.06a217.27 217.27 0 0116.17-19.35 270.57 270.57 0 0021.13 19.19z",
                                fill: "url(#linear-gradient-4)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M165.12 139a226.29 226.29 0 0121.82-25.16 264.7 264.7 0 0026.61 25z",
                                fill: "#0052cc"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M175.27 99.13c-.75 3.6-4 6.57-7.49 6.58a5.26 5.26 0 01-5.28-6.53 8.62 8.62 0 018-6.5c3.5-.02 5.5 2.84 4.77 6.45z",
                                fill: "#ffab00"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-4",
                                d: "M476.06 385.69c0-19-35.86-35.51-88-43.44a91.08 91.08 0 01-34.27-12.67C320.42 309 251 294.77 170.65 294.77 57.91 294.77 0 322.73 0 357.22c0 17 22.25 32.45 58.32 43.71 7.08 2.21 10.11 16.77 5.82 27a16 16 0 00-1.29 6.21c0 26.77 37.45 48.47 124.94 48.47 86.36 0 156.58-21.15 158.39-47.44a2.18 2.18 0 011.81-1.93 8.39 8.39 0 011-.06c59.22-3.84 127.07-27.68 127.07-47.49z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M476.06 385.69c0-19-35.86-35.51-88-43.44a91.08 91.08 0 01-34.27-12.67C320.42 309 251 294.77 170.65 294.77 57.91 294.77 0 322.73 0 357.22c0 17 22.25 32.45 58.32 43.71 7.08 2.21 10.11 16.77 5.82 27a16 16 0 00-1.29 6.21c0 26.77 37.45 48.47 124.94 48.47 86.36 0 156.58-21.15 158.39-47.44a2.18 2.18 0 011.81-1.93 8.39 8.39 0 011-.06c59.22-3.84 127.07-27.68 127.07-47.49z",
                                opacity: ".4",
                                fill: "#79e2f2"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M6.25 358.05z",
                                fill: "url(#linear-gradient-5)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M10.57 363.88a34.13 34.13 0 01-4.19-5.61 34.13 34.13 0 004.19 5.61z",
                                fill: "url(#linear-gradient-6)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M69.18 403.31c0-.11 0-.21-.05-.32.02.11.03.21.05.32z",
                                fill: "url(#linear-gradient-7)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M63.81 392.36l-.39-.3z",
                                fill: "url(#linear-gradient-8)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M67.44 397l-.22-.43z",
                                fill: "url(#linear-gradient-9)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M68.24 399l-.06-.19z",
                                fill: "url(#linear-gradient-10)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M68.83 401.28c0-.17-.07-.33-.1-.5.03.22.07.33.1.5z",
                                fill: "url(#linear-gradient-11)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M69.36 405.62z",
                                fill: "url(#linear-gradient-12)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M52.78 387.47l-.54-.15z",
                                fill: "url(#linear-gradient-13)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M56.85 388.76l-.36-.12z",
                                fill: "url(#linear-gradient-14)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M54.69 388l-.45-.13z",
                                fill: "url(#linear-gradient-15)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M60.44 390.25l-.28-.13z",
                                fill: "url(#linear-gradient-16)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M62.35 391.32l-.38-.23z",
                                fill: "url(#linear-gradient-17)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M58.76 389.5l-.51-.21z",
                                fill: "url(#linear-gradient-18)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M66.5 395.35l-.3-.44z",
                                fill: "url(#linear-gradient-19)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M3.16 347.11a20.58 20.58 0 00.13 2.24 20.58 20.58 0 01-.13-2.24z",
                                fill: "url(#linear-gradient-20)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M261.42 301.27a609.78 609.78 0 00-90.77-6.5c-46.73 0-84 4.81-111.68 12.89 51-4.09 112.85-6.49 179.48-6.49q11.55 0 22.97.1z",
                                fill: "url(#linear-gradient-21)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M72.61 389.43c13.52 1.46 23-7.28 24.46-8.66a31.57 31.57 0 0018.2 9.25 28.77 28.77 0 006.33.13L131.82 373c-46.35-1.93-87.72-5.09-121.25-9.13a59.82 59.82 0 0010.28 8.71 120.25 120.25 0 0022.79 12.05 68.6 68.6 0 006.89 2.19 39.55 39.55 0 006.15-4.29 30.07 30.07 0 0015.93 6.9z",
                                fill: "url(#linear-gradient-22)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M155.07 392.74c2.57 1.87 4.48 3.74 4.48 5.61a412.84 412.84 0 01-90.34 11.72 28.54 28.54 0 01-1.91 7.77 16 16 0 00-1.3 6.21c0 26.77 37.45 48.47 124.94 48.47s158.43-21.7 158.43-48.47v-.78c63.6-3.54 113.92-18.7 126.69-38-.21-7.4-5.85-14.4-15.75-20.65-29.28 3.34-64.08 6-102.68 7.86l17.73 29.73L301.4 385l-56.53 77.4-48.33-66.17.86-13.31z",
                                fill: "url(#linear-gradient-23)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M5.12 355.81q-.33-.71-.6-1.44.27.74.6 1.44z",
                                fill: "url(#linear-gradient-24)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M69.37 407.61v.37c-.01-.13-.01-.25 0-.37z",
                                fill: "url(#linear-gradient-25)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M192.24 426.24a32 32 0 004.63-3.2 31.16 31.16 0 003.95-3.93q-1.92-3.23-3.81-6.79c-.87-1.64-1.68-3.25-2.46-4.83-.25.51-.53 1.05-.88 1.63-.56.89-1.11 1.81-1.67 2.75q-1.16 2-2.22 3.85a33.81 33.81 0 011.82 5.95 34.18 34.18 0 01.64 4.57z",
                                fill: "url(#linear-gradient-26)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M3.67 351.54q-.17-.74-.27-1.5.11.77.27 1.5z",
                                fill: "url(#linear-gradient-27)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M3.31 344.19c0-.32.08-.63.12-.95-.04.32-.09.63-.12.95z",
                                fill: "url(#linear-gradient-28)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M4.27 353.68c-.15-.46-.29-.92-.41-1.39.14.47.26.93.41 1.39z",
                                fill: "url(#linear-gradient-29)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M244.87 375.15v87.25L301.4 385l-42.82-9.94q-6.82.07-13.71.09z",
                                fill: "url(#linear-gradient-30)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M244.87 375.15v87.25L301.4 385l-42.82-9.94q-6.82.07-13.71.09z",
                                fill: "url(#linear-gradient-31)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M238.45 375.16h-7.57l-33.48 7.77c-.25 4.19-.56 9.21-.86 13.31l48.33 66.17v-87.26z",
                                fill: "url(#linear-gradient-32)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M238.45 375.16h-7.57l-33.48 7.77c-.25 4.19-.56 9.21-.86 13.31l48.33 66.17v-87.26z",
                                fill: "url(#linear-gradient-33)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M185.45 381.74l.15-.48-.28-.39c.04.29.09.58.13.87z",
                                fill: "url(#linear-gradient-34)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M185.45 381.74l.15-.48-.28-.39c.04.29.09.58.13.87z",
                                fill: "url(#linear-gradient-35)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M131.82 373l-10.22 17.15c11.14-.95 18.69-8 19.85-9.09 0 3.89 8.26 7.79 13.62 11.68l18.15-4.21c.43-5 1-9.48 1.7-14.12q-22.15-.52-43.1-1.41z",
                                fill: "url(#linear-gradient-36)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M131.82 373l-10.22 17.15c11.14-.95 18.69-8 19.85-9.09 0 3.89 8.26 7.79 13.62 11.68l18.15-4.21c.43-5 1-9.48 1.7-14.12q-22.15-.52-43.1-1.41z",
                                fill: "url(#linear-gradient-37)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M185.32 380.87l.28.39c.7-2.2 1.39-4.4 2.06-6.58l-3.28-.06c.31 2.08.62 4.17.94 6.25z",
                                fill: "url(#linear-gradient-38)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M185.32 380.87l.28.39c.7-2.2 1.39-4.4 2.06-6.58l-3.28-.06c.31 2.08.62 4.17.94 6.25z",
                                fill: "url(#linear-gradient-39)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M185.32 380.87l.28.39c.7-2.2 1.39-4.4 2.06-6.58l-3.28-.06c.31 2.08.62 4.17.94 6.25z",
                                fill: "url(#linear-gradient-40)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M197.86 375c-.07 1.14-.24 4.2-.46 7.93l33.48-7.77q-16.74 0-33-.29a.57.57 0 00-.02.13z",
                                fill: "url(#linear-gradient-41)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M197.86 375c-.07 1.14-.24 4.2-.46 7.93l33.48-7.77q-16.74 0-33-.29a.57.57 0 00-.02.13z",
                                fill: "url(#linear-gradient-42)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M197.86 375c-.07 1.14-.24 4.2-.46 7.93l33.48-7.77q-16.74 0-33-.29a.57.57 0 00-.02.13z",
                                fill: "url(#linear-gradient-43)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M197.86 375a.57.57 0 010-.13 1679 1679 0 01-10.21-.18c-.67 2.18-1.36 4.38-2.06 6.58l-.15.48c0-.29-.09-.58-.13-.87-.31-2.08-.63-4.17-.94-6.25-3.17-.06-6.33-.13-9.46-.21-.67 4.64-1.27 9.14-1.7 14.12l24.18-5.61c.23-3.74.4-6.8.47-7.93z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M197.86 375a.57.57 0 010-.13 1679 1679 0 01-10.21-.18c-.67 2.18-1.36 4.38-2.06 6.58l-.15.48c0-.29-.09-.58-.13-.87-.31-2.08-.63-4.17-.94-6.25-3.17-.06-6.33-.13-9.46-.21-.67 4.64-1.27 9.14-1.7 14.12l24.18-5.61c.23-3.74.4-6.8.47-7.93z",
                                fill: "url(#linear-gradient-44)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M301.4 385l73.93 17.16-17.73-29.71q-23.31 1.11-48.32 1.78z",
                                fill: "url(#linear-gradient-45)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M301.4 385l73.93 17.16-17.73-29.71q-23.31 1.11-48.32 1.78z",
                                fill: "url(#linear-gradient-46)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M258.58 375.08L301.4 385l7.88-10.79c-16.45.46-33.39.79-50.7.87z",
                                fill: "url(#linear-gradient-47)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M258.58 375.08L301.4 385l7.88-10.79c-16.45.46-33.39.79-50.7.87z",
                                fill: "url(#linear-gradient-48)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M258.58 375.08L301.4 385l7.88-10.79c-16.45.46-33.39.79-50.7.87z",
                                fill: "url(#linear-gradient-49)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M357.6 372.45c38.6-1.83 73.4-4.52 102.68-7.86-12.11-7.65-30.58-14.18-53.33-18.94-12.88 3.28-33.93 6.1-60.46 8.17z",
                                fill: "url(#linear-gradient-50)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M357.6 372.45c38.6-1.83 73.4-4.52 102.68-7.86-12.11-7.65-30.58-14.18-53.33-18.94-12.88 3.28-33.93 6.1-60.46 8.17z",
                                fill: "url(#linear-gradient-51)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M3.86 352.29c-.07-.25-.14-.5-.19-.75.05.25.12.46.19.75z",
                                fill: "url(#linear-gradient-52)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M4.52 354.37z",
                                fill: "url(#linear-gradient-53)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M5.36 356.36l-.24-.55z",
                                fill: "url(#linear-gradient-54)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M3.16 347.11z",
                                fill: "url(#linear-gradient-55)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M6.38 358.27c0-.08-.08-.15-.13-.22s.08.14.13.22z",
                                fill: "url(#linear-gradient-56)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M3.44 343.18v.06a.64.64 0 000-.07z",
                                fill: "url(#linear-gradient-57)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                fill: "url(#linear-gradient-58)",
                                opacity: ".9",
                                d: "M10.57 363.88z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M3.4 350c0-.22-.08-.45-.11-.68.03.27.07.5.11.68z",
                                fill: "url(#linear-gradient-59)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M142.74 354.71c-52.13-3.42-86.87-9.55-86.87-16.55 0-10.73 81.74-19.43 182.58-19.43 37.22 0 71.81 1.19 100.68 3.23-19.64-8.77-46.39-15.93-77.71-20.69q-11.38-.11-23-.1c-66.63 0-128.45 2.4-179.48 6.49-29.73 8.69-48.32 21.15-55.52 35.51a.64.64 0 010 .07c0 .32-.09.63-.12.95-.09 1-.15 1.94-.15 2.92a20.58 20.58 0 00.13 2.24c0 .23.07.46.11.68q.11.76.27 1.5c.05.25.12.5.19.75.12.47.26.93.41 1.39.08.23.16.46.25.69q.27.74.6 1.44l.24.55c.28.57.58 1.13.89 1.69 0 .07.08.14.13.22a34.13 34.13 0 004.19 5.61c33.53 4 74.9 7.2 121.25 9.13z",
                                fill: "url(#linear-gradient-60)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M142.74 354.71c-52.13-3.42-86.87-9.55-86.87-16.55 0-10.73 81.74-19.43 182.58-19.43 37.22 0 71.81 1.19 100.68 3.23-19.64-8.77-46.39-15.93-77.71-20.69q-11.38-.11-23-.1c-66.63 0-128.45 2.4-179.48 6.49-29.73 8.69-48.32 21.15-55.52 35.51a.64.64 0 010 .07c0 .32-.09.63-.12.95-.09 1-.15 1.94-.15 2.92a20.58 20.58 0 00.13 2.24c0 .23.07.46.11.68q.11.76.27 1.5c.05.25.12.5.19.75.12.47.26.93.41 1.39.08.23.16.46.25.69q.27.74.6 1.44l.24.55c.28.57.58 1.13.89 1.69 0 .07.08.14.13.22a34.13 34.13 0 004.19 5.61c33.53 4 74.9 7.2 121.25 9.13z",
                                fill: "url(#linear-gradient-61)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M244.87 375.15q6.88 0 13.71-.07l-13.71-3.18z",
                                fill: "url(#linear-gradient-62)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M244.87 375.15q6.88 0 13.71-.07l-13.71-3.18z",
                                fill: "url(#linear-gradient-63)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M244.87 375.15q6.88 0 13.71-.07l-13.71-3.18z",
                                fill: "url(#linear-gradient-64)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M230.88 375.15h14v-3.25z",
                                fill: "url(#linear-gradient-65)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M230.88 375.15h14v-3.25z",
                                fill: "url(#linear-gradient-66)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M230.88 375.15h14v-3.25z",
                                fill: "url(#linear-gradient-67)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M175.85 367.91l-8.66-11.85c-8.5-.39-16.67-.84-24.45-1.35L131.82 373q20.91.87 43.1 1.4c.3-2.1.62-4.24.93-6.49z",
                                fill: "url(#linear-gradient-68)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M175.85 367.91l-8.66-11.85c-8.5-.39-16.67-.84-24.45-1.35L131.82 373q20.91.87 43.1 1.4c.3-2.1.62-4.24.93-6.49z",
                                fill: "url(#linear-gradient-69)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M175.85 367.91l-8.66-11.85c-8.5-.39-16.67-.84-24.45-1.35L131.82 373q20.91.87 43.1 1.4c.3-2.1.62-4.24.93-6.49z",
                                fill: "url(#linear-gradient-70)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M177.36 356.48q-5.16-.19-10.17-.42l8.66 11.85a2.36 2.36 0 000-.28c.48-3.06.98-6.81 1.51-11.15z",
                                fill: "url(#linear-gradient-71)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M177.36 356.48q-5.16-.19-10.17-.42l8.66 11.85a2.36 2.36 0 000-.28c.48-3.06.98-6.81 1.51-11.15z",
                                fill: "url(#linear-gradient-72)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M177.36 356.48q-5.16-.19-10.17-.42l8.66 11.85a2.36 2.36 0 000-.28c.48-3.06.98-6.81 1.51-11.15z",
                                fill: "url(#linear-gradient-73)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M177.36 356.48q-5.16-.19-10.17-.42l8.66 11.85a2.36 2.36 0 000-.28c.48-3.06.98-6.81 1.51-11.15z",
                                fill: "url(#linear-gradient-74)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M206.52 357.3l-7.39-.16-1.26 17.72q16.26.24 33 .29l14-3.25z",
                                fill: "url(#linear-gradient-75)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M206.52 357.3l-7.39-.16-1.26 17.72q16.26.24 33 .29l14-3.25z",
                                fill: "url(#linear-gradient-76)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M206.52 357.3l-7.39-.16-1.26 17.72q16.26.24 33 .29l14-3.25z",
                                fill: "url(#linear-gradient-77)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M206.52 357.3l-7.39-.16-1.26 17.72q16.26.24 33 .29l14-3.25z",
                                fill: "url(#linear-gradient-78)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M190.78 356.92l-5-.15a53.37 53.37 0 01.08 8.34 45.13 45.13 0 01-1.57 8.64c.05.29.09.58.13.87l3.28.06.55-1.75q1.25-8.01 2.53-16.01z",
                                fill: "url(#linear-gradient-79)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M190.78 356.92l-5-.15a53.37 53.37 0 01.08 8.34 45.13 45.13 0 01-1.57 8.64c.05.29.09.58.13.87l3.28.06.55-1.75q1.25-8.01 2.53-16.01z",
                                fill: "url(#linear-gradient-80)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M190.78 356.92l-5-.15a53.37 53.37 0 01.08 8.34 45.13 45.13 0 01-1.57 8.64c.05.29.09.58.13.87l3.28.06.55-1.75q1.25-8.01 2.53-16.01z",
                                fill: "url(#linear-gradient-81)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M190.78 356.92l-5-.15a53.37 53.37 0 01.08 8.34 45.13 45.13 0 01-1.57 8.64c.05.29.09.58.13.87l3.28.06.55-1.75q1.25-8.01 2.53-16.01z",
                                fill: "url(#linear-gradient-82)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M185.82 365.11a53.37 53.37 0 00-.08-8.34l-8.38-.29c-.53 4.34-1 8.09-1.47 11.15a2.36 2.36 0 010 .28c-.31 2.25-.63 4.39-.93 6.5 3.13.08 6.29.15 9.46.21 0-.29-.08-.58-.13-.87a45.13 45.13 0 001.53-8.64z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M185.82 365.11a53.37 53.37 0 00-.08-8.34l-8.38-.29c-.53 4.34-1 8.09-1.47 11.15a2.36 2.36 0 010 .28c-.31 2.25-.63 4.39-.93 6.5 3.13.08 6.29.15 9.46.21 0-.29-.08-.58-.13-.87a45.13 45.13 0 001.53-8.64z",
                                fill: "url(#linear-gradient-83)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M185.82 365.11a53.37 53.37 0 00-.08-8.34l-8.38-.29c-.53 4.34-1 8.09-1.47 11.15a2.36 2.36 0 010 .28c-.31 2.25-.63 4.39-.93 6.5 3.13.08 6.29.15 9.46.21 0-.29-.08-.58-.13-.87a45.13 45.13 0 001.53-8.64z",
                                fill: "url(#linear-gradient-84)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M190.78 356.92q-1.28 8-2.57 16l-.55 1.75c3.39.07 6.78.13 10.21.18l1.26-17.72z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M190.78 356.92q-1.28 8-2.57 16l-.55 1.75c3.39.07 6.78.13 10.21.18l1.26-17.72z",
                                fill: "url(#linear-gradient-85)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M190.78 356.92q-1.28 8-2.57 16l-.55 1.75c3.39.07 6.78.13 10.21.18l1.26-17.72z",
                                fill: "url(#linear-gradient-86)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M206.52 357.3l38.35 14.6 39.18-14.9c-14.58.4-29.86.61-45.6.61-10.89-.02-21.56-.12-31.93-.31z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M206.52 357.3l38.35 14.6 39.18-14.9c-14.58.4-29.86.61-45.6.61-10.89-.02-21.56-.12-31.93-.31z",
                                fill: "url(#linear-gradient-87)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M323.05 355.38l-13.77 18.85q25-.66 48.32-1.78l-11.11-18.63c-7.41.58-15.24 1.11-23.44 1.56z",
                                fill: "url(#linear-gradient-88)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M323.05 355.38l-13.77 18.85q25-.66 48.32-1.78l-11.11-18.63c-7.41.58-15.24 1.11-23.44 1.56z",
                                fill: "url(#linear-gradient-89)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M323.05 355.38l-13.77 18.85q25-.66 48.32-1.78l-11.11-18.63c-7.41.58-15.24 1.11-23.44 1.56z",
                                fill: "url(#linear-gradient-90)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M244.87 371.9l13.71 3.18c17.31-.13 34.25-.41 50.7-.85l13.77-18.85c-12.25.69-25.31 1.23-39 1.6z",
                                fill: "url(#linear-gradient-91)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M244.87 371.9l13.71 3.18c17.31-.13 34.25-.41 50.7-.85l13.77-18.85c-12.25.69-25.31 1.23-39 1.6z",
                                fill: "url(#linear-gradient-92)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M244.87 371.9l13.71 3.18c17.31-.13 34.25-.41 50.7-.85l13.77-18.85c-12.25.69-25.31 1.23-39 1.6z",
                                fill: "url(#linear-gradient-93)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M244.87 371.9l13.71 3.18c17.31-.13 34.25-.41 50.7-.85l13.77-18.85c-12.25.69-25.31 1.23-39 1.6z",
                                fill: "url(#linear-gradient-94)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M55.87 338.16c0 7 34.74 13.13 86.87 16.55l2.86-4.81c-31.4-2.81-51.36-7-51.36-11.74 0-8.47 64.56-15.34 144.21-15.34 46.32 0 87.52 2.32 113.9 5.94a125.83 125.83 0 00-13.22-6.8c-28.87-2-63.46-3.23-100.68-3.23-100.84 0-182.58 8.7-182.58 19.43z",
                                fill: "url(#linear-gradient-95)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M55.87 338.16c0 7 34.74 13.13 86.87 16.55l2.86-4.81c-31.4-2.81-51.36-7-51.36-11.74 0-8.47 64.56-15.34 144.21-15.34 46.32 0 87.52 2.32 113.9 5.94a125.83 125.83 0 00-13.22-6.8c-28.87-2-63.46-3.23-100.68-3.23-100.84 0-182.58 8.7-182.58 19.43z",
                                fill: "url(#linear-gradient-96)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M55.87 338.16c0 7 34.74 13.13 86.87 16.55l2.86-4.81c-31.4-2.81-51.36-7-51.36-11.74 0-8.47 64.56-15.34 144.21-15.34 46.32 0 87.52 2.32 113.9 5.94a125.83 125.83 0 00-13.22-6.8c-28.87-2-63.46-3.23-100.68-3.23-100.84 0-182.58 8.7-182.58 19.43z",
                                fill: "url(#linear-gradient-97)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M346.49 353.82c26.53-2.07 47.58-4.89 60.46-8.17q-9-1.89-18.93-3.4c-2.52-.38-5-.89-7.47-1.49-4.88 3-18.12 5.77-37.13 7.92z",
                                fill: "url(#linear-gradient-98)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M346.49 353.82c26.53-2.07 47.58-4.89 60.46-8.17q-9-1.89-18.93-3.4c-2.52-.38-5-.89-7.47-1.49-4.88 3-18.12 5.77-37.13 7.92z",
                                fill: "url(#linear-gradient-99)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M346.49 353.82c26.53-2.07 47.58-4.89 60.46-8.17q-9-1.89-18.93-3.4c-2.52-.38-5-.89-7.47-1.49-4.88 3-18.12 5.77-37.13 7.92z",
                                fill: "url(#linear-gradient-100)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M163.71 351.29q-9.57-.62-18.11-1.39l-2.86 4.81c7.78.51 15.95 1 24.45 1.35z",
                                fill: "url(#linear-gradient-101)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M163.71 351.29q-9.57-.62-18.11-1.39l-2.86 4.81c7.78.51 15.95 1 24.45 1.35z",
                                fill: "url(#linear-gradient-102)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M163.71 351.29q-9.57-.62-18.11-1.39l-2.86 4.81c7.78.51 15.95 1 24.45 1.35z",
                                fill: "url(#linear-gradient-103)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M163.71 351.29q-9.57-.62-18.11-1.39l-2.86 4.81c7.78.51 15.95 1 24.45 1.35z",
                                fill: "url(#linear-gradient-104)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-105)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-106)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-107)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-108)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M199.13 357.14l7.39.16-7.2-2.75c-.06.86-.12 1.73-.19 2.59z",
                                fill: "url(#linear-gradient-109)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-110)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-111)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-112)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-113)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M177.87 352.09c-4.87-.24-9.6-.51-14.16-.8l3.48 4.77q5 .22 10.17.42c.17-1.4.34-2.87.51-4.39z",
                                fill: "url(#linear-gradient-114)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-115)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-116)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-117)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-118)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M185.55 352.44c0 1.64.11 3 .19 4.33l5 .15.69-4.25z",
                                fill: "url(#linear-gradient-119)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M177.87 352.09c-.17 1.52-.34 3-.51 4.39l8.38.29c-.08-1.29-.15-2.69-.19-4.33z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M177.87 352.09c-.17 1.52-.34 3-.51 4.39l8.38.29c-.08-1.29-.15-2.69-.19-4.33z",
                                fill: "url(#linear-gradient-120)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M177.87 352.09c-.17 1.52-.34 3-.51 4.39l8.38.29c-.08-1.29-.15-2.69-.19-4.33z",
                                fill: "url(#linear-gradient-121)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M177.87 352.09c-.17 1.52-.34 3-.51 4.39l8.38.29c-.08-1.29-.15-2.69-.19-4.33z",
                                fill: "url(#linear-gradient-122)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M194.68 352.79l-3.21-.12-.69 4.25 8.35.22c.07-.86.13-1.73.19-2.59z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M194.68 352.79l-3.21-.12-.69 4.25 8.35.22c.07-.86.13-1.73.19-2.59z",
                                fill: "url(#linear-gradient-123)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M194.68 352.79l-3.21-.12-.69 4.25 8.35.22c.07-.86.13-1.73.19-2.59z",
                                fill: "url(#linear-gradient-124)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M194.68 352.79l-3.21-.12-.69 4.25 8.35.22c.07-.86.13-1.73.19-2.59z",
                                fill: "url(#linear-gradient-125)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M194.68 352.79l4.64 1.76 7.2 2.75c10.37.19 21 .29 31.93.29 15.74 0 31-.21 45.6-.61l12.54-4.77c-17.79.83-37.45 1.3-58.14 1.3-15.26 0-29.96-.26-43.77-.72z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M194.68 352.79l4.64 1.76 7.2 2.75c10.37.19 21 .29 31.93.29 15.74 0 31-.21 45.6-.61l12.54-4.77c-17.79.83-37.45 1.3-58.14 1.3-15.26 0-29.96-.26-43.77-.72z",
                                fill: "url(#linear-gradient-126)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M194.68 352.79l4.64 1.76 7.2 2.75c10.37.19 21 .29 31.93.29 15.74 0 31-.21 45.6-.61l12.54-4.77c-17.79.83-37.45 1.3-58.14 1.3-15.26 0-29.96-.26-43.77-.72z",
                                fill: "url(#linear-gradient-127)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M323.05 355.38c8.2-.45 16-1 23.44-1.56l-3.07-5.14q-7.73.87-16.65 1.61z",
                                fill: "url(#linear-gradient-128)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M323.05 355.38c8.2-.45 16-1 23.44-1.56l-3.07-5.14q-7.73.87-16.65 1.61z",
                                fill: "url(#linear-gradient-129)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M323.05 355.38c8.2-.45 16-1 23.44-1.56l-3.07-5.14q-7.73.87-16.65 1.61z",
                                fill: "url(#linear-gradient-130)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M323.05 355.38c8.2-.45 16-1 23.44-1.56l-3.07-5.14q-7.73.87-16.65 1.61z",
                                fill: "url(#linear-gradient-131)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-132)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-133)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-134)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-135)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M296.59 352.21L284.05 357c13.69-.37 26.75-.91 39-1.6l3.72-5.09c-9.23.74-19.36 1.39-30.18 1.9z",
                                fill: "url(#linear-gradient-136)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M94.24 338.16c0 4.71 20 8.93 51.36 11.74l3.64-6.1c-17.85-1.51-28.67-3.48-28.67-5.64 0-4.77 52.78-8.64 117.88-8.64s117.87 3.87 117.87 8.64c0 1.61-6.05 3.12-16.55 4.41l3.65 6.11c19-2.15 32.25-4.88 37.13-7.92a91.39 91.39 0 01-26.8-11.18c-.45-.28-.93-.55-1.4-.82-26.38-3.62-67.58-5.94-113.9-5.94-79.65 0-144.21 6.87-144.21 15.34z",
                                fill: "url(#linear-gradient-137)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M94.24 338.16c0 4.71 20 8.93 51.36 11.74l3.64-6.1c-17.85-1.51-28.67-3.48-28.67-5.64 0-4.77 52.78-8.64 117.88-8.64s117.87 3.87 117.87 8.64c0 1.61-6.05 3.12-16.55 4.41l3.65 6.11c19-2.15 32.25-4.88 37.13-7.92a91.39 91.39 0 01-26.8-11.18c-.45-.28-.93-.55-1.4-.82-26.38-3.62-67.58-5.94-113.9-5.94-79.65 0-144.21 6.87-144.21 15.34z",
                                fill: "url(#linear-gradient-138)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M94.24 338.16c0 4.71 20 8.93 51.36 11.74l3.64-6.1c-17.85-1.51-28.67-3.48-28.67-5.64 0-4.77 52.78-8.64 117.88-8.64s117.87 3.87 117.87 8.64c0 1.61-6.05 3.12-16.55 4.41l3.65 6.11c19-2.15 32.25-4.88 37.13-7.92a91.39 91.39 0 01-26.8-11.18c-.45-.28-.93-.55-1.4-.82-26.38-3.62-67.58-5.94-113.9-5.94-79.65 0-144.21 6.87-144.21 15.34z",
                                fill: "url(#linear-gradient-139)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M94.24 338.16c0 4.71 20 8.93 51.36 11.74l3.64-6.1c-17.85-1.51-28.67-3.48-28.67-5.64 0-4.77 52.78-8.64 117.88-8.64s117.87 3.87 117.87 8.64c0 1.61-6.05 3.12-16.55 4.41l3.65 6.11c19-2.15 32.25-4.88 37.13-7.92a91.39 91.39 0 01-26.8-11.18c-.45-.28-.93-.55-1.4-.82-26.38-3.62-67.58-5.94-113.9-5.94-79.65 0-144.21 6.87-144.21 15.34z",
                                fill: "url(#linear-gradient-140)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-141)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-142)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-143)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-144)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M158.77 344.53c-3.37-.23-6.54-.47-9.53-.73l-3.64 6.1q8.53.77 18.11 1.39z",
                                fill: "url(#linear-gradient-145)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-146)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-147)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-148)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-149)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-150)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M178.47 346.61l-3-1.15c-5.94-.27-11.53-.59-16.68-.93l4.94 6.76c4.56.29 9.29.56 14.16.8.18-1.74.38-3.58.58-5.48z",
                                fill: "url(#linear-gradient-151)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-152)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-153)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-154)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-155)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-156)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M185.55 352.44l5.92.23c.05-.35.11-.7.16-1l-6.1-2.33v1c-.01.66 0 1.42.02 2.1z",
                                fill: "url(#linear-gradient-157)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z",
                                fill: "url(#linear-gradient-158)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z",
                                fill: "url(#linear-gradient-159)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z",
                                fill: "url(#linear-gradient-160)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M185.52 350.27v-1l-7.06-2.69c-.2 1.9-.4 3.74-.6 5.48l7.68.35c-.01-.65-.02-1.41-.02-2.14z",
                                fill: "url(#linear-gradient-161)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z",
                                fill: "url(#linear-gradient-162)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z",
                                fill: "url(#linear-gradient-163)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z",
                                fill: "url(#linear-gradient-164)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M194.68 352.79l-3.05-1.16c0 .34-.11.69-.16 1z",
                                fill: "url(#linear-gradient-165)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M238.45 346.8c-23.18 0-44.78-.49-63-1.34l3 1.15 7.06 2.69 6.1 2.33 3.05 1.16c13.81.46 28.51.72 43.77.72 20.69 0 40.35-.47 58.14-1.3l19.88-7.58c-20.77 1.37-48.07 2.17-78 2.17z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M238.45 346.8c-23.18 0-44.78-.49-63-1.34l3 1.15 7.06 2.69 6.1 2.33 3.05 1.16c13.81.46 28.51.72 43.77.72 20.69 0 40.35-.47 58.14-1.3l19.88-7.58c-20.77 1.37-48.07 2.17-78 2.17z",
                                fill: "url(#linear-gradient-166)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M238.45 346.8c-23.18 0-44.78-.49-63-1.34l3 1.15 7.06 2.69 6.1 2.33 3.05 1.16c13.81.46 28.51.72 43.77.72 20.69 0 40.35-.47 58.14-1.3l19.88-7.58c-20.77 1.37-48.07 2.17-78 2.17z",
                                fill: "url(#linear-gradient-167)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M238.45 346.8c-23.18 0-44.78-.49-63-1.34l3 1.15 7.06 2.69 6.1 2.33 3.05 1.16c13.81.46 28.51.72 43.77.72 20.69 0 40.35-.47 58.14-1.3l19.88-7.58c-20.77 1.37-48.07 2.17-78 2.17z",
                                fill: "url(#linear-gradient-168)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-169)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-170)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-171)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-172)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M326.77 350.29q8.91-.74 16.65-1.61l-3.65-6.11c-2.43.3-5.1.59-8 .87z",
                                fill: "url(#linear-gradient-173)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-174)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-175)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-176)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-177)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-178)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M296.59 352.21c10.82-.51 21-1.16 30.18-1.92l5-6.85c-4.58.43-9.7.83-15.31 1.19z",
                                fill: "url(#linear-gradient-179)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-180)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-181)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-182)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-183)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M244.87 337h91.59l3.31 5.55c10.5-1.29 16.55-2.8 16.55-4.41 0-4.77-52.77-8.64-117.87-8.64s-117.88 3.87-117.88 8.64c0 2.16 10.82 4.13 28.67 5.64l4-6.78z",
                                fill: "url(#linear-gradient-184)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-185)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-186)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-187)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-188)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-189)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M153.29 337l-4 6.78c3 .26 6.16.5 9.53.73z",
                                fill: "url(#linear-gradient-190)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-191)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-192)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-193)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-194)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-195)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-196)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M153.29 337l5.48 7.51c5.15.34 10.74.66 16.68.93z",
                                fill: "url(#linear-gradient-197)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-50",
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z",
                                fill: "url(#linear-gradient-198)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z",
                                fill: "url(#linear-gradient-199)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z",
                                fill: "url(#linear-gradient-200)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M238.45 346.8c29.93 0 57.23-.82 78-2.17l20-7.61H153.29l22.16 8.44c18.22.85 39.82 1.34 63 1.34z",
                                fill: "url(#linear-gradient-201)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-202)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-203)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-204)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-205)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-206)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M331.78 343.44c2.89-.28 5.56-.57 8-.87l-3.32-5.57z",
                                fill: "url(#linear-gradient-207)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-208)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-209)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-210)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-211)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-212)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-213)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M331.78 343.44l4.68-6.42-20 7.61c5.62-.36 10.74-.76 15.32-1.19z",
                                fill: "url(#linear-gradient-214)",
                                opacity: ".9"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M68.73 400.78z",
                                fill: "url(#radial-gradient)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M69.21 410.07z",
                                fill: "url(#radial-gradient-2)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M69.36 405.46c0-.72-.09-1.44-.18-2.15.09.69.15 1.43.18 2.15z",
                                fill: "url(#radial-gradient-3)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M69.13 403q-.12-.87-.3-1.71.17.83.3 1.71z",
                                fill: "url(#radial-gradient-4)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M69.36 405.62v2c.03-.68.03-1.34 0-2z",
                                fill: "url(#radial-gradient-5)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M63.81 392.36a12.87 12.87 0 011.23 1.1 13.64 13.64 0 011.16 1.45 13.64 13.64 0 00-1.2-1.45 12.87 12.87 0 00-1.19-1.1z",
                                fill: "url(#radial-gradient-6)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                className: "cls-228",
                                d: "M56.49 388.64z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M50.53 386.83l1.71.49-1.71-.49z",
                                fill: "url(#radial-gradient-8)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-230",
                                d: "M62 391.09q-.73-.45-1.53-.84.77.39 1.53.84z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M60.16 390.12z",
                                fill: "url(#radial-gradient-10)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                className: "cls-230",
                                d: "M58.25 389.29l-1.4-.53z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M68.18 398.84a15.81 15.81 0 00-.74-1.8 15.81 15.81 0 01.74 1.8z",
                                fill: "url(#radial-gradient-12)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M67.22 396.61a14.16 14.16 0 00-.72-1.26 14.16 14.16 0 01.72 1.26z",
                                fill: "url(#radial-gradient-13)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                className: "cls-228",
                                d: "M54.24 387.91l-1.46-.44z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M63.42 392.06z",
                                fill: "url(#radial-gradient-15)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M159.55 398.35c0-1.87-1.91-3.74-4.48-5.61l-40.65 9.44 7.18-12a28.77 28.77 0 01-6.33-.13 31.57 31.57 0 01-18.2-9.25c-1.46 1.38-10.94 10.12-24.46 8.66a30.07 30.07 0 01-15.93-6.89 39.55 39.55 0 01-6.15 4.29l1.71.49.54.15 1.46.44.45.13c.6.19 1.21.39 1.8.6l.36.12 1.4.53.51.21c.48.2.94.4 1.4.62l.28.13q.8.39 1.53.84l.38.23c.37.24.73.49 1.07.74l.39.3a12.87 12.87 0 011.23 1.1 13.64 13.64 0 011.16 1.45l.3.44a14.16 14.16 0 01.72 1.26l.22.43a15.81 15.81 0 01.74 1.8l.06.19c.18.57.35 1.15.49 1.75 0 .17.07.33.1.5q.18.84.3 1.71c0 .11 0 .21.05.32.09.71.15 1.43.18 2.15V408.02c0 .7-.07 1.4-.14 2.09a412.84 412.84 0 0090.33-11.76z",
                                fill: "url(#linear-gradient-215)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M141.45 381.06c-1.16 1.11-8.71 8.14-19.85 9.09l-7.18 12 40.65-9.44c-5.36-3.86-13.62-7.71-13.62-11.65z",
                                fill: "url(#linear-gradient-216)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M141.45 381.06c-1.16 1.11-8.71 8.14-19.85 9.09l-7.18 12 40.65-9.44c-5.36-3.86-13.62-7.71-13.62-11.65z",
                                fill: "url(#linear-gradient-217)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-230",
                                d: "M141.45 381.06c-1.16 1.11-8.71 8.14-19.85 9.09l-7.18 12 40.65-9.44c-5.36-3.86-13.62-7.71-13.62-11.65z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                fill: "url(#linear-gradient-218)",
                                d: "M245.54 265.79l-130.45-4.54 130.46 43.41L376 261.25l-130.46 4.54z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M239.61 200.11L154 337.73h91.59V198.21H243a4 4 0 00-3.39 1.9z",
                                fill: "url(#linear-gradient-219)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-240",
                                d: "M205.28 255.28l-3.12 5h43.39v-5h-40.27zM199.08 265.23l-3.11 5h49.58v-5h-46.47zM245.55 275.18h-52.66l-3.12 5h55.78v-5z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M251.49 200.11a4 4 0 00-3.41-1.9h-2.53v139.52h91.58z",
                                fill: "url(#linear-gradient-220)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-242",
                                d: "M245.55 255.28h20.27v5.01h-20.27zM245.55 265.23h20.27v5.01h-20.27zM245.55 275.18h4.98v5.01h-4.98z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M246.9 226.91a41 41 0 0120.1 4.17 34.66 34.66 0 004.89 1.76l-20.36-32.73a4 4 0 00-3.41-1.9h-2.53V227c.41 0 .85-.06 1.31-.09z",
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                style: {
                                    mixBlendMode: 'multiply'
                                },
                                fill: "url(#linear-gradient-221)",
                                opacity: ".1"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("ellipse", {
                                cx: "190.18",
                                cy: "308.96",
                                rx: "48.27",
                                ry: "5.8",
                                fill: "url(#linear-gradient-222)",
                                opacity: ".1"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M185.7 301.74a14 14 0 01.43 3.35 14.28 14.28 0 01-.31 3l-1.61.68-.34-.66-.57 1.09a14.39 14.39 0 01-3.08 1.26 8.93 8.93 0 01-2.56.42c-1.39 0-3.44-.35-3.53-1.06-.06-.44.67-.68 2.25-1.89a15.9 15.9 0 002.73-2.66 11.3 11.3 0 001.8-3.36l.3-.87z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M174.84 236.19c0 1.93-.39 5.85-.31 9.29.3 12.41.56 19.91 2 30.32.89 6.27 2.08 15.42 3.16 26.77a8.92 8.92 0 006.88-1c-.18-1.82-.4-4.76-.41-8.4 0-6.72.73-9.48.3-14.85a45.06 45.06 0 00-1.57-8.63q1.4-9.27 2.78-18.54a11.6 11.6 0 007-6.47 11.37 11.37 0 00-2.1-11.53z",
                                fill: "url(#linear-gradient-223)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-247",
                                d: "M196.05 302a13.43 13.43 0 00-.57 3.33 14 14 0 00.19 3l1.57.75.37-.65c.18.37.36.74.53 1.11a14.08 14.08 0 003 1.38 9.27 9.27 0 002.55.53c1.39.07 3.45-.21 3.57-.91.08-.44-.64-.71-2.18-2a16.49 16.49 0 01-2.62-2.77 11.21 11.21 0 01-1.65-3.44l-.27-.88zM192.04 238.74l-.09 4.58-8.74-4.11 8.83-.47zM191.79 237.53l1.88-.45 1.62-.19-1.63 2.37-1.87-1.73z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-247",
                                d: "M177.85 236.91q1.92 5.47 3.8 11.05 3.84 11.43 7.23 22.54l5.25 32.69 6.81-.95q-1.2-16.9-2.41-33.8c-.2-3.54-1.43-25.55-2-28.67-.1-.56-.25-1.09-.25-1.09a16.4 16.4 0 00-1.92-4.36l-1.25.63z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-4",
                                d: "M201.33 28.18l-16.94.27a13.73 13.73 0 00-13.51 13.94 13.73 13.73 0 0013.94 13.51h.78a8.27 8.27 0 018.09 5.82v.09c0 .06.11.06.12 0v-.09a8.28 8.28 0 017.9-6.08 13.71 13.71 0 0013.56-13.94 13.74 13.74 0 00-13.94-13.52zM384.25 141.53l-16.93.26a13.74 13.74 0 00-13.52 13.94 13.73 13.73 0 0013.94 13.51h.78a8.27 8.27 0 018.09 5.83v.08a.07.07 0 00.13 0v-.09a8.26 8.26 0 017.9-6.07A13.73 13.73 0 00398.19 155a13.73 13.73 0 00-13.94-13.47z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M228.71 128.46a89.94 89.94 0 00-10.59 37.28l20.12-.08c1.83 0 2.47-1.38 1.5-3.1a91.86 91.86 0 01-11.03-34.1z",
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                style: {
                                    mixBlendMode: 'multiply'
                                },
                                fill: "url(#linear-gradient-224)",
                                opacity: ".1"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-249",
                                d: "M238.24 165.66l-88.64.34a6.53 6.53 0 01-5.13-3.07 91.69 91.69 0 01-.57-89.34 6.53 6.53 0 015.1-3.1l89.05-.34c1.84 0 2.49 1.36 1.53 3.07a91.74 91.74 0 00.16 89.34c.97 1.72.33 3.1-1.5 3.1z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-242",
                                d: "M192.09 291.26l-3.44-1.53a612 612 0 0040.22-125.5A612.62 612.62 0 00241.27 45H245a615.38 615.38 0 01-12.47 120 615.64 615.64 0 01-40.44 126.26z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-250",
                                d: "M342.5 235.7c.15-.74.44-1 1.47-2.24l.88-1c2-2.42 2.53-3.68 3.34-3.68.57 0 .92 1 2 2.06 1.33 1.24 1.26 2 1.14 2.62-.18.85-2.92 4.06-4.43 4.51-.45.13-3 1.24-3.43 1-.93-.5-1.19-2.08-1-3.24"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M299.43 243.7c.3.22.77.55 1.34.92 1.68 1.08 8.57 2.84 10.74 3.75s12.52 3.33 14.57 3.06a6.65 6.65 0 001.78-.49l16.46-11.48-1.32-4.81c-7 3.08-11.64 5.5-18.65 8.58l-22.71-6.32-2.13 3.22z",
                                fill: "#2684ff"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M308.31 220.59c.57-.87 1.3-2.19.83-2.85s-1.42-.18-3.85-.08c-3.5.13-3.88-.47-5.65.09a6.82 6.82 0 00-3.52 2.44c-1.68 2.39-.9 5.38-.66 6.28a10 10 0 004.55 5.8l1.9 1.21 5.37-9.24z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M302.16 236.73h7.25a13.5 13.5 0 01-.78-8.17l-4.42-.21c-.06.26-.14.63-.27 1.08a3.75 3.75 0 01-.48 1.23 2.58 2.58 0 01-1.94.84c.21 1.74.42 3.49.64 5.23",
                                fill: "#543e36"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M302.9 314.33c0-.14-2.25-.5-2.26-.65-.29-4.21-1-23.6-1.6-28.34-.89-7.08-1.73-13.77-1.27-16.81.12-.84.81-4 1.21-5.72a13.39 13.39 0 01.55-1.84 15.28 15.28 0 01.92-2l.32-.58.64.19a14.22 14.22 0 001.59.4c.45.09.82.14 1.09.17h.24c1.39.21 4.13.54 11.84 1.13h.35l.22.27a21.75 21.75 0 011.48 2.08 24.5 24.5 0 013.11 7.49c4.6 18.9 5.37 21.45 5.48 21.76v.2c.3 1.71 2.17 11.12 2.46 12.86-2.31 1.89-4.35 1.51-7.73 1.29-1.63-3.1-6.21-12.94-7.84-16.07l-3.58-6.91c0 5.11.16 22.38.13 27.49-3.05 1.27-4.25 4.1-7.41 3.55",
                                fill: "#091e42"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M300.94 274.09a11.32 11.32 0 01-2.37-5 15 15 0 01.41-6.31 14.78 14.78 0 01.55-1.84 15.28 15.28 0 01.92-2l.32-.59.64.2c.52.16 1 .3 1.59.41s.82.13 1.09.16h.24c1.39.21 4.13.54 11.84 1.13h.35l.22.27a21.75 21.75 0 011.48 2.08c2.66 4.2 3.58 9.74 4.87 14.53q1.46 5.37 2.73 10.79c.21.9 2.63 8.75 1.94 9.31-2.31 1.9-5.73 2.44-9.12 2.22-1.62-3.1-3.25-6.19-4.88-9.32-2-3.78-3.64-7.36-6.79-10.31a57.06 57.06 0 01-6-5.8",
                                fill: "#253858"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-250",
                                d: "M308.31 220.59c.35.8.69 1.59 1 2.39l3.09 1.9c-.25.44-.5.88-.76 1.32l.27 4.75a11.78 11.78 0 01-3 1.6c-.42.14-.6.14-4.32.27-1.59.06-2.39.08-2.75-.36a2.08 2.08 0 01-.13-2c.24-.59.54-.54.82-1.12.43-.9-.11-1.42.17-2.27s.91-.67 1.9-1.71.9-1.95 2-3.35a6.5 6.5 0 011.69-1.45"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M311.67 226.2a1.23 1.23 0 01.4.53 1.14 1.14 0 010 .73 4.73 4.73 0 01-1.2.42 4.66 4.66 0 01-.92.09c0 .24.06.57.11 1 .14 1 .22 1.13.31 1.18.33.18 1-.2 1.28-.75a1.45 1.45 0 00.14-.64 2.26 2.26 0 01.7 1.13 2.29 2.29 0 01-.28 1.63 3 3 0 01-2.26 1.29h-.15c-4 .2-4.31.2-4.56.13-2.28-.69-2.12-7.66-2.12-8l2.54-1.52a3.32 3.32 0 00-.32 2.85c.09.21.55 1.39 1.5 1.58s1.5-.89 3.4-1.42a6.35 6.35 0 011.4-.24"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-250",
                                d: "M343 230.84s1.53 1.69.62 3.1c-.64 1 1.8 1.33 1.8 1.33a2.2 2.2 0 00.24-3.06c-1.29-1.77-2.66-2.34-2.66-1.37"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-4",
                                d: "M372.38 264.49a513.32 513.32 0 01-70.76-88 512.55 512.55 0 01-57.87-126l3.59-1.1a508.92 508.92 0 0057.45 125.07A509.3 509.3 0 00375 261.83z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-250",
                                d: "M348 228.66s-1.78 3.06-1.21 3.71 1.21-.08 1.21-.08-.73 1-.4 1.45 1.12-.32 1.12-.32-.64 1 0 1.37 1.05-.49 1.05-.49-.56 2.1 0 1.86 1.21-1 1.61-2.74-2-5.32-3.38-4.76M330.15 211.75c.29-.72-.1-1.12 0-3.88v-.51c0-1.44-.95-2-3.35-4.71-.59-.66-1.52-1.73-1.9-1.53a.67.67 0 00-.28.37c-.08.26.06.42 0 .53s-.55-.09-.73 0 .18 1.12.62 2.24c.8 2 .82 2.67.69 3.21 0 .13-.24.93-.7 1-.13 0-.3 0-.7-.34a8 8 0 01-1.14-1.27c-.52-.6-1.3-1.16-1.5-1s.13.53.27 1.39a13.9 13.9 0 010 1.62c.08.62.44 1 2.56 2.79a9.87 9.87 0 002.38 1.73 3.49 3.49 0 003.74-1.69"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M325.44 212.82c1.91 6.66 1 18.09 1 18.09s-13.3 3.32-16.49 3.61c0 0-6.81.64-10.54 2.5-.88.44-1.74.95-1.74.95-.47.28-.77.48-.77.48l-.1.06a4.93 4.93 0 00-1.9 5.56c.37 1.21.72 2.47 1.05 3.79a74.38 74.38 0 012.19 16.19 30.77 30.77 0 0021.17-1.62 99.26 99.26 0 01-1.49-11.3c-.18-2.33-.26-4.56-.28-6.67 2.38-.56 9.65-4.62 14.18-7.35a6.26 6.26 0 002.93-6.54c-1.15-6.13-2.93-16.42-4.23-19.47-3.12 1.12-4.98 1.72-4.98 1.72z",
                                fill: "url(#linear-gradient-225)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                fill: "url(#linear-gradient-226)",
                                d: "M376 261.25l-38.87 76.48-91.58-33.07L376 261.25z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-242",
                                d: "M318.63 280.34l-5 1.67v35.67h5v-37.34zM328.59 277.03l-5.01 1.66v38.99h5.01v-40.65zM338.54 273.72l-5.01 1.66v27h5.01v-28.66z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                fill: "url(#linear-gradient-227)",
                                d: "M337.13 337.73H153.96l91.59-33.07 91.58 33.07z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                fill: "url(#linear-gradient-228)",
                                d: "M245.55 304.66l-91.59 33.07-38.87-76.48 130.46 43.41z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M245.55 0a5 5 0 015 5v201.67h-5V0z",
                                fill: "#fafbfc"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                className: "cls-242",
                                d: "M245.54 0v206.67h-5V5a5 5 0 015-5z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M250 101.43a90.13 90.13 0 000 94.19h98.7a90.13 90.13 0 010-94.19z",
                                fill: "url(#linear-gradient-229)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M306.75 128.62a6.3 6.3 0 01-5.66-3.1c-.89-1.2-1.45-2-3.23-2s-2.81.78-4.33 2c-1.75 1.38-3.86 3.1-7.17 3.1a6.29 6.29 0 01-5.66-3.1c-.89-1.2-1.45-2-3.24-2s-2.8.78-4.32 2c-1.75 1.38-3.86 3.1-7.18 3.1a6.28 6.28 0 01-5.65-3.1c-.89-1.2-1.45-2-3.23-2 .37-1.27.76-2.52 1.18-3.77 3.31 0 4.46 1.68 5.44 3 .85 1.19 1.44 2 3.22 2s2.78-.79 4.34-2c1.78-1.37 4.06-3 7.38-3s4.47 1.68 5.45 3c.85 1.19 1.44 2 3.22 2s2.78-.79 4.34-2c1.78-1.37 4.06-3 7.38-3a5.86 5.86 0 015.45 3c.85 1.19 1.44 2 3.22 2s2.79-.79 4.35-2c1.78-1.37 4.07-3 7.38-3-.42 1.25-.81 2.5-1.17 3.77-1.78 0-2.82.78-4.34 2-1.74 1.38-3.85 3.1-7.17 3.1z"
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M304.88 140.51a7.32 7.32 0 01-6.08-3.15c-1.05-1.22-1.72-2-3.51-2s-2.7.8-4.05 2c-1.56 1.4-3.44 3.15-6.75 3.15a7.35 7.35 0 01-6.08-3.15c-1.05-1.22-1.72-2-3.51-2s-2.69.8-4 2c-1.56 1.4-3.44 3.15-6.75 3.15a7.35 7.35 0 01-6.08-3.15c-1-1.22-1.72-2-3.5-2 .19-1.3.41-2.58.66-3.87 3.31 0 4.7 1.73 5.86 3.13 1 1.22 1.71 2 3.49 2s2.68-.81 4.07-2c1.59-1.4 3.64-3.13 7-3.13s4.7 1.73 5.87 3.13c1 1.22 1.71 2 3.49 2s2.68-.81 4.07-2c1.6-1.4 3.64-3.13 7-3.13s4.71 1.73 5.87 3.13c1 1.22 1.71 2 3.49 2s2.69-.81 4.08-2c1.6-1.4 3.64-3.13 7-3.13-.24 1.29-.46 2.57-.65 3.87-1.78 0-2.71.8-4.06 2-1.73 1.4-3.61 3.15-6.93 3.15z"
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M304.61 152.52c-3.31 0-5.11-1.75-6.5-3.16-1.21-1.23-2-2-3.78-2s-2.58.81-3.78 2c-1.37 1.41-3 3.16-6.33 3.16s-5.11-1.75-6.5-3.16c-1.22-1.23-2-2-3.78-2s-2.59.81-3.78 2c-1.37 1.41-3 3.16-6.33 3.16s-5.11-1.75-6.5-3.16c-1.21-1.23-2-2-3.77-2 0-1.3.06-2.61.14-3.91 3.31 0 4.93 1.76 6.28 3.17 1.18 1.23 2 2 3.76 2s2.57-.81 3.8-2.05c1.41-1.4 3.22-3.16 6.54-3.16s4.93 1.76 6.29 3.16c1.18 1.24 2 2.05 3.76 2.05s2.57-.81 3.8-2.05c1.41-1.4 3.22-3.16 6.54-3.16s4.94 1.76 6.29 3.16c1.18 1.24 2 2.05 3.77 2.05s2.57-.81 3.8-2.05c1.41-1.41 3.22-3.16 6.54-3.16-.07 1.3-.12 2.61-.13 3.91-1.78 0-2.6.81-3.79 2-1.37 1.45-3.02 3.2-6.34 3.2z"
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M306 164.48c-3.32 0-5.35-1.74-6.92-3.13-1.38-1.23-2.27-2-4.06-2s-2.48.81-3.51 2c-1.18 1.4-2.59 3.14-5.91 3.14s-5.34-1.74-6.92-3.13c-1.38-1.23-2.27-2-4.05-2s-2.48.81-3.51 2c-1.18 1.4-2.59 3.14-5.91 3.14s-5.34-1.74-6.92-3.14c-1.38-1.22-2.26-2-4-2-.16-1.29-.29-2.59-.38-3.89 3.31 0 5.16 1.75 6.7 3.16 1.34 1.22 2.26 2 4 2s2.47-.81 3.53-2c1.22-1.41 2.8-3.16 6.12-3.16s5.17 1.75 6.71 3.16c1.34 1.22 2.25 2 4 2s2.46-.81 3.54-2a7.4 7.4 0 016.11-3.16c3.32 0 5.17 1.75 6.71 3.16 1.35 1.22 2.26 2 4 2s2.47-.81 3.53-2c1.22-1.41 2.8-3.16 6.12-3.16.1 1.3.23 2.6.38 3.89-1.78 0-2.48.81-3.51 2-1.18 1.38-2.59 3.12-5.85 3.12z"
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                                className: "cls-261",
                                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: "cls-262",
                                    d: "M297.21 171.16c-1.78 0-2.37.8-3.24 2-1 1.37-2.17 3.06-5.48 3.06s-5.58-1.69-7.35-3.06c-1.54-1.19-2.53-2-4.32-2s-2.37.8-3.24 2c-1 1.37-2.17 3.06-5.48 3.06s-5.58-1.69-7.34-3.06c-1.55-1.19-2.54-2-4.32-2-.33-1.27-.63-2.54-.91-3.82 3.32 0 5.4 1.72 7.14 3.1 1.5 1.2 2.52 2 4.3 2s2.35-.79 3.26-2a6.38 6.38 0 015.69-3.1c3.31 0 5.4 1.73 7.13 3.1 1.51 1.2 2.53 2 4.31 2s2.35-.79 3.26-2a6.38 6.38 0 015.69-3.1"
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M182.26 189.82c-3.63 5.16 4.34 17.38 9.25 16.82 3.35-.38 5.2-6.62 5.37-7.19.51-1.71 1.53-5.17-.43-8.4a8.93 8.93 0 00-5.3-3.83c-3.29-.83-7.22.24-8.89 2.6z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M183 208.52l4.17 1 2.6-10.5-8.24-2.02c-.79.44-4 2.37-4.69 6-.18.92-.55 2.8.6 4.25s3.33 1.91 5.56 1.27z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M185 214.79c-3.72 1.33-6.9 2.27-9.32 2.92a48.24 48.24 0 01-6.84 1.37c-2.58.33-3.87.5-4.44.12-1.92-1.27-.92-5.22.43-16 .35-2.79.6-5.06.75-6.44.08-.62.17-1.24.25-1.86l4.48.28c-.36.73-.73 1.45-1.09 2.17q.09 7.35.17 14.7l11.43-4.33a6.71 6.71 0 011.79.42 5 5 0 012.6 2.17 5.08 5.08 0 01-.21 4.48z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M170.77 211.15l12.4-4.57a5.61 5.61 0 014 3.4 5.46 5.46 0 01-.66 4.76l-14 3.69a7.85 7.85 0 00-1.74-7.28z",
                                fill: "url(#linear-gradient-230)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M175 217c.55-2.31 1.68-1.93 3.36-5.75a8.35 8.35 0 011.9-3.26 6.41 6.41 0 012.65-1.45h5.5a4.58 4.58 0 001.57 1.64c1.52.92 2.8.45 4.8.91h.1a6 6 0 012.88 1.68 5.09 5.09 0 011.45 3 15.48 15.48 0 01-1.72 8.3 33.5 33.5 0 00-2.49 10.49c.45 1.24 1 4.27 1.48 5.52a34.78 34.78 0 01-22.07.15c2-9.74 1.61-13.49 1.16-15.16-1.11-4.31-.89-4.72-.57-6.07z",
                                fill: "url(#linear-gradient-231)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M183.33 208.07a10.5 10.5 0 003.56.61 10.74 10.74 0 004.19-.87 8.4 8.4 0 01-1-2.18 7.87 7.87 0 01-.26-2.87l-6.77.9z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M183.82 190.38a22.9 22.9 0 00-1.07 2.16 22.06 22.06 0 00-1.08 3c-.11.14-.31.4-.58.71-.83.92-1.62 1.41-1.47 1.7 0 0 .75.45.87.58s-.3 2.64.09 3.7c.79 2.16 7.2 3.64 9.76 1a4.13 4.13 0 001.07-2.3 3.3 3.3 0 00-.32-.18 3.38 3.38 0 00-2.45-.1 4.19 4.19 0 00.05-2.92c-.35-.86-.82-.95-2.89-3.07a6.6 6.6 0 01-1.62-2.1 5.08 5.08 0 01-.36-2.18z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-245",
                                d: "M191 210.05a4.52 4.52 0 004.83-.1 4.18 4.18 0 001.41-3c.12-1.79-.95-2.42-1.07-4.33a6.26 6.26 0 01.73-3.2 19.22 19.22 0 01-3.22-.73 20.07 20.07 0 01-4.09-1.86 5.26 5.26 0 01-.24 2.62c-1 2.6-3.62 2.62-4.52 5a4.53 4.53 0 00.6 4.25c1.11 1.49 3.31 1.99 5.57 1.35z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M200.34 250.5c-.18 1.21-.3 2.37-.43 3.57s-.23 2.66-.47 3.74a1.2 1.2 0 01-.67.84c-.22.1-.05-.37-.18-.24s0 .54-.24.73a.16.16 0 01-.17.07c-.13 0-.19-.43-.31-.42s-.17.38-.26.48-.21.31-.4.31-.11-.31-.32-.31-.2.69-.41.65-.29-.36-.31-.77c-.08-1.29.37-2.64.42-4.14a13.93 13.93 0 00-.26-2.58 7.75 7.75 0 00-.91 1.73 3.64 3.64 0 01-.74 1.27.89.89 0 01-.66.31c-.19 0-.46 0-.45-.14a14.18 14.18 0 01.73-2.6c.51-1.55 1.32-4.23 2.95-4.6s2.28 1.16 3.09 2.1z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M199.33 214.4c.9 4.85 1.91 8.62 2.45 14.62a80.48 80.48 0 01-1.44 21.89 21 21 0 01-3-.27c.2-6.68.5-13.68-1.15-20.08-1.24-4.83-3.2-9.14-4.74-13.52-.84-2.4-.6-3.89 1-5.53a2.41 2.41 0 011.84-.89c2.56.08 4.42.49 5.04 3.78z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M192.31 211.52a4.9 4.9 0 011.81-.94 4.37 4.37 0 015.16 3.47l1.82 8.67a8.3 8.3 0 00-3.41.68 9 9 0 00-3.26 1.74c-1-2.44-1.82-4.9-2.8-7.34a6 6 0 01-.45-4.56 4 4 0 011.13-1.72z",
                                fill: "url(#linear-gradient-232)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M156.83 188.77H160a.49.49 0 01.49.49v9.65h-4.14v-9.65a.49.49 0 01.48-.49z",
                                transform: "rotate(91.28 158.41 193.83)",
                                fill: "url(#New_Gradient_Swatch_13)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M166.94 189.54H169a.5.5 0 01.5.5v8.51h-3.08V190a.5.5 0 01.52-.46z",
                                transform: "rotate(91.28 167.981 194.045)",
                                fill: "url(#New_Gradient_Swatch_13-2)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                transform: "rotate(91.28 176.118 194.226)",
                                fill: "url(#New_Gradient_Swatch_13-3)",
                                d: "M175.15 190.6h1.92v7.27h-1.92z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-247",
                                x: "178.59",
                                y: "193.96",
                                width: "3.06",
                                height: ".74",
                                rx: ".3",
                                transform: "rotate(91.28 180.12 194.325)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-247",
                                x: "150.26",
                                y: "193.12",
                                width: "4.96",
                                height: "1.2",
                                rx: ".49",
                                transform: "rotate(91.28 152.736 193.71)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                d: "M168 194.23h1.47a.73.73 0 00.73-.73V192a1 1 0 00-.21-.52 1 1 0 00-.64-.36l-1.35-.02a.76.76 0 00-.56.24.85.85 0 00-.18.69v1.47a.74.74 0 00.74.73z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                x: "166.04",
                                y: "191.29",
                                width: "1.47",
                                height: "2.35",
                                rx: ".73",
                                transform: "rotate(180 166.77 192.47)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-263",
                                x: "169.9",
                                y: "191.29",
                                width: "1.47",
                                height: "2.35",
                                rx: ".73",
                                transform: "rotate(-180 170.63 192.47)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: "cls-249",
                                d: "M186.39 387.41l.65-2.09-.93.22c.1.62.19 1.24.28 1.87zM197.57 400.68c-.29 4.12-.58 7.54-.79 8.63-.1.55-.25 1.09-.25 1.09l-.14.48.38.12c-.45 1.24-1 4.28-1.48 5.52.14 1.52.35 2.89.59 4.14.22-.71.43-1.42.61-2.14 1.46-5.69 1.4-11.84 1.22-17.83zM344.22 423.89c-6-2.63-10-4.71-16-7.35l-2.05.57c2.65 1.35 6 3.24 8.38 4.69a5.4 5.4 0 012.52 5.62c-.48 2.55-1.08 5.92-1.7 9q4.68-5.9 9.55-11.63v-.06c-.31-.35-.54-.62-.7-.84z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M200.61 398.16h-.05c-.15-1.06-.26-2.09-.38-3.15s-.23-2.66-.47-3.74a1.2 1.2 0 00-.67-.84c-.22-.1 0 .36-.18.24s0-.55-.24-.73a.14.14 0 00-.17-.07c-.09 0-.14.19-.2.31.18-3 .33-5.72.44-7.56l-1.29.3-10.4 2.4-.65 2.09c-.09-.63-.18-1.25-.28-1.87L175.36 388c-.27 4.63-.41 9.51-.56 15.57-.05 2.44.1 5.11.21 7.15l-.31.09c2.05 9.75 1.61 13.5 1.16 15.17-.84 3.19-.93 4.24-.8 5.11a49.27 49.27 0 00-5.92-1.13c-2.58-.33-3.87-.49-4.44-.12-1.92 1.28-.92 5.23.43 16.05.35 2.79.6 5.06.75 6.43.05.4.11.79.16 1.19h-2.31a.5.5 0 00-.5-.48l-9.65.22a.47.47 0 00-.48-.43h-.23a.5.5 0 00-.48.5l.09 4a.49.49 0 00.5.47h.23a.48.48 0 00.46-.44l9.64-.21a.5.5 0 00.48-.51l2.51-.06v.44a.73.73 0 00.73.73.69.69 0 00.55-.26.9.9 0 00.14.22.81.81 0 00.56.24l1.35-.05a1 1 0 00.64-.36l.05-.09a.7.7 0 00.57.3.73.73 0 00.74-.73v-.56h.65a.52.52 0 00.49-.52v-.07l7.26-.16v.3a.3.3 0 00.3.29h.14a.31.31 0 00.3-.31l-.06-2.46a.29.29 0 00-.3-.29h-.14a.3.3 0 00-.3.31v.27l-7.27.17v1-1a.5.5 0 00-.51-.49h-1.86l-.84-1.68q.09-7.35.17-14.69l1.57.59a2.88 2.88 0 01-.22.27l7.91 2.91a3.91 3.91 0 00-1.24 1c-1.15 1.44-.78 3.32-.6 4.25a8.52 8.52 0 003 4.84l-.25.16c-.15.28.64.78 1.47 1.7.27.3.47.56.58.71-.53 2.19-.45 4.27.59 5.76 1.67 2.36 5.6 3.43 8.89 2.59a8.85 8.85 0 005.3-3.82c2-3.23.94-6.69.43-8.41-.05-.17-.26-.86-.61-1.75a5.53 5.53 0 01-.12-1.44c.12-1.91 1.19-2.55 1.08-4.33a4.5 4.5 0 00-1.1-2.67 6.4 6.4 0 001.63-1.21 5.13 5.13 0 001.44-2.92c0-.09.06-.18.08-.28l1.82-8.67h-.15c.33-1.89.62-3.93.83-6.32a80.51 80.51 0 00-1.38-21.92zm-4.12 20.36c-.18.72-.39 1.43-.61 2.14-.24-1.25-.45-2.62-.59-4.14.45-1.24 1-4.28 1.48-5.52l-.38-.12c.05-.17.11-.34.14-.48s.15-.54.25-1.09c.21-1.09.5-4.51.79-8.63h.14c.18 6 .29 12.15-1.22 17.84z",
                                fill: "url(#linear-gradient-233)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                fill: "url(#linear-gradient-234)",
                                d: "M301.4 385.02l4.39 1.02"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M327.83 451.92c.16.11.51-.12.63 0s0 .23 0 .45a.61.61 0 00.24.32c.32.17 1.12-.75 1.63-1.31 2.06-2.31 2.85-2.82 2.88-4.05v-.44a18.86 18.86 0 01.07-2.53q6.66-8.68 13.75-17c.64.85 1 1.38 1.39 1.56l.08.14c1 .4 2.55-1.6 2.88-3.17a1.68 1.68 0 000-.91 4.62 4.62 0 00-.76-1.83q9.87-11.32 20.49-21.94l-3.69-.86q-10.01 10.16-19.42 20.93a2 2 0 00-.41-.18c-.29-.09-1.56-.63-2.35-.82l.13-.5-14.14-9.86a5.44 5.44 0 00-1.53-.42c-1-.14-4.17.44-7.13 1.13 0-.3 0-.58.05-.88a85.6 85.6 0 011.28-9.71l-.86-.37a21.52 21.52 0 002.58-6.27c.11-.48.23-.94.34-1.4l.3-1.21-20.47-4.79a41.87 41.87 0 00-.41 8.76c.09.56.46 2.3.78 3.74l-.43.11a63.72 63.72 0 01-1.88 13.92c-.28 1.12-.58 2.21-.91 3.25a4.26 4.26 0 001.64 4.78h.09l.66.41s.73.44 1.5.82a14.06 14.06 0 002.25.86l-.27 2.27-1.49.95a8.58 8.58 0 00-3.91 5c-.21.78-.88 3.35.56 5.4a5.72 5.72 0 003 2.09c1.52.49 1.85 0 4.85.09 2.09.08 2.95.43 3.31-.07s-.22-1.71-.71-2.45c.29-.69.59-1.37.88-2.06l2.66-1.63c-.22-.38-.44-.76-.65-1.14a1.06 1.06 0 00.34-.45 1 1 0 000-.63l-.29-.13v-1a1.82 1.82 0 00.6-1 1.9 1.9 0 00-.24-1.4 2.56 2.56 0 00-1.94-1.11h-.13l-1.22-.06a12.75 12.75 0 01.27-1.55l1.08.12c2.74.26 14.17 3.11 14.17 3.11s.75 9.78-.88 15.51l-1.22 1c-1.82 1.5-2.13 1.86-2.2 2.4a9.91 9.91 0 010 1.39c-.12.73-.36 1.1-.23 1.2s.62-.21 1-.62q-5.31 7.17-10.32 14.54 3-1.26 5.7-2.58 2.89-4.12 5.86-8.2a.26.26 0 00.17.28zm-1.62-34.81l2.05-.57c6 2.64 10 4.72 16 7.35.16.22.39.49.72.87v.06q-4.87 5.73-9.55 11.63c.62-3.11 1.22-6.48 1.7-9a5.4 5.4 0 00-2.52-5.62c-2.43-1.48-5.75-3.37-8.4-4.72z",
                                fill: "url(#linear-gradient-235)"
                            })
                        ]
                    })
                })
            })
        ]
    });


const $599be2d733b06da7$var$styles = {
    image: "_p12f1mjv _1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _4cvr1h6o"
}; // Due to the small width of the preview panel, we need to wrap the PageNotFoundSVG with specific styles
const $599be2d733b06da7$var$PreviewPanelPageNotFoundSVG = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $599be2d733b06da7$var$styles.image,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2fe8a6927c240794$export$7cd49dc959d58823), {})
    });
};
const $599be2d733b06da7$export$d3ec4d3c4e3e468c = ({ embeddedConfluenceSource: embeddedConfluenceSource } = {})=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isInPreviewPanel = embeddedConfluenceSource === 'confluence-page-preview-panel';
    const EmptyStateImage = isInPreviewPanel ? $599be2d733b06da7$var$PreviewPanelPageNotFoundSVG : (0, $2fe8a6927c240794$export$7cd49dc959d58823);
    const EmptyStateWidth = isInPreviewPanel ? 'narrow' : 'wide';
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $abC4X.default), {
        header: formatMessage((0, $130194087263f90e$export$2e2bcd8739ae039).emptyStateHeader),
        description: formatMessage((0, $130194087263f90e$export$2e2bcd8739ae039).emptyStateDescription),
        width: EmptyStateWidth,
        renderImage: ()=>/*#__PURE__*/ (0, $l998X.jsx)(EmptyStateImage, {})
    });
};
module.exports["PageNotFoundEmptyState"] = $599be2d733b06da7$export$d3ec4d3c4e3e468c;

});

parcelRegister("gt5FF", function(module, exports) {
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $770972d787cabaf7$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Hledali jsme v\u0161ude, ale tato polo\u017Eka neexistuje. Mohla b\xfdt odstran\u011Bna. Pokud ov\u0161em nem\xe1te p\u0159eklep v\xa0adrese URL.",
    'embedded-confluence-common.src.content.empty-state-header': "Nem\u016F\u017Eeme naj\xedt, co hled\xe1te",
    'embedded.confluence.already-logged-in-paragraph': "Jste ji\u017E p\u0159ihl\xe1\u0161eni? Zkuste obnovit str\xe1nku.",
    'embedded.confluence.footer.hover.text': "Zobrazit v\xa0Confluence",
    'embedded.confluence.footer.prefix': "Pou\u017E\xedv\xe1 technologii",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "P\u0159ihlaste se do Confluence",
    'embedded.confluence.login-page.login-button': "P\u0159ihl\xe1sit se do Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "Tla\u010D\xedtko p\u0159ihl\xe1\u0161en\xed",
    'embedded.confluence.login-page.login-text': "Chcete-li zobrazit tuto str\xe1nku, mus\xedte b\xfdt p\u0159ihl\xe1\u0161eni.",
    'embedded.confluence.login-page.refresh-page-banner': "Po p\u0159ihl\xe1\u0161en\xed by se tato str\xe1nka m\u011Bla automaticky obnovit. Pokud ne, m\u016F\u017Eete ji obnovit kliknut\xedm zde.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Obnovit str\xe1nku",
    'embedded.confluence.need-to-log-in-paragraph': "Chcete-li zobrazit tuto str\xe1nku, mus\xedte b\xfdt p\u0159ihl\xe1\u0161eni.",
    'embedded.confluence.still-having-trouble-paragraph': "Po\u0159\xe1d m\xe1te pot\xed\u017Ee? Ujist\u011Bte se, \u017Ee jsou povoleny soubory cookies t\u0159et\xedch stran, nebo {link}",
    'embedded.confluence.troubleshooting-link-text': "se pod\xedvejte se do pr\u016Fvodce \u0159e\u0161en\xedm probl\xe9m\u016F.",
    'embedded.confluence.troubleshooting-link.aria-label': "odkaz na pr\u016Fvodce \u0159e\u0161en\xedm probl\xe9m\u016F"
};


var $773347a5ecc0b550$export$2e2bcd8739ae039 = (0, $770972d787cabaf7$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $1fbac85b0fe8f9ef$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Vi har ledt overalt, men den eksisterer ikke. Den er muligvis blevet slettet. Medmindre der er en sl\xe5fejl i webadressen, selvf\xf8lgelig \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Vi kunne ikke finde det, du leder efter',
    'embedded.confluence.already-logged-in-paragraph': "Er du allerede logget ind? Pr\xf8v at genindl\xe6se.",
    'embedded.confluence.footer.hover.text': 'Vis i Confluence',
    'embedded.confluence.footer.prefix': 'Drevet af',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Log p\xe5 Confluence",
    'embedded.confluence.login-page.login-button': "Log ind p\xe5 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Loginknap',
    'embedded.confluence.login-page.login-text': "Du skal v\xe6re logget ind for at kunne se denne side",
    'embedded.confluence.login-page.refresh-page-banner': "N\xe5r du har logget ind, b\xf8r denne side genindl\xe6ses automatisk. Hvis ikke, kan du klikke her for at genindl\xe6se",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Genindl\xe6s siden",
    'embedded.confluence.need-to-log-in-paragraph': "Du skal v\xe6re logget ind for at kunne se denne side",
    'embedded.confluence.still-having-trouble-paragraph': "Har du stadig problemer? S\xf8rg for, at tredjepartscookies er aktiveret, eller {link}",
    'embedded.confluence.troubleshooting-link-text': 'se denne fejlfindingsvejledning.',
    'embedded.confluence.troubleshooting-link.aria-label': 'link til fejlfindingsvejledning'
};


var $4b444f9ddec14a5d$export$2e2bcd8739ae039 = (0, $1fbac85b0fe8f9ef$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $faec8ebf3b2cca76$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Wir haben \xfcberall gesucht, aber sie existiert nicht. Sie k\xf6nnte gel\xf6scht worden sein. Es sei denn, in der URL ist ein Tippfehler enthalten \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Wir konnten nicht finden, wonach Sie suchen',
    'embedded.confluence.already-logged-in-paragraph': 'Bereits eingeloggt? Aktualisieren Sie die Seite.',
    'embedded.confluence.footer.hover.text': 'In Confluence anzeigen',
    'embedded.confluence.footer.prefix': 'Bereitgestellt von',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Bei Confluence einloggen',
    'embedded.confluence.login-page.login-button': 'Bei Confluence einloggen',
    'embedded.confluence.login-page.login-button.aria-label': "Login-Schaltfl\xe4che",
    'embedded.confluence.login-page.login-text': "Sie m\xfcssen eingeloggt sein, damit diese Seite angezeigt wird.",
    'embedded.confluence.login-page.refresh-page-banner': "Nach dem Einloggen sollte diese Seite automatisch aktualisiert werden. Wenn dies nicht der Fall ist, k\xf6nnen Sie zum Aktualisieren hier klicken.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Seite aktualisieren',
    'embedded.confluence.need-to-log-in-paragraph': "Sie m\xfcssen eingeloggt sein, damit diese Seite angezeigt wird.",
    'embedded.confluence.still-having-trouble-paragraph': 'Besteht das Problem weiterhin? Vergewissern Sie sich, dass Cookies von Drittanbietern aktiviert sind, oder {link}',
    'embedded.confluence.troubleshooting-link-text': 'lesen Sie den Leitfaden zur Fehlerbehebung.',
    'embedded.confluence.troubleshooting-link.aria-label': 'Link zum Leitfaden zur Fehlerbehebung'
};


var $14eaab80d38a0ee6$export$2e2bcd8739ae039 = (0, $faec8ebf3b2cca76$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $06c9811120bf1758$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "We couldn't find what you're looking for",
    'embedded.confluence.already-logged-in-paragraph': 'Already logged in? Try refreshing.',
    'embedded.confluence.footer.hover.text': 'View in Confluence',
    'embedded.confluence.footer.prefix': 'Powered by',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Login Button',
    'embedded.confluence.login-page.login-text': 'You need to be logged in to view this page',
    'embedded.confluence.login-page.refresh-page-banner': 'After logging in, this page should refresh automatically. If not, you can click here to refresh',
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Refresh page',
    'embedded.confluence.need-to-log-in-paragraph': 'You need to be logged in to view this page',
    'embedded.confluence.still-having-trouble-paragraph': 'Still having trouble? Make sure 3rd party cookies are enabled, or {link}',
    'embedded.confluence.troubleshooting-link-text': 'refer to this troubleshooting guide.',
    'embedded.confluence.troubleshooting-link.aria-label': 'troubleshooting guide link'
};


var $865d855a1fa5d471$export$2e2bcd8739ae039 = (0, $06c9811120bf1758$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $25e67390bb758506$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "We couldn't find what you're looking for",
    'embedded.confluence.already-logged-in-paragraph': 'Already logged in? Try refreshing.',
    'embedded.confluence.footer.hover.text': 'View in Confluence',
    'embedded.confluence.footer.prefix': 'Powered by',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button': 'Log in to Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Login Button',
    'embedded.confluence.login-page.login-text': 'You need to be logged in to view this page',
    'embedded.confluence.login-page.refresh-page-banner': 'After logging in, this page should refresh automatically. If not, you can click here to refresh',
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Refresh page',
    'embedded.confluence.need-to-log-in-paragraph': 'You need to be logged in to view this page',
    'embedded.confluence.still-having-trouble-paragraph': 'Still having trouble? Make sure 3rd party cookies are enabled, or {link}',
    'embedded.confluence.troubleshooting-link-text': 'refer to this troubleshooting guide.',
    'embedded.confluence.troubleshooting-link.aria-label': 'troubleshooting guide link'
};


var $6c55c06d45f02d30$export$2e2bcd8739ae039 = (0, $25e67390bb758506$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $43028ba70317978e$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u2063\u2062We looked everywhere, but it doesn't exist. It may have been deleted. Unless, of course, the URL has a typo in it \uD83D\uDE09\u206A\x81\u206C\u2061\u200D\u2060\u061C\u206E\u2061\x9d\u2061\u2061\u206F\x8f\u206F\u206A\u2061\u206E\u206E\u206B\u2060\u2061\u061C\u206B\x9d\x8f\u206E\x9d\x81\u200D\x8d\u206F\u2063\u2064",
    'embedded-confluence-common.src.content.empty-state-header': "\u2063\u2062We couldn't find what you're looking for\u2061\u200C\u206E\x81\x8f\u206E\u206C\u206A\u206C\u061C\u206B\u206B\u200C\u206D\x8d\x8f\u206A\u200D\u2061\u2061\x8d\u200C\u200D\u2061\u206C\x8f\u206F\u206D\u206F\u2061\u206D\u206D\u2063\u2064",
    'embedded.confluence.already-logged-in-paragraph': "\u2063\u2062Already logged in? Try refreshing.\x90\x90\u206A\x8f\u200D\u206C\u200D\x9d\u206A\x8f\x81\x8f\u200C\x9d\x8d\u206C\x8f\u2060\x90\x90\u206D\x81\u061C\x8d\u2061\x81\u206E\u206D\x90\u2060\u200D\u206F\u2063\u2064",
    'embedded.confluence.footer.hover.text': "\u2063\u2062View in Confluence\u200C\u206D\u200D\x90\u200D\u2061\u206C\u206D\x9d\u2060\x9d\x9d\u206A\u2061\u2061\u061C\u2060\u2060\u2060\u200D\u206E\x90\x81\u200C\x8f\u2060\u2060\u206D\u2060\u2060\u206C\u206F\u2063\u2064",
    'embedded.confluence.footer.prefix': "\u2063\u2062Powered by\u206C\x8f\u206B\u206E\u206B\u200C\x8d\x90\u206C\x81\x8f\u206C\x8f\u200C\x8d\x9d\u206F\u061C\u206E\x9d\u206D\x9d\u206F\x90\u061C\u061C\u200C\x8f\u200C\u206B\u206F\u200C\u2063\u2064",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u2063\u2062Log in to Confluence\u061C\u2060\u2060\u206F\x8d\u2061\u206E\x81\x9d\x90\x8f\u206E\x81\x8d\x8f\x90\u206F\u2061\u061C\x8d\u206C\u206D\u206A\x81\u206D\x9d\u206A\x8f\u206E\x81\u206E\u206D\u2063\u2064",
    'embedded.confluence.login-page.login-button': "\u2063\u2062Log in to Confluence\u206D\u206A\u206A\x8d\u206F\u061C\u200C\u061C\u206C\u206B\u2061\u061C\u200C\x90\u206A\u206D\u206A\u206B\u200D\u061C\u206B\x8f\x90\u200C\u206B\u206E\u206C\u206A\u2061\x81\u206A\x90\u2063\u2064",
    'embedded.confluence.login-page.login-button.aria-label': "\u2063\u2062Login Button\x8d\x90\u206E\x90\u206D\x8d\u061C\u200C\u206E\x90\x8d\u061C\u2060\u200D\u206F\x8d\u206D\u2061\x81\u200D\x90\x8d\x90\x90\x9d\u061C\u206F\x81\u206E\u200C\x9d\x90\u2063\u2064",
    'embedded.confluence.login-page.login-text': "\u2063\u2062You need to be logged in to view this page\u206F\u206A\u200C\x8d\u206E\x81\x81\u2061\x81\x90\u206F\u2060\x8d\u206E\x8f\x9d\x90\u2061\u2061\u206F\u200D\x81\x90\u206C\u206D\u206B\x90\u206A\u206E\u2060\u2061\x90\u2063\u2064",
    'embedded.confluence.login-page.refresh-page-banner': "\u2063\u2062After logging in, this page should refresh automatically. If not, you can click here to refresh\u200C\x81\u200D\u200D\u206F\u206D\x90\u200C\u206D\x81\u2060\u206A\u2061\x8d\u206C\u200C\x90\x8d\x8f\x8f\u2061\x9d\u206E\x9d\u2060\u2061\u2060\u061C\x8f\u206C\u206D\u2061\u2063\u2064",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u2063\u2062Refresh page\u2060\x90\u2061\u061C\u200D\u206E\x8d\x90\u200D\x9d\u2060\u206A\u2061\x90\x8d\x8f\u206E\x8d\x9d\u206A\x9d\u061C\u206B\x8f\u206B\u200D\u061C\u206E\u206A\u206C\u206A\x90\u2063\u2064",
    'embedded.confluence.need-to-log-in-paragraph': "\u2063\u2062You need to be logged in to view this page\u200D\u061C\u206D\u206C\u206E\u206D\u206F\x8d\u206F\x8d\u061C\u206E\u206A\u206F\u206E\u206C\u206F\u200D\x90\u2061\x81\x90\x81\u206E\x8d\x8f\x8f\x90\u206D\x90\u206C\u206F\u2063\u2064",
    'embedded.confluence.still-having-trouble-paragraph': "\u2063\u2062Still having trouble? Make sure 3rd party cookies are enabled, or {link}\x90\x90\u061C\u206E\x90\u206D\x90\x8f\u200D\x8d\x8d\u061C\u206D\x9d\x9d\x90\u061C\u206D\x8d\x8f\u061C\u200C\u2061\u206E\u206A\x9d\x9d\u206F\x81\u206F\u2061\u206F\u2063\u2064",
    'embedded.confluence.troubleshooting-link-text': "\u2063\u2062refer to this troubleshooting guide.\u206C\u206A\x90\u206D\u2061\x81\x8d\x8f\u206F\x9d\u206B\u206C\x81\u206A\u206B\u206C\u200D\u200C\x8d\u206B\u200C\x90\u206C\u061C\u061C\x8f\u2061\x9d\u2060\u206A\u2060\u061C\u2063\u2064",
    'embedded.confluence.troubleshooting-link.aria-label': "\u2063\u2062troubleshooting guide link\u200C\x90\u206C\u206D\u206E\x9d\u206D\u200D\x90\x8f\u200D\x8f\x90\u206A\u206D\x90\u206D\u200C\u200D\u206F\u206A\x90\u206F\x90\u200C\u2061\x90\u206E\u200D\x8d\u206C\u206A\u2063\u2064"
};


var $a9c1813fe7e4af9d$export$2e2bcd8739ae039 = (0, $43028ba70317978e$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $b061fd8aff37e484$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Hemos buscado en todas partes, pero no existe. Puede que se haya borrado. A no ser que la URL contenga un error \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'No hemos podido encontrar lo que buscas.',
    'embedded.confluence.already-logged-in-paragraph': "\xbfHas iniciado sesi\xf3n? Prueba a actualizar.",
    'embedded.confluence.footer.hover.text': 'Ver en Confluence',
    'embedded.confluence.footer.prefix': "Con tecnolog\xeda de",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Iniciar sesi\xf3n en Confluence",
    'embedded.confluence.login-page.login-button': "Iniciar sesi\xf3n en Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "Bot\xf3n de inicio de sesi\xf3n",
    'embedded.confluence.login-page.login-text': "Tienes que iniciar sesi\xf3n para poder ver esta p\xe1gina",
    'embedded.confluence.login-page.refresh-page-banner': "Tras iniciar sesi\xf3n, esta p\xe1gina deber\xeda actualizarse autom\xe1ticamente. Si no, puedes hacer clic aqu\xed para actualizar.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Actualizar p\xe1gina",
    'embedded.confluence.need-to-log-in-paragraph': "Tienes que iniciar sesi\xf3n para poder ver esta p\xe1gina",
    'embedded.confluence.still-having-trouble-paragraph': "\xbfSigues teniendo problemas? Aseg\xfarate de que las cookies de terceros est\xe1n habilitadas o {link}",
    'embedded.confluence.troubleshooting-link-text': "consulta esta gu\xeda de soluci\xf3n de problemas.",
    'embedded.confluence.troubleshooting-link.aria-label': "enlace a la gu\xeda de soluci\xf3n de problemas"
};


var $e36d3bdbd9bcfbc6$export$2e2bcd8739ae039 = (0, $b061fd8aff37e484$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $ecd1f7d292ef1208$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Etsimme kaikkialta, mutta sit\xe4 ei ole olemassa. Se on saatettu poistaa. Paitsi tietenkin jos URL-osoitteessa on kirjoitusvirhe \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Emme l\xf6yt\xe4neet etsim\xe4\xe4si",
    'embedded.confluence.already-logged-in-paragraph': "Oletko jo kirjautuneena sis\xe4\xe4n? Kokeile p\xe4ivitt\xe4\xe4.",
    'embedded.confluence.footer.hover.text': "N\xe4yt\xe4 Confluencessa",
    'embedded.confluence.footer.prefix': 'Palvelun tarjoaa',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Kirjaudu sis\xe4\xe4n Confluenceen",
    'embedded.confluence.login-page.login-button': "Kirjaudu sis\xe4\xe4n Confluenceen",
    'embedded.confluence.login-page.login-button.aria-label': 'Kirjautumispainike',
    'embedded.confluence.login-page.login-text': "Sinun on oltava kirjautuneena sis\xe4\xe4n, jotta voit tarkastella t\xe4t\xe4 sivua",
    'embedded.confluence.login-page.refresh-page-banner': "T\xe4m\xe4n sivun tulisi p\xe4ivitty\xe4 automaattisesti sis\xe4\xe4nkirjautumisen j\xe4lkeen. Jos n\xe4in ei tapahdu, voit p\xe4ivitt\xe4\xe4 sivun napsauttamalla t\xe4t\xe4.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "P\xe4ivit\xe4 sivu",
    'embedded.confluence.need-to-log-in-paragraph': "Sinun on oltava kirjautuneena sis\xe4\xe4n, jotta voit katsoa t\xe4t\xe4 sivua",
    'embedded.confluence.still-having-trouble-paragraph': "Onko sinulla viel\xe4 ongelmia? Varmista, ett\xe4 kolmansien osapuolten ev\xe4steet ovat k\xe4yt\xf6ss\xe4, tai {link}",
    'embedded.confluence.troubleshooting-link-text': "katso t\xe4m\xe4 ongelmanratkaisuopas.",
    'embedded.confluence.troubleshooting-link.aria-label': 'ongelmanratkaisuoppaan linkki'
};


var $a53fe41909f30ebd$export$2e2bcd8739ae039 = (0, $ecd1f7d292ef1208$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $ce7e2f0f781940c8$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Nous avons cherch\xe9 partout, mais ce contenu n'existe pas. Il a peut-\xeatre \xe9t\xe9 supprim\xe9. Il est possible que l'URL contienne une faute de frappe. V\xe9rifiez bien \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Impossible de trouver ce que vous recherchez',
    'embedded.confluence.already-logged-in-paragraph': "D\xe9j\xe0 connect\xe9\xa0? Essayez d'actualiser.",
    'embedded.confluence.footer.hover.text': 'Afficher dans Confluence',
    'embedded.confluence.footer.prefix': "Optimis\xe9 par",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Connexion \xe0 Confluence",
    'embedded.confluence.login-page.login-button': "Connexion \xe0 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Bouton de connexion',
    'embedded.confluence.login-page.login-text': "Vous devez \xeatre connect\xe9 pour voir cette page",
    'embedded.confluence.login-page.refresh-page-banner': "Apr\xe8s la connexion, cette page devrait s'actualiser automatiquement. Si ce n'est pas le cas, cliquez ici pour l'actualiser.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Actualiser la page',
    'embedded.confluence.need-to-log-in-paragraph': "Vous devez \xeatre connect\xe9 pour voir cette page",
    'embedded.confluence.still-having-trouble-paragraph': "Vous rencontrez toujours des probl\xe8mes\xa0? Assurez-vous que les cookies tiers sont activ\xe9s, ou {link}.",
    'embedded.confluence.troubleshooting-link-text': "reportez-vous \xe0 ce guide de d\xe9pannage",
    'embedded.confluence.troubleshooting-link.aria-label': "lien vers le guide de d\xe9pannage"
};


var $cee97febb9adf70f$export$2e2bcd8739ae039 = (0, $ce7e2f0f781940c8$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $86e0fa8f65d81e65$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Megpr\xf3b\xe1ltuk megkeresni, de nincs ilyen oldal. Lehet, hogy t\xf6r\xf6lt\xe9k. Az is lehet, hogy csak el\xedrtad az URL-t \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Nem tal\xe1ltuk meg, amit keresel",
    'embedded.confluence.already-logged-in-paragraph': "M\xe1r bejelentkezt\xe9l? Pr\xf3b\xe1lj meg friss\xedteni.",
    'embedded.confluence.footer.hover.text': "Megtekint\xe9s a Confluence-ben",
    'embedded.confluence.footer.prefix': "Szolg\xe1ltat\xf3:",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Bejelentkez\xe9s a Confluence-be",
    'embedded.confluence.login-page.login-button': "Bejelentkez\xe9s a Confluence-be",
    'embedded.confluence.login-page.login-button.aria-label': "Bejelentkez\xe9s gomb",
    'embedded.confluence.login-page.login-text': "Az oldal megtekint\xe9s\xe9hez be kell jelentkezned",
    'embedded.confluence.login-page.refresh-page-banner': "Bejelentkez\xe9s ut\xe1n az oldal automatikusan friss\xfcl. Ha nem, kattints ide a friss\xedt\xe9shez.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Oldal friss\xedt\xe9se",
    'embedded.confluence.need-to-log-in-paragraph': "Az oldal megtekint\xe9s\xe9hez be kell jelentkezned",
    'embedded.confluence.still-having-trouble-paragraph': "M\xe9g mindig probl\xe9m\xe1ba \xfctk\xf6z\xf6l? Gy\u0151z\u0151dj meg r\xf3la, hogy enged\xe9lyezted a harmadik felekt\u0151l sz\xe1rmaz\xf3 s\xfctiket, vagy {link}",
    'embedded.confluence.troubleshooting-link-text': "olvasd el ezt a hibaelh\xe1r\xedt\xe1si \xfatmutat\xf3t.",
    'embedded.confluence.troubleshooting-link.aria-label': "hibaelh\xe1r\xedt\xe1si \xfatmutat\xf3 linkje"
};


var $4fd5ea0e4e732beb$export$2e2bcd8739ae039 = (0, $86e0fa8f65d81e65$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $b20f747ff4d27782$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Abbiamo cercato ovunque, ma la pagina non esiste. Potrebbe essere stata eliminata, o forse hai sbagliato a scrivere l'URL \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Non siamo riusciti a trovare la pagina cercata',
    'embedded.confluence.already-logged-in-paragraph': "Hai gi\xe0 effettuato l'accesso? Prova ad aggiornare la pagina.",
    'embedded.confluence.footer.hover.text': 'Visualizza in Confluence',
    'embedded.confluence.footer.prefix': 'Offerto da',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Accedi a Confluence',
    'embedded.confluence.login-page.login-button': 'Accedi a Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Pulsante di accesso',
    'embedded.confluence.login-page.login-text': "Per visualizzare questa pagina devi avere effettuato l'accesso.",
    'embedded.confluence.login-page.refresh-page-banner': "Dopo l'accesso, questa pagina dovrebbe aggiornarsi automaticamente. In caso contrario, clicca qui per aggiornarla",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Aggiorna la pagina',
    'embedded.confluence.need-to-log-in-paragraph': "Deve avere effettuato l'accesso per visualizzare questa pagina",
    'embedded.confluence.still-having-trouble-paragraph': 'Riscontri ancora problemi? Assicurati che i cookie di terze parti siano abilitati, oppure {link}',
    'embedded.confluence.troubleshooting-link-text': 'consulta questa guida alla risoluzione dei problemi.',
    'embedded.confluence.troubleshooting-link.aria-label': 'link alla guida alla risoluzione dei problemi'
};


var $fe343340a045571b$export$2e2bcd8739ae039 = (0, $b20f747ff4d27782$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $dc55569a1eabd9b6$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u304A\u63A2\u3057\u306E\u30DA\u30FC\u30B8\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002\u524A\u9664\u3055\u308C\u305F\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002URL \u306B\u5165\u529B\u30DF\u30B9\u304C\u306A\u3044\u304B\u3001\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u304A\u63A2\u3057\u306E\u3082\u306E\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F",
    'embedded.confluence.already-logged-in-paragraph': "\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u3044\u307E\u3059\u304B?\u66F4\u65B0\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002",
    'embedded.confluence.footer.hover.text': "Confluence \u3067\u8868\u793A",
    'embedded.confluence.footer.prefix': "\u4F7F\u7528\u30BD\u30EA\u30E5\u30FC\u30B7\u30E7\u30F3: ",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Confluence \u306B\u30ED\u30B0\u30A4\u30F3",
    'embedded.confluence.login-page.login-button': "Confluence \u306B\u30ED\u30B0\u30A4\u30F3",
    'embedded.confluence.login-page.login-button.aria-label': "\u30ED\u30B0\u30A4\u30F3 \u30DC\u30BF\u30F3",
    'embedded.confluence.login-page.login-text': "\u3053\u306E\u30DA\u30FC\u30B8\u3092\u8868\u793A\u3059\u308B\u306B\u306F\u3001\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059",
    'embedded.confluence.login-page.refresh-page-banner': "\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u3068\u3001\u3053\u306E\u30DA\u30FC\u30B8\u306F\u81EA\u52D5\u3067\u66F4\u65B0\u3055\u308C\u307E\u3059\u3002\u66F4\u65B0\u3055\u308C\u306A\u3044\u5834\u5408\u306F\u3001\u3053\u3053\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u66F4\u65B0\u3067\u304D\u307E\u3059",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u30DA\u30FC\u30B8\u3092\u66F4\u65B0",
    'embedded.confluence.need-to-log-in-paragraph': "\u3053\u306E\u30DA\u30FC\u30B8\u3092\u8868\u793A\u3059\u308B\u306B\u306F\u3001\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002",
    'embedded.confluence.still-having-trouble-paragraph': "\u554F\u984C\u304C\u89E3\u6C7A\u3057\u306A\u3044\u5834\u5408\u306F\u3001\u30B5\u30FC\u30C9\u30D1\u30FC\u30C6\u30A3 Cookie \u304C\u6709\u52B9\u306B\u306A\u3063\u3066\u3044\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u307E\u305F\u306F\u3001{link}",
    'embedded.confluence.troubleshooting-link-text': "\u3053\u306E\u30C8\u30E9\u30D6\u30EB\u30B7\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0 \u30AC\u30A4\u30C9\u3092\u53C2\u7167\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'embedded.confluence.troubleshooting-link.aria-label': "\u30C8\u30E9\u30D6\u30EB\u30B7\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0 \u30AC\u30A4\u30C9\u306E\u30EA\u30F3\u30AF"
};


var $fc6992a6d33f0da5$export$2e2bcd8739ae039 = (0, $dc55569a1eabd9b6$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $7b7ae6970e843014$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\uC790\uC138\uD788 \uB458\uB7EC\uBCF4\uC558\uC9C0\uB9CC \uCC3E\uC744 \uC218\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4. \uC0AD\uC81C\uB418\uC5C8\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4. URL\uC5D0 \uC785\uB825 \uC624\uB958\uAC00 \uC788\uB294\uC9C0 \uD655\uC778\uD574\uBCF4\uC138\uC694 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\uC6D0\uD558\uB294 \uD56D\uBAA9\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
    'embedded.confluence.already-logged-in-paragraph': "\uC774\uBBF8 \uB85C\uADF8\uC778\uD558\uC168\uC2B5\uB2C8\uAE4C? \uC0C8\uB85C \uACE0\uCCD0 \uBCF4\uC138\uC694.",
    'embedded.confluence.footer.hover.text': "Confluence\uC5D0\uC11C \uBCF4\uAE30",
    'embedded.confluence.footer.prefix': "\uC81C\uACF5:",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Confluence\uC5D0 \uB85C\uADF8\uC778",
    'embedded.confluence.login-page.login-button': "Confluence\uC5D0 \uB85C\uADF8\uC778",
    'embedded.confluence.login-page.login-button.aria-label': "\uB85C\uADF8\uC778 \uBC84\uD2BC",
    'embedded.confluence.login-page.login-text': "\uC774 \uD398\uC774\uC9C0\uB97C \uBCF4\uB824\uBA74 \uB85C\uADF8\uC778\uD574\uC57C \uD569\uB2C8\uB2E4",
    'embedded.confluence.login-page.refresh-page-banner': "\uB85C\uADF8\uC778\uD558\uBA74 \uC774 \uD398\uC774\uC9C0\uAC00 \uC790\uB3D9\uC73C\uB85C \uC0C8\uB85C \uACE0\uCCD0\uC9D1\uB2C8\uB2E4. \uADF8\uB807\uC9C0 \uC54A\uC740 \uACBD\uC6B0 \uC5EC\uAE30\uB97C \uD074\uB9AD\uD558\uC5EC \uC0C8\uB85C \uACE0\uCE60 \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\uD398\uC774\uC9C0 \uC0C8\uB85C \uACE0\uCE58\uAE30",
    'embedded.confluence.need-to-log-in-paragraph': "\uC774 \uD398\uC774\uC9C0\uB97C \uBCF4\uB824\uBA74 \uB85C\uADF8\uC778\uD574\uC57C \uD569\uB2C8\uB2E4",
    'embedded.confluence.still-having-trouble-paragraph': "\uC544\uC9C1 \uBB38\uC81C\uAC00 \uC788\uC2B5\uB2C8\uAE4C? \uD0C0\uC0AC \uCFE0\uD0A4\uB97C \uC0AC\uC6A9\uC73C\uB85C \uC124\uC815\uD588\uB294\uC9C0 \uD655\uC778\uD558\uAC70\uB098 {link}",
    'embedded.confluence.troubleshooting-link-text': "\uBB38\uC81C \uD574\uACB0 \uAC00\uC774\uB4DC\uB97C \uCC38\uC870\uD558\uC138\uC694.",
    'embedded.confluence.troubleshooting-link.aria-label': "\uBB38\uC81C \uD574\uACB0 \uAC00\uC774\uB4DC \uB9C1\uD06C"
};


var $0433a47f9fb8dcfc$export$2e2bcd8739ae039 = (0, $7b7ae6970e843014$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $3d61379279fb7978$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Vi har sett overalt, men dette innholdet eksisterer ikke. Det kan ha blitt slettet. Med mindre nettadressen har en skrivefeil \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Vi finner ikke det du leter etter',
    'embedded.confluence.already-logged-in-paragraph': "Er du allerede logget p\xe5? Pr\xf8v \xe5 oppdatere.",
    'embedded.confluence.footer.hover.text': 'Vis i Confluence',
    'embedded.confluence.footer.prefix': 'Levert av',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Logg p\xe5 Confluence",
    'embedded.confluence.login-page.login-button': "Logg p\xe5 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "P\xe5loggingsknapp",
    'embedded.confluence.login-page.login-text': "Du m\xe5 v\xe6re logget p\xe5 for \xe5 se denne siden",
    'embedded.confluence.login-page.refresh-page-banner': "Etter p\xe5logging skal denne siden oppdateres automatisk. Hvis ikke, kan du klikke her for \xe5 oppdatere",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Oppdater siden',
    'embedded.confluence.need-to-log-in-paragraph': "Du m\xe5 v\xe6re logget p\xe5 for \xe5 se denne siden",
    'embedded.confluence.still-having-trouble-paragraph': 'Har du fortsatt problemer? Kontroller at tredjeparts informasjonskapsler er aktivert, eller {link}',
    'embedded.confluence.troubleshooting-link-text': "se denne feils\xf8kingsveiledningen.",
    'embedded.confluence.troubleshooting-link.aria-label': "kobling til feils\xf8kingsveiledning"
};


var $746f02eed1044242$export$2e2bcd8739ae039 = (0, $3d61379279fb7978$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $427e9bf382879429$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "We hebben overal gezocht, maar de pagina bestaat niet. Het kan zijn dat deze verwijderd is. Tenzij de URL een typefout bevat \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'We konden niet vinden wat je zocht',
    'embedded.confluence.already-logged-in-paragraph': 'Al ingelogd? Probeer te vernieuwen.',
    'embedded.confluence.footer.hover.text': 'Weergeven in Confluence',
    'embedded.confluence.footer.prefix': 'Mogelijk gemaakt door',
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Inloggen bij Confluence',
    'embedded.confluence.login-page.login-button': 'Inloggen bij Confluence',
    'embedded.confluence.login-page.login-button.aria-label': 'Login-knop',
    'embedded.confluence.login-page.login-text': 'Je moet ingelogd zijn om deze pagina te bekijken',
    'embedded.confluence.login-page.refresh-page-banner': 'Nadat je bent ingelogd, moet deze pagina automatisch vernieuwen. Als dit niet gebeurt, kun je hier klikken om te vernieuwen',
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Pagina vernieuwen',
    'embedded.confluence.need-to-log-in-paragraph': 'Je moet ingelogd zijn om deze pagina te bekijken',
    'embedded.confluence.still-having-trouble-paragraph': 'Nog steeds niet gelukt? Zorg ervoor dat cookies van derden zijn ingeschakeld of {link}',
    'embedded.confluence.troubleshooting-link-text': 'raadpleeg deze handleiding voor probleemoplossing.',
    'embedded.confluence.troubleshooting-link.aria-label': 'link naar handleiding voor probleemoplossing'
};


var $a7633fcbda8fb655$export$2e2bcd8739ae039 = (0, $427e9bf382879429$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $0cff0319137b1b7e$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Szukali\u015Bmy tej strony wsz\u0119dzie, ale nigdzie jej nie ma. Mo\u017Cliwe, \u017Ce\xa0zosta\u0142a usuni\u0119ta. O\xa0ile, oczywi\u015Bcie, do\xa0adresu URL nie wkrad\u0142a si\u0119 liter\xf3wka \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Nie mo\u017Cna znale\u017A\u0107 tego, czego szukasz",
    'embedded.confluence.already-logged-in-paragraph': "Ju\u017C przeprowadzono logowanie? Spr\xf3buj od\u015Bwie\u017Cy\u0107.",
    'embedded.confluence.footer.hover.text': "Wy\u015Bwietl w Confluence",
    'embedded.confluence.footer.prefix': "Obs\u0142ugiwane przez",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Zaloguj si\u0119 w Confluence",
    'embedded.confluence.login-page.login-button': "Zaloguj si\u0119 w systemie Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Przycisk logowania',
    'embedded.confluence.login-page.login-text': "Musisz si\u0119 zalogowa\u0107, aby wy\u015Bwietli\u0107 t\u0119 stron\u0119.",
    'embedded.confluence.login-page.refresh-page-banner': "Po zalogowaniu ta strona powinna od\u015Bwie\u017Cy\u0107 si\u0119 automatycznie. Je\u015Bli tak si\u0119 nie stanie, kliknij tutaj, aby od\u015Bwie\u017Cy\u0107.",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Od\u015Bwie\u017C stron\u0119",
    'embedded.confluence.need-to-log-in-paragraph': "Musisz si\u0119 zalogowa\u0107, aby wy\u015Bwietli\u0107 t\u0119 stron\u0119.",
    'embedded.confluence.still-having-trouble-paragraph': "Nadal masz problem? Upewnij si\u0119, \u017Ce obs\u0142uga plik\xf3w cookie innych firm jest w\u0142\u0105czona lub {link}.",
    'embedded.confluence.troubleshooting-link-text': "zapoznaj si\u0119 z tym przewodnikiem rozwi\u0105zywania problem\xf3w",
    'embedded.confluence.troubleshooting-link.aria-label': "\u0142\u0105cze do przewodnika rozwi\u0105zywania problem\xf3w"
};


var $44b404dcb1fc48a7$export$2e2bcd8739ae039 = (0, $0cff0319137b1b7e$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $a94647d63e99be1c$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "A gente procurou em todo lugar, mas ela n\xe3o existe. Talvez tenha sido exclu\xedda. A menos, \xe9 claro, que o URL contenha um erro de digita\xe7\xe3o \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "N\xe3o foi poss\xedvel encontrar o que voc\xea est\xe1 procurando",
    'embedded.confluence.already-logged-in-paragraph': "J\xe1 entrou? Experimente atualizar.",
    'embedded.confluence.footer.hover.text': 'Visualizar no Confluence',
    'embedded.confluence.footer.prefix': "Distribu\xeddo por",
    'embedded.confluence.generic-error-page.login-to-confluence-button': 'Entrar no Confluence',
    'embedded.confluence.login-page.login-button': 'Entrar no Confluence',
    'embedded.confluence.login-page.login-button.aria-label': "Bot\xe3o Entrar",
    'embedded.confluence.login-page.login-text': "Voc\xea precisa entrar para ver esta p\xe1gina",
    'embedded.confluence.login-page.refresh-page-banner': "Depois do login, a atualiza\xe7\xe3o da p\xe1gina \xe9 autom\xe1tica. Se isso n\xe3o acontecer, voc\xea pode clicar aqui para atualizar",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Atualizar p\xe1gina",
    'embedded.confluence.need-to-log-in-paragraph': "Voc\xea precisa entrar para ver esta p\xe1gina",
    'embedded.confluence.still-having-trouble-paragraph': "Ainda est\xe1 tendo problemas? Verifique se os cookies de terceiros est\xe3o habilitados ou {link}",
    'embedded.confluence.troubleshooting-link-text': "consulte este guia de solu\xe7\xe3o de problemas.",
    'embedded.confluence.troubleshooting-link.aria-label': "link do guia de solu\xe7\xe3o de problemas"
};


var $91dadffec46da81e$export$2e2bcd8739ae039 = (0, $a94647d63e99be1c$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $3f545fe5823c593a$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u041C\u044B \u0438\u0441\u043A\u0430\u043B\u0438 \u043F\u043E\u0432\u0441\u044E\u0434\u0443, \u043D\u043E \u0442\u0430\u043A\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442. \u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u043E\u043D\u0430 \u0431\u044B\u043B\u0430 \u0443\u0434\u0430\u043B\u0435\u043D\u0430. \u0415\u0441\u043B\u0438, \u043A\u043E\u043D\u0435\u0447\u043D\u043E, URL-\u0430\u0434\u0440\u0435\u0441 \u0443\u043A\u0430\u0437\u0430\u043D \u0432\u0435\u0440\u043D\u043E \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043D\u0430\u0439\u0442\u0438 \u0442\u043E, \u0447\u0442\u043E \u0432\u044B \u0438\u0449\u0435\u0442\u0435",
    'embedded.confluence.already-logged-in-paragraph': "\u0412\u044B \u0443\u0436\u0435 \u0432\u043E\u0448\u043B\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443? \u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443.",
    'embedded.confluence.footer.hover.text': "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0432 Confluence",
    'embedded.confluence.footer.prefix': "\u041F\u0440\u0438 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0435",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0412\u043E\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button': "\u0412\u043E\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u041A\u043D\u043E\u043F\u043A\u0430 \u0432\u0445\u043E\u0434\u0430",
    'embedded.confluence.login-page.login-text': "\u0414\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.login-page.refresh-page-banner': "\u041F\u043E\u0441\u043B\u0435 \u0432\u0445\u043E\u0434\u0430 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C\u0441\u044F. \u0415\u0441\u043B\u0438 \u044D\u0442\u043E\u0433\u043E \u043D\u0435 \u043F\u0440\u043E\u0438\u0437\u043E\u0439\u0434\u0435\u0442, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u0437\u0434\u0435\u0441\u044C, \u0447\u0442\u043E\u0431\u044B \u0435\u0435 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443",
    'embedded.confluence.need-to-log-in-paragraph': "\u0414\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.still-having-trouble-paragraph': "\u041F\u0440\u043E\u0431\u043B\u0435\u043C\u0430 \u043D\u0435 \u0438\u0441\u0447\u0435\u0437\u043B\u0430? \u0423\u0431\u0435\u0434\u0438\u0442\u0435\u0441\u044C, \u0447\u0442\u043E \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0438\u0435 \u0444\u0430\u0439\u043B\u044B cookie \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u044B, \u0438\u043B\u0438 {link}",
    'embedded.confluence.troubleshooting-link-text': "\u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u043A \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u0443 \u043F\u043E \u0443\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u044E \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A.",
    'embedded.confluence.troubleshooting-link.aria-label': "\u0441\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u043E \u043F\u043E \u0443\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u0438\u044E \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A"
};


var $f2ebe896db83eed6$export$2e2bcd8739ae039 = (0, $3f545fe5823c593a$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $34e7fd9a8ca859a8$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Vi tittade \xf6verallt, men den finns bara inte. Den kan ha raderats. S\xe5vida webbadressen inte inneh\xe5ller n\xe5got stavfel \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': 'Vi hittar inte det du letar efter',
    'embedded.confluence.already-logged-in-paragraph': "\xc4r du redan inloggad? Uppdatera sidan.",
    'embedded.confluence.footer.hover.text': 'Visa i Confluence',
    'embedded.confluence.footer.prefix': 'Drivs av',
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Logga in p\xe5 Confluence",
    'embedded.confluence.login-page.login-button': "Logga in p\xe5 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': 'Inloggningsknapp',
    'embedded.confluence.login-page.login-text': "Du m\xe5ste vara inloggad f\xf6r att visa den h\xe4r sidan",
    'embedded.confluence.login-page.refresh-page-banner': "Den h\xe4r sidan b\xf6r uppdateras automatiskt efter inloggningen. Annars kan du klicka h\xe4r f\xf6r att uppdatera den",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Uppdatera sidan',
    'embedded.confluence.need-to-log-in-paragraph': "Du m\xe5ste vara inloggad f\xf6r att visa den h\xe4r sidan",
    'embedded.confluence.still-having-trouble-paragraph': "Har du fortfarande problem? Se till att cookies f\xf6r tredje parter \xe4r aktiverade, eller {link}",
    'embedded.confluence.troubleshooting-link-text': "kolla in den h\xe4r fels\xf6kningsguiden.",
    'embedded.confluence.troubleshooting-link.aria-label': "l\xe4nk till fels\xf6kningsguide"
};


var $e47846e1ecea23cd$export$2e2bcd8739ae039 = (0, $34e7fd9a8ca859a8$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Thai (Thailand)
var $946e420301e09504$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u0E40\u0E23\u0E32\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E17\u0E38\u0E01\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27 \u0E41\u0E15\u0E48\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23 \u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2D\u0E32\u0E08\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E2D\u0E2D\u0E01\u0E44\u0E1B\u0E41\u0E25\u0E49\u0E27 \u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E32\u0E08\u0E21\u0E35\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E1C\u0E34\u0E14\u0E43\u0E19 URL \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E2A\u0E34\u0E48\u0E07\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E04\u0E49\u0E19\u0E2B\u0E32",
    'embedded.confluence.already-logged-in-paragraph': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E41\u0E25\u0E49\u0E27\u0E43\u0E0A\u0E48\u0E44\u0E2B\u0E21 \u0E25\u0E2D\u0E07\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E2B\u0E19\u0E49\u0E32",
    'embedded.confluence.footer.hover.text': "\u0E14\u0E39\u0E43\u0E19 Confluence",
    'embedded.confluence.footer.prefix': "\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E42\u0E14\u0E22",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A Confluence",
    'embedded.confluence.login-page.login-button': "\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u0E1B\u0E38\u0E48\u0E21\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A",
    'embedded.confluence.login-page.login-text': "\u0E04\u0E38\u0E13\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49",
    'embedded.confluence.login-page.refresh-page-banner': "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E41\u0E25\u0E49\u0E27 \u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E19\u0E35\u0E49\u0E04\u0E27\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34 \u0E2B\u0E32\u0E01\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34 \u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25",
    'embedded.confluence.need-to-log-in-paragraph': "\u0E04\u0E38\u0E13\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49",
    'embedded.confluence.still-having-trouble-paragraph': "\u0E22\u0E31\u0E07\u0E04\u0E07\u0E21\u0E35\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E43\u0E0A\u0E48\u0E44\u0E2B\u0E21 \u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E04\u0E38\u0E01\u0E01\u0E35\u0E49\u0E02\u0E2D\u0E07\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21\u0E2D\u0E22\u0E39\u0E48 \u0E2B\u0E23\u0E37\u0E2D {link}",
    'embedded.confluence.troubleshooting-link-text': "\u0E14\u0E39\u0E17\u0E35\u0E48\u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E19\u0E35\u0E49",
    'embedded.confluence.troubleshooting-link.aria-label': "\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02\u0E1B\u0E31\u0E0D\u0E2B\u0E32"
};


var $7725b2b070b751bc$export$2e2bcd8739ae039 = (0, $946e420301e09504$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Turkish (Turkey)
var $0e582826fbc9fc61$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Her yere bakt\u0131k fakat bulamad\u0131k. Silinmi\u015F olabilir. Tabii e\u011Fer URL'de bir yaz\u0131m hatas\u0131 yoksa \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Arad\u0131\u011F\u0131n\u0131z bulunamad\u0131",
    'embedded.confluence.already-logged-in-paragraph': "Oturumunuz zaten a\xe7\u0131k m\u0131? Sayfay\u0131 yenilemeyi deneyin.",
    'embedded.confluence.footer.hover.text': "Confluence'ta g\xf6r\xfcnt\xfcleyin",
    'embedded.confluence.footer.prefix': "Sa\u011Flayan:",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "Confluence'ta oturum a\xe7",
    'embedded.confluence.login-page.login-button': "Confluence'ta oturum a\xe7",
    'embedded.confluence.login-page.login-button.aria-label': "Oturum A\xe7ma D\xfc\u011Fmesi",
    'embedded.confluence.login-page.login-text': "Bu sayfay\u0131 g\xf6r\xfcnt\xfclemek i\xe7in oturum a\xe7man\u0131z gerekir",
    'embedded.confluence.login-page.refresh-page-banner': "Oturum a\xe7t\u0131ktan sonra bu sayfa otomatik olarak yenilenmelidir. Yenilenmezse buraya t\u0131klayarak yenileyebilirsiniz",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "Sayfay\u0131 yenile",
    'embedded.confluence.need-to-log-in-paragraph': "Bu sayfay\u0131 g\xf6r\xfcnt\xfclemek i\xe7in oturum a\xe7man\u0131z gerekir",
    'embedded.confluence.still-having-trouble-paragraph': "Sorun ya\u015Famaya devam m\u0131 ediyorsunuz? \xdc\xe7\xfcnc\xfc taraf \xe7erezlerinin etkinle\u015Ftirildi\u011Finden emin olun ya da {link}",
    'embedded.confluence.troubleshooting-link-text': "bu sorun giderme k\u0131lavuzuna ba\u015Fvurun",
    'embedded.confluence.troubleshooting-link.aria-label': "sorun giderme k\u0131lavuzu ba\u011Flant\u0131s\u0131"
};


var $ed36669dfc29feb4$export$2e2bcd8739ae039 = (0, $0e582826fbc9fc61$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Ukrainian (Ukraine)
var $46c750dbfcb62780$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u041D\u0430 \u0436\u0430\u043B\u044C, \u043D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E. \u041C\u043E\u0436\u043B\u0438\u0432\u043E, \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0431\u0443\u043B\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E. \u042F\u043A\u0449\u043E, \u0437\u0432\u0456\u0441\u043D\u043E, \u0432 URL-\u0430\u0434\u0440\u0435\u0441\u0456 \u043D\u0435\u043C\u0430\u0454 \u043F\u043E\u043C\u0438\u043B\u043A\u0438 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u041D\u0430 \u0436\u0430\u043B\u044C, \u0437\u0430 \u0432\u0430\u0448\u0438\u043C \u0437\u0430\u043F\u0438\u0442\u043E\u043C \u043D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    'embedded.confluence.already-logged-in-paragraph': "\u0423\u0436\u0435 \u0432\u0432\u0456\u0439\u0448\u043B\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443? \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443.",
    'embedded.confluence.footer.hover.text': "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.footer.prefix': "\u041D\u0430 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0456",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0423\u0432\u0456\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button': "\u0423\u0432\u0456\u0439\u0442\u0438 \u0432 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u041A\u043D\u043E\u043F\u043A\u0430 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0443",
    'embedded.confluence.login-page.login-text': "\u0429\u043E\u0431 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0446\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443, \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0432\u0456\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.login-page.refresh-page-banner': "\u041F\u0456\u0441\u043B\u044F \u0432\u0445\u043E\u0434\u0443 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u0446\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430 \u043E\u043D\u043E\u0432\u043B\u044E\u0432\u0430\u0442\u0438\u043C\u0435\u0442\u044C\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E. \u042F\u043A\u0449\u043E \u043D\u0456, \u0432\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u0442\u0438\u0441\u043D\u0443\u0442\u0438 \u0442\u0443\u0442, \u0449\u043E\u0431 \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0457\u0457",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
    'embedded.confluence.need-to-log-in-paragraph': "\u0429\u043E\u0431 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0446\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443, \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0432\u0456\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    'embedded.confluence.still-having-trouble-paragraph': "\u0414\u043E\u0441\u0456 \u0432\u0438\u043D\u0438\u043A\u0430\u044E\u0442\u044C \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438? \u041F\u0435\u0440\u0435\u043A\u043E\u043D\u0430\u0439\u0442\u0435\u0441\u044F, \u0449\u043E \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0456 \u0444\u0430\u0439\u043B\u0438 cookie \u0432\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u043E, \u0430\u0431\u043E {link}.",
    'embedded.confluence.troubleshooting-link-text': "\u0441\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u0439\u0442\u0435\u0441\u044F \u0446\u0438\u043C \u043F\u043E\u0441\u0456\u0431\u043D\u0438\u043A\u043E\u043C \u0437 \u0443\u0441\u0443\u043D\u0435\u043D\u043D\u044F \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A",
    'embedded.confluence.troubleshooting-link.aria-label': "\u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0430 \u043F\u043E\u0441\u0456\u0431\u043D\u0438\u043A \u0437 \u0443\u0441\u0443\u043D\u0435\u043D\u043D\u044F \u043D\u0435\u043F\u043E\u043B\u0430\u0434\u043E\u043A"
};


var $aa8d0c7996b9d139$export$2e2bcd8739ae039 = (0, $46c750dbfcb62780$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Vietnamese (Vietnam)
var $15b8e8af209dce71$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "Ch\xfang t\xf4i \u0111\xe3 t\xecm kh\u1EAFp n\u01A1i nh\u01B0ng n\u1ED9i dung n\xe0y kh\xf4ng t\u1ED3n t\u1EA1i. N\u1ED9i dung n\xe0y c\xf3 th\u1EC3 \u0111\xe3 b\u1ECB x\xf3a. Tr\u1EEB phi c\xf3 l\u1ED7i \u0111\xe1nh m\xe1y trong URL \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "Ch\xfang t\xf4i kh\xf4ng t\xecm \u0111\u01B0\u1EE3c nh\u1EEFng g\xec b\u1EA1n mu\u1ED1n",
    'embedded.confluence.already-logged-in-paragraph': "B\u1EA1n \u0111\xe3 \u0111\u0103ng nh\u1EADp? H\xe3y th\u1EED l\xe0m m\u1EDBi.",
    'embedded.confluence.footer.hover.text': 'Xem trong Confluence',
    'embedded.confluence.footer.prefix': "\u0110\u01B0\u1EE3c h\u1ED7 tr\u1EE3 b\u1EDFi",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u0110\u0103ng nh\u1EADp v\xe0o Confluence",
    'embedded.confluence.login-page.login-button': "\u0110\u0103ng nh\u1EADp v\xe0o Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "N\xfat \u0110\u0103ng nh\u1EADp",
    'embedded.confluence.login-page.login-text': "B\u1EA1n c\u1EA7n \u0111\u0103ng nh\u1EADp \u0111\u1EC3 xem trang n\xe0y",
    'embedded.confluence.login-page.refresh-page-banner': "Sau khi \u0111\u0103ng nh\u1EADp, trang n\xe0y s\u1EBD t\u1EF1 \u0111\u1ED9ng l\xe0m m\u1EDBi. N\u1EBFu kh\xf4ng, b\u1EA1n c\xf3 th\u1EC3 b\u1EA5m v\xe0o \u0111\xe2y \u0111\u1EC3 l\xe0m m\u1EDBi",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "L\xe0m m\u1EDBi trang",
    'embedded.confluence.need-to-log-in-paragraph': "B\u1EA1n c\u1EA7n \u0111\u0103ng nh\u1EADp \u0111\u1EC3 xem trang n\xe0y",
    'embedded.confluence.still-having-trouble-paragraph': "B\u1EA1n v\u1EABn g\u1EB7p s\u1EF1 c\u1ED1? \u0110\u1EA3m b\u1EA3o b\u1EA1n \u0111\xe3 b\u1EADt c\xe1c cookie c\u1EE7a b\xean th\u1EE9 3 ho\u1EB7c {link}",
    'embedded.confluence.troubleshooting-link-text': "tham kh\u1EA3o h\u01B0\u1EDBng d\u1EABn kh\u1EAFc ph\u1EE5c s\u1EF1 c\u1ED1 n\xe0y.",
    'embedded.confluence.troubleshooting-link.aria-label': "li\xean k\u1EBFt h\u01B0\u1EDBng d\u1EABn kh\u1EAFc ph\u1EE5c s\u1EF1 c\u1ED1"
};


var $e5aa7fa4798e6e30$export$2e2bcd8739ae039 = (0, $15b8e8af209dce71$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $cab995b32cecb231$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u6211\u4EEC\u5DF2\u56DB\u5904\u5BFB\u627E\uFF0C\u4F46\u5B83\u5E76\u4E0D\u5B58\u5728\u3002\u5B83\u53EF\u80FD\u5DF2\u88AB\u5220\u9664\u3002\u9664\u975E\u60A8\u7684 URL \u5305\u542B\u9519\u522B\u5B57 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u672A\u627E\u5230\u60A8\u8981\u67E5\u627E\u7684\u9875\u9762",
    'embedded.confluence.already-logged-in-paragraph': "\u5DF2\u767B\u5F55\uFF1F\u8BF7\u5C1D\u8BD5\u5237\u65B0\u3002",
    'embedded.confluence.footer.hover.text': "\u5728 Confluence \u4E2D\u67E5\u770B",
    'embedded.confluence.footer.prefix': "\u6280\u672F\u652F\u6301\uFF1A",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u767B\u5F55\u5230 Confluence",
    'embedded.confluence.login-page.login-button': "\u767B\u5F55 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u767B\u5F55\u6309\u94AE",
    'embedded.confluence.login-page.login-text': "\u60A8\u9700\u8981\u767B\u5F55\u624D\u80FD\u67E5\u770B\u6B64\u9875\u9762",
    'embedded.confluence.login-page.refresh-page-banner': "\u767B\u5F55\u540E\uFF0C\u6B64\u9875\u9762\u5E94\u4F1A\u81EA\u52A8\u5237\u65B0\u3002\u5982\u679C\u672A\u5237\u65B0\uFF0C\u60A8\u53EF\u4EE5\u70B9\u51FB\u6B64\u5904\u8FDB\u884C\u5237\u65B0",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u5237\u65B0\u9875\u9762",
    'embedded.confluence.need-to-log-in-paragraph': "\u60A8\u9700\u8981\u767B\u5F55\u624D\u80FD\u67E5\u770B\u6B64\u9875\u9762",
    'embedded.confluence.still-having-trouble-paragraph': "\u4ECD\u6709\u95EE\u9898\uFF1F\u8BF7\u786E\u4FDD\u5DF2\u542F\u7528\u7B2C\u4E09\u65B9 Cookie\uFF0C\u6216{link}",
    'embedded.confluence.troubleshooting-link-text': "\u53C2\u9605\u6B64\u6545\u969C\u6392\u9664\u6307\u5357\u3002",
    'embedded.confluence.troubleshooting-link.aria-label': "\u6545\u969C\u6392\u9664\u6307\u5357\u94FE\u63A5"
};


var $f0833e2eb2dc192d$export$2e2bcd8739ae039 = (0, $cab995b32cecb231$export$2e2bcd8739ae039);

/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $ef147dc4e43d0e40$export$2e2bcd8739ae039 = {
    'embedded-confluence-common.src.content.empty-state-description': "\u6211\u5011\u5DF2\u627E\u904D\u56DB\u8655\uFF0C\u4F46\u8A72\u7DB2\u9801\u4F3C\u4E4E\u4E0D\u5B58\u5728\uFF0C\u53EF\u80FD\u5DF2\u906D\u5230\u522A\u9664\u3002\u7576\u7136\uFF0C\u9664\u975E URL \u4E2D\u6709\u932F\u5B57 \uD83D\uDE09",
    'embedded-confluence-common.src.content.empty-state-header': "\u6211\u5011\u627E\u4E0D\u5230\u60A8\u8981\u5C0B\u627E\u7684\u5167\u5BB9",
    'embedded.confluence.already-logged-in-paragraph': "\u5DF2\u7D93\u767B\u5165\u4E86\u55CE\uFF1F\u8ACB\u5617\u8A66\u91CD\u65B0\u6574\u7406\u3002",
    'embedded.confluence.footer.hover.text': "\u5728 Confluence \u4E2D\u6AA2\u8996",
    'embedded.confluence.footer.prefix': "\u7531\u4EE5\u4E0B\u6280\u8853\u652F\u63F4\uFF1A",
    'embedded.confluence.generic-error-page.login-to-confluence-button': "\u767B\u5165 Confluence",
    'embedded.confluence.login-page.login-button': "\u767B\u5165 Confluence",
    'embedded.confluence.login-page.login-button.aria-label': "\u767B\u5165\u6309\u9215",
    'embedded.confluence.login-page.login-text': "\u60A8\u9700\u8981\u767B\u5165\u624D\u80FD\u6AA2\u8996\u6B64\u9801\u9762",
    'embedded.confluence.login-page.refresh-page-banner': "\u767B\u5165\u5F8C\uFF0C\u6B64\u9801\u9762\u61C9\u8A72\u6703\u81EA\u52D5\u91CD\u65B0\u6574\u7406\u3002\u5982\u679C\u6C92\u6709\uFF0C\u60A8\u53EF\u4EE5\u6309\u4E00\u4E0B\u9019\u88E1\u9032\u884C\u91CD\u65B0\u6574\u7406",
    'embedded.confluence.login-page.refresh-page-banner-refresh-link': "\u91CD\u65B0\u6574\u7406\u9801\u9762",
    'embedded.confluence.need-to-log-in-paragraph': "\u60A8\u9700\u8981\u767B\u5165\u624D\u80FD\u6AA2\u8996\u6B64\u9801\u9762",
    'embedded.confluence.still-having-trouble-paragraph': "\u4ECD\u7136\u6709\u554F\u984C\u55CE\uFF1F\u8ACB\u78BA\u5B9A\u60A8\u5DF2\u555F\u7528\u7B2C\u4E09\u65B9 Cookie\uFF0C\u6216{link}",
    'embedded.confluence.troubleshooting-link-text': "\u53C3\u95B1\u6B64\u7591\u96E3\u6392\u89E3\u6307\u5357\u3002",
    'embedded.confluence.troubleshooting-link.aria-label': "\u7591\u96E3\u6392\u89E3\u6307\u5357\u9023\u7D50"
};


var $a311485efbb78027$export$2e2bcd8739ae039 = (0, $ef147dc4e43d0e40$export$2e2bcd8739ae039);


const $b4f623f5c9d64129$var$localeToTranslations = {
    'cs-CZ': $773347a5ecc0b550$export$2e2bcd8739ae039,
    'da-DK': $4b444f9ddec14a5d$export$2e2bcd8739ae039,
    'de-DE': $14eaab80d38a0ee6$export$2e2bcd8739ae039,
    'en-US': $865d855a1fa5d471$export$2e2bcd8739ae039,
    'en-GB': $6c55c06d45f02d30$export$2e2bcd8739ae039,
    'en-ZZ': $a9c1813fe7e4af9d$export$2e2bcd8739ae039,
    'es-ES': $e36d3bdbd9bcfbc6$export$2e2bcd8739ae039,
    'fi-FI': $a53fe41909f30ebd$export$2e2bcd8739ae039,
    'fr-FR': $cee97febb9adf70f$export$2e2bcd8739ae039,
    'hu-HU': $4fd5ea0e4e732beb$export$2e2bcd8739ae039,
    'it-IT': $fe343340a045571b$export$2e2bcd8739ae039,
    'ja-JP': $fc6992a6d33f0da5$export$2e2bcd8739ae039,
    'ko-KR': $0433a47f9fb8dcfc$export$2e2bcd8739ae039,
    'no-NO': $746f02eed1044242$export$2e2bcd8739ae039,
    'nl-NL': $a7633fcbda8fb655$export$2e2bcd8739ae039,
    'pl-PL': $44b404dcb1fc48a7$export$2e2bcd8739ae039,
    'pt-BR': $91dadffec46da81e$export$2e2bcd8739ae039,
    'ru-RU': $f2ebe896db83eed6$export$2e2bcd8739ae039,
    'sv-SE': $e47846e1ecea23cd$export$2e2bcd8739ae039,
    'tr-TR': $ed36669dfc29feb4$export$2e2bcd8739ae039,
    'th-TH': $7725b2b070b751bc$export$2e2bcd8739ae039,
    'uk-UA': $aa8d0c7996b9d139$export$2e2bcd8739ae039,
    'vi-VN': $e5aa7fa4798e6e30$export$2e2bcd8739ae039,
    'zh-TW': $a311485efbb78027$export$2e2bcd8739ae039,
    'zh-CN': $f0833e2eb2dc192d$export$2e2bcd8739ae039
};
const $b4f623f5c9d64129$var$fetchTranslations = async (locale)=>$b4f623f5c9d64129$var$localeToTranslations[locale] ?? $865d855a1fa5d471$export$2e2bcd8739ae039;
var $b4f623f5c9d64129$export$2e2bcd8739ae039 = $b4f623f5c9d64129$var$fetchTranslations;
module.exports["default"] = $b4f623f5c9d64129$export$2e2bcd8739ae039;

});

parcelRegister("aI44c", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");

/* ViewPage.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $7pThu = parcelRequire("7pThu");


var $9tQM5 = parcelRequire("9tQM5");

var $kFwgS = parcelRequire("kFwgS");

var $44JTv = parcelRequire("44JTv");


var $1oYQ9 = parcelRequire("1oYQ9");


var $6wQcp = parcelRequire("6wQcp");


var $cGc86 = parcelRequire("cGc86");

const $f3c4af92b1079227$var$embeddedPageContainerSytles = null;
const $f3c4af92b1079227$var$StyledEmbeddedPageContainer = ({ children: children, containerHeight: containerHeight })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testId": "styled-embedded-page-container-id",
        style: {
            height: containerHeight
        },
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4"
        ]),
        children: children
    });
};
const $f3c4af92b1079227$export$767e3006bdbb424a = (props)=>{
    const { hasFooterLogo: shouldShowFooter, isHeightSetFromContent: isHeightSetFromContent, showFooter: showFooter = true } = props;
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const { height: height } = (0, $44JTv.useContentSize)(uniqueKey);
    (0, $6wQcp.useGetCurrentScrollPosition)(isHeightSetFromContent);
    const contentConfiguration = (0, $42omo.useMemo)(()=>({
            experiences: {
                experience: (0, $7pThu.ExperienceNames).VIEW_PAGE,
                ccExperience: (0, $7pThu.ExperienceNames).CC_VIEW_PAGE
            },
            getWrapperElement: (children)=>/*#__PURE__*/ (0, $l998X.jsx)($f3c4af92b1079227$var$StyledEmbeddedPageContainer, {
                    containerHeight: isHeightSetFromContent ? `${height}px` : '100%',
                    children: children
                }),
            hasFooter: showFooter
        }), [
        isHeightSetFromContent,
        height,
        showFooter
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1oYQ9.Content), {
        ...props,
        contentType: (0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE,
        mode: (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
        contentConfiguration: contentConfiguration,
        isHeightSetFromContent: isHeightSetFromContent,
        shouldShowFooter: shouldShowFooter
    });
};



var $elkSx = parcelRequire("elkSx");


var $I1nNR = parcelRequire("I1nNR");


var $gt5FF = parcelRequire("gt5FF");


var $kudeD = parcelRequire("kudeD");




const $d51843cacb6b0e00$export$767e3006bdbb424a = (props)=>{
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $kudeD.usePerformanceMetrics)();
    (0, $42omo.useLayoutEffect)(()=>{
        markIframeLoadMetrics('lazy-load-end');
        markIframeLoadMetrics('common-load-start');
    }, [
        markIframeLoadMetrics
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $gt5FF.default),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cGc86.UniqueKeyProvider), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $elkSx.PageNotFoundEmptyState), {}),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $f3c4af92b1079227$export$767e3006bdbb424a), {
                    ...props
                })
            })
        })
    });
};
module.exports["ViewPage"] = $d51843cacb6b0e00$export$767e3006bdbb424a;

});

parcelRegister("44JTv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $4eu1q = parcelRequire("4eu1q");







const $13cd0f2521f3e6f6$var$MESSAGE_TYPE = 'embeddedConfluenceVisibleHeight';
const $13cd0f2521f3e6f6$export$4b9c38587bbe6e8b = (uniqueKey)=>{
    // The initial height is arbitrarily set to 1000
    const [visibleHeight, setVisibleHeight] = (0, $42omo.useState)(1000);
    (0, $42omo.useEffect)(()=>{
        const contentSizeHandler = (postMessage)=>{
            const data = postMessage.data;
            if (data?.type === $13cd0f2521f3e6f6$var$MESSAGE_TYPE && data?.value && (uniqueKey && (0, $dh538.fg)('platform_deprecate_lp_cc_embed') ? data?.uniqueKey === uniqueKey : true)) setVisibleHeight(data.value);
        };
        window.addEventListener('message', contentSizeHandler);
        return ()=>{
            window.removeEventListener('message', contentSizeHandler);
        };
    }, [
        uniqueKey
    ]);
    return {
        visibleHeight: visibleHeight
    };
};


const $e4f5fef5273f9751$var$MESSAGE_TYPE = 'contentSize';
const $e4f5fef5273f9751$export$7e7123f55b1139c9 = (uniqueKey)=>{
    // The initial height is arbitrarily set to 1000
    const [height, setHeight] = (0, $42omo.useState)(1000);
    /* This visible height refers to the portion of the confluence page that is visible within the iframe without having to scroll.
		When isHeightSetFromContent is true, the embedded page container height toggles between the visible height and the content height
		depending on whether media viewer is open or close.
		This updated was added as a resolution to the bug explained in this ticket: https://hello.jira.atlassian.cloud/browse/CBT-3636
	*/ const { isMediaOpen: isMediaOpen } = (0, $4eu1q.useMediaViewerListener)();
    const { visibleHeight: visibleHeight } = (0, $13cd0f2521f3e6f6$export$4b9c38587bbe6e8b)(uniqueKey);
    (0, $42omo.useEffect)(()=>{
        const contentSizeHandler = (postMessage)=>{
            const data = postMessage.data;
            if (data?.type === $e4f5fef5273f9751$var$MESSAGE_TYPE && data?.height && (uniqueKey && (0, $dh538.fg)('platform_deprecate_lp_cc_embed') ? data?.uniqueKey === uniqueKey : true)) setHeight(data.height);
        };
        window.addEventListener('message', contentSizeHandler);
        return ()=>{
            window.removeEventListener('message', contentSizeHandler);
        };
    }, [
        uniqueKey
    ]);
    return {
        height: isMediaOpen ? visibleHeight : height
    };
};
module.exports["useContentSize"] = $e4f5fef5273f9751$export$7e7123f55b1139c9;

});

parcelRegister("1oYQ9", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");




parcelRequire("42omo");


var $42omo = parcelRequire("42omo");

const $9f20096665d70f6d$var$defaultExperienceContextValue = undefined;
const $9f20096665d70f6d$export$fb99266658f5da06 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($9f20096665d70f6d$var$defaultExperienceContextValue);


function $2b815948b6973dc0$export$c90b54e658fc4d7c({ children: children, name: name }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9f20096665d70f6d$export$fb99266658f5da06).Provider, {
        value: name,
        children: children
    });
}


var $jJf3a = parcelRequire("jJf3a");


var $iudHJ = parcelRequire("iudHJ");




var $4HdGj = parcelRequire("4HdGj");

const $b6040bd8c2dd6c87$export$48d5d434479c259e = ({ experienceTracker: experienceTracker, contentId: contentId, spaceKey: spaceKey, experience: experience, ccExperience: ccExperience })=>{
    const idRef = (0, $42omo.useRef)();
    const ccExperienceStartedRef = (0, $42omo.useRef)(false);
    const id = `${spaceKey}-${contentId}`;
    /**
	 * Start experience as close to the user action as possible.
	 * Our approximation is component's first render.
	 *
	 * Addition to starting experience on first render, embedding products may do SPA transition e.g. view different contents without remounting component.
	 * We need to re-start experience if `contentId` or `spaceKey` has changed.
	 * In this case, experience will abort the current ongoing one and start a new experience (by checking experience id)
	 */ if (idRef.current !== id) {
        experienceTracker.start({
            name: experience,
            id: id,
            collect (events, experience) {
                if (events.find((event)=>event.action === 'taskStart' && event.name === ccExperience && event.id === contentId)) ccExperienceStartedRef.current = true;
                /**
				 * We have experience forwarding from confluence-frontend
				 * With the forwarding experience set up, EP experience will be concluded following CC experience, either "succeed", "fail" or "abort"
				 */ experience.stopOn(events.find((event)=>(0, $4HdGj.isStop)(event) && event.name === ccExperience && event.id === contentId));
            }
        });
        idRef.current = id;
    }
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            /**
			 * User can navigates away (EP component unmount) before CC experience started
			 * In this case, we want to abort EP experience as the conclusion.
			 */ if (idRef.current && !ccExperienceStartedRef.current) experienceTracker.abort({
                name: experience,
                reason: 'User navigated away before starting to load'
            });
        };
    }, [
        experienceTracker,
        experience
    ]);
};


/* Iframe.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");











var $diaaX = parcelRequire("diaaX");


var $dh538 = parcelRequire("dh538");


var $cGc86 = parcelRequire("cGc86");

let $61a21d08c4c4e245$var$host = null;


// simple-xdm relies on window object. It is not available in SSR.
if (typeof window !== 'undefined') {
    // unable to evaluate fg('platform_deprecate_lp_cc_embed') at the module level and using uniqueKey query param (which is feature gated) instead
    let hasUniqueKey = false;
    if (typeof window !== 'undefined') try {
        hasUniqueKey = new URL(window.location.href).searchParams.has('uniqueKey');
    } catch (e) {
        hasUniqueKey = false;
    }
    $61a21d08c4c4e245$var$host = hasUniqueKey ? (parcelRequire("aPXOP")) : (parcelRequire("8RVyV"));
}
function $61a21d08c4c4e245$var$defineModule(name, module) {
    $61a21d08c4c4e245$var$host.defineModule(name, module);
}
const $61a21d08c4c4e245$var$useExperienceForwardingModule = ()=>{
    const experienceTrackerRef = (0, $42omo.useRef)();
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const experienceTracker = (0, $42omo.useContext)((0, $jJf3a.ExperienceTrackerContext));
    if (experienceTrackerRef.current !== experienceTracker) {
        $61a21d08c4c4e245$var$defineModule(uniqueKey && (0, $dh538.fg)('platform_deprecate_lp_cc_embed') ? `${0, $diaaX.EXPERIENCE_FORWARDING_MODULE_NAME}_${uniqueKey}` : (0, $diaaX.EXPERIENCE_FORWARDING_MODULE_NAME), {
            start (options) {
                experienceTracker.start(options);
            },
            abort (options) {
                experienceTracker.abort(options);
            },
            succeed (options) {
                experienceTracker.succeed(options);
            },
            fail (options) {
                experienceTracker.fail(options);
            }
        });
        experienceTrackerRef.current = experienceTracker;
    }
};
const $61a21d08c4c4e245$var$usePassThroughPropsModule = (props)=>{
    const { onContentLoadStarted: onContentLoadStarted, ...passThroughProps } = props;
    const dispatchPropsUpdated = (0, $42omo.useCallback)(()=>{
        $61a21d08c4c4e245$var$host.dispatch((0, $diaaX.PROPS_UPDATED), {
            addon_key: (0, $dh538.fg)('platform_deprecate_lp_cc_embed') ? passThroughProps.uniqueKey ?? (0, $diaaX.CHANNEL_NAME) : (0, $diaaX.CHANNEL_NAME),
            ...(0, $dh538.fg)('platform_deprecate_lp_cc_embed') && {
                key: passThroughProps.uniqueKey ?? (0, $diaaX.CHANNEL_NAME)
            }
        }, {
            message: JSON.stringify(passThroughProps)
        });
    /**
		 * Disable react-hooks/exhaustive-deps linting, the dependency has passThroughProps spreading on its keys and values
		 * This should be able to handle any changes to the `passThroughProps` would recall the effect function.
		 **/ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...Object.keys(passThroughProps),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...Object.values(passThroughProps),
        passThroughProps.uniqueKey
    ]);
    const dispatchPropsUpdatedRef = (0, $42omo.useRef)();
    if (dispatchPropsUpdatedRef.current !== dispatchPropsUpdated) {
        $61a21d08c4c4e245$var$defineModule(passThroughProps.uniqueKey && (0, $dh538.fg)('platform_deprecate_lp_cc_embed') ? `${0, $diaaX.PASSTHROUGH_PROPS_MODULE_NAME}_${passThroughProps.uniqueKey}` : (0, $diaaX.PASSTHROUGH_PROPS_MODULE_NAME), {
            getProps: ()=>{
                onContentLoadStarted?.();
                dispatchPropsUpdated();
            },
            navigationPolicyNavigate: passThroughProps.navigationPolicy?.navigate,
            onPublish: passThroughProps?.onPublish
        });
        dispatchPropsUpdatedRef.current = dispatchPropsUpdated;
    }
    (0, $42omo.useEffect)(dispatchPropsUpdated, [
        dispatchPropsUpdated
    ]);
};
function $61a21d08c4c4e245$export$c745b3af35ea8585(iframeSrc, passThroughProps) {
    const channelRef = (0, $42omo.useRef)();
    const uniqueKey = passThroughProps.uniqueKey ?? (0, $diaaX.CHANNEL_NAME);
    $61a21d08c4c4e245$var$useExperienceForwardingModule();
    $61a21d08c4c4e245$var$usePassThroughPropsModule(passThroughProps);
    if (channelRef.current?.src !== iframeSrc) channelRef.current = $61a21d08c4c4e245$var$host.create({
        addon_key: (0, $dh538.fg)('platform_deprecate_lp_cc_embed') ? uniqueKey : (0, $diaaX.CHANNEL_NAME),
        key: (0, $dh538.fg)('platform_deprecate_lp_cc_embed') ? uniqueKey : (0, $diaaX.CHANNEL_NAME),
        url: iframeSrc,
        options: {
            globalOptions: {},
            // `hostFrameOffset` - Offset number specified to find iframe's host frame, it will be `window.top` if not specified.
            // Since EP frame can be embedded by middle layer frame(s), we set `hostFrameOffset` to 1 to ensure EP iframe's direct parent is the host frame.
            hostFrameOffset: 1,
            hostOrigin: window.location.origin
        }
    });
    return channelRef.current;
}





function $52c6198c4c30a183$var$isSameOrigin(targetWindow, currentWindow = window) {
    let isSameOrigin1;
    try {
        isSameOrigin1 = targetWindow?.location.origin === currentWindow?.location.origin;
    } catch (e) {
        // catch the DOM exception, mark the resolution to "false"
        isSameOrigin1 = false;
    }
    return isSameOrigin1;
}
const $52c6198c4c30a183$export$28f1b4bd74242643 = (hostWindow, offset = 0)=>{
    let currentWindow = hostWindow;
    let hostFrameOffset = 0;
    while(currentWindow && currentWindow !== window.top){
        hostFrameOffset += 1;
        currentWindow = currentWindow.parent;
    }
    return hostFrameOffset - offset;
};
const $52c6198c4c30a183$var$attachHostOffsetOverride = (window1)=>{
    if (window1.top) {
        if ($52c6198c4c30a183$var$isSameOrigin(window1.top)) {
            const containerDepth = $52c6198c4c30a183$export$28f1b4bd74242643(window1);
            // @ts-ignore https://hello.atlassian.net/browse/TYPEF-946
            window1.top.getHostOffsetFunctionOverride = (hostWindow)=>$52c6198c4c30a183$export$28f1b4bd74242643(hostWindow, containerDepth + 1);
        }
    }
};
const $52c6198c4c30a183$var$detachHostOffsetOverride = ()=>{
    if (window.top) {
        if ($52c6198c4c30a183$var$isSameOrigin(window.top)) // @ts-ignore https://hello.atlassian.net/browse/TYPEF-946
        delete window.top.getHostOffsetFunctionOverride;
    }
};
function $52c6198c4c30a183$export$db5957f3934e2c38() {
    (0, $42omo.useEffect)(()=>{
        $52c6198c4c30a183$var$attachHostOffsetOverride(window);
        return ()=>{
            $52c6198c4c30a183$var$detachHostOffsetOverride();
        };
    }, []);
}



var $kudeD = parcelRequire("kudeD");







const $96c652b8f1100cf8$var$iframeStyles = null;
const $96c652b8f1100cf8$export$5137ec99f248330b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ src: src, onLoad: onLoad, onUnload: onUnload, onContentLoadStarted: onContentLoadStarted, ...passThroughProps }, ref)=>{
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $kudeD.usePerformanceMetrics)();
    (0, $42omo.useLayoutEffect)(()=>{
        markIframeLoadMetrics('common-load-end');
        markIframeLoadMetrics('iframe-content-initialized-start');
    }, [
        markIframeLoadMetrics
    ]);
    const iframeOnLoad = (0, $42omo.useCallback)((event)=>{
        onLoad && onLoad(event);
    }, [
        onLoad
    ]);
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    (0, $42omo.useEffect)(()=>{
        const handler = (e)=>{
            // only fire onUnload handler if uniqueKey (if it exists) matches
            const uniqueKeyMatch = !uniqueKey || !e.data?.uniqueKey || e.data.uniqueKey === uniqueKey || !(0, $dh538.fg)('platform_deprecate_lp_cc_embed');
            if (e.data.type === 'windowUnload' && uniqueKeyMatch) onUnload?.();
        };
        window.addEventListener('message', handler);
        return ()=>{
            window.removeEventListener('message', handler);
        };
    }, [
        onUnload,
        uniqueKey
    ]);
    (0, $52c6198c4c30a183$export$db5957f3934e2c38)();
    const channel = (0, $61a21d08c4c4e245$export$c745b3af35ea8585)(src, {
        ...passThroughProps,
        onContentLoadStarted: onContentLoadStarted
    }); // implementation because cleaner index export is not possible with forwardRef
    return /*#__PURE__*/ (0, $l998X.jsx)("iframe", {
        ref: ref,
        title: "confluence-article-iframe",
        "data-testid": "confluence-page-iframe",
        name: channel.name,
        src: src,
        onLoad: iframeOnLoad,
        allow: "autoplay; fullscreen; encrypted-media; clipboard-write" // Same as "fullscreen" in "allow" attribute but it's considered a legacy attribute. https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe#attr-allowfullscreen
        ,
        // Need it in case the browser doesn't support "fullscreen" feature policy.
        allowFullScreen: true,
        ...passThroughProps,
        className: (0, $gMc0m.default)([
            "_19itglyw _1bsb1osq _4t3i1osq"
        ])
    });
});


/* Footer.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-html-anchor */ 









var $inPa6 = parcelRequire("inPa6");


var $lAFHW = parcelRequire("lAFHW");


var $3gadb = parcelRequire("3gadb");


var $fuqSI = parcelRequire("fuqSI");

const $d46b25c378604447$var$FOOTER_CONTENT_HEIGHT = 52;
const $d46b25c378604447$var$FOOTER_BORDER_PX = 2;
const $d46b25c378604447$export$a2dd5f25b5a4e5d2 = $d46b25c378604447$var$FOOTER_CONTENT_HEIGHT + $d46b25c378604447$var$FOOTER_BORDER_PX;
const $d46b25c378604447$var$containerStyles = null;
const $d46b25c378604447$var$contentWrapperStyles = null;
const $d46b25c378604447$var$logoWrapperSyles = null;
const $d46b25c378604447$var$linkStyles = null;
const $d46b25c378604447$export$a06f1c675e846f6f = ({ url: url, linkTooltip: linkTooltip, label: label })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": "footer-container",
        className: (0, $gMc0m.default)([
            "_11c8dcr7 _16jlidpf _1o9zidpf _i0dl1ex1 _x3do1vhv _4t3i1ex1 _syazazsu _1e0c1txw _4cvr1h6o _1bah1h6o"
        ]),
        children: url ? /*#__PURE__*/ (0, $l998X.jsx)($d46b25c378604447$var$ContentAction, {
            tooltipText: linkTooltip,
            href: url,
            children: ({ isHovered: isHovered })=>/*#__PURE__*/ (0, $l998X.jsx)($d46b25c378604447$var$Content, {
                    isHovered: isHovered,
                    label: label
                })
        }) : /*#__PURE__*/ (0, $l998X.jsx)($d46b25c378604447$var$Content, {
            label: label
        })
    });
const $d46b25c378604447$var$Content = ({ isHovered: isHovered, label: label })=>/*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            "_4t3i7vkz _1e0c1txw _1bah1h6o _4cvresu3"
        ]),
        children: [
            label,
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _2lx21bp4 _1bah1h6o _19pkidpf _2hwxidpf _otyridpf _18u0u2gc"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceLogo), {
                    appearance: isHovered ? 'brand' : 'neutral',
                    size: "xxsmall"
                })
            })
        ]
    });
const $d46b25c378604447$var$ContentAction = ({ children: children, tooltipText: tooltipText, href: href })=>{
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'confluenceFooter',
            source: 'embeddedConfluenceViewPageScreen',
            eventType: 'ui'
        }).fire((0, $fuqSI.ANALYTICS_CHANNEL));
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: tooltipText,
        children: /*#__PURE__*/ (0, $l998X.jsx)("a", {
            href: href,
            target: "_blank" // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            ,
            onMouseEnter: ()=>{
                setIsHovered(true);
            },
            onMouseLeave: ()=>{
                setIsHovered(false);
            },
            onClick: handleClick,
            "data-testid": "link",
            className: (0, $gMc0m.default)([
                "_12ji1r31 _1qu2glyw _12y31o36 _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1kw7 _16qsglyw _1q5t1r31 _nt751r31 _1dit1r31 _1ohyglyw _49pcglyw _ksodglyw _1r9x1o36 _1hvw1o36 _4hz81o36 _1nrm1r31 _1a3b1r31 _9oik1r31 _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _9h8h1kw7 _f8pj1kw7 _30l31kw7 _180dglyw _7ehiglyw _1dbzglyw"
            ]),
            children: children({
                isHovered: isHovered
            })
        })
    });
};







/* ErrorScreen.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $8C5kA = parcelRequire("8C5kA");


var $7p4As = parcelRequire("7p4As");


var $7hXDW = parcelRequire("7hXDW");


var $2Nwuj = parcelRequire("2Nwuj");





var $8tdj3 = parcelRequire("8tdj3");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");





var $7pThu = parcelRequire("7pThu");




parcelRequire("42omo");

const $db080d242cf20bf8$export$ae31f6824db63a1c = ({ className: className })=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        width: "148",
        height: "160",
        viewBox: "0 0 148 160",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_499_12980)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "147.652",
                        height: "160",
                        transform: "translate(0.174194)",
                        fill: "var(--ds-icon-inverse, white)",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M90.3627 138.196C90.4862 138.281 90.9631 138.59 91.4435 138.436C91.6734 138.36 91.8243 138.206 92.0268 137.993C92.2944 137.715 92.4625 137.437 92.562 137.245L93.557 137.465C93.6325 137.482 93.7183 137.455 93.7594 137.386C93.8246 137.283 93.78 137.153 93.6737 137.108L92.7438 136.734C92.6718 136.707 92.5929 136.703 92.5208 136.731L91.6253 137.046L90.3558 137.52L90.3627 138.196Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M93.2825 137.273L93.7526 137.492C93.8384 137.534 93.8864 137.63 93.8624 137.722C93.8384 137.825 93.7354 137.894 93.6291 137.873L92.411 137.647L91.6974 138.004L91.7969 137.427L92.5414 137.084L93.2825 137.273Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M93.7457 138.22C93.708 138.312 93.6051 138.357 93.5124 138.326C93.2757 138.22 93.0355 138.11 92.7988 138.004C92.4419 137.99 92.0851 137.973 91.7283 137.959L91.8175 137.578L92.9223 137.582L93.66 137.973C93.7457 138.021 93.7835 138.127 93.7457 138.22Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M93.1281 138.642C93.0767 138.697 92.9943 138.7 92.936 138.655L92.4247 138.257C92.2257 138.209 92.0302 138.161 91.8312 138.113C91.8655 138.014 91.9032 137.911 91.9375 137.811C92.1949 137.87 92.4556 137.931 92.713 137.99L93.1281 138.45C93.1796 138.504 93.1796 138.59 93.1281 138.642Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.7",
                        d: "M132.434 20.5211L60.2655 23.3826V136.799L132.434 139.664V44.1953V20.5211Z",
                        fill: "url(#paint0_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            opacity: "0.6",
                            d: "M147.826 44.9982H121.774V46.1167H147.826V44.9982Z",
                            fill: "url(#paint1_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            opacity: "0.6",
                            d: "M147.826 47.9763H121.774V49.0948H147.826V47.9763Z",
                            fill: "url(#paint2_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            opacity: "0.6",
                            d: "M141.564 50.951H121.774V52.0696H141.564V50.951Z",
                            fill: "url(#paint3_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            opacity: "0.6",
                            d: "M82.238 0H56.186V1.11852H82.238V0Z",
                            fill: "url(#paint4_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            opacity: "0.6",
                            d: "M82.238 2.97815H56.186V4.09667H82.238V2.97815Z",
                            fill: "url(#paint5_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("g", {
                        opacity: "0.6",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            opacity: "0.6",
                            d: "M75.9763 5.95288H56.186V7.0714H75.9763V5.95288Z",
                            fill: "url(#paint6_linear_499_12980)"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.7",
                        d: "M138.058 26.0039L65.889 22.6929V136.11L138.058 132.799V47.2249V26.0039Z",
                        fill: "url(#paint7_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M139.286 108.401L118.151 103.576C117.746 103.484 117.485 103.052 117.571 102.609L122.052 79.5694C122.138 79.1268 122.536 78.8455 122.94 78.9381L144.076 83.7622C144.481 83.8548 144.741 84.2871 144.656 84.7297L140.175 107.769C140.089 108.208 139.691 108.493 139.286 108.401Z",
                        fill: "url(#paint8_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M119.791 101.72L123.75 81.3536L142.436 85.6149L138.476 105.985L119.791 101.72Z",
                        fill: "var(--ds-icon-inverse, white)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M122.813 97.2153L128.169 93.4069L131.652 99.2328L122.813 97.2153Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #99C1FF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M125.912 97.9221L132.866 92.978L137.389 100.54L125.912 97.9221Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #CCE0FF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M130.421 88.2318C130.435 87.3034 129.754 86.5407 128.902 86.5283C128.049 86.5158 127.347 87.2583 127.333 88.1868C127.32 89.1152 128 89.8779 128.853 89.8903C129.705 89.9028 130.407 89.1603 130.421 88.2318Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #99C1FF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M46.2531 49.0468L28.5798 55.9261C28.2401 56.0564 27.8421 55.8712 27.6878 55.5109L19.6248 36.6264C19.4704 36.2627 19.6179 35.8647 19.9576 35.7309L37.6309 28.8517C37.9706 28.7213 38.3686 28.9066 38.523 29.2668L46.586 48.1513C46.7404 48.515 46.5928 48.9164 46.2531 49.0468Z",
                        fill: "url(#paint9_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M28.8577 53.7782L21.728 37.0862L37.353 31.0029L44.4827 47.6984L28.8577 53.7782Z",
                        fill: "var(--ds-background-accent-yellow-subtlest, #FFFAE5)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M35.4488 43.9346H31.2698V48.1136H35.4488V43.9346Z",
                        fill: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M34.8141 35.8716L33.4142 40.6099L38.7254 38.7983L34.8141 35.8716Z",
                        fill: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M29.6298 42.0365C30.4614 41.1853 30.4147 39.7911 29.5256 38.9225C28.6364 38.0538 27.2415 38.0397 26.4099 38.8909C25.5783 39.7421 25.625 41.1363 26.5141 42.005C27.4033 42.8736 28.7982 42.8878 29.6298 42.0365Z",
                        fill: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.7",
                        d: "M124.872 12.64L49.6259 22.6929V136.11L124.872 146.163V39.1722V12.64Z",
                        fill: "url(#paint10_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M94.0374 10.6705L42.3109 22.6929V136.11L117.557 153.292V34.6295L94.0374 10.6705Z",
                        fill: "url(#paint11_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M79.1715 90.5898L79.1198 91.8823L109.851 93.1125L109.903 91.82L79.1715 90.5898Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M47.6972 89.3282L47.6455 90.6207L79.1207 91.8807L79.1725 90.5882L47.6972 89.3282Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M47.704 92.8613L47.6342 94.1528L109.838 97.5169L109.908 96.2253L47.704 92.8613Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M71.0629 97.9737L70.9751 99.2642L109.831 101.909L109.919 100.618L71.0629 97.9737Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M47.7211 96.3936L47.6332 97.6841L70.9859 99.2758L71.0739 97.9853L47.7211 96.3936Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M47.723 99.9274L47.6171 101.216L94.2916 105.052L94.3976 103.763L47.723 99.9274Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M42.3109 91.2761L60.2759 95.7056C61.4664 96.0006 62.7291 95.8257 63.7961 95.2184C64.8632 94.6111 66.1224 94.4395 67.3164 94.7312L67.7899 94.8478L67.8791 94.4807L69.7078 94.9302C69.9514 94.9919 70.1813 94.786 70.147 94.5356L70.0098 93.4754C69.9892 93.3279 69.8828 93.2078 69.7387 93.1735L68.2839 92.8166L68.3594 92.5147L67.7178 92.3569C66.6267 92.0892 65.6661 91.4442 65.0004 90.5384L64.9181 90.4286C64.2525 89.5228 63.2918 88.8812 62.2007 88.6102L45.2033 84.4209L42.9148 83.8547C42.9148 83.8547 42.9148 83.8547 42.9148 83.8582L42.3109 83.7106V91.2761Z",
                        fill: "var(--ds-background-accent-gray-subtle, #6C798F)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M75.5989 27.5788L47.6736 32.9175V28.5326L75.5989 22.7067V27.5788Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M84.4022 32.8103L47.093 38.827L47.2989 40.1039L84.6082 34.0873L84.4022 32.8103Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M84.4182 36.8671L47.1039 42.3507L47.292 43.6305L84.6063 38.1469L84.4182 36.8671Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M75.6704 42.0758L47.1106 45.8759L47.2812 47.1582L75.8411 43.3581L75.6704 42.0758Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M60.7905 75.4418V84.1979L47.6702 83.9851V75.6614L60.7905 75.4418Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M60.7905 66.6859V75.4419L47.6702 75.6615V67.3412L60.7905 66.6859Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M60.7905 57.9298V66.6858L47.6702 67.3412V59.0209L60.7905 57.9298Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M60.7905 49.1772V57.9298L47.6702 59.0209V50.7006L60.7905 49.1772Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M75.3519 47.4857V56.7221L60.7905 57.9298V49.1772L75.3519 47.4857Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M91.6115 45.5986V55.3737L75.3518 56.7221V47.4857L91.6115 45.5986Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M109.878 43.4748V53.8571L91.6116 55.3737V45.5986L109.878 43.4748Z",
                        fill: "var(--ds-background-accent-gray-subtlest, #DEEBFF)",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M109.879 53.8571V84.9939L60.7905 84.1979V57.9298L109.879 53.8571Z",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M109.879 74.6116L91.6116 74.9204L75.3519 75.1948L60.7905 75.4419",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M109.879 64.2326L91.6116 65.1453L75.3519 65.9584L60.7905 66.6858",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M91.6116 84.6954V74.9203V65.1453V55.3737",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M75.3518 84.4312V75.1948V65.9584V56.722",
                        stroke: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                        strokeWidth: "3.1142",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M94.0374 10.6705L101.28 46.024L117.557 34.6295L94.0374 10.6705Z",
                        fill: "url(#paint12_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M53.8528 13.7208L47.2858 15.1858C46.4829 15.3642 45.8345 16.3043 45.8345 17.2822V23.6262C45.8345 24.604 46.4864 25.2525 47.2858 25.0741L48.9087 24.7138L50.1267 26.5288C50.3429 26.8514 50.7958 26.7519 51.0119 26.3298L52.2299 23.9727L53.8528 23.6125C54.6557 23.434 55.3042 22.4939 55.3042 21.5161V15.1687C55.3042 14.1908 54.6557 13.5423 53.8528 13.7208Z",
                        fill: "url(#paint13_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M53.1976 13.8683L46.6305 15.3333C45.8277 15.5117 45.1792 16.4518 45.1792 17.4297V23.7737C45.1792 24.7516 45.8311 25.4 46.6305 25.2216L48.2534 24.8613L49.4714 26.6764C49.6876 26.9989 50.1405 26.8994 50.3566 26.4774L51.5747 24.1202L53.1976 23.76C54.0004 23.5816 54.6489 22.6415 54.6489 21.6636V15.3127C54.6523 14.3349 54.0004 13.6864 53.1976 13.8683Z",
                        fill: "url(#paint14_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M105.302 76.9652L98.5595 77.4181C97.7361 77.473 97.067 78.3102 97.067 79.2881V85.6321C97.067 86.6099 97.7361 87.3579 98.5595 87.303L100.224 87.1898L101.476 89.1901C101.699 89.5469 102.162 89.516 102.385 89.1283L103.637 86.9599L105.302 86.8467C106.125 86.7918 106.794 85.9546 106.794 84.9767V78.6327C106.794 77.6583 106.125 76.9103 105.302 76.9652Z",
                        fill: "url(#paint15_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M104.632 77.0099L97.8904 77.4628C97.067 77.5177 96.3979 78.3548 96.3979 79.3327V85.6767C96.3979 86.6545 97.067 87.4025 97.8904 87.3476L99.5545 87.2344L100.807 89.2347C101.03 89.5915 101.493 89.5606 101.716 89.1729L102.968 87.0045L104.632 86.8913C105.456 86.8364 106.125 85.9992 106.125 85.0214V78.6773C106.122 77.7029 105.456 76.955 104.632 77.0099Z",
                        fill: "url(#paint16_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M94.1334 142.388L113.55 146.139V119.318L94.1334 117.369V142.388Z",
                        fill: "var(--ds-background-accent-gray-subtle, #6C798F)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M48.1231 128.537L63.8029 131.564C64.1461 131.629 64.4617 131.368 64.4617 131.018V107.313C64.4617 107.028 64.2456 106.788 63.9608 106.76L48.2809 105.189C47.9549 105.155 47.6702 105.412 47.6702 105.741V127.992C47.6736 128.259 47.8623 128.486 48.1231 128.537ZM49.1078 106.942L63.0275 108.339V123.501V129.728L58.1314 128.784L49.5641 127.131L49.1078 127.041V106.942Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M66.4312 132.071L84.7392 135.605C85.0823 135.67 85.398 135.41 85.398 135.06V109.413C85.398 109.128 85.1818 108.888 84.8971 108.86L66.589 107.025C66.2631 106.99 65.9783 107.248 65.9783 107.577V131.526C65.9817 131.793 66.1704 132.02 66.4312 132.071ZM67.4159 118.766V108.781L83.9638 110.442V121.332V133.773L69.2103 130.925L67.4159 130.579V118.766Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M54.92 121.349L59.6514 127.141L63.0275 123.501V108.339L49.1078 106.942V127.041L49.5641 127.131L54.92 121.349Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M54.92 121.349L59.6514 127.141L63.0275 123.501V108.339L49.1078 106.942V127.041L49.5641 127.131L54.92 121.349Z",
                        fill: "url(#paint17_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M73.8628 125.902L81.219 117.966L83.9638 121.325V110.439L67.4159 108.778V118.766L67.7453 118.409L73.8628 125.902Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M73.8628 125.902L81.219 117.966L83.9638 121.325V110.439L67.4159 108.778V118.766L67.7453 118.409L73.8628 125.902Z",
                        fill: "url(#paint18_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M49.5641 127.131L58.1314 128.784L49.5641 127.131Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M59.6514 127.141L54.92 121.349L49.5641 127.131L58.1314 128.784L59.6514 127.141Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M69.2103 130.922L67.4159 130.575L69.2103 130.922Z",
                        fill: "var(--ds-background-accent-gray-bolder, #42526E)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M73.8628 125.902L67.7453 118.409L67.4159 118.766V130.575L69.2103 130.922L73.8628 125.902Z",
                        fill: "var(--ds-background-accent-gray-bolder, #42526E)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M58.1315 128.784L63.0276 129.728L58.1315 128.784Z",
                        fill: "var(--ds-background-accent-gray-bolder, #42526E)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M58.1315 128.784L63.0276 129.728V123.501L59.6514 127.141L58.1315 128.784Z",
                        fill: "var(--ds-background-accent-gray-bolder, #42526E)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M69.2103 130.922L83.9638 133.77L69.2103 130.922Z",
                        fill: "var(--ds-background-accent-gray-subtle, #5E6C84)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M73.8628 125.902L69.2103 130.922L83.9638 133.77V121.325L81.219 117.966L73.8628 125.902Z",
                        fill: "var(--ds-background-accent-gray-subtle, #5E6C84)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M87.3125 129.824C87.4464 129.8 87.9404 129.694 88.1429 129.292C88.2389 129.1 88.2355 128.908 88.2286 128.644C88.2218 128.301 88.1497 128.023 88.0914 127.837L88.8565 127.343C88.9148 127.306 88.9492 127.234 88.9354 127.165C88.9114 127.059 88.8016 127.007 88.7056 127.045L87.8855 127.398C87.8238 127.426 87.7723 127.474 87.7449 127.535L87.3812 128.301L86.8837 129.398L87.3125 129.824Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M88.5614 127.402L88.9937 127.244C89.0726 127.213 89.1653 127.247 89.2099 127.319C89.2613 127.402 89.2373 127.508 89.1584 127.559L88.2492 128.187L88.0262 128.863L87.7277 128.438L87.9781 127.755L88.5614 127.402Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M89.45 127.704C89.4843 127.786 89.45 127.879 89.3711 127.92C89.1549 128.002 88.9354 128.084 88.7192 128.167C88.4859 128.383 88.2526 128.599 88.0193 128.815L87.834 128.52L88.5305 127.827L89.2407 127.604C89.3265 127.58 89.4191 127.621 89.45 127.704Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M89.3333 128.359C89.3368 128.424 89.2887 128.479 89.2235 128.489L88.6505 128.561C88.4962 128.654 88.3418 128.75 88.1874 128.846C88.1462 128.76 88.105 128.675 88.0638 128.589C88.2628 128.462 88.4653 128.338 88.6643 128.211L89.2167 128.239C89.2784 128.239 89.3299 128.294 89.3333 128.359Z",
                        fill: "var(--ds-icon-accent-yellow, #72594B)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M78.4398 136.71C79.7779 136.213 81.2052 135.739 82.7183 135.31C83.2536 135.159 83.7785 135.019 84.3001 134.888C84.5848 134.247 84.825 133.728 84.9863 133.379C85.4597 132.363 85.7171 131.872 86.3106 130.63C86.568 130.088 86.7738 129.649 86.9042 129.368C87.1581 129.491 87.412 129.615 87.6659 129.738C87.4841 130.96 87.1238 132.486 86.393 134.126C86.0602 134.878 85.6965 135.544 85.3397 136.123C84.8524 136.47 83.3634 137.509 81.9772 138.031C81.7233 138.127 81.3322 138.257 80.8278 138.288C80.399 138.316 79.8568 138.347 79.3422 138.031C78.6079 137.578 78.4604 136.83 78.4398 136.71Z",
                        fill: "url(#paint19_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M91.0009 111.708L86.5851 136.686C86.5062 137.132 86.7979 137.561 87.2439 137.647L107.563 141.637C108.019 141.726 108.461 141.424 108.54 140.965L113.296 114.069C113.382 113.592 113.042 113.146 112.558 113.098L91.9033 111.025C91.471 110.981 91.0764 111.279 91.0009 111.708ZM107.298 139.867L106.598 139.729L88.1188 136.099L89.4501 128.565L92.2498 112.727L111.748 114.683L107.298 139.867Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M89.4535 128.568L93.2414 134.363L99.4584 128.808L106.598 139.733L107.298 139.87L111.752 114.69L92.2532 112.734L89.4535 128.568ZM102.231 117.918C103.397 117.918 104.149 118.996 103.915 120.323C103.682 121.651 102.546 122.729 101.38 122.729C100.213 122.729 99.4619 121.651 99.6952 120.323C99.9285 118.996 101.064 117.918 102.231 117.918Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M89.4535 128.568L93.2414 134.363L99.4584 128.808L106.598 139.733L107.298 139.87L111.752 114.69L92.2532 112.734L89.4535 128.568ZM102.231 117.918C103.397 117.918 104.149 118.996 103.915 120.323C103.682 121.651 102.546 122.729 101.38 122.729C100.213 122.729 99.4619 121.651 99.6952 120.323C99.9285 118.996 101.064 117.918 102.231 117.918Z",
                        fill: "url(#paint20_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M106.598 139.729L88.1222 136.103L106.598 139.729Z",
                        fill: "var(--ds-background-accent-gray-subtle, #5E6C84)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M93.2413 134.36L89.4534 128.568L88.1222 136.103L106.598 139.729L99.4584 128.805L93.2413 134.36Z",
                        fill: "var(--ds-background-accent-gray-subtle, #5E6C84)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M101.38 122.732C102.546 122.732 103.679 121.655 103.915 120.327C104.149 118.999 103.397 117.922 102.231 117.922C101.064 117.922 99.9319 118.999 99.6952 120.327C99.4584 121.655 100.213 122.732 101.38 122.732Z",
                        fill: "var(--ds-icon-inverse, #FAFBFC)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M101.38 122.732C102.546 122.732 103.679 121.655 103.915 120.327C104.149 118.999 103.397 117.922 102.231 117.922C101.064 117.922 99.9319 118.999 99.6952 120.327C99.4584 121.655 100.213 122.732 101.38 122.732Z",
                        fill: "url(#paint21_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M101.38 122.732C102.546 122.732 103.679 121.655 103.915 120.327C104.149 118.999 103.397 117.922 102.231 117.922C101.064 117.922 99.9319 118.999 99.6952 120.327C99.4584 121.655 100.213 122.732 101.38 122.732Z",
                        fill: "url(#paint22_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M28.1132 148.904C43.5435 148.904 56.0522 147.858 56.0522 146.567C56.0522 145.277 43.5435 144.231 28.1132 144.231C12.6829 144.231 0.174194 145.277 0.174194 146.567C0.174194 147.858 12.6829 148.904 28.1132 148.904Z",
                        fill: "url(#paint23_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M43.3951 146.149C43.1481 146.149 42.9147 145.998 42.8221 145.754L29.6435 111.015C29.5234 110.699 29.6812 110.346 30.0003 110.226C30.3159 110.106 30.6693 110.264 30.7894 110.579L43.9681 145.319C44.0882 145.634 43.9303 145.988 43.6112 146.108C43.5426 146.135 43.4671 146.149 43.3951 146.149Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M54.8514 146.149C54.6044 146.149 54.371 145.998 54.2784 145.754L41.0998 111.015C40.9797 110.699 41.1375 110.346 41.4566 110.226C41.7722 110.106 42.1256 110.264 42.2457 110.579L55.4244 145.319C55.5445 145.634 55.3866 145.988 55.0675 146.108C54.9989 146.135 54.9234 146.149 54.8514 146.149Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M43.3642 115.866H31.908C31.5717 115.866 31.2972 115.592 31.2972 115.256C31.2972 114.92 31.5717 114.645 31.908 114.645H43.3642C43.7005 114.645 43.975 114.92 43.975 115.256C43.975 115.592 43.7005 115.866 43.3642 115.866Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M45.265 120.879H33.8087C33.4725 120.879 33.198 120.605 33.198 120.269C33.198 119.932 33.4725 119.658 33.8087 119.658H45.265C45.6012 119.658 45.8757 119.932 45.8757 120.269C45.8757 120.605 45.6047 120.879 45.265 120.879Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M47.1659 125.892H35.7096C35.3734 125.892 35.0989 125.618 35.0989 125.281C35.0989 124.945 35.3734 124.671 35.7096 124.671H47.1659C47.5021 124.671 47.7766 124.945 47.7766 125.281C47.7766 125.618 47.5055 125.892 47.1659 125.892Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M49.07 130.905H37.6138C37.2775 130.905 37.0031 130.63 37.0031 130.294C37.0031 129.958 37.2775 129.683 37.6138 129.683H49.07C49.4063 129.683 49.6808 129.958 49.6808 130.294C49.6808 130.63 49.4063 130.905 49.07 130.905Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M50.9709 135.918H39.5147C39.1784 135.918 38.9039 135.643 38.9039 135.307C38.9039 134.971 39.1784 134.696 39.5147 134.696H50.9709C51.3072 134.696 51.5816 134.971 51.5816 135.307C51.5816 135.643 51.3072 135.918 50.9709 135.918Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M52.8717 140.927H41.4154C41.0792 140.927 40.8047 140.652 40.8047 140.316C40.8047 139.98 41.0792 139.705 41.4154 139.705H52.8717C53.2079 139.705 53.4824 139.98 53.4824 140.316C53.4824 140.652 53.2114 140.927 52.8717 140.927Z",
                        fill: "var(--ds-background-accent-blue-bolder, #2684FF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M24.5484 146.149C24.4763 146.149 24.4043 146.135 24.3322 146.108C24.0166 145.988 23.8587 145.634 23.9754 145.319L37.154 110.579C37.2741 110.264 37.6275 110.106 37.9432 110.226C38.2588 110.346 38.4167 110.699 38.3 111.015L25.1214 145.754C25.0253 145.998 24.7954 146.149 24.5484 146.149Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M13.0921 146.149C13.02 146.149 12.948 146.135 12.8759 146.108C12.5603 145.988 12.4024 145.634 12.5191 145.319L25.6978 110.579C25.8178 110.264 26.1712 110.106 26.4869 110.226C26.8026 110.346 26.9604 110.699 26.8437 111.015L13.6616 145.754C13.569 145.998 13.3391 146.149 13.0921 146.149Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M42.6025 111.283H25.5536C24.8091 111.283 24.2052 110.679 24.2052 109.934C24.2052 109.19 24.8091 108.586 25.5536 108.586H42.6025C43.347 108.586 43.9509 109.19 43.9509 109.934C43.9509 110.679 43.347 111.283 42.6025 111.283Z",
                        fill: "var(--ds-background-accent-blue-subtlest, #B2D4FF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M42.6025 111.283H39.2915C38.547 111.283 37.9431 110.679 37.9431 109.934C37.9431 109.19 38.547 108.586 39.2915 108.586H42.6025C43.347 108.586 43.9509 109.19 43.9509 109.934C43.9509 110.679 43.347 111.283 42.6025 111.283Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M36.0355 115.866H24.5792C24.243 115.866 23.9685 115.592 23.9685 115.256C23.9685 114.92 24.243 114.645 24.5792 114.645H36.0355C36.3717 114.645 36.6462 114.92 36.6462 115.256C36.6462 115.592 36.3717 115.866 36.0355 115.866Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M34.1347 120.879H22.6785C22.3422 120.879 22.0677 120.605 22.0677 120.269C22.0677 119.932 22.3422 119.658 22.6785 119.658H34.1347C34.471 119.658 34.7455 119.932 34.7455 120.269C34.7455 120.605 34.471 120.879 34.1347 120.879Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M32.2339 125.892H20.7742C20.4379 125.892 20.1635 125.618 20.1635 125.281C20.1635 124.945 20.4379 124.671 20.7742 124.671H32.2304C32.5667 124.671 32.8412 124.945 32.8412 125.281C32.8412 125.618 32.5701 125.892 32.2339 125.892Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M30.3297 130.905H18.8734C18.5372 130.905 18.2627 130.63 18.2627 130.294C18.2627 129.958 18.5372 129.683 18.8734 129.683H30.3297C30.6659 129.683 30.9404 129.958 30.9404 130.294C30.9404 130.63 30.6694 130.905 30.3297 130.905Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M28.4288 135.918H16.9725C16.6363 135.918 16.3618 135.643 16.3618 135.307C16.3618 134.971 16.6363 134.696 16.9725 134.696H28.4288C28.765 134.696 29.0395 134.971 29.0395 135.307C29.0395 135.643 28.7685 135.918 28.4288 135.918Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M26.528 140.927H15.0718C14.7355 140.927 14.4611 140.652 14.4611 140.316C14.4611 139.98 14.7355 139.705 15.0718 139.705H26.528C26.8643 139.705 27.1388 139.98 27.1388 140.316C27.1388 140.652 26.8643 140.927 26.528 140.927Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M40.2832 79.2538C42.033 79.6003 43.7829 79.9503 45.5327 80.2968C47.5605 80.4787 49.5882 80.6571 51.616 80.8389C51.6125 81.1443 51.6057 81.4497 51.6022 81.755C49.8558 81.906 47.8967 81.9815 45.7626 81.9197C43.4158 81.8511 41.2851 81.6246 39.4152 81.3296C39.7034 80.6365 39.9916 79.9434 40.2832 79.2538Z",
                        fill: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M67.5497 93.7637L67.9408 94.0553L69.3784 92.1339L68.8501 91.7394C67.9511 91.0669 67.3164 90.0993 67.0556 89.0048L67.0247 88.871C66.764 87.7765 66.1292 86.8124 65.2303 86.1365L30.6248 60.2492C29.0019 59.0346 26.6996 59.3674 25.4851 60.9903C24.2705 62.6132 24.6033 64.9154 26.2262 66.13L60.6876 91.9143C61.6723 92.6486 62.8972 92.9814 64.1186 92.8407C65.3401 92.6966 66.5684 93.0294 67.5497 93.7637Z",
                        fill: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M47.7216 82.2113C47.104 80.3311 46.4281 77.775 45.9066 75.8158C45.3679 73.7778 44.8979 72.052 44.4724 70.611L41.7825 68.5969C42.5579 70.7585 43.4294 74.0386 44.0298 76.3133C44.4278 77.8127 44.7778 79.1199 45.0969 80.2488L47.7216 82.2113Z",
                        fill: "var(--ds-icon-brand, #0065FF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M31.8119 61.1344C34.9513 71.3349 36.6531 73.3455 38.3 73.1053C39.7754 72.8892 40.1631 70.9129 40.5748 68.8234C40.6297 68.5386 40.6983 68.1886 40.7772 67.8421L39.0857 66.576C38.9279 67.1387 38.8009 67.7769 38.6671 68.446C38.5196 69.2008 38.2588 70.5217 37.9878 71.057C37.552 70.6418 36.461 69.0636 34.495 63.1416L31.8119 61.1344Z",
                        fill: "var(--ds-icon-brand, #0065FF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M49.324 74.2376C49.1525 78.8249 48.8849 81.4257 48.6378 82.8941L50.3533 84.1774C50.7239 82.6094 51.019 79.9949 51.2145 75.6512L49.324 74.2376Z",
                        fill: "var(--ds-icon-brand, #0065FF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M70.2362 94.6901L70.5209 93.6608C70.5621 93.5201 70.5072 93.3657 70.3905 93.2765L69.1931 92.381L68.1672 93.75L69.6769 94.8788C69.8793 95.0332 70.1675 94.9337 70.2362 94.6901Z",
                        fill: "var(--ds-icon-brand, #0065FF)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M29.1598 105.645C28.9573 105.711 28.6828 105.824 28.3946 106.023C28.103 106.218 27.8971 106.431 27.7599 106.596C27.8045 106.719 27.856 106.846 27.9143 106.973C28.2368 107.673 28.676 108.198 29.0774 108.572C29.5852 108.575 30.093 108.579 30.6008 108.582C30.6077 108.538 30.6077 108.493 30.6008 108.459C30.5356 108.068 29.846 107.92 29.8048 107.913C29.7327 107.759 29.6195 107.467 29.6229 107.083C29.6229 106.706 29.7362 106.417 29.8082 106.266C29.5921 106.061 29.3759 105.851 29.1598 105.645Z",
                        fill: "var(--ds-icon, #344563)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M35.1091 84.3146C36.7729 84.3146 38.1216 82.9659 38.1216 81.3021C38.1216 79.6384 36.7729 78.2897 35.1091 78.2897C33.4454 78.2897 32.0967 79.6384 32.0967 81.3021C32.0967 82.9659 33.4454 84.3146 35.1091 84.3146Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M36.0046 85.6938C37.0202 84.8429 39.3739 85.2409 40.0842 86.4521C40.8253 87.7147 39.7548 89.8145 38.4784 92.2814C38.125 92.9608 37.5863 93.9558 35.1572 97.8329C33.8088 99.9841 33.5309 100.382 32.68 101.768C31.4585 103.755 30.515 105.391 29.918 106.448C29.4822 106.242 29.0465 106.04 28.6073 105.834C29.242 104.348 29.7087 103.124 30.014 102.29C30.6591 100.526 30.9233 99.5758 31.6163 98.0696C32.0727 97.078 32.505 96.2992 32.7897 95.8085C33.0608 95.0057 33.3319 94.1891 33.596 93.3622C34.1107 91.753 34.591 90.1679 35.0337 88.6171C35.0028 88.2705 34.9993 87.6907 35.2224 87.0319C35.3047 86.778 35.538 86.0815 36.0046 85.6938Z",
                        fill: "var(--ds-background-accent-teal-subtle, #00B8D9)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M38.523 106.716C38.4646 106.929 38.4098 107.155 38.3617 107.399C38.3 107.725 38.2588 108.033 38.2382 108.315C38.2279 108.459 38.3411 108.582 38.4852 108.582C39.5351 108.579 40.585 108.572 41.6349 108.569C41.6452 108.442 41.6349 108.274 41.532 108.15C41.4051 108.003 41.2163 108.013 40.9933 107.975C40.9933 107.975 40.3414 107.869 39.8233 107.361C39.6964 107.237 39.518 107.025 39.3842 106.685C39.096 106.695 38.8078 106.706 38.523 106.716Z",
                        fill: "var(--ds-icon, #344563)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M37.902 84.4107C38.0015 84.3832 39.0857 84.1156 39.9538 84.7126C40.7258 85.241 41.086 86.2771 41.0345 90.1577C41.0071 92.0893 40.887 94.1823 40.5508 97.3217C40.2969 99.6822 40.1768 100.235 39.9881 102.334C39.8131 104.283 39.7273 105.882 39.6827 106.942C39.1612 106.973 38.6362 107.004 38.1147 107.032C37.7716 105.083 37.5452 103.436 37.3976 102.17C37.2432 100.869 37.1815 100.08 37.2913 99.1093C37.4217 97.9667 37.7682 96.8105 37.8025 96.6972C37.878 96.4502 37.9535 96.2203 38.0255 96.0145C37.9294 95.4895 37.7716 94.6729 37.5452 93.6779C37.2673 92.4393 37.0202 91.3482 36.6222 89.9792C35.9532 87.677 35.6787 87.4368 35.8434 86.682C36.0458 85.7659 36.7663 84.7092 37.902 84.4107Z",
                        fill: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M41.2335 76.1109C41.3399 76.4231 41.5595 77.0613 41.2918 77.8161C41.2164 78.0289 40.9659 78.6396 40.3963 78.9518C40.3071 78.9999 40.1081 79.1096 39.8199 79.144C39.7273 79.1543 39.4253 79.192 39.2641 79.1028C38.6431 78.7665 39.3464 76.1212 40.2419 75.459C40.4684 75.2943 40.6228 75.3115 40.6605 75.3183C40.9796 75.3767 41.1374 75.8399 41.2335 76.1109Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M35.1091 87.2653C35.4419 87.5226 36.7663 88.497 38.6706 88.3838C40.2866 88.2877 41.3674 87.4677 41.7276 87.1692C41.5904 86.9565 41.3948 86.6202 41.2404 86.1776C41.134 85.8654 40.7463 84.6302 41.1787 83.275C41.3845 82.6265 41.5869 82.5544 41.5972 82.0535C41.6007 81.827 41.5595 81.7241 41.261 80.6365C41.0414 79.8405 41.0345 79.789 40.9591 79.6861C40.887 79.5866 40.5439 79.1646 39.271 79.1028C37.854 79.0307 36.6325 79.5077 35.8468 79.9194C35.936 80.8801 36.0733 81.6521 36.183 82.1942C36.4267 83.3985 36.6428 83.9097 36.4061 84.6233C36.2928 84.963 36.1968 84.9905 35.8159 85.711C35.4728 86.356 35.2464 86.9016 35.1091 87.2653Z",
                        fill: "var(--ds-background-accent-teal-subtle, #79E2F2)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M41.1684 77.106C41.1547 77.13 41.117 77.1574 41.0449 77.2158C40.9831 77.2638 40.9282 77.2981 40.8871 77.3221C40.8871 77.4285 40.8836 77.5417 40.8768 77.6584C40.8631 77.8848 40.8356 78.0907 40.8013 78.2794C40.6435 78.3206 40.4239 78.3686 40.1563 78.396C39.8818 78.4235 39.4666 78.4647 38.9794 78.348C38.7804 78.3 38.4888 78.2313 38.228 78.0495C37.6996 77.679 37.2364 76.7869 37.5864 75.9394C37.9501 75.0611 39.1167 74.6836 39.8372 74.9993C39.9298 75.0405 40.3999 75.2463 40.5954 75.6992C40.6812 75.8948 40.6366 75.9188 40.7739 76.2516C40.8082 76.3306 40.8493 76.4335 40.918 76.5639C41.0861 76.8727 41.2199 76.9996 41.1684 77.106Z",
                        fill: "var(--ds-background-accent-orange-subtler, #CEA28B)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M38.1216 77.4971C38.2074 77.6412 38.3515 77.9362 38.372 78.3377C38.3961 78.77 38.2657 79.0959 38.1936 79.2503C38.4853 79.4425 38.7838 79.6483 39.0857 79.8576C39.518 80.163 39.9297 80.4649 40.3243 80.7669C40.1493 80.3208 39.9778 79.8782 39.8028 79.4322C39.7994 79.2881 39.8062 79.1303 39.8199 78.9621C39.8405 78.7494 39.8714 78.5573 39.9092 78.3891C39.3122 78.0906 38.7186 77.7921 38.1216 77.4971Z",
                        fill: "var(--ds-background-accent-orange-subtler, #CEA28B)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M35.8777 69.9248C35.9772 69.8424 36.3409 69.5165 36.3238 69.0807C36.3135 68.8714 36.2174 68.7136 36.087 68.494C35.9155 68.2092 35.7233 68.0068 35.5861 67.8799L35.9944 67.101C36.0253 67.0393 36.0218 66.9638 35.9738 66.9157C35.9052 66.8368 35.7851 66.8471 35.7233 66.926L35.2018 67.6122C35.1606 67.6637 35.1435 67.7289 35.1469 67.7941L35.315 69.7738L35.8777 69.9248Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M35.7714 67.2897L36.0596 66.9501C36.1145 66.8883 36.2037 66.8711 36.2758 66.9089C36.3581 66.9535 36.389 67.053 36.3478 67.1353L35.8812 68.096L36.015 68.7719L35.5587 68.5592L35.442 67.8627L35.7714 67.2897Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M36.6669 67.1182C36.7321 67.1697 36.7492 67.2657 36.7012 67.3378C36.5571 67.5128 36.4164 67.6843 36.2723 67.8593C36.1797 68.1509 36.087 68.446 35.9944 68.7377L35.6993 68.5764L35.9532 67.6603L36.4473 67.1354C36.5022 67.0702 36.5983 67.0633 36.6669 67.1182Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M36.8762 67.7254C36.9105 67.7803 36.8968 67.849 36.8453 67.8867L36.3993 68.2229C36.3135 68.3773 36.2277 68.5283 36.1454 68.6827C36.0699 68.6312 35.9944 68.5763 35.9189 68.5249C36.0287 68.3224 36.1351 68.12 36.2449 67.921L36.7218 67.6808C36.7733 67.65 36.8453 67.6705 36.8762 67.7254Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M35.5587 68.9949C35.5072 68.9949 35.3116 69.3346 35.2773 69.29L34.7421 68.0651C34.6837 67.9896 34.6975 67.8833 34.7695 67.825C34.845 67.7666 34.9514 67.7804 35.0097 67.8524L35.6925 68.717C35.7508 68.7925 35.7371 68.8989 35.665 68.9572C35.6341 68.9847 35.5964 68.9949 35.5587 68.9949Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M40.0224 76.5982C39.8474 76.8143 39.7548 76.7079 39.5867 76.9001C39.2298 77.3015 39.5901 77.8162 39.2573 78.1867C39.0995 78.3651 38.9416 78.2416 38.8113 78.4132C38.6225 78.6671 38.9245 78.9518 38.8113 79.391C38.7255 79.7204 38.4407 80.0223 38.125 80.1081C37.7442 80.2145 37.5726 79.94 37.2879 80.0464C36.8796 80.2008 37.0546 80.8664 36.6531 81.2644C36.1247 81.7893 34.8964 81.8339 34.0936 81.182C33.2907 80.5301 33.2495 79.4596 33.4245 78.8009C33.5961 78.1456 34.0661 77.5794 34.5945 77.2706C35.14 76.9516 35.4694 77.0716 35.9944 76.6359C36.2311 76.4403 36.2551 76.4403 36.6806 75.785C36.8761 75.4796 37.2295 74.9375 37.7854 74.6287C38.4235 74.2753 39.0754 74.3645 39.3499 74.3989C39.693 74.4469 40.3484 74.5327 40.5714 74.9821C40.592 75.0233 40.7395 75.339 40.6091 75.5929C40.5679 75.6752 40.5268 75.6855 40.4479 75.7713C40.1631 76.0663 40.2489 76.3202 40.0224 76.5982Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M38.1216 80.7943C37.7236 79.0548 37.3256 77.3152 36.9276 75.5757C36.6909 73.5548 36.4507 71.5339 36.2139 69.5096C35.9086 69.5233 35.6032 69.537 35.3013 69.5508C35.2018 71.3006 35.1812 73.2597 35.3047 75.3904C35.442 77.7338 35.7267 79.8576 36.0767 81.7207C36.756 81.4119 37.4388 81.1031 38.1216 80.7943Z",
                        fill: "var(--ds-background-accent-teal-subtle, #79E2F2)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M72.9364 160C81.113 160 87.7414 159.161 87.7414 158.127C87.7414 157.092 81.113 156.253 72.9364 156.253C64.7599 156.253 58.1315 157.092 58.1315 158.127C58.1315 159.161 64.7599 160 72.9364 160Z",
                        fill: "url(#paint24_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M77.5306 136.604C78.5198 136.604 79.3216 135.802 79.3216 134.813C79.3216 133.824 78.5198 133.022 77.5306 133.022C76.5415 133.022 75.7396 133.824 75.7396 134.813C75.7396 135.802 76.5415 136.604 77.5306 136.604Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M69.2892 157.228C71.5571 157.444 74.9333 157.66 77.2012 157.876C77.3865 157.866 78.2271 157.794 78.7417 157.125C79.0848 156.682 79.1191 156.192 79.1397 155.872C79.1877 155.176 78.9613 154.534 78.8412 154.202C78.8103 154.112 78.7829 154.04 78.7623 153.992C77.9217 151.889 77.5237 151.144 77.0948 150.026C76.4086 148.235 76.6659 148.307 76.2096 147.384C75.7258 146.406 74.8509 145.229 73.1491 144.159C72.933 144.461 72.655 144.907 72.4011 145.483C72.209 145.919 71.9757 146.451 71.9105 147.137C71.8762 147.497 71.8796 147.981 72.1061 148.842C72.2193 149.275 72.583 150.537 73.6981 152.284C74.0858 152.891 74.645 153.68 75.4136 154.538C74.5524 154.332 73.6432 154.14 72.6859 153.972C71.9585 153.841 70.1401 153.735 69.4607 153.649C69.4024 154.84 69.3441 156.034 69.2892 157.228Z",
                        fill: "url(#paint25_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M73.3208 143.932C73.0634 144.245 72.7272 144.715 72.4356 145.336C72.0582 146.145 71.5847 147.164 71.8969 148.348C71.9484 148.547 72.1679 149.71 73.2419 150.252C73.5644 150.414 73.8526 150.554 74.1957 150.681C74.1957 150.681 74.8716 150.928 75.6642 151.059C77.3179 151.333 79.7883 151.021 79.9496 151C79.4315 151.446 78.8894 151.951 78.3404 152.524C77.6062 153.285 76.9851 154.03 76.4636 154.723C77.5684 155.402 78.6732 156.082 79.778 156.765C80.5534 155.941 81.3597 155.015 82.1729 153.982C83.1164 152.781 83.9261 151.618 84.6158 150.527C84.6741 150.328 84.7908 149.844 84.6055 149.299C84.2727 148.324 83.2811 148.015 83.1747 147.984C81.9567 147.659 80.7387 147.333 79.5207 147.01C78.6183 146.773 77.7125 146.537 76.8101 146.3C76.1617 145.936 75.472 145.511 74.7618 145.017C74.2403 144.656 73.76 144.289 73.3208 143.932Z",
                        fill: "var(--ds-background-accent-yellow-subtle, #FFAB00)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M79.2805 143.325C78.8585 143.747 78.4433 144.166 78.0796 144.619C77.7434 145.041 77.3591 145.61 77.0263 146.358C76.3881 146.169 75.623 145.885 74.7995 145.449C74.0962 145.078 73.5129 144.68 73.0428 144.317C73.4752 143.562 73.7908 142.917 74.0035 142.443C74.4358 141.486 74.5422 141.061 74.9368 140.296C75.3211 139.544 75.7225 138.964 76.021 138.577C76.021 138.577 76.8513 137.345 77.4483 136.885C77.4689 136.868 77.86 136.569 77.86 136.569L79.6888 138.264C79.8535 138.415 79.9701 138.607 80.0319 138.824C80.0593 139.218 80.1245 139.829 80.3167 140.556C80.5019 141.27 80.6323 141.431 80.574 141.785C80.4951 142.234 80.2172 142.388 79.2805 143.325Z",
                        fill: "url(#paint26_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M79.6201 138.748C79.6201 138.669 79.6098 138.57 79.5824 138.456C79.5481 138.319 79.5 138.209 79.4554 138.131C79.4486 137.829 79.4863 137.352 79.7299 136.851C79.8123 136.686 79.9015 136.545 79.9907 136.425L78.7315 135.626L77.86 136.569L78.2992 137.091C78.5805 137.427 78.8104 137.805 79.0231 138.185C79.0609 138.254 79.1089 138.323 79.1672 138.395C79.3285 138.59 79.5103 138.693 79.6201 138.748Z",
                        fill: "var(--ds-background-accent-orange-subtler, #CEA28B)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M82.8796 158.734C82.8796 158.734 82.6257 158.226 81.9258 157.962C81.2705 157.715 80.9033 158.013 80.0867 157.705C79.8603 157.619 79.3182 157.413 79.2873 157.053C79.2702 156.864 79.404 156.696 79.5069 156.596C78.9682 156.264 78.4295 155.931 77.8909 155.598C77.8909 155.598 77.4723 156.089 77.2458 157.077C77.016 158.065 77.1052 159.033 77.1052 159.033L82.8796 158.734Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M69.4128 154.562C69.2 154.486 68.9015 154.407 68.5378 154.387C68.109 154.363 67.7556 154.428 67.5154 154.493C67.6286 155.643 67.7418 156.792 67.8585 157.941C67.8585 157.979 67.8516 158.24 68.0575 158.429C68.2153 158.573 68.3972 158.586 68.4486 158.59C68.9804 158.542 69.5123 158.49 70.0406 158.442C70.0029 158.37 69.9343 158.257 69.821 158.147C69.4574 157.794 69.0696 157.886 68.8981 157.574C68.8055 157.406 68.826 157.217 68.8363 157.152C68.8569 156.967 68.9393 156.84 69.0045 156.737C69.0628 156.648 69.1623 156.511 69.327 156.384C69.3579 155.776 69.3853 155.169 69.4128 154.562Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M78.7624 135.694L80.2823 136.655C80.4916 136.786 80.7421 136.834 80.9857 136.782C81.195 136.738 81.3837 136.621 81.5209 136.456L82.0905 135.76L82.3066 135.918C82.389 135.979 82.5056 135.918 82.5022 135.815L82.4782 135.125L82.6017 134.758C82.7595 134.288 82.8144 133.787 82.7664 133.293C82.7012 132.641 82.3512 132.047 81.8126 131.673C81.2224 131.265 80.4745 131.162 79.7951 131.395L79.6613 131.443C79.5138 131.495 79.3765 131.577 79.2564 131.68C78.6148 132.253 78.3609 133.142 78.5977 133.969L78.7383 134.452L78.7624 135.694Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M90.3627 138.196C90.4862 138.282 90.9631 138.59 91.4435 138.436C91.6734 138.36 91.8243 138.206 92.0268 137.993C92.2944 137.715 92.4625 137.437 92.562 137.245L93.557 137.465C93.6325 137.482 93.7183 137.455 93.7594 137.386C93.8246 137.283 93.78 137.153 93.6737 137.108L92.7438 136.734C92.6718 136.707 92.5929 136.703 92.5208 136.731L91.6253 137.046L90.3558 137.52L90.3627 138.196Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M93.2825 137.273L93.7526 137.492C93.8384 137.534 93.8864 137.63 93.8624 137.722C93.8384 137.825 93.7354 137.894 93.6291 137.873L92.411 137.647L91.6974 138.004L91.7969 137.427L92.5414 137.084L93.2825 137.273Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M93.7457 138.22C93.708 138.312 93.6051 138.357 93.5124 138.326C93.2757 138.22 93.0355 138.11 92.7988 138.004C92.4419 137.99 92.0851 137.973 91.7283 137.959L91.8175 137.578L92.9223 137.582L93.66 137.973C93.7457 138.021 93.7835 138.127 93.7457 138.22Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M93.1281 138.642C93.0767 138.697 92.9943 138.7 92.936 138.655L92.4247 138.257C92.2257 138.209 92.0302 138.161 91.8312 138.113C91.8655 138.014 91.9032 137.911 91.9375 137.811C92.1949 137.87 92.4556 137.932 92.713 137.99L93.1281 138.45C93.1796 138.505 93.1796 138.59 93.1281 138.642Z",
                        fill: "var(--ds-background-accent-orange-subtler, #E4B69D)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M77.8566 136.58C79.3114 137.249 80.8176 138.01 82.3616 138.879C82.9071 139.184 83.4355 139.493 83.9502 139.801C84.6844 139.52 85.2883 139.301 85.6966 139.153C86.8803 138.728 87.4738 138.546 88.9355 138.031C89.5702 137.808 90.0849 137.623 90.4108 137.506C90.5137 137.805 90.6167 138.107 90.7196 138.405C89.6011 139.228 88.1017 140.148 86.2181 140.869C85.3569 141.198 84.5403 141.435 83.7923 141.61C83.4629 141.555 82.7939 141.435 82.0219 141.243C81.4283 141.095 80.5809 140.872 79.6133 140.443C78.9168 140.134 77.9527 139.623 76.9165 138.782C77.2253 138.048 77.541 137.314 77.8566 136.58Z",
                        fill: "url(#paint27_linear_499_12980)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M78.2649 132.733C78.1757 133.317 78.4845 133.619 78.5908 134.799C78.6286 135.2 78.6251 135.533 78.6183 135.749C79.0677 135.458 79.3525 135.135 79.5138 134.919C79.6819 134.693 79.7986 134.538 79.8878 134.288C80.073 133.766 79.9427 133.368 80.2 133.217C80.224 133.204 80.3269 133.142 80.4196 133.18C80.6735 133.282 80.4127 133.948 80.7078 134.226C80.9994 134.5 81.6547 134.233 81.9944 134.096C82.3856 133.938 82.7767 133.78 82.9071 133.413C83.0512 133.011 82.7973 132.596 82.6841 132.408C82.1694 131.56 80.8141 130.665 79.5618 131.2C78.9579 131.454 78.3712 132.044 78.2649 132.733Z",
                        fill: "var(--ds-icon, #253858)"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M90.4519 33.2228L117.557 34.6295L94.0374 10.6705L90.4519 33.2228Z",
                        fill: "url(#paint28_linear_499_12980)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint0_linear_499_12980",
                        x1: "50.6701",
                        y1: "127.204",
                        x2: "144.895",
                        y2: "32.9795",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.2415",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFF)",
                                stopOpacity: "0.7585"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.4317",
                                stopColor: "var(--ds-background-accent-blue-bolder, #59A1FF)",
                                stopOpacity: "0.5683"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.6043",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AABFF)",
                                stopOpacity: "0.3957"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.7666",
                                stopColor: "var(--ds-background-accent-blue-subtle, #81B8FF)",
                                stopOpacity: "0.2334"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.9202",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #9FC9FF)",
                                stopOpacity: "0.0798"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #B2D4FF)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint1_linear_499_12980",
                        x1: "121.776",
                        y1: "45.5575",
                        x2: "147.826",
                        y2: "45.5575",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint2_linear_499_12980",
                        x1: "121.776",
                        y1: "48.5346",
                        x2: "147.826",
                        y2: "48.5346",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint3_linear_499_12980",
                        x1: "121.776",
                        y1: "51.5113",
                        x2: "141.565",
                        y2: "51.5113",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint4_linear_499_12980",
                        x1: "56.1854",
                        y1: "0.55854",
                        x2: "82.2361",
                        y2: "0.55854",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint5_linear_499_12980",
                        x1: "56.1854",
                        y1: "3.53525",
                        x2: "82.2361",
                        y2: "3.53525",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint6_linear_499_12980",
                        x1: "56.1854",
                        y1: "6.51231",
                        x2: "75.9746",
                        y2: "6.51231",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint7_linear_499_12980",
                        x1: "54.7482",
                        y1: "124.969",
                        x2: "145.885",
                        y2: "33.833",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #2684FF)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.3613",
                                stopColor: "var(--ds-background-accent-blue-subtle, #2986FF)",
                                stopOpacity: "0.6387"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.6457",
                                stopColor: "var(--ds-background-accent-blue-subtle, #338CFF)",
                                stopOpacity: "0.3543"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.9031",
                                stopColor: "var(--ds-background-accent-blue-subtle, #4495FF)",
                                stopOpacity: "0.0969"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-blue-subtle, #4C9AFF)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint8_linear_499_12980",
                        x1: "132.434",
                        y1: "109.023",
                        x2: "129.764",
                        y2: "78.307",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-subtlest, #99C1FF)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.7911",
                                stopColor: "var(--ds-background-accent-blue-subtle, #66A3FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint9_linear_499_12980",
                        x1: "23.785",
                        y1: "51.7314",
                        x2: "42.402",
                        y2: "33.1132",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.2089",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint10_linear_499_12980",
                        x1: "42.596",
                        y1: "129.08",
                        x2: "141.953",
                        y2: "29.7225",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-blue-bolder, #4C9AFF)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.208",
                                stopColor: "var(--ds-background-accent-blue-bolder, #4F9CFE)",
                                stopOpacity: "0.792"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.3719",
                                stopColor: "var(--ds-background-accent-blue-subtle, #59A0FD)",
                                stopOpacity: "0.6281"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.5207",
                                stopColor: "var(--ds-background-accent-blue-subtle, #6AA8FA)",
                                stopOpacity: "0.4793"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.6606",
                                stopColor: "var(--ds-background-accent-blue-subtler, #81B4F6)",
                                stopOpacity: "0.3394"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.7942",
                                stopColor: "var(--ds-background-accent-blue-subtler, #A0C2F0)",
                                stopOpacity: "0.2058"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.9214",
                                stopColor: "var(--ds-background-accent-blue-subtlest, #C4D4EA)",
                                stopOpacity: "0.0786"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint11_linear_499_12980",
                        x1: "37.0626",
                        y1: "130.862",
                        x2: "125.647",
                        y2: "42.2776",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DEEBFF)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.6383",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #EBF1FA)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #F4F5F7)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint12_linear_499_12980",
                        x1: "94.0388",
                        y1: "28.347",
                        x2: "117.556",
                        y2: "28.347",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-gray-subtle, #6E7C93)",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtle, #6C798F)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint13_linear_499_12980",
                        x1: "50.5705",
                        y1: "26.7136",
                        x2: "49.861",
                        y2: "13.9285",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.2629",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.6568",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.7051",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC607)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.7745",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFCA1A)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.8568",
                                stopColor: "var(--ds-background-accent-yellow-subtler, #FFD239)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.9483",
                                stopColor: "var(--ds-background-accent-yellow-subtler, #FFDC64)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint14_linear_499_12980",
                        x1: "45.5246",
                        y1: "24.8807",
                        x2: "54.0025",
                        y2: "13.9733",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.321",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.766",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint15_linear_499_12980",
                        x1: "101.929",
                        y1: "89.445",
                        x2: "103.151",
                        y2: "76.738",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.2629",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.6568",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.7051",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC607)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.7745",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFCA1A)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.8568",
                                stopColor: "var(--ds-background-accent-yellow-subtler, #FFD239)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.9483",
                                stopColor: "var(--ds-background-accent-yellow-subtler, #FFDC64)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint16_linear_499_12980",
                        x1: "96.7524",
                        y1: "86.8327",
                        x2: "105.46",
                        y2: "77.236",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.321",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.766",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint17_linear_499_12980",
                        x1: "46.7436",
                        y1: "124.678",
                        x2: "85.5786",
                        y2: "85.843",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.1228",
                                stopColor: "var(--ds-background-accent-teal-subtle, #2FD3EC)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.286",
                                stopColor: "var(--ds-background-accent-teal-subtle, #67E2F4)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.4263",
                                stopColor: "var(--ds-background-accent-teal-subtler, #90ECFA)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.5367",
                                stopColor: "var(--ds-background-accent-teal-subtler, #AAF3FE)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.6033",
                                stopColor: "var(--ds-background-accent-teal-subtlest, #B3F5FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint18_linear_499_12980",
                        x1: "55.645",
                        y1: "135.098",
                        x2: "94.1816",
                        y2: "96.5612",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.1228",
                                stopColor: "var(--ds-background-accent-teal-subtle, #2FD3EC)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.286",
                                stopColor: "var(--ds-background-accent-teal-subtle, #67E2F4)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.4263",
                                stopColor: "var(--ds-background-accent-teal-subtler, #90ECFA)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.5367",
                                stopColor: "var(--ds-background-accent-teal-subtler, #AAF3FE)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.6033",
                                stopColor: "var(--ds-background-accent-teal-subtlest, #B3F5FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint19_linear_499_12980",
                        x1: "82.9016",
                        y1: "129.529",
                        x2: "83.3365",
                        y2: "138.118",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFAB00)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint20_linear_499_12980",
                        x1: "66.7271",
                        y1: "153.359",
                        x2: "112.794",
                        y2: "115.971",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.1228",
                                stopColor: "var(--ds-background-accent-teal-subtle, #2FD3EC)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.286",
                                stopColor: "var(--ds-background-accent-teal-subtle, #67E2F4)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.4263",
                                stopColor: "var(--ds-background-accent-teal-subtler, #90ECFA)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.5367",
                                stopColor: "var(--ds-background-accent-teal-subtler, #AAF3FE)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.6033",
                                stopColor: "var(--ds-background-accent-teal-subtlest, #B3F5FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint21_linear_499_12980",
                        x1: "64.8985",
                        y1: "150.541",
                        x2: "110.859",
                        y2: "113.239",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-teal-subtle, #00C7E5)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.1228",
                                stopColor: "var(--ds-background-accent-teal-subtle, #2FD3EC)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.286",
                                stopColor: "var(--ds-background-accent-teal-subtle, #67E2F4)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.4263",
                                stopColor: "var(--ds-background-accent-teal-subtler, #90ECFA)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.5367",
                                stopColor: "var(--ds-background-accent-teal-subtler, #AAF3FE)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.6033",
                                stopColor: "var(--ds-background-accent-teal-subtlest, #B3F5FF)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint22_linear_499_12980",
                        x1: "99.6982",
                        y1: "120.33",
                        x2: "103.749",
                        y2: "121.161",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.766",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint23_linear_499_12980",
                        x1: "0.174194",
                        y1: "146.568",
                        x2: "56.0521",
                        y2: "146.568",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "var(--ds-icon, #091E42)",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-icon, #091E42)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint24_linear_499_12980",
                        x1: "58.1309",
                        y1: "158.125",
                        x2: "87.7433",
                        y2: "158.125",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "var(--ds-icon, #091E42)",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-icon, #091E42)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint25_linear_499_12980",
                        x1: "78.6253",
                        y1: "150.658",
                        x2: "68.697",
                        y2: "151.584",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.452",
                                stopColor: "var(--ds-background-accent-orange-subtle, #FF991F)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint26_linear_499_12980",
                        x1: "79.3893",
                        y1: "142.265",
                        x2: "75.8395",
                        y2: "140.601",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFC400)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.3539",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFB500)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.7017",
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFAB00)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint27_linear_499_12980",
                        x1: "76.9238",
                        y1: "139.183",
                        x2: "90.7241",
                        y2: "138.741",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "var(--ds-background-accent-yellow-subtle, #FFAB00)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.7262",
                                stopColor: "var(--ds-background-accent-yellow-subtlest, #FFE380)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint28_linear_499_12980",
                        x1: "90.4515",
                        y1: "22.6491",
                        x2: "117.556",
                        y2: "22.6491",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.0346",
                                stopColor: "var(--ds-icon-inverse, white)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.3965",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #F7F7F8)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "0.9604",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #E1E3E6)"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "var(--ds-background-accent-gray-subtlest, #DFE1E5)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip0_499_12980",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "147.652",
                            height: "160",
                            fill: "var(--ds-icon-inverse, white)",
                            transform: "translate(0.174194)"
                        })
                    })
                ]
            })
        ]
    });



var $cgtv4 = parcelRequire("cgtv4");

const $30be43982da321bc$var$messages = (0, $cgtv4.defineMessages)({
    connectToConfluenceHeading: {
        id: "embedded.confluence.connect-to-confluence.heading",
        defaultMessage: "Connect to Confluence"
    },
    connectToConfluenceDescription: {
        id: "embedded.confluence.connect-to-confluence.description",
        defaultMessage: "Save ideas, track agenda items, and take notes together as a team."
    },
    connectConfluenceButton: {
        id: "embedded.confluence.connect-to-confluence.button",
        defaultMessage: "Connect Confluence"
    },
    connectConfluenceButtonAriaLabel: {
        id: "embedded.confluence.connect-to-confluence.button.aria-label",
        defaultMessage: "Connect Confluence Button"
    },
    buttonLoginToConfluenceNewTab: {
        id: "embedded.confluence.generic-error-page.login-to-confluence-button",
        defaultMessage: "Log in to Confluence"
    },
    paragraphLogin: {
        id: "embedded.confluence.need-to-log-in-paragraph",
        defaultMessage: "You need to be logged in to view this page"
    },
    paragraphAlreadyLoggedIn: {
        id: "embedded.confluence.already-logged-in-paragraph",
        defaultMessage: "Already logged in? Try refreshing."
    },
    paragraphStillHavingTrouble: {
        id: "embedded.confluence.still-having-trouble-paragraph",
        defaultMessage: "Still having trouble? Make sure 3rd party cookies are enabled, or {link}"
    },
    linkTroubleshootingText: {
        id: "embedded.confluence.troubleshooting-link-text",
        defaultMessage: "refer to this troubleshooting guide."
    },
    linkAriaLabel: {
        id: "embedded.confluence.troubleshooting-link.aria-label",
        defaultMessage: "troubleshooting guide link"
    },
    loginAriaLabel: {
        id: "embedded.confluence.login-page.login-button.aria-label",
        defaultMessage: "Login Button"
    },
    loginText: {
        id: "embedded.confluence.login-page.login-text",
        defaultMessage: "You need to be logged in to view this page"
    },
    loginButton: {
        id: "embedded.confluence.login-page.login-button",
        defaultMessage: "Log in to Confluence"
    },
    refreshBanner: {
        id: "embedded.confluence.login-page.refresh-page-banner",
        defaultMessage: "After logging in, this page should refresh automatically. If not, you can click here to refresh"
    },
    refreshBannerLink: {
        id: "embedded.confluence.login-page.refresh-page-banner-refresh-link",
        defaultMessage: "Refresh page"
    }
});
var $30be43982da321bc$export$2e2bcd8739ae039 = $30be43982da321bc$var$messages;





const $b67c8ce1deb4b4b8$var$LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES = 'https://support.atlassian.com/atlassian-account/docs/login-issues-related-to-browser-cookies/';
const $b67c8ce1deb4b4b8$var$styles = {
    loginButtonWrapper: "_19pkxy5q _otyrpxbi",
    mainWrapper: "_1e0c1n7u _4cvr1h6o _6a6z1h6o _y3gn1h6o"
};
const $b67c8ce1deb4b4b8$export$42f84e610f279c31 = ({ standaloneConfluenceUrl: standaloneConfluenceUrl })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $jJf3a.ExperienceTrackerContext));
    const experience = (0, $42omo.useContext)((0, $9f20096665d70f6d$export$fb99266658f5da06));
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { cancelIframeLoadMetrics: cancelIframeLoadMetrics } = (0, $kudeD.usePerformanceMetrics)();
    (0, $42omo.useEffect)(()=>{
        cancelIframeLoadMetrics();
    }, [
        cancelIframeLoadMetrics
    ]);
    (0, $42omo.useEffect)(()=>{
        experienceTracker.abort({
            name: experience,
            reason: (0, $7pThu.ExperienceReasons).UNABLE_TO_DISPLAY_CONTENT
        });
    }, [
        experience,
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        "data-testid": "error-screen-container",
        className: (0, $gMc0m.default)([
            $b67c8ce1deb4b4b8$var$styles.mainWrapper
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.250",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceLogo), {
                        size: "large",
                        appearance: "brand"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $db080d242cf20bf8$export$ae31f6824db63a1c), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                        as: "h2",
                        size: "large",
                        children: formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).paragraphLogin)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $b67c8ce1deb4b4b8$var$styles.loginButtonWrapper,
                // used instead of className as the className prop is not allowed
                // suggested by #help-design-system https://atlassian.slack.com/archives/CFJ9DU39U/p1746963980938489
                "data-embedded-confluence-no-global-styles-link-button": "true",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
                    appearance: "primary",
                    "aria-label": formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).buttonLoginToConfluenceNewTab),
                    iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
                    href: standaloneConfluenceUrl ?? '',
                    target: "_blank",
                    children: formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).buttonLoginToConfluenceNewTab)
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        as: "p",
                        children: formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).paragraphAlreadyLoggedIn)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        as: "p",
                        children: formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).paragraphStillHavingTrouble, {
                            link: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                href: $b67c8ce1deb4b4b8$var$LOGIN_ISSUES_RELATED_TO_BROWSER_COOKIES,
                                target: "_blank",
                                "aria-label": formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).linkAriaLabel),
                                children: formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).linkTroubleshootingText)
                            })
                        })
                    })
                ]
            })
        ]
    });
};


/* LoginPage.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $fVUfS = parcelRequire("fVUfS");













var $ccHMk = parcelRequire("ccHMk");





var $9HehF = parcelRequire("9HehF");











parcelRequire("42omo");


var $eCEXz = parcelRequire("eCEXz");


var $3sFtD = parcelRequire("3sFtD");


var $6fnsQ = parcelRequire("6fnsQ");

const $6035301bc49c38a6$var$RefreshBanner = ({ reloadEP: reloadEP, title: title, actionLabel: actionLabel })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $eCEXz.default), {
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
            spacing: "spacious",
            color: `var(--ds-icon-information, ${(0, $6fnsQ.B300)})`,
            label: "Info"
        }),
        id: "refreshBanner",
        title: title,
        actions: [
            {
                content: actionLabel,
                onClick: reloadEP
            }
        ]
    });
var $6035301bc49c38a6$export$2e2bcd8739ae039 = $6035301bc49c38a6$var$RefreshBanner;









parcelRequire("42omo");

const $e7b6f154db87a25a$export$b8ca9c7db864e9fb = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "167",
        height: "110",
        viewBox: "0 0 167 110",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M31.3301 44.2761C32.0417 39.4311 36.5463 36.0803 41.3913 36.792L76.4821 41.9462C81.3272 42.6579 84.6779 47.1624 83.9663 52.0075L78.812 87.0983C78.1004 91.9433 73.5958 95.294 68.7508 94.5824L33.66 89.4282C28.815 88.7165 25.4642 84.2119 26.1759 79.3669L31.3301 44.2761Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M67.5284 73.4352C59.3 67.8513 56.8065 66.8312 53.0744 66.2831C48.6954 65.6399 44.6958 66.9131 40.6098 71.5432L39.9395 72.2997C39.3904 72.9231 39.2547 73.1546 39.2113 73.45C39.1679 73.7454 39.2811 74.0134 39.7778 74.4384L44.8874 78.7596C45.1571 79.0004 45.3914 79.1354 45.6402 79.1719C45.9388 79.2158 46.1595 79.0973 46.5232 78.6981L47.6213 77.4513C49.3256 75.5391 50.6708 75.0326 52.2632 75.2665C53.6565 75.4712 55.2408 76.1062 57.1364 77.3904L62.6032 81.0097C63.157 81.3928 63.8256 81.3401 64.2254 80.6948L67.9086 74.9997C68.3084 74.3544 68.1745 73.8821 67.5284 73.4352ZM43.286 58.8607C51.5144 64.4446 54.0079 65.4647 57.74 66.0129C62.119 66.656 66.1186 65.3828 70.2046 60.7527L70.8749 59.9962C71.424 59.3728 71.5597 59.1413 71.6031 58.8459C71.6464 58.5505 71.5333 58.2825 71.0366 57.8575L65.9269 53.5363C65.6573 53.2956 65.4229 53.1606 65.1741 53.124C64.8756 53.0802 64.6548 53.1986 64.2912 53.5978L63.193 54.8446C61.4888 56.7568 60.1435 57.2633 58.5512 57.0294C57.1579 56.8247 55.5736 56.1897 53.678 54.9055L48.2111 51.2862C47.6574 50.9031 46.9888 50.9558 46.589 51.6011L42.9058 57.2962C42.506 57.9415 42.6399 58.4138 43.286 58.8607Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M79.0185 46.5871C78.7238 41.699 82.4475 37.4974 87.3356 37.2027L122.739 35.0683C127.627 34.7736 131.828 38.4973 132.123 43.3855L134.257 78.7885C134.552 83.6766 130.828 87.8782 125.94 88.1729L90.5372 90.3073C85.6491 90.602 81.4476 86.8782 81.1529 81.9901L79.0185 46.5871Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M131.339 50.0102C131.38 50.4171 131.327 50.505 131.302 50.1756C131.296 50.0816 131.32 49.9587 131.339 50.0102ZM131.57 52.9057C131.605 53.3647 131.523 53.1278 131.517 53.0508C131.491 52.7277 131.544 52.4429 131.45 52.3368C131.432 52.1403 131.48 52.3249 131.475 52.2024C131.466 51.974 131.411 51.7504 131.395 51.5148C131.394 51.4988 131.393 51.4827 131.392 51.4667C131.409 51.4389 131.425 51.3739 131.444 51.3812C131.483 51.6293 131.561 52.7919 131.57 52.9057ZM131.427 50.9503C131.427 51.0635 131.396 51.0164 131.425 51.2291C131.405 51.2768 131.371 51.0701 131.365 50.9646C131.366 50.9616 131.384 50.975 131.383 50.95C131.373 50.7637 131.336 50.4831 131.384 50.4742C131.369 50.6602 131.426 50.8363 131.427 50.9503ZM131.282 48.5903C131.246 48.5428 131.245 48.4575 131.257 48.3261C131.265 48.3353 131.273 48.3382 131.281 48.3488C131.28 48.4257 131.282 48.5106 131.282 48.5903ZM131.26 48.1016C131.214 48.0042 131.204 47.4619 131.229 47.556C131.24 47.7377 131.25 47.9201 131.26 48.1016ZM107.62 90.4766C107.274 90.5679 106.006 90.5716 105.721 90.5878C104.407 90.6624 103.378 90.7473 102.165 90.8174C101.392 90.862 100.675 90.8822 99.9078 90.9254C99.7367 90.8515 99.5625 90.7784 99.3886 90.705C99.498 90.7054 99.555 90.7128 99.6801 90.7055C99.8054 90.698 100.106 90.6919 100.18 90.6481C100.066 90.6154 99.6636 90.6311 99.5409 90.6386C99.305 90.6532 99.4564 90.6823 99.2947 90.7011C99.1322 90.7198 98.859 90.6833 98.6613 90.7154C98.1978 90.7907 99.0717 90.7683 99.232 90.7501C99.1833 90.8416 98.7878 90.762 98.6394 90.8403C98.6993 90.8575 98.9438 90.8941 99.0348 90.8735C99.125 90.8526 98.9797 90.809 99.1761 90.8123C99.3083 90.8528 99.4553 90.895 99.5867 90.9362C99.3933 90.9602 99.0982 90.9499 98.9253 90.9616C97.8606 91.0345 96.8159 91.0945 95.7699 91.1505C94.9029 91.1696 94.0376 91.187 93.174 91.2031C93.1836 91.205 93.1924 91.2072 93.2008 91.2093C93.2152 91.2129 93.2294 91.2164 93.2482 91.2186C93.2489 91.2181 93.2496 91.2176 93.2504 91.2171C93.2716 91.22 93.3038 91.2207 93.3367 91.2214C93.3818 91.2223 93.4283 91.2234 93.4497 91.2302C93.4243 91.2339 93.3988 91.2377 93.3734 91.2414C93.3171 91.2482 93.2574 91.2556 93.2003 91.2626C93.1442 91.2437 93.0882 91.2247 93.0322 91.2058C92.7606 91.2108 92.489 91.2157 92.2176 91.2205C92.2071 91.2169 92.1935 91.2133 92.1762 91.2101C92.1625 91.2076 92.1487 91.2051 92.135 91.2025C92.1133 91.2019 92.0916 91.2013 92.0699 91.2006C91.957 91.1974 91.8172 91.1977 91.7043 91.1983C91.674 91.1985 91.6449 91.1988 91.6183 91.199C91.5339 91.1995 91.4672 91.2 91.416 91.1995C91.4092 91.1994 91.4019 91.1995 91.3948 91.1994C91.3921 91.197 91.3877 91.1948 91.3823 91.1928C91.342 91.1785 91.2874 91.1824 91.2329 91.1949C91.2272 91.1964 91.2215 91.1979 91.2158 91.1994C91.1868 91.1995 91.1581 91.1996 91.132 91.1996C91.0351 91.1998 90.9251 91.1993 90.7943 91.1963C90.7267 91.1947 90.6606 91.1924 90.5904 91.1899C90.5804 91.1896 90.5702 91.1894 90.56 91.189C90.5594 91.189 90.5589 91.189 90.5583 91.189C90.5114 91.1876 90.4628 91.1858 90.411 91.1836C90.3415 91.1806 90.267 91.1769 90.1953 91.1735C90.1278 91.1703 90.0396 91.1663 89.946 91.164C89.7468 91.1666 88.9653 91.107 88.5938 91.034C88.4281 91.0058 88.2629 90.9911 88.1944 91.0022C88.101 90.9806 88.007 90.9575 87.9141 90.9331C87.9082 90.9345 87.8999 90.9352 87.8885 90.9345C87.864 90.9327 87.823 90.9258 87.7788 90.9177C87.6952 90.9027 87.6003 90.8836 87.5888 90.8972C87.6785 90.9206 87.7675 90.9425 87.8575 90.9632C87.8634 90.9646 87.8693 90.9661 87.8752 90.9675C87.9335 90.993 87.6034 90.9524 87.4974 90.905C87.413 90.8688 87.4552 90.8308 87.4954 90.8131C87.4526 90.7998 87.4099 90.7861 87.3674 90.7721C87.3541 90.7724 87.3444 90.775 87.3343 90.7775C87.3182 90.7815 87.3009 90.7859 87.265 90.7827C87.0814 90.7695 86.6535 90.5904 86.8491 90.6095C86.7354 90.5643 86.716 90.5671 86.6938 90.5718C86.6703 90.5765 86.6421 90.5832 86.4934 90.5273C86.3176 90.4597 86.2527 90.4186 86.1919 90.3808C86.1597 90.3605 86.1282 90.3405 86.0824 90.3162C86.0409 90.2943 85.967 90.2599 85.8842 90.2195C85.7023 90.1317 85.48 90.011 85.4441 89.959C85.4025 89.9008 85.4973 89.942 85.58 89.9786C85.3732 89.8604 85.1712 89.7347 84.9742 89.6018C84.9683 89.6082 84.9628 89.6164 84.9563 89.626C84.6803 89.4614 84.6463 89.4058 84.7056 89.4138C84.4619 89.2369 84.2266 89.0487 84.0011 88.8505C83.9491 88.815 83.898 88.778 83.8573 88.7474C83.8663 88.77 83.9181 88.8143 83.9672 88.8549C84.0087 88.8894 84.0486 88.9216 84.0578 88.9379C84.1217 89.065 83.5954 88.7066 83.7348 88.7207C83.7682 88.7247 83.8061 88.7288 83.773 88.6802C83.7475 88.644 83.6269 88.5267 83.5785 88.4881C83.58 88.4881 83.5814 88.4881 83.5829 88.4881C83.5793 88.4851 83.5723 88.4815 83.5627 88.4766C83.5507 88.4709 83.5388 88.4651 83.5268 88.4593C83.495 88.4441 83.4558 88.4248 83.4272 88.4066C83.3929 88.384 83.3536 88.3551 83.3137 88.325C82.8696 87.978 83.1905 88.265 82.8441 87.8048C82.8172 87.7684 82.7836 87.7308 82.7522 87.695C82.7247 87.6635 82.6985 87.6329 82.6802 87.6068C82.6449 87.5582 82.616 87.5138 82.5881 87.4702C82.5357 87.3883 82.4859 87.3084 82.4032 87.2011C82.4008 87.1982 82.4038 87.2055 82.4083 87.2165C82.5222 87.4874 82.2959 87.0342 82.2912 87.0204C82.2843 87.0085 82.2788 86.9991 82.2796 86.9978C82.2871 86.9874 82.3585 87.0764 82.4443 87.1771C82.525 87.2721 82.6195 87.3779 82.6785 87.4268C82.6462 87.3841 82.6142 87.341 82.5827 87.2978C82.544 87.2596 82.5018 87.2089 82.4626 87.1481C82.4523 87.1315 82.4576 87.1307 82.4627 87.1299C82.4628 87.1298 82.4629 87.1298 82.4629 87.1297C82.4354 87.0902 82.4081 87.0506 82.3812 87.0107C82.3732 87.0062 82.3701 87.0087 82.3696 87.0092C82.3688 87.0091 82.3681 87.009 82.3673 87.0089C82.3132 86.9471 82.1273 86.6606 82.1188 86.6193C82.1159 86.6088 82.1154 86.6013 82.1174 86.5973C82.0521 86.4889 81.989 86.3792 81.9282 86.2686C81.92 86.2589 81.9122 86.2484 81.9052 86.2367C81.8892 86.2113 81.8767 86.182 81.8655 86.1525C81.8362 86.0972 81.8071 86.0414 81.779 85.9858C81.7779 85.9858 81.7768 85.9858 81.7757 85.9858C81.7681 85.986 81.7599 85.986 81.7526 85.9766C81.9146 86.2648 81.8715 86.2166 81.8189 86.1646C81.795 86.1404 81.7701 86.115 81.7643 86.1207C81.7571 86.1293 81.7854 86.1854 81.8128 86.238C81.8471 86.3039 81.8798 86.3648 81.835 86.3242C81.7541 86.1559 81.6866 86.0493 81.6196 85.9409C81.4113 85.5958 81.4418 85.5059 81.5671 85.7679C81.5941 85.8225 81.6228 85.879 81.6506 85.9161C81.6827 85.9595 81.7048 85.9637 81.7246 85.9673C81.734 85.9691 81.7432 85.9709 81.7526 85.9766C81.7505 85.9738 81.7485 85.971 81.7465 85.9681C81.7389 85.9589 81.5991 85.7219 81.5883 85.6967C81.5147 85.5528 81.5228 85.5549 81.535 85.5597C81.5414 85.5621 81.5492 85.5651 81.5486 85.5495C81.5479 85.5434 81.5404 85.5246 81.533 85.5057C81.5233 85.4809 81.5138 85.4558 81.5184 85.4579C81.5225 85.4581 81.5307 85.4662 81.5403 85.4775C81.5243 85.4406 81.5084 85.4033 81.4928 85.3661C81.4797 85.3476 81.4678 85.3297 81.4595 85.3121C81.4553 85.3034 81.3896 85.1212 81.3911 85.1194C81.3912 85.1189 81.3925 85.12 81.3947 85.1222C81.2502 84.748 81.1298 84.3647 81.0343 83.9759C81.0341 83.9724 81.0338 83.9689 81.0336 83.9654C81.0332 83.9596 81.0329 83.9536 81.0325 83.9476C81.0317 83.9311 81.0309 83.9146 81.0301 83.8981C81.0275 83.8381 81.0247 83.7495 81.0197 83.6666C81.0161 83.6075 81.0102 83.5303 80.9992 83.4389C80.9883 83.3487 80.9675 83.2035 80.9296 83.0313C80.9038 82.9144 80.8771 82.8037 80.8493 82.7188C80.8136 82.6096 80.7836 82.558 80.7674 82.5406C80.7627 82.5356 80.7584 82.5334 80.7545 82.5341C80.7425 82.5071 80.7338 82.4871 80.733 82.4854C80.7088 82.3834 80.7232 82.3809 80.7338 82.3798C80.7362 82.3795 80.7386 82.3791 80.7402 82.3776C80.7451 82.3701 80.7683 82.3392 80.7809 82.3254C80.7742 82.2219 80.7692 82.1179 80.7659 82.0134C80.7559 81.6901 80.7456 81.3663 80.7349 81.0422C80.7207 80.6135 80.7032 80.181 80.6826 79.745C80.6695 79.4657 80.6552 79.1847 80.6397 78.9027C80.6302 78.9271 80.6201 78.9398 80.6023 78.8581C80.5776 78.7426 80.5856 78.4294 80.5869 78.3818C80.585 78.373 80.5814 78.3636 80.5772 78.3522C80.5673 78.3258 80.5531 78.288 80.5445 78.2183C80.5251 78.0634 80.3678 77.3508 80.3787 77.1825C80.3693 77.0425 80.3596 76.9019 80.3497 76.7614C80.348 76.7092 80.3461 76.6588 80.3445 76.6114C80.348 76.5958 80.3509 76.5773 80.3531 76.555C80.3757 76.3205 80.3758 75.8656 80.4059 75.605C80.4224 75.6733 80.4382 75.7545 80.4543 75.8278C80.4653 75.7741 80.4764 75.7195 80.4874 75.665C80.4942 75.6747 80.5009 75.6836 80.5077 75.6925C80.5085 75.5271 80.5092 75.3616 80.51 75.1962C80.5093 75.1966 80.5085 75.1968 80.5078 75.1971C80.4996 75.1382 80.5033 75.1116 80.5104 75.095C80.5108 75.0137 80.5113 74.9324 80.5117 74.8511C80.5071 74.8269 80.5022 74.8005 80.497 74.7742C80.4786 74.7564 80.4601 74.7386 80.4416 74.7209C80.4489 74.6766 80.4562 74.6324 80.4635 74.5882C80.4432 74.4592 80.4319 74.3318 80.4533 74.2422C80.4471 74.1671 80.4409 74.0919 80.4347 74.0168C80.4269 73.9667 80.4215 73.911 80.4189 73.8562C80.3929 73.7794 80.2514 73.5491 80.2112 73.1899C80.2561 73.1982 80.301 73.2066 80.346 73.215C80.3322 73.1088 80.3184 73.0027 80.3046 72.8965C80.275 72.8709 80.2454 72.8452 80.2159 72.8196C80.2372 72.806 80.2586 72.7923 80.2799 72.7787C80.264 72.5745 80.2481 72.3704 80.2322 72.1662C80.2318 72.1662 80.2314 72.1663 80.2311 72.1663C80.2279 72.1399 80.2271 72.1211 80.2277 72.1076C80.2256 72.0798 80.2234 72.052 80.2212 72.0242C80.2403 72.0275 80.2593 72.0309 80.2784 72.0343C80.2785 72.0312 80.2788 72.0281 80.2787 72.0245C80.2776 71.9657 80.2699 71.9109 80.2596 71.8565C80.2526 71.8783 80.2457 71.9001 80.2388 71.9219C80.2027 71.6505 80.1667 71.3791 80.1307 71.1076C80.1409 71.072 80.1512 71.0364 80.1615 71.0008C80.1598 70.9882 80.1585 70.9758 80.1579 70.9648C80.1582 70.9631 80.1657 70.9624 80.1731 70.9594C80.1772 70.9448 80.1814 70.9302 80.1856 70.9156C80.1853 70.9103 80.185 70.9051 80.1846 70.8998C80.1459 70.8409 80.1072 70.7821 80.0684 70.7233C80.0579 70.5699 80.0474 70.4165 80.037 70.2631C80.035 70.1419 80.0339 70.0263 80.0328 69.9182C80.0445 69.7275 80.0562 69.5368 80.0678 69.346C80.0515 69.3242 80.0392 69.3047 80.0301 69.2856C80.0302 69.2133 80.0303 69.1724 80.0303 69.1724C80.0221 69.163 80.0138 69.1537 80.0055 69.1444C80.0071 69.0531 80.0211 68.9288 79.969 68.6875C80.0104 68.6956 80.0517 68.7037 80.0931 68.7117C80.0956 68.688 80.0999 68.6606 80.1057 68.631C80.0471 68.3825 79.9886 68.1341 79.9301 67.8857C79.9837 67.7705 80.0373 67.6552 80.0909 67.54C80.0838 67.262 80.0766 66.9841 80.0695 66.7062C80.0664 66.6765 80.0636 66.6465 80.0605 66.6168C80.0416 66.7078 80.0226 66.7988 80.0037 66.8898C79.944 66.8071 79.8842 66.7244 79.8245 66.6416C79.8578 66.4725 79.8911 66.3034 79.9244 66.1342C79.8061 65.3199 79.9727 64.5136 79.7355 64.8227C79.7519 64.9322 79.7684 65.0417 79.7848 65.1512C79.7383 65.0113 79.6918 64.8714 79.6454 64.7315C79.6676 64.5993 79.6898 64.4671 79.712 64.3348C79.6892 64.1731 79.6663 64.0114 79.6435 63.8497C79.671 63.8019 79.6985 63.7542 79.726 63.7065C79.6899 63.5758 79.6537 63.4451 79.6176 63.3144C79.6609 63.2008 79.7042 63.0871 79.7475 62.9735C79.6979 62.3226 79.6483 61.6717 79.5987 61.0208C79.6525 60.0392 79.5116 60.5012 79.4237 59.8255C79.4384 59.5102 79.4531 59.195 79.4678 58.8797C79.4325 58.7663 79.3972 58.6529 79.362 58.5395C79.3723 58.4369 79.3826 58.3344 79.393 58.2318C79.3687 57.749 79.3445 57.2662 79.3202 56.7834C79.2766 56.8794 79.233 56.9754 79.1894 57.0714C79.1742 56.982 79.1591 56.8925 79.1439 56.8031C79.1899 56.564 79.2358 56.3249 79.2818 56.0858C79.2522 55.9 79.2227 55.7143 79.1932 55.5286C79.1887 55.2678 79.1841 55.0071 79.1795 54.7464C79.2151 54.7336 79.2506 54.7209 79.2861 54.7082C79.2221 54.6167 79.158 54.5251 79.094 54.4336C79.0614 54.0636 79.0287 53.6935 78.996 53.3235C79.0365 53.5433 79.077 53.7631 79.1175 53.9829C79.1303 53.7921 79.1431 53.6013 79.1559 53.4105C79.1273 53.2084 79.0986 53.0062 79.07 52.8041C79.0432 52.7445 79.0165 52.685 78.9898 52.6254C78.9878 52.2029 78.9857 51.7805 78.9837 51.358C78.954 50.8549 78.9243 50.3518 78.8946 49.8487C78.7823 49.4097 78.8897 48.6265 78.6532 48.5856C78.6472 48.1752 78.6413 47.7648 78.6354 47.3544C78.617 47.2651 78.5985 47.1759 78.5801 47.0866C78.6077 47.0381 78.6353 46.9897 78.6629 46.9412C78.6391 46.8317 78.6154 46.7223 78.5916 46.6128C78.5777 46.5465 78.5646 46.48 78.5521 46.4135C78.544 46.1586 78.5462 45.9011 78.5589 45.6468C78.5767 45.7278 78.5956 45.8079 78.6155 45.888C78.6565 45.1694 78.7813 44.4595 78.9865 43.7757C78.9398 43.7258 78.8935 43.6754 78.8475 43.6243C78.9342 43.3654 79.0325 43.1102 79.1413 42.861C79.12 42.8162 79.0991 42.771 79.0784 42.7256C79.233 42.3018 79.4186 41.8886 79.6329 41.4908C79.8971 41.1088 80.1878 40.7491 80.501 40.4152C80.7499 39.8965 81.5911 38.9271 81.9551 38.918C82.4932 38.438 83.09 38.0189 83.7307 37.6738C83.7112 37.7222 83.692 37.7707 83.6735 37.8191C83.7343 37.7993 83.7953 37.7801 83.8561 37.7618C83.8806 37.6928 83.9062 37.6239 83.9328 37.5549C84.1786 37.4814 84.4251 37.419 84.673 37.3669C84.5981 37.4263 84.5235 37.487 84.4508 37.5484C84.3568 37.5872 84.264 37.6274 84.1714 37.6694C84.3145 37.6444 84.457 37.6232 84.5999 37.6053C84.5945 37.6084 84.5891 37.6114 84.5836 37.6145C85.2161 37.4001 85.7845 37.3042 86.2854 37.2596C86.3256 37.2564 86.3657 37.2534 86.4059 37.2506C86.9855 37.2195 87.24 37.3094 87.3206 37.3772C87.3386 37.3929 87.3481 37.4094 87.3491 37.4263C87.3491 37.4263 87.3491 37.4263 87.3491 37.4263C87.3536 37.5039 87.1847 37.5851 86.856 37.6805C86.8279 37.6884 86.7999 37.6964 86.7721 37.7045C86.3117 37.8332 85.8271 37.9752 85.3817 38.137C85.4686 38.1219 85.5525 38.1102 85.6205 38.1063C85.5736 38.1325 85.517 38.1606 85.4671 38.1881C85.5109 38.1893 85.5557 38.1906 85.5999 38.1924C85.5919 38.2047 85.5899 38.215 85.578 38.2289C85.3094 38.3084 84.98 38.4856 84.7525 38.5867C84.5446 38.6783 84.408 38.6911 84.2496 38.7672C84.0868 38.8398 83.6355 39.1787 83.6803 39.0438C83.6527 39.0557 83.6141 39.0751 83.5873 39.0857C83.615 39.1859 83.3832 39.2423 83.1935 39.3952C83.1035 39.4659 82.8854 39.7388 83.0403 39.4458C83.0091 39.4667 82.9936 39.4718 82.9658 39.4879C82.7884 39.7796 82.6552 39.8348 82.3589 40.0477C82.1924 40.1656 81.8866 40.4424 82.0829 40.3758C81.9825 40.5636 81.7389 40.6956 81.648 40.8147C81.5589 40.9321 81.7257 40.811 81.6061 40.9687C81.5856 40.9942 81.4152 41.2135 81.3615 41.2767C81.3074 41.3385 81.3322 41.2371 81.2587 41.3492C80.9423 41.8384 80.7524 42.3451 80.5338 42.8996C80.0775 44.0705 79.8857 45.2827 79.9687 46.5298C80.0068 47.0976 80.0444 47.6739 80.0832 48.2653C80.1054 48.6026 80.2269 50.3483 80.2056 50.5496C80.1319 51.2394 79.9913 49.7944 80.0004 50.7772C80.3346 51.0247 80.2752 51.6099 80.3287 52.4314C80.3681 53.0372 80.4728 54.0132 80.4669 54.5351C80.4607 55.092 80.3957 54.6488 80.3477 54.9832C80.4922 55.1983 80.5351 55.4647 80.5703 55.922C80.6074 56.4025 80.5958 56.8851 80.616 57.3871C80.6228 57.5562 80.6651 57.7847 80.6653 57.9784C80.6656 58.2199 80.587 58.1635 80.585 58.3117C80.5831 58.4603 80.6621 58.3274 80.6855 58.4876C80.6962 58.5605 80.7297 59.0693 80.7028 59.1805C80.6965 59.2064 80.6631 59.1128 80.6386 59.1345C80.6252 59.1465 80.5177 59.1487 80.5343 59.2722C80.6361 59.3769 80.733 59.3798 80.7632 59.7658C80.8107 60.376 80.801 60.9562 80.8335 61.6063C80.8409 61.7518 80.9318 62.092 80.8594 62.2541C80.8383 62.3014 80.7444 62.2823 80.7631 62.5136C80.7791 62.7126 80.823 62.7413 80.8651 62.9129C80.881 62.978 80.8385 62.9994 80.8719 63.1225C80.9052 63.2464 80.9753 63.4223 80.8664 63.5094C80.902 63.5238 80.9328 63.5246 80.9664 63.5343C80.9856 63.7547 80.882 64.1396 80.983 64.0672C80.9972 64.2942 81.0114 64.5217 81.0256 64.7487C80.9906 64.7907 80.9553 64.8316 80.9201 64.8736C80.8761 64.7406 80.9118 64.5274 80.8399 64.5069C80.8461 64.7026 80.8524 64.9009 80.8585 65.0948C81.0434 65.0319 81.1744 65.6375 80.9695 65.514C80.9306 65.491 80.9861 65.8896 81.0041 65.9755C81.022 66.0608 81.0994 66.0792 81.0619 66.2597C81.0407 66.3622 80.9991 66.427 81.0658 66.6657C81.0782 66.5177 81.0946 66.3596 81.109 66.2086C81.1136 66.43 81.157 66.7154 81.1287 66.9141C81.1216 66.9632 81.082 66.7738 81.0714 66.8647C81.0607 66.9559 81.0921 67.3236 81.1609 67.2422C81.0275 67.4207 81.1452 67.3897 81.1706 67.7482C81.1736 67.7938 81.0587 68.1645 81.1418 68.3253C81.1714 68.3821 81.262 68.2671 81.2374 68.5537C81.2192 68.7646 81.1234 68.5544 81.0907 68.789C81.1945 68.6745 81.2802 69.0334 81.2957 69.2456C81.3233 69.6218 81.2503 69.5699 81.2271 69.6922C81.1854 69.9128 81.2883 70.0951 81.2113 70.2217C81.2053 70.1579 81.195 70.1003 81.1874 70.0389C81.1847 70.1751 81.1825 70.3115 81.1798 70.4471C81.2253 70.4385 81.271 70.4288 81.3161 70.4208C81.345 70.6481 81.2953 70.7473 81.2954 70.9378C81.2955 70.9645 81.3263 70.9358 81.3283 70.963C81.3444 71.1821 81.3311 71.2535 81.4059 71.4106C81.2912 71.4278 81.385 71.7063 81.3478 71.9351C81.3372 71.9992 81.2802 72.0386 81.4063 72.0244C81.4037 72.4543 81.4333 72.7757 81.3579 73.1275C81.4762 72.9922 81.5078 73.4838 81.4906 73.7712C81.4857 73.8479 81.4013 73.9199 81.4262 74.0801C81.4614 74.0345 81.5017 73.9823 81.5381 73.9337C81.57 74.2598 81.449 74.1949 81.4783 74.4711C81.4913 74.5923 81.6174 74.5074 81.5731 74.7418C81.5476 74.876 81.3938 74.9617 81.5904 74.999C81.6113 75.1832 81.5413 75.0724 81.5417 75.202C81.5421 75.2834 81.6195 75.3695 81.6182 75.4949C81.6153 75.7334 81.4976 76.062 81.6404 76.0674C81.6607 76.2346 81.5938 76.1173 81.6107 76.2693C81.6334 76.473 81.7574 76.9754 81.6503 77.0673C81.6505 77.0675 81.6507 77.0678 81.6509 77.068C81.7258 77.2307 81.7354 77.7772 81.6288 77.65C81.6382 77.3597 81.5181 77.1442 81.537 77.4343C81.5561 77.7269 81.5481 77.8044 81.5098 77.8429C81.5386 77.9894 81.5777 78.0631 81.596 78.2689C81.609 78.4151 81.6007 78.6197 81.6128 78.7972C81.631 78.7961 81.6476 78.8036 81.6596 78.845C81.6904 78.9522 81.6575 79.3112 81.6652 79.4291C81.6653 79.4313 81.6656 79.4336 81.6657 79.4358C81.6852 79.4575 81.7136 79.4506 81.7332 79.5715C81.7387 79.6052 81.717 79.6885 81.7063 79.7898C81.7181 79.8755 81.7292 79.9576 81.7347 80.0388C81.7367 80.0694 81.7375 80.1027 81.7376 80.1375C81.7695 80.2945 81.8212 80.5598 81.8288 80.6757C81.8332 80.7442 81.8059 80.8818 81.8057 80.9081C81.8064 80.9997 81.8553 80.954 81.8643 81.033C81.8969 81.3173 81.9205 81.6306 81.9422 81.9425C81.9631 82.243 81.9994 82.539 82.052 82.7981C82.1536 83.2782 82.2275 83.5353 82.3958 84.0036C82.5562 84.4368 82.8028 84.7398 82.412 84.5236C82.5366 84.891 82.5486 84.7214 82.6308 84.7478C82.6799 84.7633 82.6931 84.8683 82.7088 84.884C82.7603 84.9343 82.7158 84.7788 82.7556 84.82C82.9001 84.9919 83.3403 85.854 83.4787 86.0175C84.0563 86.7981 84.6208 87.2996 85.3402 87.8156C85.802 88.1402 86.2618 88.4206 86.7771 88.6427C86.8985 88.785 87.0282 88.9245 87.1654 89.0607C87.0867 89.0258 87.0454 88.9991 86.9579 88.9657C86.8696 88.9331 86.6612 88.8338 86.6134 88.8547C86.6948 88.9347 86.9796 89.0561 87.0671 89.0859C87.2348 89.1449 87.1205 89.0645 87.2341 89.0941C87.3474 89.124 87.5549 89.2431 87.6944 89.2594C88.0173 89.2978 87.3797 89.0942 87.2703 89.0588C87.2884 88.9737 87.5891 89.1765 87.6807 89.128C87.6323 89.0937 87.4491 88.9855 87.3889 88.9811C87.3283 88.9775 87.4408 89.0691 87.2998 89.007C87.1981 88.9223 87.0888 88.829 86.994 88.7398C87.1234 88.7776 87.3311 88.8802 87.4512 88.916C88.4365 89.2163 89.4532 89.3364 90.4743 89.2633C90.8804 89.2347 91.2884 89.2062 91.6995 89.1771C91.8445 89.1668 92.1325 89.1468 92.2748 89.1505C92.3853 89.1536 92.3677 89.2155 92.469 89.1912C92.4791 89.1873 92.4249 89.1528 92.5623 89.1345C92.8227 89.0996 93.4025 89.0557 93.6957 89.0353C96.5687 88.834 99.3834 88.6223 102.299 88.5115C102.451 88.5058 103.024 88.4704 103.131 88.4848C103.449 88.5281 103.397 88.6145 103.568 88.4739C103.736 88.4566 103.622 88.5264 103.701 88.5388C103.733 88.5427 103.924 88.4412 104.009 88.4683C104.2 88.5309 103.884 88.5563 103.773 88.5974C104.056 88.6222 104.336 88.5333 104.575 88.5172C104.642 88.5126 104.656 88.5819 104.671 88.5833C104.954 88.5902 104.918 88.4547 104.901 88.3978C104.759 88.3992 104.619 88.4005 104.477 88.4024C104.752 88.3656 104.959 88.394 105.24 88.3953C105.307 88.3955 105.213 88.338 105.367 88.3528C105.418 88.3939 105.467 88.438 105.517 88.4802C105.873 88.4196 105.998 88.3857 105.547 88.3423C105.725 88.3324 105.904 88.3219 106.082 88.3124C106.021 88.3626 106.118 88.4302 106.291 88.3759C106.331 88.363 106.221 88.3202 106.272 88.3024C106.323 88.2848 106.709 88.2737 106.742 88.2755C107.039 88.2932 107.092 88.3899 107.343 88.3227C107.266 88.3299 106.926 88.2971 107.145 88.2565C107.39 88.2114 108.407 88.2081 108.705 88.2089C109.212 88.2105 109.458 88.2207 109.897 88.2667C109.98 88.2755 109.978 88.3383 110.14 88.3529C110.355 88.3722 110.745 88.3682 110.988 88.3942C110.94 88.4105 110.881 88.4262 110.829 88.4421C110.882 88.452 110.936 88.462 110.99 88.4719C110.984 88.482 110.984 88.4913 110.974 88.5021C110.673 88.5279 110.308 88.6122 110.039 88.6372C109.793 88.6598 109.625 88.6255 109.433 88.6384C109.242 88.6515 108.673 88.7619 108.731 88.6614C108.696 88.6601 108.647 88.6605 108.613 88.658C108.644 88.7564 108.354 88.7045 108.102 88.7394C107.983 88.7559 107.671 88.8672 107.906 88.706C107.864 88.7076 107.844 88.7037 107.807 88.7028C107.543 88.8488 107.362 88.8217 106.946 88.8124C106.713 88.8072 106.255 88.815 106.512 88.8899C106.327 88.9652 105.984 88.8972 105.827 88.9157C105.671 88.9344 105.92 88.9671 105.71 88.9911C105.673 88.9953 105.372 89.0192 105.278 89.0191C105.184 89.0188 105.265 88.9734 105.124 88.9901C104.51 89.0621 103.982 89.1887 103.336 89.2587C103.094 89.285 102.852 89.3103 102.612 89.3348C103.136 89.3553 103.527 89.4546 104.191 89.1609C104.628 89.1218 105.064 89.0827 105.5 89.0436C105.526 89.056 105.553 89.0685 105.579 89.081C105.608 89.0781 105.634 89.0753 105.658 89.0731C105.831 89.0562 106.036 89.0382 106.257 89.0201C106.703 88.9836 107.28 88.9407 107.942 88.8939C109.272 88.7999 111.002 88.6864 112.838 88.572C112.849 88.5713 112.861 88.5706 112.872 88.5698C112.883 88.5693 112.894 88.5687 112.905 88.5681C112.961 88.5653 113.023 88.5624 113.082 88.5602C113.115 88.5589 113.245 88.5537 113.383 88.5549C113.421 88.5552 113.677 88.5565 113.854 88.5927C113.881 88.5982 113.905 88.6045 113.926 88.6114C114.067 88.616 114.208 88.6206 114.349 88.6252C114.348 88.6452 114.347 88.6651 114.347 88.6851C114.461 88.6773 114.575 88.6697 114.688 88.662C114.702 88.6539 114.717 88.6458 114.731 88.6377C115.087 88.6059 115.443 88.574 115.798 88.5422C115.898 88.5507 115.997 88.5592 116.097 88.5677C116.427 88.5464 116.746 88.5261 117.049 88.5076C117.064 88.4833 117.078 88.459 117.093 88.4347C117.255 88.4484 117.417 88.4622 117.579 88.4759C117.893 88.4577 118.183 88.4419 118.441 88.4289C118.433 88.4203 118.425 88.4116 118.417 88.4029C118.735 88.3554 119.053 88.3078 119.371 88.2603C119.503 88.2731 119.635 88.286 119.767 88.2989C119.867 88.2753 119.966 88.2518 120.066 88.2283C120.499 88.1981 120.932 88.1679 121.365 88.1377C121.473 88.1688 121.581 88.1999 121.689 88.231C121.816 88.2179 121.943 88.2047 122.069 88.1916C121.967 88.1745 121.865 88.1574 121.763 88.1403C122.122 88.1116 122.481 88.083 122.84 88.0544C122.848 88.0184 122.855 87.9825 122.863 87.9465C122.758 87.9585 122.656 87.9697 122.565 87.9757C122.487 87.9806 122.505 87.9378 122.489 87.9378C122.177 87.9428 122.154 88.0258 122.146 88.0605C122.305 88.055 122.461 88.0495 122.62 88.0437C122.297 88.0756 122.079 88.0649 121.767 88.0733C121.693 88.0754 121.77 88.108 121.605 88.1038C121.567 88.08 121.533 88.0542 121.498 88.0297C121.073 88.079 120.918 88.1043 121.4 88.1163C121.197 88.1283 120.994 88.1407 120.79 88.1525C120.882 88.1193 120.806 88.0807 120.588 88.1199C120.537 88.1292 120.638 88.1522 120.573 88.165C120.508 88.1776 120.071 88.1974 120.038 88.1973C119.715 88.1961 119.702 88.1381 119.392 88.1879C119.481 88.181 119.842 88.19 119.579 88.2223C119.286 88.2584 118.152 88.2938 117.821 88.3031C117.257 88.3189 116.987 88.321 116.519 88.3069C116.43 88.3042 116.463 88.2649 116.29 88.2612C116.059 88.2563 115.622 88.2717 115.364 88.2636C115.384 88.2597 115.408 88.256 115.431 88.2521C115.678 88.2338 115.914 88.22 116.121 88.2141C116.872 88.0834 117.738 88.0405 118.013 88.0156C118.011 88.0179 118.009 88.0205 118.004 88.0234C118.042 88.023 118.096 88.0211 118.133 88.0216C118.138 87.9958 118.196 87.9857 118.284 87.9797C118.325 87.9786 118.375 87.9773 118.439 87.9758C118.436 87.9748 118.435 87.9736 118.433 87.9726C118.522 87.9693 118.624 87.9653 118.727 87.9556C118.805 87.9602 118.886 87.9625 118.958 87.964C118.953 87.9655 118.948 87.9671 118.943 87.9686C118.991 87.9663 119.011 87.9678 119.052 87.9672C119.053 87.9669 119.055 87.9665 119.056 87.9662C119.062 87.9664 119.069 87.9666 119.075 87.9667C119.093 87.9671 119.113 87.9674 119.133 87.9679C119.242 87.9703 119.371 87.9732 119.491 87.9741C119.62 87.9749 119.744 87.9695 119.928 87.9564C120.006 87.9509 120.1 87.9437 120.217 87.9341C120.044 87.9827 120.346 88.0334 120.852 87.9989C120.922 87.964 120.731 87.9939 120.73 87.9773C120.73 87.9605 120.921 87.9679 120.85 87.9414C120.536 87.9517 120.684 87.9779 120.446 87.9994C120.502 87.9778 120.439 87.9481 120.481 87.9303C120.546 87.9024 120.683 87.9095 120.71 87.8922C120.728 87.8906 120.746 87.8888 120.765 87.8872C120.906 87.8801 121.047 87.8728 121.187 87.8654C121.326 87.8394 121.86 87.8849 122.121 87.9005C122.105 87.9033 122.089 87.906 122.074 87.9087C122.113 87.9071 122.151 87.9055 122.189 87.9039C122.208 87.9047 122.223 87.9054 122.235 87.9055C122.301 87.9056 122.339 87.9142 122.366 87.9207C122.354 87.9247 122.348 87.9287 122.353 87.9325C122.544 87.9232 122.742 87.9132 122.941 87.9033C122.941 87.9079 122.935 87.9127 122.926 87.9177C123.208 87.8993 123.488 87.8798 123.767 87.8594C124.202 87.8274 124.634 87.7928 125.061 87.7554C125.345 87.7305 125.628 87.7054 125.911 87.68C126.043 87.6679 126.173 87.6528 126.303 87.6347C126.313 87.6199 126.335 87.5917 126.341 87.585C126.342 87.5832 126.342 87.5806 126.342 87.5781C126.341 87.5674 126.34 87.5536 126.434 87.5554C126.435 87.5557 126.454 87.5599 126.481 87.5655C126.481 87.5694 126.484 87.5733 126.489 87.5767C126.508 87.5884 126.56 87.6062 126.664 87.6115C126.745 87.6157 126.851 87.6086 126.958 87.5941C127.117 87.5727 127.247 87.5341 127.325 87.5069C127.404 87.4794 127.469 87.4507 127.517 87.4273C127.584 87.3947 127.655 87.3548 127.702 87.3278C127.718 87.3186 127.732 87.3105 127.741 87.3051C127.746 87.3025 127.75 87.3 127.754 87.2975C127.757 87.2959 127.76 87.2943 127.762 87.2927C128.1 87.1798 128.431 87.0443 128.749 86.8889C128.746 86.8889 128.745 86.8886 128.745 86.8882C128.748 86.8852 128.895 86.8048 128.903 86.8005C128.918 86.7936 128.937 86.7882 128.957 86.7836C128.988 86.7672 129.019 86.7506 129.05 86.7339C129.037 86.736 129.027 86.7365 129.024 86.734C129.02 86.7324 129.04 86.7204 129.059 86.7084C129.075 86.6992 129.09 86.6898 129.094 86.6857C129.102 86.6747 129.095 86.6719 129.089 86.6697C129.077 86.6652 129.071 86.663 129.196 86.5998C129.219 86.5885 129.433 86.4869 129.443 86.4816C129.446 86.4805 129.449 86.4793 129.452 86.4782C129.433 86.4722 129.414 86.4662 129.395 86.4601C129.383 86.4588 129.367 86.4603 129.345 86.4681C129.307 86.481 129.26 86.5078 129.214 86.5329C129.134 86.5772 129.058 86.6166 129.051 86.5739C129.161 86.5089 129.247 86.4702 129.331 86.4309C129.43 86.385 129.528 86.3379 129.655 86.2407C129.706 86.2297 129.658 86.2638 129.605 86.2998C129.563 86.3285 129.518 86.3585 129.521 86.3692C129.523 86.3769 129.554 86.3695 129.583 86.3624C129.645 86.3462 129.702 86.3349 129.452 86.4782C129.462 86.4749 129.468 86.4792 129.474 86.4836C129.475 86.4842 129.476 86.4848 129.477 86.4855C129.524 86.4564 129.57 86.4265 129.616 86.3965C129.637 86.3782 129.658 86.3608 129.681 86.3479C129.691 86.3418 129.702 86.3367 129.712 86.3326C129.804 86.2711 129.894 86.2074 129.983 86.1423C129.982 86.1381 129.985 86.1318 129.991 86.124C130.012 86.0944 130.249 85.9165 130.307 85.8774C130.308 85.8775 130.309 85.8776 130.309 85.8777C130.309 85.8777 130.311 85.8819 130.32 85.8805C130.353 85.8541 130.385 85.8274 130.417 85.8004C130.417 85.8004 130.416 85.8005 130.416 85.8006C130.412 85.7982 130.407 85.7954 130.42 85.7836C130.466 85.741 130.511 85.7077 130.552 85.6836C130.586 85.6529 130.621 85.6213 130.656 85.5901C130.596 85.6207 130.497 85.6917 130.408 85.7519C130.314 85.8157 130.232 85.8677 130.228 85.8562C130.227 85.8549 130.234 85.8485 130.243 85.8402C130.274 85.8105 130.329 85.7572 130.191 85.8127C130.472 85.5813 130.408 85.6674 130.382 85.7054C130.376 85.7138 130.373 85.7193 130.375 85.7176C130.467 85.6474 130.522 85.5887 130.578 85.528C130.607 85.4957 130.637 85.4623 130.673 85.426C130.691 85.4065 130.717 85.3844 130.744 85.3613C130.774 85.3349 130.806 85.3068 130.831 85.2782C130.851 85.255 130.899 85.1862 130.943 85.119C130.991 85.0465 131.036 84.975 131.047 84.9659C131.083 84.9693 131.162 84.9106 131.238 84.8515C131.271 84.8257 131.303 84.8002 131.332 84.78C131.356 84.7637 131.388 84.7468 131.415 84.7325C131.425 84.7269 131.436 84.7212 131.446 84.7155C131.454 84.7109 131.46 84.7067 131.463 84.704C131.461 84.7043 131.46 84.7045 131.458 84.7048C131.497 84.6685 131.585 84.5547 131.599 84.5197C131.613 84.4847 131.598 84.4795 131.577 84.4817C131.563 84.4842 131.549 84.4866 131.535 84.489C131.517 84.4905 131.51 84.4841 131.536 84.4487C131.655 84.2828 131.801 84.1881 131.79 84.2561C131.786 84.2719 131.76 84.307 131.732 84.3431C131.699 84.3855 131.663 84.4303 131.66 84.4516C131.69 84.42 131.727 84.3805 131.764 84.3419C131.913 84.1343 132.052 83.9202 132.18 83.7006C132.132 83.723 132.143 83.6714 132.289 83.4458C132.299 83.4514 132.307 83.4563 132.315 83.4595C132.41 83.2835 132.499 83.1033 132.579 82.9216C132.54 82.9868 132.492 83.0585 132.489 82.9968C132.485 82.9427 132.577 82.7558 132.642 82.604C132.672 82.5347 132.697 82.4729 132.71 82.4363C132.723 82.396 132.729 82.3658 132.735 82.3352C132.738 82.3218 132.741 82.3078 132.744 82.2931C132.782 82.1944 132.821 82.0863 132.859 81.9722C132.876 81.9428 132.887 81.9347 132.897 81.9279C132.914 81.9169 132.928 81.9075 132.955 81.8102C132.919 81.8613 132.911 81.8385 132.918 81.7847C132.946 81.6947 132.972 81.6017 132.996 81.5089C133.005 81.4862 133.015 81.4652 133.024 81.4486C133.039 81.4227 133.051 81.413 133.062 81.4039C133.069 81.3981 133.076 81.3924 133.082 81.3835C133.09 81.3478 133.097 81.312 133.104 81.2762C133.088 81.2863 133.067 81.2937 133.05 81.2902C133.06 81.2491 133.07 81.2079 133.078 81.1673C133.094 81.1486 133.113 81.0868 133.13 81.03C133.14 80.995 133.149 80.9614 133.156 80.9429C133.16 80.9343 133.164 80.929 133.167 80.9251C133.179 80.8476 133.19 80.7706 133.2 80.6932C133.232 80.6454 133.27 80.512 133.283 80.3756C133.294 80.2724 133.307 80.1304 133.315 79.9834C133.325 79.9753 133.339 79.948 133.357 79.8382C133.345 79.7991 133.334 79.7573 133.326 79.713C133.33 79.5149 133.326 79.3393 133.323 79.2639C133.321 79.1879 133.314 79.1164 133.308 79.0613C133.301 79.003 133.292 78.9429 133.283 78.8869C133.281 78.8736 133.279 78.8605 133.277 78.8476C133.272 78.8168 133.267 78.787 133.263 78.7583C133.263 78.7578 133.263 78.7573 133.263 78.7568C133.251 78.6812 133.24 78.6108 133.229 78.5391C133.203 78.1079 133.188 77.6693 133.161 77.2203C133.15 77.0263 133.115 76.7699 133.106 76.5463C133.095 76.2674 133.143 76.3188 133.137 76.1472C133.132 75.9753 133.092 76.1431 133.071 75.9624C133.061 75.8798 133.019 75.298 133.03 75.1653C133.032 75.1349 133.056 75.2369 133.069 75.2075C133.077 75.1913 133.138 75.1689 133.123 75.0298C133.059 74.9272 133.003 74.9409 132.968 74.5007C132.913 73.8049 132.892 73.1341 132.844 72.3894C132.833 72.223 132.765 71.8461 132.8 71.6461C132.81 71.5878 132.865 71.5929 132.844 71.3293C132.825 71.1027 132.799 71.0775 132.767 70.887C132.754 70.8146 132.778 70.7824 132.753 70.6461C132.728 70.5091 132.68 70.3183 132.739 70.1985C132.718 70.1882 132.7 70.1922 132.68 70.1869C132.659 69.936 132.701 69.4743 132.646 69.5758C132.628 69.3163 132.609 69.0564 132.591 68.7969C132.609 68.7422 132.627 68.6882 132.646 68.6335C132.677 68.7791 132.666 69.0318 132.709 69.0427C132.697 68.8178 132.684 68.5898 132.672 68.3669C132.567 68.4724 132.464 67.7985 132.588 67.9045C132.612 67.9234 132.562 67.4736 132.547 67.3777C132.533 67.2825 132.488 67.2752 132.501 67.0603C132.509 66.9381 132.53 66.8557 132.48 66.5919C132.48 66.7649 132.478 66.9499 132.476 67.1268C132.463 66.8719 132.425 66.5505 132.433 66.3161C132.435 66.2582 132.466 66.4693 132.468 66.3623C132.47 66.2551 132.435 65.8367 132.399 65.9429C132.468 65.7132 132.402 65.77 132.371 65.3609C132.367 65.3094 132.417 64.8613 132.361 64.6902C132.342 64.63 132.294 64.7782 132.296 64.4427C132.297 64.1959 132.362 64.4216 132.37 64.1445C132.315 64.2953 132.249 63.8967 132.231 63.6546C132.198 63.2254 132.242 63.2722 132.25 63.1271C132.264 62.8651 132.196 62.6724 132.235 62.5126C132.241 62.5853 132.25 62.6501 132.257 62.7197C132.253 62.562 132.248 62.4048 132.243 62.2478C132.217 62.2659 132.191 62.2843 132.165 62.3016C132.138 62.0443 132.163 61.9213 132.154 61.7012C132.153 61.6709 132.136 61.7093 132.134 61.6783C132.115 61.4283 132.119 61.3443 132.069 61.1763C132.134 61.136 132.067 60.8303 132.079 60.5596C132.082 60.4838 132.113 60.4288 132.041 60.4675C132.023 59.9708 131.991 59.6054 132.019 59.1859C131.956 59.3629 131.916 58.8021 131.913 58.4674C131.912 58.3778 131.958 58.2791 131.936 58.0983C131.918 58.1571 131.897 58.2242 131.878 58.2868C131.845 57.9164 131.918 57.9698 131.888 57.6564C131.875 57.5189 131.806 57.6392 131.821 57.3614C131.83 57.2019 131.915 57.0757 131.799 57.0675C131.779 56.8584 131.824 56.9736 131.818 56.824C131.814 56.7302 131.766 56.6446 131.761 56.4997C131.752 56.2239 131.805 55.8229 131.722 55.8421C131.703 55.6533 131.747 55.7774 131.73 55.6053C131.708 55.3744 131.613 54.8165 131.671 54.6914C131.671 54.6912 131.671 54.6909 131.671 54.6907C131.62 54.5165 131.59 53.8865 131.657 54.0142C131.665 54.3512 131.744 54.5785 131.72 54.2468C131.68 53.7032 131.708 53.8023 131.777 53.6702C131.787 53.6508 131.783 53.4961 131.799 53.5269C131.815 53.5575 131.851 53.8877 131.87 53.7C131.874 53.6637 131.839 53.4949 131.869 53.4577C131.86 53.424 131.851 53.4078 131.842 53.3809C131.892 53.0737 131.914 53.0428 131.958 53.6011C131.942 53.5874 131.926 53.5739 131.91 53.5595C131.933 53.6377 131.956 53.7046 131.98 53.7908C132.017 54.4028 132.128 55.2221 132.143 55.7752C132.156 56.2587 132.104 55.5966 132.1 55.5852C132.063 55.4654 132.064 55.6879 132.045 55.6935C132.026 55.6983 131.979 55.4282 132.004 55.6719C132.007 55.7043 132.087 56.0233 132.096 56.034C132.141 56.085 132.154 56.0152 132.171 56.0846C132.101 54.5358 132.049 53.278 131.995 52.0608C131.981 51.7405 131.966 51.4202 131.952 51.0999C131.898 49.9494 131.872 49.0718 131.852 48.3491C131.828 48.1218 131.803 47.8945 131.779 47.6671C131.783 47.5914 131.787 47.5156 131.792 47.4398C131.768 47.0426 131.745 46.6453 131.721 46.248C131.733 46.2299 131.745 46.2118 131.757 46.1938C131.595 45.5363 131.853 45.3268 131.604 44.7653C131.583 44.5234 131.561 44.2816 131.54 44.0398C131.566 43.9841 131.593 43.9283 131.619 43.8726C131.61 43.8508 131.6 43.829 131.591 43.8071C131.589 43.6774 131.588 43.5476 131.586 43.4178C131.586 43.3393 131.584 43.2609 131.581 43.1828C131.546 43.0366 131.506 42.8909 131.463 42.7476C131.558 42.6223 131.163 41.5097 131.287 41.7132C131.241 41.5509 131.19 41.3921 131.134 41.233C131.158 41.2671 131.182 41.3014 131.205 41.336C131.205 41.3084 131.205 41.2808 131.205 41.2532C131.151 41.1392 131.095 41.0276 131.036 40.9169C131.096 40.6984 130.914 40.5445 130.869 40.4701C130.798 40.3466 130.678 40.1145 130.667 40.1011C130.651 40.081 130.728 40.3091 130.618 40.1405C130.589 40.0362 130.558 39.9325 130.524 39.8288C130.507 39.8241 130.491 39.8195 130.474 39.815C130.444 39.7481 130.413 39.6816 130.382 39.6155C130.394 39.6095 130.407 39.6035 130.42 39.5975C130.402 39.5581 130.383 39.5189 130.365 39.4797C130.341 39.4653 130.317 39.4511 130.294 39.437C130.189 39.2836 130.079 39.134 129.964 38.9883C129.9 38.8652 129.832 38.743 129.761 38.6223C129.713 38.5675 129.665 38.5135 129.616 38.4601C129.587 38.4642 129.558 38.4685 129.53 38.4729C129.425 38.3071 129.314 38.1441 129.196 37.9845C129.116 37.9124 129.034 37.8419 128.951 37.7732C128.961 37.7995 128.971 37.8258 128.98 37.8521C129.014 37.873 129.047 37.8942 129.08 37.9157C129.079 37.9287 129.077 37.9417 129.075 37.9547C128.945 37.8497 128.811 37.749 128.675 37.6526C128.632 37.5997 128.587 37.5473 128.542 37.4953C128.496 37.4695 128.449 37.4442 128.402 37.4193C128.224 37.2819 128.041 37.1517 127.853 37.0291C127.819 36.9813 127.784 36.9338 127.749 36.8864C127.691 36.8533 127.633 36.8209 127.575 36.7892C127.613 36.8275 127.651 36.8661 127.688 36.905C127.528 36.8085 127.365 36.7176 127.199 36.6322C127.18 36.6525 127.161 36.6728 127.143 36.6932C127.073 36.65 127.002 36.608 126.931 36.5669C126.933 36.5516 126.936 36.5363 126.938 36.5211C126.646 36.3466 126.343 36.1897 126.028 36.0514C126.006 36.0736 125.984 36.0958 125.962 36.1181C125.54 35.9251 125.065 35.8467 124.661 35.7684C124.491 35.7341 124.274 35.6311 124.298 35.7111C123.964 35.6614 123.628 35.6323 123.29 35.6237C123.191 35.6378 123.096 35.6536 122.999 35.6711C122.924 35.6625 122.849 35.6549 122.774 35.6484C122.696 35.6423 122.619 35.6363 122.542 35.6302C122.312 35.7014 121.11 35.8108 121.139 35.7249C120.872 35.7608 120.892 35.7418 120.569 35.7903C120.491 35.7786 120.412 35.7669 120.334 35.7552C120.197 35.7604 120.06 35.7655 119.923 35.7707C119.743 35.7964 119.562 35.8221 119.381 35.8478C119.258 35.829 119.135 35.8102 119.011 35.7915C119.006 35.8123 119.001 35.8332 118.997 35.854C118.89 35.8672 118.783 35.8803 118.677 35.8935C118.392 36.0132 118.724 35.6983 117.818 35.8742C117.957 35.8675 118.095 35.8608 118.233 35.8542C118.287 35.8762 118.342 35.8983 118.397 35.9204C118.205 35.9423 118.013 35.9641 117.821 35.986C117.685 35.986 117.549 35.9859 117.413 35.9859C117.3 36.0001 117.187 36.0144 117.074 36.0287C116.772 36.0305 116.47 36.0324 116.168 36.0343C115.885 36.0577 115.601 36.0811 115.317 36.1046C115.265 36.0916 115.213 36.0787 115.162 36.0657C115.038 36.0926 114.914 36.1195 114.79 36.1464C114.74 36.1462 114.69 36.146 114.64 36.1458C114.625 36.1327 114.609 36.1196 114.594 36.1064C114.368 36.1281 114.142 36.1498 113.916 36.1715C113.757 36.1684 113.598 36.1654 113.439 36.1624C113.446 36.1744 113.453 36.1865 113.46 36.1985C112.731 36.2409 112.003 36.2834 111.274 36.3258C111.272 36.3257 111.271 36.3257 111.269 36.3256C111.19 36.291 110.813 36.4017 110.852 36.276C110.83 36.2894 110.808 36.3029 110.786 36.3163C110.707 36.3138 110.628 36.3113 110.549 36.3088C110.553 36.2943 110.557 36.2798 110.561 36.2653C110.502 36.2683 110.443 36.2713 110.383 36.2742C110.379 36.2924 110.375 36.3105 110.37 36.3286C110.438 36.3364 110.505 36.3441 110.573 36.3518C110.405 36.3557 110.238 36.3596 110.071 36.3635C110.093 36.3501 110.115 36.3367 110.138 36.3233C109.921 36.3029 109.286 36.485 109.756 36.1744C109.873 36.1791 109.99 36.1838 110.106 36.1886C110.04 36.1672 109.975 36.1458 109.909 36.1245C109.925 36.1028 109.941 36.0812 109.956 36.0596C110.062 36.0668 110.169 36.0739 110.275 36.0811C110.328 36.064 110.381 36.047 110.434 36.0299C110.396 36.0236 110.358 36.0174 110.32 36.0111C110.382 35.9955 110.445 35.9799 110.508 35.9643C110.719 35.9478 110.929 35.9313 111.14 35.9148C111.177 35.9215 111.214 35.9281 111.251 35.9347C111.615 35.9169 111.98 35.8992 112.345 35.8814C112.302 35.8999 112.259 35.9184 112.216 35.9369C112.312 35.9316 112.408 35.9263 112.505 35.921C112.535 35.9047 112.565 35.8884 112.595 35.8721C112.691 35.8623 112.787 35.8525 112.882 35.8427C112.865 35.872 112.848 35.9013 112.831 35.9306C112.739 35.9561 112.648 35.9817 112.556 36.0072C112.633 36.0116 112.71 36.016 112.787 36.0205C112.8 35.9989 112.813 35.9773 112.825 35.9557C112.936 35.9506 113.046 35.9456 113.156 35.9406C113.102 35.9286 113.048 35.9166 112.995 35.9047C113.02 35.886 113.046 35.8673 113.072 35.8486C113.227 35.8318 113.382 35.8149 113.537 35.7981C113.554 35.8096 113.572 35.8212 113.589 35.8328C113.702 35.8111 113.816 35.7894 113.929 35.7677C113.986 35.7728 114.043 35.7779 114.099 35.7831C114.124 35.7736 114.149 35.7642 114.173 35.7548C114.304 35.7483 114.435 35.7419 114.566 35.7354C114.647 35.7443 114.728 35.7532 114.809 35.7621C114.891 35.7449 114.972 35.7277 115.053 35.7106C115.545 35.6941 116.036 35.6777 116.527 35.6612C116.856 35.5677 117.633 35.6326 117.584 35.5636C118.002 35.5409 118.42 35.5182 118.838 35.4956C118.922 35.502 119.006 35.5085 119.09 35.515C119.507 35.4826 119.925 35.4502 120.343 35.4178C120.866 35.4084 121.388 35.399 121.911 35.3896C121.856 35.3675 121.802 35.3454 121.748 35.3233C121.912 35.315 122.076 35.3067 122.24 35.2984C122.34 35.3105 122.44 35.3225 122.539 35.3345C122.61 35.3183 122.681 35.3021 122.752 35.2859C122.773 35.281 122.794 35.2763 122.814 35.2716C122.943 35.393 123.258 35.2276 123.672 35.2888C123.898 35.1876 124.206 35.4015 124.478 35.3244C124.464 35.3346 124.449 35.3449 124.435 35.3553C124.52 35.3677 124.606 35.3816 124.691 35.3966C124.869 35.4115 125.048 35.4322 125.225 35.4585C125.227 35.4759 125.229 35.4933 125.23 35.5108C125.304 35.5309 125.377 35.5521 125.45 35.5742C125.406 35.5771 125.362 35.5802 125.319 35.5838C125.382 35.6039 125.445 35.6248 125.508 35.6464C125.742 35.6916 125.974 35.7471 126.205 35.8123C126.258 35.8455 126.311 35.8793 126.364 35.9135C126.399 35.9138 126.434 35.9143 126.469 35.9151C126.596 35.9769 126.722 36.042 126.845 36.1097C126.841 36.0941 126.837 36.0784 126.833 36.0628C126.775 36.0358 126.717 36.0095 126.659 35.9838C126.667 35.9739 126.675 35.9639 126.683 35.954C126.878 36.0402 127.07 36.1338 127.257 36.2341C127.246 36.2187 127.234 36.2034 127.223 36.1881C127.383 36.2724 127.541 36.362 127.696 36.4561C127.693 36.4535 127.69 36.4503 127.687 36.4476C127.636 36.3952 127.725 36.3498 127.392 36.1706C127.104 36.0218 127.036 36.0295 126.767 35.9363C126.664 35.9023 126.656 35.8572 126.459 35.8008C126.259 35.743 125.963 35.6941 125.883 35.5686C125.844 35.5869 125.829 35.6091 125.798 35.6287C125.462 35.5228 124.905 35.2966 124.976 35.4036C124.619 35.3307 124.255 35.2802 123.891 35.2531C123.835 35.2171 123.778 35.1816 123.72 35.1466C123.947 35.1269 124.278 35.2048 124.335 35.1531C124.019 35.1084 123.696 35.0808 123.38 35.0709C123.416 35.1789 122.962 35.2483 122.749 35.2444C122.65 35.241 122.602 35.2155 122.677 35.1589C122.721 35.125 122.061 35.1877 121.918 35.2063C121.776 35.2249 121.732 35.2917 121.445 35.2665C121.282 35.2523 121.184 35.2192 120.782 35.2855C121.021 35.2904 121.274 35.2983 121.517 35.3048C121.156 35.3172 120.684 35.3652 120.365 35.3486C120.286 35.3444 120.602 35.3035 120.456 35.2979C120.31 35.2923 119.706 35.333 119.825 35.3887C119.56 35.2815 119.587 35.3808 118.998 35.4163C118.923 35.4206 118.342 35.3367 118.064 35.414C117.966 35.4415 118.136 35.5144 117.673 35.5043C117.333 35.4968 117.694 35.4069 117.317 35.3879C117.484 35.4723 116.883 35.5593 116.534 35.5806C115.917 35.6185 116.016 35.5542 115.821 35.539C115.47 35.5117 115.153 35.6068 114.961 35.5459C115.066 35.5383 115.161 35.5272 115.263 35.5184C115.042 35.5213 114.82 35.5247 114.6 35.5276C114.605 35.5661 114.612 35.6047 114.617 35.6429C114.241 35.6763 114.089 35.6377 113.779 35.6451C113.735 35.6461 113.776 35.6713 113.731 35.6741C113.371 35.6962 113.258 35.6877 112.988 35.7576C112.982 35.6602 112.508 35.7512 112.143 35.7279C112.041 35.7213 111.989 35.6743 111.987 35.7814C111.287 35.7957 110.759 35.8332 110.2 35.7821C110.398 35.8781 109.591 35.924 109.126 35.9203C109.002 35.9193 108.901 35.8495 108.635 35.8769C108.703 35.9053 108.779 35.9378 108.851 35.9671C108.314 36.0067 108.443 35.901 107.988 35.9365C107.788 35.9523 107.902 36.0569 107.529 36.028C107.315 36.0114 107.205 35.883 107.106 36.0526C106.802 36.0775 106.997 36.0133 106.785 36.0187C106.652 36.0222 106.497 36.0916 106.293 36.0953C105.905 36.102 105.392 36.0139 105.356 36.1362C105.08 36.1598 105.285 36.0983 105.034 36.1185C104.699 36.1456 103.855 36.271 103.726 36.1828C103.726 36.183 103.726 36.1832 103.726 36.1834C103.447 36.2537 102.553 36.2827 102.781 36.1867C103.252 36.1836 103.626 36.0727 103.15 36.1C102.369 36.1447 102.527 36.1069 102.397 36.0022C102.378 35.9871 102.159 35.9891 102.214 35.9659C102.269 35.9427 102.753 35.8987 102.509 35.8651C102.462 35.8588 102.2 35.906 102.171 35.8609C102.118 35.8743 102.09 35.8863 102.045 35.8992C101.659 35.8179 101.633 35.7849 102.438 35.7342C102.407 35.7575 102.375 35.7809 102.343 35.8042C102.469 35.7711 102.579 35.7396 102.716 35.7057C103.59 35.6669 104.806 35.5239 105.581 35.5156C106.258 35.5083 105.311 35.5684 105.288 35.5735C105.093 35.6256 105.402 35.6293 105.395 35.6578C105.387 35.6862 104.977 35.7485 105.333 35.7176C105.38 35.7133 105.88 35.6045 105.903 35.5916C106.068 35.4887 105.755 35.4966 106.498 35.4299C106.763 35.4061 107.53 35.3537 107.821 35.3325C108.141 35.3093 108.403 35.342 108.594 35.3256C108.784 35.309 108.603 35.289 108.828 35.2707C109.274 35.2347 109.919 35.2277 110.33 35.2024C110.796 35.1737 110.928 35.1187 111.379 35.0913C111.691 35.0723 112.114 35.083 112.465 35.0473C112.549 35.0677 112.396 35.1728 112.63 35.1527C112.915 35.128 112.514 35.0935 112.655 35.0565C112.943 35.0245 112.74 35.0796 112.75 35.0804C112.893 35.0905 113.134 35.0635 113.309 35.0627C113.192 35.05 113.078 35.039 112.954 35.0265C113.434 35.03 113.186 34.9767 113.568 34.9401C113.668 34.9307 113.899 34.9892 114.245 34.9488C114.327 34.9392 115.139 34.8437 115.402 34.8309C115.515 34.8254 115.7 34.8475 115.74 34.8468C115.883 34.8442 115.866 34.8011 115.999 34.7913C116.986 34.7187 118.122 34.6777 119.064 34.6194C119.96 34.5639 120.448 34.5326 121.361 34.477C122.208 34.4255 122.977 34.3084 122.073 34.5841C122.722 34.5761 122.541 34.5229 122.702 34.4601C122.704 34.4594 122.705 34.4588 122.707 34.4582C122.816 34.4198 122.974 34.4433 123.022 34.4367C123.182 34.4134 122.902 34.3951 123.027 34.3775C123.538 34.2573 125.375 34.5579 125.762 34.7148C127.6 35.2452 128.929 36.0678 130.156 37.3315C130.928 38.1493 131.498 39.04 131.948 40.0575C131.981 40.3059 132.005 40.5576 132.019 40.8061C131.972 40.6587 131.953 40.581 131.887 40.4157C131.824 40.25 131.655 39.8569 131.576 39.7753C131.621 39.9302 131.841 40.4527 131.898 40.6166C132.014 40.9288 131.972 40.7191 132.054 40.9349C132.136 41.1519 132.2 41.53 132.278 41.7994C132.46 42.438 132.217 41.2218 132.119 41.0109C132.217 41.0611 132.288 41.6184 132.388 41.8178C132.388 41.7321 132.344 41.3851 132.293 41.2614C132.244 41.1394 132.261 41.3471 132.192 41.0768C132.175 40.8878 132.147 40.678 132.118 40.4892C132.231 40.7481 132.339 41.1613 132.404 41.403C132.58 42.043 132.686 42.6965 132.723 43.3493C132.834 45.305 132.93 47.2322 133.032 49.2082C133.044 49.4466 133.068 49.9182 133.068 50.1363C133.067 50.3058 133.011 50.2089 133.035 50.3943C133.039 50.4161 133.069 50.3663 133.088 50.604C133.125 51.0502 133.177 52.0064 133.202 52.4879C133.41 56.5582 133.625 60.5694 133.784 64.6007C133.791 64.5582 133.798 64.5158 133.804 64.4733C133.833 64.5867 133.861 64.7 133.889 64.8133C133.919 65.1931 133.949 65.5729 133.978 65.9526C133.966 66.0193 133.954 66.086 133.942 66.1526C133.975 66.8104 134.007 67.4682 134.039 68.1259C134.005 68.0486 133.972 67.9714 133.939 67.8941C133.948 68.0677 133.958 68.2413 133.968 68.4149C133.997 68.4695 134.026 68.5241 134.055 68.5787C134.073 68.7508 134.091 68.9229 134.108 69.095C134.056 69.0642 134.003 69.0334 133.95 69.0026C133.92 68.8957 133.891 68.7887 133.861 68.6818C133.861 68.6842 133.86 68.6865 133.86 68.6894C133.856 68.7328 133.953 69.1494 133.93 69.2508C133.926 69.2674 133.922 69.2793 133.919 69.2884C133.923 69.3886 133.928 69.4887 133.932 69.5889C133.954 69.4922 133.975 69.3955 133.997 69.2988C134.031 69.3451 134.064 69.3914 134.098 69.4377C134.128 69.7178 134.158 69.9979 134.189 70.2779C134.168 70.3086 134.147 70.3393 134.127 70.37C134.166 70.5746 134.205 70.7791 134.244 70.9836C134.235 71.0864 134.225 71.1891 134.216 71.2919C134.233 71.3359 134.25 71.3799 134.267 71.424C134.279 71.6601 134.29 71.8963 134.302 72.1324C134.286 72.2788 134.27 72.4253 134.254 72.5717C134.285 72.7184 134.316 72.865 134.347 73.0116C134.377 73.8981 134.406 74.7845 134.436 75.671C134.604 76.2637 134.488 77.6653 134.612 77.5753C134.633 77.9713 134.655 78.3672 134.676 78.7632C134.697 79.1403 134.695 79.5156 134.67 79.8915C134.64 80.0475 134.606 80.2011 134.568 80.3546C134.494 81.1362 134.319 81.91 134.047 82.6502C133.656 83.5536 133.122 84.3874 132.476 85.1127C132.573 85.066 132.669 85.0173 132.766 84.9665C132.575 85.2102 132.372 85.4444 132.159 85.6678C132.007 85.7815 131.853 85.8898 131.697 85.9928C131.59 86.1326 131.478 86.2698 131.361 86.4043C131.036 86.3762 130.727 86.9835 129.99 87.3186C129.721 87.7028 129.021 87.677 128.625 88.026C128.635 88.025 128.645 88.0241 128.655 88.0232C128.645 88.0401 128.642 88.0551 128.63 88.0723C128.55 88.0903 128.461 88.1139 128.376 88.1331C128.424 88.0634 128.501 88.0396 128.617 88.0271C128.631 88.0014 128.645 87.9758 128.659 87.9501C128.503 88.0071 128.344 88.0602 128.185 88.1086C127.866 88.2362 127.537 88.3464 127.204 88.438C127.187 88.4108 127.17 88.3836 127.154 88.3563C127.059 88.3709 126.964 88.3842 126.869 88.3959C126.876 88.4053 126.874 88.416 126.856 88.4267C126.406 88.5112 126.336 88.4129 126.695 88.3664C126.734 88.3609 126.776 88.3629 126.809 88.3695C126.854 88.3475 126.898 88.3251 126.943 88.3023C126.816 88.3157 126.69 88.3262 126.563 88.3343C126.361 88.374 126.161 88.4066 125.956 88.4329C125.752 88.4596 125.547 88.4863 125.343 88.513C125.362 88.5313 125.377 88.5503 125.366 88.57C125.206 88.6001 124.717 88.6347 124.315 88.6599C124.315 88.6608 124.314 88.6617 124.314 88.6625C124.242 88.6661 124.171 88.6696 124.099 88.6731C123.916 88.684 123.777 88.6919 123.74 88.6945C123.667 88.6995 123.611 88.7004 123.569 88.6992C123.439 88.7056 123.309 88.712 123.179 88.7185C123.168 88.7203 123.156 88.722 123.143 88.7235C123.174 88.7356 123.204 88.7477 123.235 88.7597C122.901 88.7763 122.567 88.7928 122.233 88.8093C122.092 88.8421 122.063 88.887 122.286 88.8734C122.864 88.838 122.748 88.8796 122.848 89.0078C122.863 89.0262 123.024 89.0289 122.984 89.0553C122.944 89.0818 122.586 89.1231 122.769 89.1689C122.804 89.1775 122.996 89.1271 123.019 89.1816C123.058 89.1669 123.078 89.1533 123.11 89.139C123.399 89.2452 123.42 89.285 122.824 89.327C122.847 89.2999 122.869 89.2726 122.892 89.2456C122.799 89.2821 122.72 89.3172 122.619 89.3545C121.973 89.3807 121.075 89.5236 120.501 89.5155C119.999 89.5085 120.702 89.4584 120.717 89.453C120.859 89.3953 120.632 89.3838 120.635 89.3501C120.639 89.3163 120.942 89.2512 120.679 89.2797C120.645 89.2836 120.275 89.403 120.26 89.4174C120.141 89.5363 120.372 89.5342 119.824 89.5967C119.628 89.619 119.061 89.6637 118.846 89.6823C118.609 89.7026 118.414 89.6574 118.273 89.6727C118.132 89.688 118.267 89.7161 118.101 89.7327C117.772 89.7655 117.294 89.759 116.99 89.7796C116.645 89.8032 116.549 89.8659 116.216 89.8882C115.985 89.9037 115.672 89.881 115.412 89.9155C115.349 89.8893 115.46 89.7672 115.287 89.7859C115.076 89.8088 115.374 89.8592 115.271 89.9C115.06 89.9315 115.204 89.8715 115.2 89.8694C115.094 89.854 114.916 89.8807 114.786 89.8777C114.872 89.8955 114.957 89.9114 115.05 89.9291C114.694 89.9138 114.879 89.9831 114.598 90.018C114.524 90.027 114.351 89.9518 114.095 89.9921C114.034 90.0018 113.435 90.0968 113.241 90.1061C113.157 90.1099 113.019 90.0793 112.99 90.0792C112.884 90.079 112.898 90.1308 112.8 90.1394C112.07 90.2033 111.229 90.2262 110.532 90.274C109.87 90.3196 109.509 90.3456 108.834 90.3908C108.208 90.4327 107.641 90.5548 108.303 90.2464C107.818 90.2409 107.961 90.3101 107.837 90.3823C107.764 90.4248 107.653 90.397 107.62 90.4059C107.511 90.4363 107.705 90.4539 107.62 90.4766ZM131.794 52.3138C131.865 52.5254 131.873 52.3166 131.849 52.7824C131.761 52.3416 131.766 52.982 131.713 52.9884C131.683 52.9912 131.687 52.7722 131.668 52.708C131.637 52.6094 131.608 52.7596 131.585 52.6413C131.562 52.5233 131.565 52.1028 131.555 51.968C131.536 51.7101 131.503 51.4911 131.487 51.2759C131.472 51.0606 131.475 50.7198 131.469 50.5801C131.463 50.4409 131.448 50.3074 131.443 50.2849C131.416 50.1545 131.379 50.2499 131.366 50.0615C131.406 50.0349 131.454 49.7515 131.497 50.0189C131.495 49.9786 131.5 49.9263 131.496 49.8883C131.479 49.7092 131.429 49.8289 131.414 49.7475C131.388 49.6101 131.438 49.6921 131.441 49.69C131.465 49.5367 131.43 49.6213 131.409 49.5658C131.398 49.5359 131.36 49.2703 131.357 49.2118C131.354 49.1542 131.381 49.2189 131.38 49.1802C131.374 49.0128 131.368 48.8403 131.352 48.6767C131.336 48.5134 131.291 48.4341 131.347 48.4165C131.356 48.4141 131.37 48.5046 131.389 48.4676C131.389 48.4676 131.389 48.4676 131.389 48.4676C131.395 48.4553 131.417 48.3092 131.449 48.4889C131.458 48.5397 131.465 48.5956 131.469 48.6538C131.46 48.6352 131.451 48.6174 131.443 48.5988C131.445 48.644 131.448 48.6892 131.45 48.7343C131.429 48.7159 131.407 48.6962 131.386 48.6852C131.37 48.7512 131.401 48.805 131.402 48.8157C131.404 48.9735 131.363 48.9729 131.417 49.0624C131.418 48.9551 131.419 48.8488 131.42 48.7444C131.43 48.7432 131.441 48.7418 131.451 48.7403C131.452 48.7608 131.453 48.7814 131.454 48.802C131.461 48.7879 131.469 48.7732 131.476 48.7591C131.483 48.9071 131.48 49.0652 131.475 49.2047C131.461 49.1624 131.444 49.1151 131.429 49.0738C131.451 49.2503 131.42 49.1556 131.415 49.2861C131.464 49.3031 131.458 49.3771 131.462 49.4841C131.466 49.5909 131.492 49.4415 131.503 49.5473C131.526 49.7631 131.495 50.1544 131.568 50.1875C131.544 50.4811 131.515 50.141 131.497 50.1276C131.419 50.0712 131.488 50.6371 131.534 50.7113C131.516 50.7991 131.484 50.8107 131.507 51.0233C131.538 51.3118 131.535 50.6664 131.568 51.0611C131.59 51.3252 131.554 51.2992 131.554 51.4335C131.556 51.6831 131.602 52.1117 131.641 51.9425C131.656 51.8744 131.618 51.6965 131.634 51.6182C131.642 51.575 131.748 51.6318 131.656 51.4304C131.646 51.4109 131.618 51.544 131.605 51.3602C131.601 51.3073 131.622 51.1205 131.602 50.9737C131.594 50.9093 131.53 50.6479 131.535 50.4764C131.541 50.2913 131.568 50.562 131.58 50.4896C131.591 50.4161 131.574 50.1928 131.608 50.1896C131.653 50.2972 131.596 50.3317 131.601 50.3705C131.622 50.5197 131.67 50.3759 131.678 50.5992C131.65 50.6429 131.556 50.4724 131.598 50.789C131.6 50.7891 131.614 50.7074 131.627 50.8091C131.651 50.9872 131.682 51.3335 131.696 51.5571C131.74 51.526 131.718 51.2533 131.74 51.1036C131.768 51.4018 131.805 51.7324 131.776 51.9668C131.763 51.8553 131.748 51.7433 131.735 51.6325C131.746 51.7651 131.757 51.898 131.768 52.0299C131.746 51.9871 131.678 51.7047 131.681 51.9204C131.732 51.9198 131.76 52.2129 131.794 52.3138ZM131.642 53.9472C131.594 53.8009 131.588 53.572 131.574 53.3321C131.617 53.3703 131.623 53.7664 131.642 53.9472ZM131.363 47.6522C131.417 47.4685 131.453 48.0949 131.461 48.3485C131.457 48.2902 131.453 48.2308 131.45 48.1725C131.438 48.2037 131.425 48.2326 131.413 48.2638C131.407 48.2002 131.401 48.1367 131.395 48.0731C131.386 48.1539 131.375 48.227 131.365 48.3044C131.294 48.1639 131.331 48.1368 131.324 47.8932C131.319 47.7372 131.294 47.6861 131.28 47.4964C131.211 46.6087 131.12 45.7047 131.067 44.7863C131.118 44.7651 131.132 44.7807 131.15 44.9467C131.135 44.9461 131.119 44.948 131.104 44.948C131.117 45.057 131.131 45.1637 131.145 45.2694C131.146 45.1636 131.148 45.0585 131.151 44.955C131.156 45.0052 131.162 45.0686 131.17 45.1479C131.175 45.2062 131.197 45.2125 131.2 45.2933C131.207 45.4662 131.161 45.7143 131.19 45.895C131.207 45.9996 131.253 45.8296 131.255 46.0957C131.203 45.9589 131.16 45.8661 131.204 46.258C131.224 46.0124 131.223 46.2008 131.247 46.2773C131.263 46.3255 131.235 45.9881 131.274 46.1972C131.282 46.242 131.352 46.9125 131.316 46.8992C131.237 46.8687 131.243 46.8309 131.316 47.2533C131.307 46.686 131.392 47.1732 131.388 47.4287C131.386 47.5588 131.336 47.358 131.363 47.6522ZM131.08 44.3431C131.088 44.515 131.126 44.5458 131.111 44.6817C131.109 44.6934 131.067 44.5942 131.06 44.5127C131.053 44.4306 131.032 43.8971 131.036 43.8783C131.085 43.6976 131.077 44.2829 131.08 44.3431ZM131.048 43.8066C131.039 43.6884 131.03 43.5702 131.021 43.4519C131.015 43.3722 131.008 43.2929 131 43.2141C131 43.2143 131 43.2146 131 43.2148C131.008 43.2189 131.016 43.2238 131.024 43.2285C131.029 43.3024 131.032 43.3766 131.035 43.4511C131.039 43.5696 131.044 43.6882 131.048 43.8066ZM131.776 54.7145C131.722 54.6726 131.729 54.8776 131.735 54.9556C131.758 55.2351 131.726 55.4132 131.784 55.5167C131.803 55.3426 131.76 55.235 131.758 55.152C131.755 54.9705 131.796 54.9531 131.776 54.7145ZM131.834 55.7916C131.828 55.8681 131.8 55.8417 131.8 55.9447C131.799 56.048 131.809 56.3449 131.826 56.4513C131.843 56.5573 131.881 56.5278 131.901 56.6113C131.879 56.3344 131.857 56.0687 131.834 55.7916ZM131.953 57.3753C131.946 57.2172 131.881 57.046 131.915 57.4011C131.916 57.4166 131.959 57.5354 131.944 57.6485C131.934 57.7217 131.917 57.6735 131.907 57.7701C131.896 57.8666 131.984 58.0666 131.953 57.3753ZM132.146 60.93C132.141 60.8557 132.111 60.7747 132.109 60.8122C132.096 61.1066 132.171 61.2751 132.146 60.93ZM131.151 44.955C131.151 44.9522 131.15 44.9494 131.15 44.9467C131.15 44.9467 131.151 44.9466 131.151 44.9466C131.151 44.9493 131.151 44.9523 131.151 44.955ZM132.109 60.2066C132.127 60.3438 132.146 60.4813 132.165 60.6185C132.168 60.5296 132.171 60.4412 132.174 60.3529C132.152 60.3046 132.13 60.2551 132.109 60.2066ZM132.199 59.9528C132.165 59.942 132.137 59.9665 132.128 60.1413C132.162 60.1665 132.18 60.066 132.199 59.9528ZM132.264 62.1801C132.248 62.3839 132.382 62.4757 132.307 62.2002C132.299 62.174 132.266 62.1651 132.264 62.1801ZM131.451 48.7403C131.45 48.7383 131.45 48.7363 131.45 48.7343C131.452 48.7361 131.455 48.7381 131.457 48.7399C131.455 48.7402 131.453 48.74 131.451 48.7403ZM93.3376 89.2456C93.4786 89.2881 93.6173 89.1511 93.5883 89.1444C93.4469 89.113 93.2374 89.2151 93.3376 89.2456ZM132.148 57.9964C132.166 57.5171 132.062 57.4667 132.05 57.4352C131.987 57.2718 132.07 57.1938 132.067 57.1526C132.051 56.957 131.975 57.2219 131.975 57.2495C131.978 57.684 132.043 57.5514 132.068 57.5882C132.123 57.6695 132.103 57.9714 132.148 57.9964ZM131.476 48.7591C131.474 48.7236 131.472 48.6886 131.47 48.6546C131.471 48.6585 131.474 48.6631 131.475 48.667C131.475 48.5996 131.475 48.5322 131.475 48.4647C131.485 48.5442 131.496 48.6234 131.506 48.7022C131.496 48.7214 131.486 48.7399 131.476 48.7591ZM132.637 67.2545C132.682 66.9435 132.544 65.9749 132.564 66.6367C132.567 66.7509 132.584 66.6872 132.589 66.7575C132.589 66.7577 132.589 66.758 132.589 66.7583C132.595 66.8291 132.603 67.4856 132.637 67.2545ZM131.869 54.5247C131.843 54.6183 131.863 54.7594 131.88 54.9295C131.89 54.9086 131.901 54.8873 131.911 54.8665C131.897 54.7529 131.883 54.6382 131.869 54.5247ZM91.1452 89.4018C91.2906 89.3803 91.5548 89.3909 91.5384 89.3233C91.4172 89.3231 91.2956 89.3226 91.1744 89.3224C91.1647 89.3488 91.155 89.3754 91.1452 89.4018ZM89.6884 89.5722C89.8134 89.5537 89.6778 89.5091 89.7259 89.4792C89.7745 89.4514 90.1742 89.4666 89.9016 89.387C89.8181 89.3656 89.3461 89.4106 89.1993 89.3395C89.1109 89.4847 89.3859 89.4038 89.5757 89.4759C89.6332 89.4977 89.4673 89.5638 89.6884 89.5722ZM132.687 68.2316C132.702 68.3677 132.717 68.5051 132.733 68.6411C132.725 68.5062 132.717 68.3704 132.71 68.2355C132.702 68.2344 132.695 68.2327 132.687 68.2316ZM131.352 84.5971C131.364 84.5782 131.377 84.5592 131.389 84.5401C131.435 84.4867 131.478 84.4353 131.518 84.3872C131.542 84.3727 131.566 84.3581 131.59 84.3433C131.512 84.4297 131.433 84.5143 131.352 84.5971ZM132.93 71.0545C132.936 70.8174 132.867 70.5127 132.85 70.6924C132.829 70.9085 132.921 71.44 132.93 71.0545ZM132.792 69.6947C132.811 70.2086 132.913 70.5556 132.846 69.8968C132.842 69.8604 132.8 69.8162 132.792 69.6947ZM130.528 85.422C130.69 85.3417 130.168 85.8454 129.979 85.9428C130.014 85.8872 130.047 85.8314 130.08 85.7754C130.101 85.7589 130.123 85.7392 130.145 85.7188C130.205 85.673 130.307 85.5936 130.429 85.4905C130.479 85.4567 130.525 85.4248 130.53 85.4224C130.529 85.4222 130.529 85.4221 130.528 85.422ZM84.7985 87.5101C85.0408 87.9015 85.2114 87.8508 85.0075 87.6512C84.9826 87.6273 84.8108 87.4837 84.7985 87.5101ZM132.262 59.3645C132.276 59.3477 132.37 59.4982 132.287 59.2264C132.258 59.1327 132.237 59.1571 132.215 58.8796C132.239 59.1362 132.174 59.1114 132.172 59.1404C132.15 59.377 132.24 59.6048 132.269 59.5529C132.277 59.5369 132.248 59.382 132.262 59.3645ZM131.492 47.9518C131.483 47.8133 131.475 47.6741 131.467 47.5357C131.479 47.5483 131.491 47.5595 131.503 47.572C131.499 47.6991 131.497 47.8289 131.492 47.9518ZM86.1421 88.7104C86.1822 88.6832 85.9517 88.3588 85.9174 88.3224C85.6791 88.0937 85.4797 88.0842 85.2615 87.8631C85.2656 88.0089 85.4902 88.0781 85.615 88.2244C85.6541 88.2696 85.4269 88.2397 85.6581 88.4205C85.6583 88.4207 85.6584 88.4209 85.6586 88.421C85.7331 88.4803 86.0396 88.6231 86.1421 88.7104ZM129.735 86.0995C129.823 86.0603 129.709 86.2261 129.508 86.2753C129.501 86.2763 129.502 86.2702 129.502 86.2646C129.503 86.2594 129.504 86.2544 129.498 86.2556C129.48 86.2611 129.408 86.2971 129.322 86.3369C129.149 86.4191 128.917 86.5129 128.989 86.4538C129.097 86.3971 129.205 86.338 129.312 86.2761C129.34 86.2678 129.366 86.2627 129.39 86.258C129.424 86.2516 129.458 86.2449 129.5 86.2283C129.577 86.1977 129.663 86.1443 129.709 86.1151C129.727 86.104 129.738 86.0967 129.741 86.0955C129.739 86.0968 129.737 86.0982 129.735 86.0995ZM82.9098 85.881C82.9177 85.9342 83.0551 86.1475 83.082 86.1532C83.1064 86.1586 83.0981 86.1199 83.0914 86.0852C83.0763 86.0588 83.0613 86.0323 83.0464 86.0057C83.0605 86.0268 83.0749 86.048 83.0891 86.0689C83.0833 86.0332 83.0853 86.0121 83.1408 86.0698C83.2656 86.2594 83.4012 86.4487 83.5431 86.6292C83.5513 86.5874 83.5602 86.5458 83.5694 86.5047C83.5329 86.4775 83.4962 86.4496 83.46 86.4219C83.4398 86.379 83.4201 86.3361 83.4006 86.2932C83.6219 86.2859 83.7143 86.7281 84.017 86.9257C83.9891 86.9517 83.9622 86.9811 83.9335 87.0049C84.3273 87.4778 84.0702 87.1425 84.1079 87.0467C84.1293 86.9918 84.2365 87.1707 84.2684 87.1891C84.4813 87.3127 84.0977 86.8238 83.9759 86.6783C83.8482 86.5374 83.6247 86.3727 83.4946 86.2004C83.4178 86.0982 83.4391 86.0599 83.3651 85.9557C83.2533 85.8 83.0772 85.5091 82.9732 85.3762C82.9351 85.3286 82.9 85.4151 82.9014 85.4346C82.9059 85.4819 82.9805 85.5347 83.0005 85.5802C83.0204 85.6257 82.9776 85.6139 83.0086 85.6705C83.0388 85.7288 83.2375 86.0038 83.2563 86.0179C83.3586 86.1037 83.2731 85.914 83.3702 86.0626C83.2969 86.3955 83.0793 85.817 83.0286 85.7527C82.9008 85.6109 82.9017 85.6486 82.9268 85.7191C82.9837 85.8289 83.042 85.9367 83.0414 85.945C83.0323 86.0253 82.9837 85.9628 82.935 85.8712C82.9193 85.8647 82.9056 85.8603 82.9086 85.8793C82.909 85.8799 82.9094 85.8804 82.9098 85.881ZM81.7036 78.6226C81.6739 78.2203 81.7973 78.4439 81.8031 78.5116C81.8267 78.7953 81.7165 79.0257 81.8694 79.1412C81.8875 79.3137 81.8178 79.1428 81.8178 79.2492C81.8181 79.4602 81.9074 79.68 81.911 79.8998C81.8801 79.9191 81.8489 79.9722 81.8155 79.9607C81.7667 79.7386 81.7111 78.7236 81.7036 78.6226ZM131.997 56.0241C132.022 56.2069 132.048 56.3902 132.073 56.573C132.049 56.3065 132.038 56.2099 132.067 56.0365C132.044 56.0326 132.02 56.028 131.997 56.0241ZM132.703 67.0617C132.706 67.0355 132.666 66.5469 132.641 66.5505C132.638 66.6399 132.677 67.2342 132.703 67.0617ZM81.9024 81.1621C81.8613 80.8032 81.9575 80.7415 81.977 81.0299C81.9824 81.1123 81.9327 81.2116 81.9024 81.1621ZM104.208 88.6997C104.254 88.6981 104.861 88.6579 104.799 88.599C104.472 88.6106 104.122 88.6242 103.787 88.6369C103.808 88.6552 103.903 88.6705 103.951 88.6755C104.069 88.6886 104.04 88.7054 104.208 88.6997ZM81.8166 80.3344C81.8232 80.237 81.8731 80.285 81.8385 80.0952C81.8432 80.0939 81.8479 80.0926 81.8526 80.0913C81.886 80.1043 81.9197 80.2573 81.9227 80.3378C81.9223 80.3409 81.8918 80.3237 81.8921 80.3457C81.8967 80.5078 81.9401 80.7574 81.8576 80.7525C81.8965 80.5974 81.8102 80.4322 81.8166 80.3344ZM132.182 57.3238C132.17 57.1167 132.116 57.0025 132.087 57.0456C132.102 57.1816 132.118 57.3184 132.133 57.4544C132.149 57.411 132.165 57.3673 132.182 57.3238ZM107.736 88.4741C107.674 88.4709 107.612 88.468 107.55 88.4649C107.586 88.4564 107.623 88.448 107.66 88.4395C107.608 88.4358 107.554 88.4322 107.501 88.4285C107.447 88.4637 107.393 88.499 107.338 88.5343C107.47 88.5143 107.603 88.494 107.736 88.4741ZM84.7116 87.9431C84.8085 88.0758 84.849 87.9309 84.7906 87.8662C84.7319 87.8016 84.584 87.7179 84.5657 87.6274C84.67 87.6832 84.7485 87.7956 84.8731 87.8734C85.0203 87.9641 84.9147 87.795 84.8683 87.7806C84.7748 87.7518 84.8187 87.8592 84.6768 87.6794C84.5587 87.5254 84.7885 87.5663 84.6743 87.4567C84.5315 87.3167 84.5397 87.4239 84.5643 87.5075C84.4633 87.4335 84.3649 87.3556 84.2678 87.2762C84.5375 87.5358 84.5163 87.6274 84.4989 87.7635C84.6143 87.8796 84.5484 87.7216 84.6704 87.8379C84.7135 87.8786 84.7038 87.9317 84.7116 87.9431ZM90.646 89.5248C90.9748 89.5026 90.9658 89.4159 90.689 89.4751C90.6301 89.4877 90.6353 89.5061 90.646 89.5248ZM132.1 56.6454C132.106 56.7579 132.112 56.8708 132.118 56.9833C132.126 56.9844 132.134 56.9861 132.142 56.9872C132.136 56.8749 132.129 56.7624 132.123 56.65C132.116 56.649 132.108 56.6465 132.1 56.6454ZM131.967 54.4085C131.983 54.5582 131.975 54.8174 132.012 54.8188C132.009 54.6843 132.006 54.5492 132.002 54.4147C131.991 54.4125 131.979 54.4101 131.967 54.4085ZM132.705 66.6199C132.705 66.6517 132.707 66.6798 132.709 66.7049C132.708 66.6764 132.706 66.6477 132.705 66.6191C132.705 66.6194 132.705 66.6197 132.705 66.6199ZM131.934 53.7989C131.948 53.9124 131.962 54.0273 131.976 54.1407C131.973 54.0288 131.971 53.9164 131.969 53.8051C131.957 53.8028 131.946 53.8012 131.934 53.7989ZM126.522 87.3726C126.484 87.3868 126.322 87.3981 126.174 87.4025C126.076 87.4057 125.983 87.4065 125.932 87.4099C126.116 87.2733 126.551 87.3634 126.522 87.3726ZM106.342 88.7655C107.128 88.7354 106.76 88.517 106.131 88.5628C106.091 88.617 106.246 88.5768 106.259 88.6044C106.271 88.632 106.09 88.6105 106.173 88.6576C106.454 88.6559 106.301 88.6055 106.504 88.5817C106.468 88.6144 106.545 88.6663 106.52 88.6936C106.472 88.7445 106.297 88.7094 106.342 88.7655ZM82.2246 84.1768C82.2244 84.175 82.224 84.1728 82.2238 84.1711C82.2113 84.059 82.3347 83.9972 82.3325 83.9769C82.2954 83.7471 82.1456 83.6669 82.1392 83.8189C82.1363 83.9087 82.2588 84.0157 82.1785 84.0459C82.1401 83.8734 82.1126 83.8154 82.0906 83.8005C82.132 83.9265 82.1769 84.0521 82.2246 84.1768ZM81.7253 78.2566C81.6546 78.2125 81.6704 77.871 81.6507 77.7114C81.7214 77.849 81.7163 78.0472 81.7253 78.2566ZM132.249 58.7529C132.266 59.0153 132.29 58.9544 132.308 58.9963C132.305 58.9355 132.302 58.8748 132.299 58.8149C132.282 58.7942 132.266 58.7734 132.249 58.7529ZM81.2569 71.6008C81.2611 71.6659 81.3077 71.7436 81.3133 71.7114C81.3553 71.4628 81.2377 71.2987 81.2569 71.6008ZM82.5823 84.9327C82.6884 85.0831 82.8245 85.4296 82.8973 85.3549C82.7981 85.0454 82.828 85.1727 82.7186 85.0707C82.6451 85.001 82.6327 84.8291 82.5823 84.9327ZM105.072 88.6515C104.972 88.654 104.871 88.6565 104.771 88.6589C104.808 88.676 104.846 88.6933 104.884 88.7104C104.946 88.6909 105.01 88.6711 105.072 88.6515ZM126.991 87.3618C126.96 87.4289 126.252 87.4813 126.353 87.4411C126.637 87.4164 126.618 87.398 126.597 87.3806C126.587 87.3719 126.576 87.3624 126.595 87.35C126.701 87.286 127.016 87.3135 126.991 87.3618ZM132.196 56.9296C132.193 57.0068 132.189 57.0847 132.186 57.1612C132.199 57.1904 132.211 57.2195 132.224 57.2488C132.221 57.178 132.217 57.1075 132.214 57.038C132.208 57.0019 132.202 56.9657 132.196 56.9296ZM82.0184 83.4501C82.0595 83.1711 82.123 83.1168 82.0321 83.118C82.0339 83.1715 82.0283 83.2016 82.0124 83.1772C82.0086 83.1579 82.0052 83.1387 82.0016 83.1193C81.9868 83.1207 81.9692 83.1221 81.9491 83.1245C81.9699 83.2326 81.9932 83.3425 82.0184 83.4501ZM81.3478 74.6949C81.3493 74.8321 81.449 74.9953 81.4157 74.6825C81.4138 74.6683 81.3497 74.5561 81.3814 74.4634C81.4037 74.403 81.4293 74.4484 81.4544 74.3684C81.4793 74.2886 81.3419 74.0949 81.3478 74.6949ZM81.3858 75.3624C81.4048 75.6052 81.4251 75.8388 81.446 76.0822C81.4605 76.0183 81.5074 76.0481 81.5148 75.9602C81.5222 75.8717 81.5251 75.6145 81.5033 75.5192C81.4814 75.4244 81.4154 75.4392 81.3858 75.3624ZM124.13 87.8099C124.014 87.8233 123.755 87.8529 123.808 87.8219C123.831 87.8099 123.9 87.8079 123.96 87.8063C124.032 87.8043 124.094 87.8026 124.061 87.7847C123.817 87.758 123.608 87.7793 123.323 87.8087C123.315 87.8096 123.306 87.8105 123.298 87.8114C123.295 87.8122 123.305 87.8147 123.319 87.8182C123.356 87.8273 123.423 87.8438 123.383 87.8593C123.365 87.8582 123.348 87.8573 123.334 87.8569C123.208 87.8527 123.249 87.8414 123.058 87.8506C123.046 87.8512 123.002 87.854 122.941 87.8583C122.921 87.8555 122.898 87.8534 122.871 87.8527C122.83 87.8516 122.778 87.8533 122.723 87.8552C122.635 87.8582 122.54 87.8615 122.477 87.8532C122.516 87.8291 122.7 87.8319 122.851 87.8344C122.945 87.8359 123.025 87.8373 123.05 87.8318C123.056 87.8306 123.068 87.8217 123.082 87.8104C123.105 87.7923 123.135 87.768 123.164 87.7592C123.147 87.7587 123.111 87.7624 123.071 87.7666C122.992 87.7751 122.897 87.7852 122.909 87.7656C122.91 87.7648 122.91 87.7639 122.911 87.7631C122.912 87.7621 122.912 87.7611 122.912 87.7601C122.913 87.76 122.913 87.7599 122.913 87.7598C122.931 87.7293 122.961 87.6793 123.139 87.6672C123.154 87.6659 123.166 87.669 123.179 87.6726C123.194 87.6768 123.212 87.6815 123.241 87.6807C123.284 87.6791 123.331 87.6744 123.379 87.6696C123.441 87.6633 123.505 87.6567 123.559 87.6572C123.575 87.6572 123.593 87.661 123.612 87.6651C123.637 87.6704 123.664 87.6761 123.694 87.6753C123.717 87.6745 123.751 87.6674 123.793 87.6587C123.866 87.6433 123.964 87.6231 124.061 87.6244C124.127 87.6249 124.246 87.6736 124.12 87.6916C124.043 87.7027 124.026 87.6959 124.011 87.69C124.003 87.6869 123.994 87.6841 123.979 87.6843C123.943 87.6851 123.9 87.6891 123.859 87.6932C123.762 87.7028 123.668 87.7122 123.667 87.6762C123.571 87.6814 123.582 87.7201 123.61 87.7267C123.684 87.747 124.514 87.7353 124.591 87.7142C124.593 87.7134 124.588 87.7121 124.582 87.7102C124.556 87.7026 124.496 87.6843 124.654 87.6398C124.776 87.6061 124.927 87.5992 124.997 87.596C125.018 87.5951 125.031 87.5944 125.035 87.5935C125.039 87.5922 125.029 87.5868 125.015 87.5795C124.958 87.55 124.837 87.4877 125.304 87.5182C125.36 87.5101 125.349 87.5004 125.34 87.4922C125.333 87.4864 125.328 87.4812 125.346 87.4778C125.399 87.4677 125.62 87.4463 125.646 87.4483C125.659 87.4581 125.672 87.4679 125.685 87.4777C125.681 87.4787 125.657 87.4811 125.623 87.4847C125.511 87.4965 125.284 87.5205 125.296 87.5409C125.565 87.5097 125.668 87.5159 125.882 87.529C125.887 87.5292 125.894 87.5299 125.902 87.5308C125.909 87.5318 125.918 87.5332 125.927 87.5347C125.987 87.544 126.076 87.5563 126.115 87.5169C126.124 87.5084 126.085 87.5082 126.043 87.5077C125.986 87.5072 125.923 87.5056 125.954 87.4861C126.091 87.4774 126.164 87.4582 126.25 87.435C126.256 87.4336 126.261 87.4321 126.266 87.4306C126.301 87.4366 126.27 87.4482 126.243 87.4581C126.224 87.4648 126.206 87.471 126.214 87.4742C126.218 87.4775 126.417 87.4899 126.428 87.4894C126.465 87.4875 126.553 87.476 126.64 87.4627C126.699 87.4537 126.758 87.4439 126.801 87.4373C126.846 87.43 126.905 87.4242 126.952 87.4189C126.988 87.4148 127.018 87.4112 127.032 87.4082C127.059 87.402 127.087 87.3916 127.115 87.3808C127.15 87.3676 127.187 87.3533 127.227 87.3449C127.247 87.3408 127.272 87.3394 127.299 87.3382C127.284 87.346 127.268 87.3543 127.25 87.363C127.225 87.3755 127.202 87.3872 127.179 87.3984C127.139 87.4186 127.1 87.4376 127.053 87.4576C127.044 87.4554 127.032 87.4539 127.019 87.453C126.975 87.4313 126.799 87.463 126.538 87.5065C126.476 87.5165 126.471 87.5243 126.467 87.5312C126.464 87.5356 126.462 87.5397 126.445 87.5434C126.35 87.5625 126.229 87.5784 126.105 87.5915C126.039 87.5984 125.971 87.6047 125.906 87.6107C125.828 87.6179 125.754 87.6257 125.689 87.6348C125.694 87.648 125.763 87.6403 125.818 87.6342C125.845 87.6312 125.869 87.6287 125.88 87.6293C125.893 87.6303 125.907 87.6387 125.909 87.6489C125.909 87.6495 125.909 87.6502 125.909 87.6508C125.909 87.6628 125.891 87.6767 125.838 87.6842C125.645 87.7101 125.58 87.6922 125.519 87.6752C125.489 87.6668 125.46 87.6587 125.416 87.656C125.132 87.6399 124.744 87.6883 124.948 87.7375C124.708 87.7288 124.702 87.7356 124.693 87.7463C124.689 87.751 124.684 87.7563 124.66 87.7614C124.463 87.8045 124.417 87.8038 124.338 87.8022C124.3 87.8015 124.254 87.8005 124.18 87.8043C124.172 87.8049 124.154 87.8071 124.13 87.8099ZM81.472 77.0184C81.5626 77.0688 81.5638 76.8911 81.5584 76.8229C81.539 76.5779 81.6055 76.4342 81.5129 76.3303C81.4691 76.4742 81.5342 76.5771 81.5318 76.6486C81.5256 76.8052 81.4538 76.809 81.472 77.0184ZM81.921 82.5539C81.933 82.5801 81.9307 82.6841 81.9594 82.8546C81.9545 82.8183 81.9499 82.7815 81.9455 82.7456C81.9659 82.7663 81.9825 82.8109 81.9959 82.8638C81.9681 82.6976 81.9503 82.5926 81.9288 82.5577C81.9262 82.5566 81.9236 82.5552 81.921 82.5539C81.9183 82.5481 81.9148 82.5436 81.9103 82.5462C81.9103 82.5467 81.9102 82.5472 81.9102 82.5476C81.9138 82.5501 81.9175 82.5521 81.921 82.5539ZM108.385 88.5644C108.346 88.5441 108.306 88.5236 108.267 88.5033C108.231 88.5374 108.196 88.5717 108.161 88.6058C108.235 88.5921 108.31 88.5781 108.385 88.5644ZM127.47 87.2361C127.402 87.2471 127.331 87.2537 127.336 87.241C127.429 87.2233 127.504 87.1948 127.571 87.1643C127.57 87.1649 127.569 87.1656 127.569 87.1662C127.568 87.1669 127.567 87.1675 127.566 87.1682C127.565 87.1689 127.564 87.1696 127.563 87.1703C127.536 87.1908 127.503 87.2143 127.47 87.2361ZM128.144 87.056C128.117 87.0661 128.093 87.0727 128.071 87.0771C128.08 87.07 128.088 87.063 128.096 87.0564C128.129 87.0273 128.147 87.0057 128.161 86.9859C128.22 86.9652 128.279 86.9441 128.309 86.9344C128.336 86.9515 128.302 86.9985 128.144 87.056ZM82.6844 39.6906C82.7068 39.7005 82.7294 39.7104 82.7517 39.7205C82.7392 39.7075 82.734 39.6804 82.7273 39.6549C82.713 39.6668 82.6987 39.6787 82.6844 39.6906ZM80.5969 62.726C80.5714 62.9275 80.6682 63.2065 80.7098 63.0575C80.7594 62.878 80.6385 62.399 80.5969 62.726ZM91.5024 89.5393C91.6757 89.6012 92.1506 89.5893 91.7996 89.5346C91.7106 89.5208 91.5964 89.5366 91.5024 89.5393ZM81.2728 72.2303C81.2497 72.1078 81.2266 71.984 81.2035 71.8615C81.1925 71.9368 81.1817 72.013 81.1706 72.0877C81.2047 72.1349 81.2389 72.1832 81.2728 72.2303ZM80.8435 66.0569C80.7454 66.3113 80.9161 67.1766 80.9267 66.6046C80.9283 66.5067 80.8955 66.5562 80.891 66.495C80.891 66.4948 80.8911 66.4945 80.8912 66.4943C80.887 66.4321 80.9168 65.8682 80.8435 66.0569ZM81.1394 70.4994C81.1811 70.3294 80.9574 70.2156 81.0681 70.4712C81.0789 70.4955 81.1358 70.5117 81.1394 70.4994ZM80.7428 63.9299C80.7447 63.4833 80.593 63.1574 80.6632 63.7406C80.6676 63.773 80.7384 63.8221 80.7428 63.9299ZM80.8231 65.2072C80.8064 65.0867 80.7897 64.9652 80.7729 64.8447C80.7765 64.9622 80.7803 65.0808 80.7838 65.1982C80.7969 65.2012 80.81 65.2042 80.8231 65.2072ZM127.167 87.3282C127.238 87.3084 127.333 87.2857 127.424 87.2662C127.414 87.2726 127.404 87.2787 127.395 87.2842C127.383 87.2916 127.37 87.2992 127.357 87.3068C127.294 87.3147 127.23 87.3218 127.167 87.3282ZM81.8165 81.8566C81.8182 81.8535 81.8193 81.8485 81.8191 81.8406C81.8191 81.8391 81.8187 81.8372 81.8185 81.8354C81.8178 81.8423 81.8172 81.8499 81.8165 81.8566ZM81.7781 82.0282C81.7937 82.0792 81.7988 82.037 81.8077 81.9506C81.8103 81.923 81.8131 81.8912 81.8165 81.8566C81.8075 81.8729 81.7779 81.8337 81.7779 81.862C81.7779 81.8919 81.7777 81.9221 81.7777 81.9524C81.7776 81.9777 81.7777 82.003 81.7781 82.0282ZM81.6684 81.2003C81.6716 81.2434 81.6752 81.2859 81.6797 81.3235C81.7109 81.3349 81.746 81.3254 81.7579 81.3671C81.7623 81.3829 81.765 81.3954 81.7662 81.4051C81.7754 81.3469 81.7779 81.2629 81.7727 81.1782C81.7361 81.2132 81.6992 81.2416 81.6684 81.2003ZM81.102 72.4233C81.1593 72.4415 81.2085 72.4275 81.2352 72.2802C81.1784 72.2496 81.1409 72.3312 81.102 72.4233ZM81.7109 81.4605C81.733 81.4969 81.7499 81.4788 81.761 81.4318C81.7468 81.4429 81.7105 81.4077 81.7083 81.4093C81.7049 81.4176 81.7019 81.4258 81.6995 81.4325C81.7029 81.444 81.7068 81.4537 81.7109 81.4605ZM81.6209 80.2956C81.6262 80.34 81.6363 80.3767 81.6513 80.3859C81.6794 80.4025 81.6855 80.3202 81.6831 80.2397C81.6627 80.1033 81.6412 80.2376 81.6209 80.2956ZM81.6443 80.8861C81.649 80.921 81.6529 80.9704 81.6566 81.0251C81.6941 81.0329 81.7092 80.9814 81.71 80.9079C81.6922 80.8835 81.6703 80.8737 81.6443 80.8861ZM101.029 36.5274C101.182 36.5225 101.457 36.4608 101.523 36.4955C101.364 36.5181 101.623 36.5744 101.779 36.5445C101.926 36.5192 101.902 36.5028 101.78 36.4883C102.291 36.4586 102.88 36.3927 103.286 36.41C103.208 36.4222 103.195 36.4392 103.182 36.4572C103.182 36.4575 103.182 36.4578 103.182 36.4581C103.344 36.4501 103.434 36.4733 103.625 36.4508C103.595 36.428 103.533 36.4183 103.47 36.4097C103.882 36.3966 104.455 36.3113 104.743 36.3547C104.425 36.3725 104.187 36.3818 104.271 36.4592C104.404 36.4462 104.534 36.4321 104.664 36.4194C104.87 36.4568 104.473 36.5151 104.71 36.5083C104.933 36.4726 104.985 36.5133 105.204 36.4772C105.212 36.4204 105.151 36.3733 104.95 36.315C105.679 36.2586 106.418 36.1983 107.132 36.1488C106.901 36.204 106.627 36.1988 106.506 36.2122C106.398 36.2245 106.417 36.2535 106.323 36.2681C106.338 36.2649 106.037 36.2551 106.09 36.2918C106.193 36.3004 106.297 36.3089 106.402 36.3165C106.718 36.3051 106.562 36.2542 106.819 36.2369C106.953 36.2659 107.633 36.2414 107.443 36.1736C107.3 36.1845 107.078 36.2302 107.081 36.1732C107.324 36.144 107.454 36.1678 107.728 36.1255C107.851 36.1477 107.581 36.203 107.831 36.1903C107.934 36.1794 107.859 36.1543 107.938 36.1418C108.144 36.2329 108.636 36.1927 109.075 36.1762C108.849 36.2248 108.594 36.3283 108.295 36.3124C108.367 36.3419 108.241 36.3552 108.215 36.3772C107.984 36.3702 107.403 36.4572 107.541 36.4088C107.589 36.3924 107.8 36.3926 107.75 36.3687C107.47 36.3503 107.004 36.4954 107.54 36.4656C107.41 36.4783 107.282 36.4924 107.152 36.5051C106.968 36.4437 107.274 36.4199 107.209 36.3679C107.096 36.3579 106.841 36.3992 106.766 36.4323C107.165 36.4027 106.803 36.4395 107.023 36.4811C106.617 36.4888 106.43 36.5693 106.062 36.5602C106.305 36.5333 106.461 36.462 106.612 36.3913C106.42 36.3867 106.069 36.4637 106.089 36.52C105.899 36.5332 105.702 36.5199 105.726 36.5759C105.83 36.5751 105.928 36.5756 106.01 36.5847C105.316 36.6953 104.534 36.7187 103.435 36.847C103.275 36.8463 103.146 36.831 102.969 36.8382C102.738 36.8957 102.355 36.877 102.218 36.8772C102.079 36.8767 101.87 36.9017 101.802 36.9006C101.379 36.8912 101.154 36.8027 100.846 36.7533C100.844 36.7532 100.842 36.7532 100.84 36.7532C101.003 36.6866 100.903 36.5974 101.029 36.5274ZM81.629 79.7333C81.626 79.5695 81.4776 79.2026 81.5664 79.6329C81.5496 79.6474 81.533 79.6621 81.5163 79.6767C81.516 79.6791 81.5156 79.682 81.5151 79.6843C81.553 79.7005 81.5911 79.7165 81.629 79.7333ZM81.6007 79.4919C81.6 79.4894 81.5994 79.4869 81.5987 79.4844C81.5988 79.4902 81.599 79.4969 81.5989 79.5025C81.5995 79.4993 81.6001 79.4951 81.6007 79.4919ZM81.4127 77.9062C81.4106 78.0109 81.3998 78.1324 81.4327 78.2221C81.4594 78.1742 81.4864 78.1247 81.5133 78.0761C81.4857 78.017 81.467 77.9525 81.4544 77.881C81.4419 77.8879 81.4279 77.8957 81.4127 77.9062ZM133.569 80.8831C133.503 81.0256 133.376 81.5059 133.498 81.187C133.529 81.1056 133.549 80.9804 133.569 80.8831ZM81.2042 74.9135C81.2495 74.8874 81.3018 74.8103 81.3027 74.7966C81.3231 74.4783 81.2387 74.5022 81.1884 74.4924C81.1929 74.5434 81.1968 74.5937 81.1996 74.6427C81.2004 74.6439 81.2012 74.6451 81.2021 74.6463C81.2284 74.7022 81.2213 74.7403 81.2044 74.77C81.2049 74.7942 81.2055 74.819 81.2053 74.8425C81.2052 74.8702 81.2047 74.8936 81.2042 74.9135ZM82.1842 84.2491C82.207 84.305 82.2293 84.3621 82.2499 84.4163C82.2645 84.4018 82.2485 84.3438 82.1843 84.202C82.1845 84.2209 82.1844 84.2362 82.1842 84.2491ZM83.7732 86.9562C83.7606 86.927 83.7485 86.8979 83.7362 86.8686C83.6877 86.8608 83.6389 86.8527 83.5899 86.8435C83.6132 86.8718 83.6379 86.9013 83.6615 86.9295C83.6986 86.9386 83.7362 86.9478 83.7732 86.9562ZM81.8376 82.9071C81.8442 82.9766 81.861 83.0215 81.88 83.072C81.8654 83.0004 81.8496 82.9265 81.8348 82.8603C81.8352 82.8747 81.8361 82.8903 81.8376 82.9071ZM118.613 88.0392C118.524 88.0501 118.433 88.0611 118.344 88.072C118.378 88.0834 118.413 88.0948 118.447 88.1061C118.502 88.0838 118.558 88.0614 118.613 88.0392ZM80.7176 66.2042C80.7102 66.2241 80.7465 66.6552 80.7894 66.659C80.799 66.5835 80.7739 66.0636 80.7176 66.2042ZM80.3254 61.8665C80.3625 61.8345 80.4762 61.8296 80.4854 61.7254C80.4996 61.5596 80.4398 61.4029 80.3905 61.4993C80.3757 61.528 80.3637 61.8461 80.3254 61.8665ZM83.3254 86.4265C83.3113 86.4244 83.2619 86.356 83.2485 86.3477C83.2655 86.375 83.2828 86.4024 83.3001 86.4294C83.3085 86.4284 83.3172 86.4276 83.3254 86.4265ZM133.512 75.2744C133.517 75.3542 133.521 75.4301 133.525 75.5024C133.524 75.4709 133.523 75.4363 133.52 75.394C133.517 75.3632 133.515 75.3209 133.512 75.2744ZM133.63 75.943C133.617 75.9181 133.601 76.0104 133.597 75.8461C133.602 75.8135 133.606 75.7795 133.61 75.7457C133.599 75.6422 133.586 75.5339 133.576 75.4276C133.562 75.5008 133.548 75.5741 133.534 75.6476C133.556 76.0183 133.573 76.2816 133.587 76.4727C133.597 76.3885 133.572 75.9187 133.56 75.8106C133.613 75.8311 133.582 76.2331 133.631 76.353C133.636 76.3173 133.641 76.2225 133.643 76.1326C133.641 76.0958 133.639 76.0588 133.636 76.022C133.635 75.9965 133.633 75.9699 133.63 75.943ZM133.482 73.9872C133.463 73.7822 133.444 73.5743 133.427 73.3638C133.428 73.4069 133.427 73.4494 133.424 73.4879C133.422 73.5023 133.417 73.497 133.41 73.4864C133.412 73.5271 133.415 73.5678 133.417 73.6076C133.428 73.799 133.438 73.9791 133.447 74.1487C133.461 74.0941 133.474 74.0345 133.482 73.9872ZM126.032 36.0474C126.083 36.0565 126.134 36.0661 126.185 36.0762C126.143 36.0577 126.101 36.0396 126.058 36.0218C126.049 36.0303 126.041 36.0389 126.032 36.0474ZM133.726 80.0079C133.696 80.3617 133.741 80.4003 133.748 80.0788C133.749 80.0108 133.738 80.0066 133.726 80.0079ZM133.318 71.8059C133.318 71.8059 133.318 71.8059 133.318 71.8059C133.322 71.8856 133.326 71.9649 133.331 72.043C133.331 72.0435 133.332 72.0439 133.333 72.0443C133.328 71.9651 133.323 71.8854 133.318 71.8059ZM80.2024 58.5658C80.1792 58.7024 80.2264 58.9079 80.2591 58.8033C80.2916 58.6983 80.2314 58.3968 80.2024 58.5658ZM82.0528 84.6593C82.0908 84.6992 82.2209 84.7949 82.249 84.7732C82.2933 84.7383 82.2682 84.5679 82.199 84.4631C82.1816 84.4644 82.1637 84.4572 82.146 84.4162C82.1096 84.4153 82.0698 84.4613 82.0391 84.2628C82.0376 84.2525 82.0391 84.2255 82.0413 84.1923C81.997 84.0904 81.9292 83.9079 81.907 83.7979C81.882 83.7832 81.8583 83.777 81.8394 83.8061C81.8076 83.8553 81.9031 84.0877 81.9296 84.1915C81.9402 84.2358 81.9143 84.272 81.916 84.2807C81.9397 84.3855 81.9869 84.4063 82.0251 84.4966C82.0429 84.5385 82.015 84.6196 82.0528 84.6593ZM119.496 88.0562C119.339 88.073 119.181 88.0899 119.024 88.1067C119.092 88.1066 119.159 88.1065 119.227 88.1064C119.182 88.1129 119.137 88.1192 119.093 88.1257C119.149 88.1263 119.207 88.1269 119.263 88.1274C119.341 88.1038 119.418 88.0799 119.496 88.0562ZM80.5658 64.534C80.5609 64.5817 80.5561 64.6301 80.5511 64.6784C80.5705 64.6734 80.59 64.6678 80.6093 64.6628C80.5835 64.5696 80.5576 64.4762 80.5318 64.3836C80.5232 64.4196 80.5145 64.4571 80.5059 64.4931C80.5258 64.507 80.546 64.5201 80.5658 64.534ZM81.0342 73.1327C81.0347 73.1409 81.0354 73.1492 81.0359 73.1575C81.0608 73.1355 81.0898 73.1388 81.0933 73.1269C81.1398 72.9555 81.0409 72.7678 80.9794 72.7464C80.9884 72.8029 80.9974 72.8783 81.0064 72.975C80.9806 72.9735 80.9544 72.9712 80.9286 72.9692C80.964 73.0245 80.9981 73.0704 81.0342 73.1327ZM80.3682 66.0206C80.3882 66.3026 80.4091 66.5823 80.4308 66.8595C80.5164 66.8311 80.5597 67.0675 80.6336 67.0376C80.6763 67.0199 80.6405 66.7491 80.6451 66.6435C80.6472 66.5986 80.6837 66.5905 80.6847 66.5822C80.6925 66.4787 80.6527 66.4224 80.6443 66.3189C80.6406 66.271 80.6946 66.2324 80.6715 66.17C80.6481 66.1074 80.5566 65.9214 80.5218 65.9132C80.4595 65.899 80.421 66.0983 80.4795 66.2525C80.508 66.3278 80.5947 66.2657 80.5578 66.4955C80.5526 66.5264 80.4678 66.6581 80.4802 66.7697C80.4164 66.6354 80.3911 66.1849 80.3958 65.9941C80.3828 65.9914 80.3741 66.0017 80.3682 66.0206ZM84.5878 88.1085C84.7082 88.2337 84.841 88.2676 84.7791 88.1527C84.7594 88.119 84.5298 87.8979 84.5276 87.8427C84.5398 87.9034 84.5123 88.0292 84.5878 88.1085ZM81.1393 74.8555C81.1429 74.9015 81.1562 74.9197 81.1738 74.9221C81.1692 74.892 81.1646 74.857 81.1605 74.824C81.1481 74.8362 81.1388 74.8462 81.1393 74.8555ZM87.034 89.4018C87.133 89.4795 87.4018 89.5205 87.2431 89.4281C87.1164 89.354 86.9367 89.3253 87.034 89.4018ZM81.5247 81.2226C81.5034 81.4155 81.4723 81.4408 81.5059 81.6526C81.5293 81.54 81.5799 81.3141 81.5247 81.2226ZM123.359 87.9212C123.41 87.9142 123.46 87.9069 123.496 87.8996C123.423 87.8982 123.347 87.9008 123.27 87.9058C123.298 87.9057 123.325 87.9055 123.352 87.9054C123.354 87.9107 123.357 87.9159 123.359 87.9212ZM81.2476 78.0506C81.2926 78.0488 81.3762 78.071 81.2734 77.9116C81.2625 77.8947 81.2519 77.8854 81.242 77.8757C81.2429 77.9143 81.266 78.0067 81.2476 78.0506ZM80.9772 73.1671C80.9874 73.2041 80.9962 73.2553 81.0028 73.3377C80.9947 73.2625 81.0014 73.2168 81.014 73.1883C81.0142 73.177 81.0145 73.1655 81.0147 73.1543C81.0022 73.1582 80.9897 73.163 80.9772 73.1671ZM82.8947 86.1337C82.8813 86.095 82.8676 86.0553 82.8549 86.0166C82.8366 86.0234 82.818 86.0304 82.7997 86.0372C82.7789 85.9916 82.7584 85.9458 82.7383 85.8995C82.7383 85.8996 82.7382 85.8996 82.7381 85.8997C82.729 85.9221 82.7201 85.9449 82.7112 85.9674C82.7717 86.0241 82.8332 86.0797 82.8947 86.1337ZM125.41 87.8882C125.306 87.8935 125.202 87.899 125.097 87.9042C124.924 87.9129 124.27 87.9536 124.158 87.9482C123.825 87.9318 123.922 87.8765 123.667 87.9693C123.471 87.9857 123.632 87.9385 123.549 87.9335C123.532 87.9327 123.457 87.9501 123.376 87.9656C123.379 87.9715 123.381 87.9774 123.384 87.9832C124.042 87.9912 124.7 87.9991 125.359 88.0071C125.376 87.9675 125.393 87.9278 125.41 87.8882ZM80.9778 74.8207C81.0082 74.9136 81.0614 74.9619 81.0976 74.9411C81.0898 74.8854 81.0819 74.8298 81.074 74.7741C81.0661 74.8031 81.0582 74.83 81.0478 74.8361C81.0171 74.8538 80.9567 74.6544 80.9778 74.8207ZM131.784 42.7479C131.771 42.6394 131.749 42.516 131.723 42.3865C131.717 42.4038 131.711 42.4211 131.706 42.4384C131.719 42.4954 131.732 42.5525 131.744 42.6093C131.728 42.6103 131.712 42.6112 131.697 42.6122C131.703 42.6919 131.708 42.7718 131.713 42.8519C131.746 42.9233 131.778 42.9954 131.809 43.0677C131.809 43.0387 131.808 43.0098 131.808 42.9809C131.801 42.9036 131.793 42.8255 131.784 42.7479ZM81.138 75.8296C81.1354 75.7729 81.1329 75.7161 81.1303 75.6595C81.1219 75.6624 81.1133 75.6651 81.105 75.6678C81.1027 75.6866 81.0992 75.7049 81.0945 75.7235C81.096 75.7556 81.0975 75.7878 81.099 75.8199C81.1119 75.8231 81.125 75.8264 81.138 75.8296ZM80.1231 62.0486C80.1542 61.9444 80.2161 61.9373 80.2866 61.9224C80.2919 61.7569 80.2194 61.8792 80.2219 61.7058C80.2228 61.6448 80.2705 61.6407 80.2737 61.6287C80.3098 61.4835 80.1709 61.4757 80.1608 61.5608C80.1509 61.6462 80.1915 61.8398 80.138 61.8906C80.1047 61.7531 80.1342 61.6288 80.1099 61.4642C80.1026 61.4147 80.0931 61.3887 80.0835 61.3782C80.0875 61.4448 80.0915 61.5116 80.0955 61.5783C80.1101 61.5969 80.1161 61.6197 80.1032 61.7092C80.1099 61.8223 80.1165 61.9355 80.1231 62.0486ZM132.005 46.1879C131.991 46.1045 131.979 46.0163 131.968 45.9213C131.957 45.9454 131.945 45.9695 131.934 45.9936C131.935 46.0428 131.936 46.0921 131.938 46.1413C131.949 46.1373 131.961 46.1387 131.975 46.1497C131.985 46.1583 131.995 46.1719 132.005 46.1879ZM80.7327 69.2916C80.7065 69.3868 80.6503 69.5749 80.7055 69.6942C80.7309 69.5207 80.7633 69.5142 80.7327 69.2916ZM81.0633 76.1256C81.0681 76.1171 81.073 76.1104 81.0786 76.1103C81.1119 76.1107 81.174 76.355 81.1475 76.1394C81.1458 76.1285 81.1301 76.0851 81.1101 76.0322C81.0893 76.0233 81.068 76.0281 81.051 76.0486C81.0551 76.0741 81.0592 76.1001 81.0633 76.1256ZM132.537 53.5224C132.503 53.4528 132.473 53.3746 132.449 53.2884C132.437 53.3762 132.425 53.464 132.413 53.5518C132.407 53.5441 132.4 53.5365 132.393 53.5288C132.393 53.5331 132.394 53.5374 132.394 53.5416C132.413 53.6001 132.426 53.653 132.435 53.7023C132.464 53.4831 132.517 53.8725 132.553 54.075C132.552 53.9446 132.551 53.8143 132.551 53.684C132.546 53.6303 132.542 53.5762 132.537 53.5224ZM131.002 40.1377C130.977 40.1239 130.953 40.1102 130.928 40.0966C130.99 40.206 131.05 40.3168 131.107 40.4295C131.114 40.4759 131.12 40.5221 131.125 40.5683C131.16 40.6091 131.194 40.6504 131.228 40.6923C131.254 40.8022 131.277 40.9125 131.298 41.0223C131.332 41.0471 131.367 41.0722 131.401 41.0976C131.394 41.0829 131.387 41.0659 131.379 41.0452C131.35 40.9713 131.214 40.6053 131.095 40.3297C131.065 40.2652 131.034 40.2012 131.002 40.1377ZM133.305 68.4963C133.306 68.525 133.307 68.5536 133.308 68.5823C133.309 68.5754 133.31 68.5685 133.312 68.5616C133.31 68.54 133.308 68.518 133.305 68.4963ZM132.387 53.0135C132.383 53.0412 132.379 53.0689 132.375 53.0965C132.375 53.1039 132.375 53.1117 132.376 53.1191C132.383 53.1016 132.39 53.0841 132.397 53.0665C132.394 53.0492 132.39 53.0313 132.387 53.0135ZM80.476 67.6761C80.4868 67.8375 80.4976 67.999 80.5084 68.1604C80.5609 68.2325 80.5489 68.0376 80.5384 67.8724C80.5307 67.9521 80.5227 68.0319 80.5132 68.1095C80.5065 67.9881 80.4996 67.8659 80.4927 67.7446C80.5058 67.7468 80.519 67.7492 80.5322 67.7512C80.5309 67.7171 80.5306 67.6901 80.5333 67.6779C80.5496 67.6075 80.6504 67.6333 80.5953 67.4454C80.5743 67.3742 80.5333 67.4622 80.5329 67.5518C80.4653 67.2331 80.4428 67.3078 80.4429 67.4931C80.4539 67.5541 80.465 67.6151 80.476 67.6761ZM79.723 53.9517C79.7901 53.8201 79.7866 53.3561 79.7238 53.6632C79.7081 53.7412 79.722 53.8596 79.723 53.9517ZM80.3503 63.2875C80.349 63.249 80.3477 63.2085 80.3465 63.17C80.3223 63.126 80.2979 63.0817 80.2737 63.0377C80.2649 63.0648 80.2559 63.0907 80.2471 63.1178C80.2814 63.1739 80.316 63.2309 80.3503 63.2875ZM80.2783 64.6563C80.2956 64.6347 80.3006 64.5128 80.3106 64.4686C80.3277 64.3941 80.3695 64.5644 80.388 64.5236C80.388 64.5229 80.388 64.5221 80.3879 64.5214C80.4064 64.4789 80.3969 64.2148 80.3775 64.1845C80.3352 64.1204 80.3179 64.3619 80.281 64.1744C80.2728 63.9334 80.2649 63.6861 80.2567 63.4427C80.2397 63.4494 80.2227 63.4565 80.2058 63.4631C80.2293 63.8626 80.2536 64.2608 80.2783 64.6563ZM131.545 41.3086C131.488 41.1013 131.474 41.2529 131.402 41.0989C131.432 41.2276 131.459 41.3563 131.482 41.4852C131.487 41.4481 131.491 41.4108 131.494 41.3734C131.518 41.4056 131.542 41.438 131.565 41.4706C131.568 41.4336 131.567 41.3916 131.545 41.3086ZM81.0342 75.2779C81.037 75.2569 81.041 75.2344 81.0464 75.2115C81.0457 75.1887 81.0448 75.1657 81.0442 75.1429C81.0313 75.147 81.0184 75.1509 81.0056 75.155C81.0067 75.1936 81.0078 75.2325 81.009 75.2711C81.0174 75.273 81.0258 75.2758 81.0342 75.2779ZM95.1887 89.8143C95.3234 89.769 95.4333 89.734 94.9234 89.7476C94.923 89.7496 94.922 89.7518 94.9215 89.7538C95.1096 89.7509 95.2175 89.7658 95.1887 89.8143ZM133.565 71.5946C133.562 71.5501 133.559 71.5228 133.555 71.5069C133.559 71.5608 133.563 71.6147 133.567 71.6685C133.558 71.8401 133.559 71.9322 133.567 71.9895C133.57 71.8389 133.573 71.7008 133.565 71.5946ZM80.8592 72.9167C80.8616 72.9129 80.8641 72.9067 80.8671 72.9034C80.8629 72.8963 80.8588 72.8926 80.8548 72.8875C80.8542 72.8942 80.8555 72.9036 80.8592 72.9167ZM130.263 38.8951C130.263 38.8933 130.263 38.8915 130.263 38.8897C130.255 38.8789 130.248 38.8681 130.24 38.8574C130.248 38.8699 130.255 38.8825 130.263 38.8951ZM81.1668 77.9731C81.1657 77.9708 81.1645 77.9688 81.1634 77.9665C81.1635 77.968 81.1635 77.9695 81.1636 77.971C81.1647 77.9717 81.1657 77.9725 81.1668 77.9731ZM82.0074 84.6689C82.0074 84.6677 82.0073 84.6662 82.0073 84.665C82.0067 84.6539 81.9744 84.5774 81.9372 84.4955C81.96 84.5532 81.9834 84.6113 82.0074 84.6689ZM127.961 36.6673C127.976 36.6741 127.991 36.6809 128.005 36.6877C127.975 36.6684 127.946 36.649 127.918 36.63C127.933 36.6424 127.947 36.6548 127.961 36.6673ZM83.8995 87.6155C83.8909 87.5939 83.8735 87.5638 83.8438 87.5223C83.7826 87.4369 83.701 87.3669 83.6415 87.3341C83.7276 87.4339 83.8155 87.5295 83.8995 87.6155ZM129.116 37.5548C129.123 37.5591 129.131 37.5633 129.139 37.5675C129.109 37.5386 129.078 37.5096 129.048 37.4809C129.071 37.5054 129.093 37.5301 129.116 37.5548ZM80.0336 60.5589C80.0448 60.5395 80.0533 60.5005 80.0568 60.4314C80.0569 60.4314 80.057 60.4314 80.0571 60.4314C80.0618 60.3344 80.0137 59.9561 80.0392 59.8306C80.0277 59.8184 80.0093 59.8285 79.988 59.8503C80.0035 60.0857 80.0188 60.3221 80.0336 60.5589ZM131.054 39.8634C130.987 39.8079 130.933 39.7772 130.872 39.7236C130.934 39.8371 130.994 39.9521 131.051 40.0686C131.044 40.0701 131.036 40.0716 131.029 40.0731C131.042 40.0852 131.054 40.0924 131.056 40.0809C131.06 40.0616 131.152 40.0406 131.054 39.8634ZM118.686 88.4018C118.661 88.4082 118.635 88.4145 118.61 88.4209C118.649 88.4194 118.688 88.4184 118.726 88.4178C118.713 88.4125 118.7 88.4072 118.686 88.4018ZM101.642 89.4297C101.632 89.4307 101.621 89.4317 101.61 89.4327C101.612 89.4337 101.613 89.4347 101.615 89.4357C101.623 89.4337 101.634 89.4317 101.642 89.4297ZM80.1782 62.8411C80.1856 62.4545 80.1786 62.4592 80.1509 62.5226C80.157 62.6274 80.163 62.7323 80.1691 62.8371C80.1721 62.8387 80.1752 62.8395 80.1782 62.8411ZM79.9449 59.2134C79.9634 59.081 79.9532 58.8218 79.9474 58.7345C79.9372 58.5795 79.9163 58.6283 79.8994 58.5879C79.9151 58.7953 79.9302 59.004 79.9449 59.2134ZM79.5953 55.4016C79.6192 55.5974 79.6424 55.7947 79.6644 55.9947C79.6657 55.9576 79.6696 55.9204 79.6791 55.8896C79.6959 55.8356 79.7792 56.0494 79.7671 55.8081C79.7379 55.6609 79.7033 55.791 79.6686 55.7234C79.6409 55.6688 79.632 55.3817 79.5953 55.4016ZM125.354 88.0165C125.257 88.0374 125.161 88.0583 125.064 88.0792C125.152 88.0785 125.239 88.0779 125.327 88.0772C125.336 88.057 125.345 88.0367 125.354 88.0165ZM132.589 54.146C132.587 54.1585 132.585 54.1709 132.583 54.1834C132.586 54.1811 132.588 54.1723 132.589 54.1543C132.589 54.1516 132.589 54.1487 132.589 54.146ZM79.6925 54.7675C79.6757 54.4383 79.5863 54.398 79.6422 54.6981C79.6541 54.7619 79.6731 54.7672 79.6925 54.7675ZM79.884 58.3864C79.8875 58.2653 79.8984 58.1222 79.8778 58.0123C79.864 57.9392 79.8534 57.9085 79.8455 57.9055C79.8586 58.065 79.8715 58.2255 79.884 58.3864ZM79.4095 52.0066C79.4271 52.0339 79.4444 52.044 79.4549 52.019C79.4847 51.947 79.4379 51.8344 79.3988 51.7694C79.4024 51.8484 79.4058 51.9275 79.4095 52.0066ZM127.191 35.8966C126.914 35.7202 126.441 35.6033 126.641 35.7315C126.882 35.8772 127.633 36.1811 127.191 35.8966ZM98.9819 36.4348C99.3531 36.3845 101.015 36.2982 101.182 36.288C101.844 36.2471 101.455 36.3616 101.344 36.3689C100.877 36.4 100.524 36.3144 100.306 36.4495C100.021 36.4717 100.313 36.4054 100.139 36.4096C99.795 36.4179 99.4207 36.5025 99.0621 36.514C99.0616 36.514 99.0611 36.5141 99.0606 36.5141C99.0352 36.4884 98.9567 36.4637 98.9819 36.4348ZM112.707 35.6375C112.6 35.6435 112.464 35.6863 112.516 35.6898C112.913 35.7163 113.202 35.6095 112.707 35.6375ZM97.0078 36.555C97.6005 36.5061 97.6824 36.5861 97.2084 36.6137C97.0732 36.6216 96.9212 36.5828 97.0078 36.555ZM98.3727 36.4499C98.5301 36.4518 98.4406 36.4965 98.7568 36.4596C98.759 36.4615 98.7611 36.4633 98.7632 36.4652C98.7706 36.4954 98.4876 36.5346 98.3464 36.5406C98.3418 36.5402 98.3752 36.5137 98.3396 36.5148C98.0747 36.5249 97.6595 36.5718 97.6833 36.501C97.9286 36.5284 98.2146 36.4481 98.3727 36.4499ZM125.295 35.2743C125.99 35.4727 126.56 35.564 125.624 35.3001C125.572 35.2875 125.464 35.3154 125.295 35.2743ZM121.816 35.0722C121.421 34.998 119.978 35.1769 120.907 35.1641C121.067 35.1618 120.993 35.1356 121.094 35.1294C121.094 35.1295 121.094 35.1295 121.094 35.1295C121.196 35.1235 122.11 35.1277 121.816 35.0722ZM123.206 35.0342C123.206 35.0343 123.206 35.0344 123.206 35.0345C123.408 35.0261 123.608 35.0241 123.811 35.0291C123.617 35.0137 123.425 35.0047 123.23 35.0017C123.222 35.0126 123.214 35.0233 123.206 35.0342ZM107.65 35.8334C107.426 35.8398 107.139 35.9317 107.656 35.8911C107.679 35.8892 107.874 35.8298 108.019 35.8534C108.113 35.8702 108.034 35.894 108.159 35.9124C108.159 35.9124 108.158 35.9124 108.158 35.9125C108.283 35.9306 108.627 35.8055 107.65 35.8334ZM101.775 36.2925C101.86 36.2303 102.413 36.2308 102.676 36.2078C102.439 36.2735 102.118 36.2768 101.775 36.2925ZM105.37 35.9704C105.472 35.9803 105.413 36.0217 105.556 36.0246C105.556 36.0247 105.556 36.0248 105.556 36.0249C105.699 36.0279 106.117 36.0206 106.276 35.9983C106.436 35.976 106.423 35.9197 106.554 35.8914C106.155 35.917 105.77 35.9432 105.37 35.9704ZM111.678 35.6752C111.882 35.6508 112.087 35.6263 112.291 35.6019C112.171 35.5953 112.049 35.589 111.929 35.5824C111.846 35.6133 111.762 35.6444 111.678 35.6752ZM114.523 35.4949C114.792 35.5243 115.02 35.3284 114.582 35.433C114.54 35.4432 114.503 35.4927 114.523 35.4949ZM103.84 36.0287C103.741 36.108 104.029 36.1021 104.141 36.0949C104.544 36.0689 104.765 36.1204 104.953 36.0373C104.726 36.0054 104.546 36.065 104.43 36.0656C104.176 36.0663 104.184 36.0051 103.84 36.0287ZM128.56 36.5079C128.576 36.5607 128.505 36.6259 128.632 36.7379C128.835 36.9158 129.068 37.0601 128.985 36.9295C128.961 36.887 128.563 36.5468 128.56 36.5079ZM111.396 35.5366C111.356 35.5863 111.369 35.6277 111.604 35.645C111.665 35.5952 111.539 35.5663 111.396 35.5366ZM131.763 40.8993C131.718 40.6819 131.556 40.3657 131.588 40.5318C131.622 40.6959 131.82 41.1667 131.763 40.8993ZM100.534 35.9434C100.881 35.8439 100.599 35.8272 101.225 35.8737C100.547 35.9927 101.438 36.0011 101.406 36.0789C101.387 36.1228 101.087 36.1118 100.984 36.1391C100.825 36.1812 101.009 36.2281 100.829 36.2587C100.649 36.2892 100.071 36.2749 99.8767 36.2859C99.5062 36.3073 99.1785 36.3507 98.8691 36.3687C98.5598 36.3867 98.0913 36.373 97.8934 36.3788C97.6958 36.3846 97.4987 36.4028 97.4649 36.4091C97.2643 36.4463 97.3687 36.5024 97.0984 36.5177C97.0919 36.4578 96.7367 36.3806 97.1396 36.3239C97.0826 36.3252 97.0136 36.3172 96.9582 36.3215C96.6976 36.342 96.8254 36.4185 96.701 36.4392C96.4899 36.4742 96.6453 36.4012 96.6419 36.3985C96.4487 36.359 96.5397 36.4118 96.4467 36.4423C96.398 36.4579 96.0001 36.5071 95.9177 36.5097C95.8362 36.5123 95.9466 36.4741 95.8922 36.4752C95.6559 36.4805 95.4134 36.4844 95.1751 36.5039C94.937 36.5236 94.7946 36.5875 94.8127 36.5047C94.8164 36.4917 94.9505 36.4726 94.9133 36.4448C94.9133 36.4446 94.9133 36.4445 94.9133 36.4443C94.9008 36.4353 94.7161 36.3985 94.9888 36.3564C95.0661 36.3445 95.1489 36.336 95.2334 36.3304C95.2007 36.3432 95.1679 36.356 95.1352 36.3688C95.2 36.366 95.2644 36.3635 95.3288 36.3609C95.2873 36.3917 95.2431 36.4241 95.2128 36.4533C95.2918 36.4802 95.3908 36.4344 95.405 36.434C95.6249 36.4345 95.5916 36.4953 95.7566 36.4172C95.6084 36.4143 95.4632 36.4099 95.3202 36.4051C95.3262 36.3903 95.3324 36.3753 95.3379 36.3605C95.3669 36.3593 95.396 36.3582 95.4252 36.357C95.4112 36.3459 95.3972 36.3346 95.3832 36.3235C95.5926 36.3173 95.8085 36.3249 95.9971 36.336C95.9278 36.3561 95.8512 36.3787 95.7827 36.3999C96.0429 36.3724 95.8875 36.4164 96.0645 36.427C96.1257 36.354 96.223 36.3652 96.3739 36.3623C96.5246 36.3593 96.3367 36.3175 96.492 36.3032C96.8078 36.2742 97.3243 36.33 97.425 36.2237C97.813 36.266 97.3221 36.3002 97.2892 36.3266C97.1524 36.4395 97.9869 36.352 98.1242 36.2868C98.2319 36.3152 98.2235 36.3631 98.5348 36.3342C98.9568 36.295 98.0621 36.2836 98.6329 36.2445C99.0148 36.2184 98.9511 36.2719 99.1368 36.2742C99.4829 36.2783 100.11 36.2201 99.9046 36.1598C99.8217 36.1358 99.5478 36.1867 99.4517 36.162C99.3987 36.1482 99.5573 35.9951 99.2094 36.1254C99.1757 36.1384 99.3381 36.1828 99.074 36.1978C98.9982 36.2021 98.7561 36.1671 98.5384 36.1924C98.4431 36.2035 98.0328 36.2911 97.7998 36.2789C97.5478 36.2662 97.9434 36.2321 97.851 36.2139C97.7578 36.1958 97.4387 36.2144 97.4592 36.1655C97.6426 36.1015 97.6469 36.1857 97.7047 36.1789C97.9263 36.1518 97.763 36.0779 98.0772 36.0713C98.1165 36.1139 97.8104 36.2488 98.2802 36.194C98.2825 36.1919 98.1774 36.1694 98.329 36.1518C98.5928 36.1211 99.0939 36.0845 99.4136 36.0696C99.4041 36.0038 99.0117 36.0288 98.8216 35.9929C99.2548 35.959 99.739 35.9136 100.041 35.961C99.8768 35.9786 99.7121 35.9964 99.5485 36.014C99.7404 36.0009 99.9328 35.9879 100.124 35.9748C100.047 36.0067 99.606 36.0994 99.907 36.0993C99.9444 36.0254 100.369 35.9907 100.534 35.9434ZM101.072 89.7744C101.077 89.7789 101.082 89.7834 101.086 89.7877C101.29 89.7757 101.493 89.7674 101.695 89.7608C101.487 89.7653 101.28 89.7699 101.072 89.7744ZM94.6675 36.6006C94.7732 36.6038 94.8929 36.6033 95.0037 36.6042C94.9106 36.6564 94.7917 36.6557 94.6189 36.6347C94.6378 36.6233 94.6467 36.612 94.6675 36.6006ZM121.6 34.9703C121.57 34.9646 120.86 35.0121 120.846 35.0491C120.966 35.0544 121.818 35.0131 121.6 34.9703ZM93.5344 36.6567C93.7938 36.6447 94.0522 36.6352 94.3103 36.6254C94.1411 36.6899 93.3828 36.6917 93.5344 36.6567ZM133.838 68.9527C133.829 68.873 133.819 68.7951 133.809 68.7378C133.806 68.8008 133.806 68.8672 133.808 68.9349C133.818 68.9409 133.828 68.9468 133.838 68.9527ZM124.385 34.925C124.309 34.9085 124.231 34.8931 124.153 34.8785C124.155 34.8953 124.157 34.9125 124.159 34.9293C124.321 34.9289 124.483 34.9326 124.645 34.9409C124.589 34.9228 124.532 34.9051 124.476 34.8882C124.446 34.9002 124.415 34.9127 124.385 34.925ZM80.2875 71.401C80.3022 71.5012 80.3177 71.6443 80.3323 71.797C80.338 71.6881 80.3438 71.5793 80.3495 71.4705C80.3284 71.4121 80.3073 71.3537 80.2861 71.2954C80.2866 71.3306 80.2871 71.3658 80.2875 71.401ZM111.806 89.3959C111.699 89.3072 112.001 89.2292 112.253 89.1969C112.217 89.1893 112.182 89.1818 112.146 89.1742C112.13 89.1754 112.113 89.1766 112.097 89.1778C112.011 89.209 111.925 89.2402 111.839 89.2714C111.688 89.2574 111.537 89.2434 111.386 89.2293C111.313 89.2347 111.241 89.2401 111.169 89.2454C111.12 89.2823 111.07 89.3191 111.021 89.356C110.91 89.3514 110.8 89.3467 110.689 89.3421C110.848 89.369 111.106 89.4084 111.251 89.3477C111.323 89.3172 111.195 89.2259 111.538 89.2487C111.791 89.2656 111.526 89.3645 111.806 89.3959ZM108.654 35.5629C108.006 35.5253 107.858 35.6758 107.805 35.6929C107.532 35.7812 107.486 35.6582 107.427 35.6614C107.145 35.6795 107.453 35.7985 107.491 35.7989C108.095 35.8051 107.96 35.706 108.03 35.67C108.184 35.5921 108.586 35.6278 108.654 35.5629ZM112.954 89.2398C112.996 89.208 113.037 89.1763 113.079 89.1445C112.957 89.1582 112.835 89.1719 112.713 89.1856C112.803 89.2001 112.818 89.2286 112.884 89.2446C112.907 89.243 112.93 89.2414 112.954 89.2398ZM121.227 34.5272C120.848 34.5141 120.512 34.6355 120.716 34.6672C120.836 34.6857 121.167 34.5996 121.085 34.6765C120.525 34.6741 120.577 34.7336 120.585 34.7441C120.641 34.8196 120.223 34.8665 120.259 34.9302C120.279 34.966 120.728 34.9251 120.899 34.925C120.972 34.925 120.978 34.9561 120.991 34.9564C121.159 34.9591 121.257 34.9231 121.428 34.912C121.507 34.907 121.558 34.9516 121.665 34.9294C121.771 34.907 122.092 34.8216 122.112 34.7916C122.147 34.7378 121.831 34.7126 121.568 34.7686C121.44 34.7959 121.524 34.8674 121.157 34.8447C121.108 34.8417 120.91 34.7739 120.725 34.7888C120.956 34.729 121.695 34.6904 122.005 34.6871C122.039 34.6305 121.52 34.679 121.322 34.6631C121.155 34.6497 121.258 34.529 121.227 34.5272ZM103.948 89.701C103.942 89.7056 103.935 89.7101 103.929 89.7147C103.953 89.7464 103.989 89.7869 104.152 89.7814C104.084 89.7546 104.016 89.7278 103.948 89.701ZM110.352 89.3477C110.383 89.3421 110.418 89.337 110.458 89.3325C110.4 89.33 110.343 89.3276 110.286 89.3251C110.308 89.3326 110.33 89.3402 110.352 89.3477ZM132.702 48.4934C132.649 48.6949 132.67 49.4525 132.712 48.9647C132.723 48.8407 132.706 48.6437 132.702 48.4934ZM80.5889 76.3505C80.5882 76.3314 80.5875 76.3124 80.5868 76.2933C80.5842 76.2859 80.5815 76.2785 80.5789 76.2711C80.5822 76.2974 80.5856 76.3244 80.5889 76.3505ZM107.839 89.5453C107.807 89.585 108.296 89.5252 108.401 89.5063C108.446 89.4981 108.479 89.4787 108.517 89.4623C108.508 89.4581 108.499 89.4539 108.489 89.4496C108.402 89.4567 108.323 89.4632 108.254 89.4689C108.124 89.4799 107.993 89.4909 107.863 89.502C107.86 89.5143 107.853 89.5287 107.839 89.5453ZM93.7674 36.4622C93.5536 36.3785 94.4477 36.3414 94.804 36.3359C94.7208 36.3398 94.6366 36.3438 94.5533 36.3479C94.5874 36.3662 94.6162 36.3851 94.6503 36.4034C94.5578 36.4108 94.4662 36.418 94.3737 36.4254C94.4786 36.4407 94.5719 36.4592 94.672 36.4748C94.4235 36.5766 94.4139 36.521 94.0717 36.526C93.8522 36.5293 93.7627 36.5643 93.4891 36.5812C92.2105 36.6604 90.8926 36.7713 89.5835 36.8266C89.5923 36.7521 89.6247 36.7321 89.8679 36.7092C89.8554 36.7318 89.8458 36.7545 89.8342 36.7771C89.9948 36.7607 90.1536 36.7429 90.3105 36.7247C90.1654 36.7196 90.0213 36.7143 89.8799 36.7081C89.9534 36.7014 90.0456 36.6941 90.1609 36.6852C90.2457 36.6786 90.2709 36.6471 90.385 36.6444C90.629 36.6386 90.9367 36.7121 91.2083 36.6738C91.3658 36.6516 91.1658 36.5797 91.5351 36.5831C91.307 36.6558 91.146 36.7168 91.721 36.6614C91.3973 36.626 91.6553 36.6331 91.7799 36.5987C91.858 36.5767 91.3714 36.6097 91.6899 36.5582C91.7545 36.5478 92.7393 36.4599 92.6914 36.5134C92.5898 36.6283 92.5426 36.6183 93.182 36.5215C92.3907 36.5205 93.1282 36.4082 93.4779 36.4207C93.6557 36.4271 93.3405 36.4953 93.7674 36.4622ZM124.509 88.5731C124.68 88.5718 124.86 88.5304 125.04 88.5012C124.987 88.4938 124.934 88.4864 124.881 88.479C124.822 88.5046 124.763 88.5302 124.704 88.5558C124.626 88.5552 124.548 88.5544 124.47 88.5538C124.463 88.5645 124.464 88.5735 124.509 88.5731ZM110.631 35.4286C110.619 35.4074 110.897 35.274 110.458 35.3894C110.307 35.4294 110.326 35.4609 109.926 35.4867C110.298 35.4573 110.214 35.5515 110.252 35.5562C110.563 35.5943 110.945 35.4675 110.896 35.4234C110.881 35.4107 110.644 35.4496 110.631 35.4286ZM107.398 89.5394C107.391 89.54 107.382 89.5406 107.374 89.5412C107.381 89.5414 107.388 89.5415 107.395 89.5417C107.396 89.541 107.397 89.5402 107.398 89.5394ZM123.964 88.6004C124.121 88.6114 124.25 88.6187 124.347 88.5525C124.203 88.5511 124.059 88.5497 123.915 88.5483C123.932 88.5657 123.948 88.5831 123.964 88.6004ZM128.891 36.3448C128.596 36.1145 128.611 36.2091 128.66 36.2908C128.454 36.1542 128.247 36.0267 128.033 35.9069C128.624 36.2793 128.554 36.3483 128.512 36.4295C128.728 36.602 128.617 36.436 128.843 36.6209C128.922 36.687 128.892 36.7156 128.905 36.7301C129.064 36.9058 129.175 36.8484 129.074 36.7477C128.972 36.6462 128.689 36.4619 128.657 36.3819C128.866 36.5076 129.009 36.6574 129.235 36.8328C129.501 37.044 129.336 36.8208 129.245 36.7641C129.064 36.653 129.138 36.7688 128.878 36.5131C128.653 36.2977 129.12 36.5285 128.891 36.3448ZM88.3058 36.8508C88.0927 36.7735 88.8978 36.8003 88.9814 36.7974C89.2257 36.7889 89.2952 36.7353 89.4722 36.7596C89.488 36.7625 89.318 36.8225 89.1994 36.831C89.0797 36.8395 88.3283 36.8576 88.3058 36.8508ZM125.818 88.5659C125.701 88.5599 125.765 88.5087 125.532 88.5456C125.53 88.5433 125.529 88.5409 125.527 88.5386C125.521 88.5024 125.73 88.4619 125.834 88.458C125.838 88.4583 125.814 88.4896 125.84 88.4892C125.877 88.488 125.917 88.4855 125.959 88.4827C126.147 88.4705 126.352 88.4435 126.342 88.5123C126.215 88.4923 126.078 88.5259 125.963 88.5479C125.907 88.559 125.857 88.5679 125.818 88.5659ZM115.704 89.1292C115.727 89.1349 115.741 89.1303 115.744 89.0883C115.709 89.0876 115.674 89.0869 115.639 89.0861C115.661 89.1005 115.682 89.1149 115.704 89.1292ZM103.647 35.8871C103.756 35.9288 103.966 35.9017 104.214 35.8812C104.193 35.8655 104.172 35.8498 104.151 35.8341C103.984 35.8517 103.815 35.8696 103.647 35.8871ZM126.486 35.3307C126.487 35.3308 126.487 35.331 126.488 35.3312C126.548 35.3552 126.609 35.3803 126.669 35.4057C126.75 35.4189 126.833 35.4339 126.914 35.4495C126.878 35.424 126.842 35.3989 126.805 35.3738C126.699 35.3575 126.593 35.3434 126.486 35.3307ZM88.2156 36.8313C87.9159 36.8491 87.6161 36.8668 87.3164 36.8846C87.3167 36.8845 87.3169 36.8845 87.3172 36.8844C87.3303 36.8726 87.3447 36.8609 87.3588 36.849C87.6443 36.8431 87.9301 36.8372 88.2156 36.8313ZM127.246 35.2891C126.907 35.1266 126.329 34.9625 125.93 34.8472C125.693 34.7782 125.71 34.7481 125.467 34.6873C125.105 34.5937 124.459 34.4811 124.106 34.4746C123.979 34.471 124.004 34.5356 124.026 34.5445C124.084 34.5656 124.287 34.5547 124.372 34.5716C124.457 34.5881 124.358 34.6009 124.475 34.6192C124.593 34.6315 125.243 34.7418 125.289 34.7532C125.572 34.7902 125.241 34.6758 125.563 34.7615C125.655 34.9971 124.77 34.6596 124.592 34.6589C123.951 34.6204 124.468 34.7019 124.586 34.7389C124.705 34.7747 124.404 34.7581 124.466 34.7851C124.467 34.7852 124.468 34.7852 124.469 34.7853C124.532 34.8089 124.976 34.8891 125.033 34.8882C125.156 34.8795 124.763 34.7749 125.089 34.8172C125.493 34.9051 125.9 35.0235 126.29 35.1665C126.287 35.1358 126.283 35.105 126.28 35.0745C126.187 35.0521 126.092 35.0307 125.999 35.0114C125.93 34.9805 125.861 34.9506 125.791 34.9216C126.266 34.9002 126.727 35.2333 127.423 35.5033C127.371 35.5129 127.323 35.5265 127.268 35.535C128.209 36.071 127.595 35.7026 127.653 35.6403C127.687 35.6053 127.955 35.8043 128.023 35.8383C128.5 36.0684 127.597 35.4335 127.246 35.2891ZM119.44 34.8638C120.623 34.7083 118.602 34.8174 118.468 34.8609C118.217 34.9433 119.121 34.8582 119.235 34.869C119.347 34.8801 119.284 34.9674 119.601 34.913C119.722 34.8923 119.586 34.8607 119.44 34.8638ZM116.568 35.1013C116.417 35.0826 116.122 35.0415 115.917 35.0934C116.195 35.1084 116.199 35.1359 116.568 35.1013ZM89.8799 36.7081C89.8759 36.7085 89.8717 36.7088 89.8679 36.7092C89.8681 36.7088 89.869 36.7083 89.8693 36.7079C89.8693 36.7078 89.8693 36.7077 89.8693 36.7076C89.8728 36.7077 89.8764 36.708 89.8799 36.7081ZM106.881 89.6672C106.791 89.6717 106.702 89.6762 106.613 89.6808C106.612 89.6821 106.61 89.6838 106.609 89.6852C106.715 89.6817 106.821 89.6781 106.927 89.6746C106.912 89.6721 106.896 89.6696 106.881 89.6672ZM132.729 44.7556C132.585 44.4656 132.706 45.0606 132.665 45.3447C132.665 45.3442 132.665 45.3437 132.665 45.3432C132.653 45.4279 132.573 45.066 132.593 45.4615C132.624 45.7066 132.648 45.501 132.68 45.6178C132.713 45.7357 132.734 46.4439 132.781 46.0308C132.796 45.9025 132.695 44.9799 132.729 44.7556ZM132.696 47.1708C132.723 47.7102 132.802 47.7935 132.742 47.2942C132.73 47.1874 132.713 47.1751 132.696 47.1708ZM80.785 83.1802C80.7615 83.0409 80.6517 82.5606 80.6005 82.0234C80.5098 81.1258 80.426 80.0982 80.6325 80.5719C80.6353 80.5782 80.6371 80.582 80.6376 80.5791C80.6862 80.2546 80.2813 79.5046 80.5519 79.0711C80.5614 79.0558 80.5689 79.0436 80.5694 79.0376C80.5718 79.0118 80.5607 78.9315 80.548 78.8388C80.5274 78.6893 80.5023 78.5066 80.5214 78.4651C80.5373 78.5267 80.5456 78.6212 80.5532 78.7093C80.5579 78.7638 80.5625 78.8159 80.5685 78.8564C80.5765 78.9107 80.5878 78.9457 80.5992 78.9806C80.6158 79.0322 80.6325 79.0841 80.6385 79.1972C80.6537 79.479 80.6085 79.3588 80.5881 79.3045C80.5829 79.2908 80.5793 79.2816 80.5787 79.2839C80.5789 79.2927 80.5791 79.3015 80.5792 79.3103C80.5843 79.5967 80.588 79.8064 80.644 80.0456C80.6657 80.0763 80.6601 80.0146 80.6534 79.9431C80.6478 79.8825 80.6413 79.8145 80.6505 79.79C80.675 79.7341 80.6764 79.9941 80.6771 80.1108C80.6772 80.1354 80.6774 80.1539 80.6777 80.1614C80.6829 80.2358 80.6892 80.2813 80.6946 80.319C80.7056 80.3969 80.7119 80.4418 80.6928 80.643C80.6906 80.6679 80.6858 80.6732 80.6816 80.6776C80.6721 80.6879 80.6661 80.6953 80.7036 80.9323C80.6302 80.7357 80.6288 81.1267 80.6789 81.4065C80.6868 81.4495 80.6985 81.4777 80.7104 81.5065C80.7347 81.5651 80.76 81.6269 80.7575 81.8216C80.7556 81.9259 80.7136 81.9 80.708 81.8698C80.7062 81.8597 80.7059 81.8357 80.7057 81.8081C80.7051 81.753 80.7044 81.6837 80.6906 81.6806C80.6887 81.7788 80.6923 81.8972 80.6969 82.0176C80.6982 82.0502 80.6997 82.083 80.7014 82.1155C80.7087 82.2566 80.7192 82.3932 80.724 82.5007C80.7247 82.5205 80.7214 82.524 80.7178 82.5279C80.681 82.5645 80.7779 83.1092 80.8216 83.1492C80.8275 83.1627 80.8334 83.1736 80.839 83.1823C80.8393 83.2397 80.838 83.288 80.8369 83.3387C80.8363 83.3667 80.8358 83.3954 80.8358 83.4273C80.8358 83.4493 80.836 83.4703 80.836 83.4894C80.7843 83.3599 80.8073 83.3152 80.785 83.1802ZM105.815 35.7362C106.087 35.7034 106.359 35.6708 106.63 35.6382C106.244 35.6664 106.102 35.681 105.885 35.6338C105.862 35.6678 105.838 35.7021 105.815 35.7362ZM129.99 37.2615C129.952 37.358 130.344 37.6871 130.486 37.945C130.53 38.0209 130.159 37.6948 130.459 38.1037C130.459 38.104 130.459 38.1042 130.459 38.1044C130.559 38.2332 130.959 38.7521 131.041 38.9452C131.125 39.0063 130.988 38.5208 130.944 38.4462C130.683 37.966 130.327 37.6729 129.99 37.2615ZM95.3379 36.3605C95.335 36.3606 95.3317 36.3607 95.3288 36.3609C95.333 36.3578 95.337 36.3546 95.3411 36.3516C95.34 36.3545 95.3389 36.3575 95.3379 36.3605ZM104.433 89.9464C104.673 89.9707 105.021 89.8699 104.846 89.8288C104.635 89.7799 104.043 89.9068 104.433 89.9464ZM133.101 52.1987C133.127 52.0128 133.03 51.5696 133.005 51.6926C132.97 51.8654 133.096 52.2355 133.101 52.1987ZM107.751 35.4965C107.456 35.508 107.257 35.5862 107.295 35.6292C107.495 35.6102 107.694 35.591 107.893 35.572C107.846 35.5469 107.798 35.5216 107.751 35.4965ZM124.229 89.1211C123.975 89.2321 124.185 89.2585 123.72 89.1884C124.219 89.062 123.558 89.0312 123.579 88.9391C123.592 88.887 123.815 88.9072 123.89 88.877C124.007 88.8304 123.869 88.7699 124.002 88.7375C124.135 88.7052 124.563 88.7358 124.707 88.7271C124.981 88.7102 125.223 88.666 125.452 88.6516C125.603 88.6421 125.807 88.6508 125.969 88.6571C126.057 88.66 126.134 88.661 126.186 88.6589C126.341 88.6528 126.493 88.6266 126.519 88.6181C126.672 88.5679 126.585 88.5053 126.792 88.4756C126.803 88.5469 127.094 88.6195 126.784 88.7081C126.829 88.7039 126.885 88.7096 126.928 88.7013C127.132 88.6604 127.018 88.5776 127.112 88.5443C127.27 88.487 127.163 88.5843 127.165 88.5881C127.324 88.619 127.243 88.564 127.31 88.5199C127.345 88.4984 127.643 88.3984 127.705 88.3835C127.767 88.3703 127.692 88.4286 127.733 88.4206C127.914 88.3846 128.103 88.3428 128.279 88.2791C128.455 88.2146 128.54 88.1122 128.556 88.2103C128.558 88.2259 128.461 88.274 128.5 88.2988C128.5 88.2989 128.5 88.2991 128.5 88.2993C128.512 88.3072 128.669 88.3132 128.471 88.4145C128.415 88.4428 128.353 88.4677 128.289 88.4888C128.311 88.4684 128.331 88.4481 128.352 88.4276C128.303 88.4423 128.254 88.4565 128.205 88.4702C128.228 88.4276 128.251 88.3831 128.265 88.3442C128.195 88.3267 128.133 88.3961 128.122 88.3982C128.123 88.3983 128.123 88.3984 128.123 88.3985C127.952 88.4325 127.961 88.356 127.854 88.4702C127.97 88.4531 128.085 88.436 128.197 88.4177C128.197 88.4359 128.198 88.4541 128.198 88.4722C128.176 88.4785 128.152 88.4849 128.13 88.491C128.144 88.5016 128.159 88.5121 128.173 88.5226C128.01 88.5645 127.837 88.5864 127.686 88.5964C127.736 88.5645 127.79 88.5282 127.838 88.4943C127.642 88.5603 127.752 88.4888 127.612 88.4979C127.581 88.5905 127.501 88.5892 127.383 88.6074C127.265 88.6251 127.42 88.6567 127.301 88.6878C127.055 88.7533 126.639 88.7101 126.568 88.838C126.254 88.7966 126.645 88.7448 126.666 88.7108C126.76 88.5751 126.118 88.6973 126.009 88.7666C125.996 88.7613 125.985 88.7555 125.975 88.7495C125.922 88.7152 125.896 88.6774 125.7 88.7006C125.389 88.7377 126.052 88.7718 125.63 88.8053C125.348 88.8275 125.394 88.7652 125.256 88.7581C125 88.7453 124.536 88.8001 124.69 88.8769C124.752 88.9078 124.954 88.8533 125.026 88.8851C125.065 88.903 124.952 89.0818 125.206 88.9344C125.231 88.9197 125.11 88.8629 125.305 88.851C125.361 88.8478 125.542 88.895 125.702 88.8697C125.742 88.8634 125.856 88.8303 125.978 88.8064C126.08 88.7877 126.185 88.7724 126.266 88.7784C126.466 88.792 126.154 88.8348 126.229 88.856C126.305 88.8785 126.558 88.8502 126.546 88.9084C126.403 88.9892 126.394 88.8881 126.349 88.8969C126.172 88.9302 126.308 89.0196 126.052 89.0248C126.023 88.9786 126.215 88.847 125.982 88.8633C125.958 88.8649 125.928 88.8683 125.894 88.8738C125.889 88.8754 125.971 88.9054 125.858 88.9232C125.663 88.9537 125.292 88.986 125.056 88.9965C125.065 89.0753 125.356 89.0544 125.498 89.1016C125.178 89.1321 124.82 89.1753 124.594 89.1117C124.716 89.0945 124.838 89.0769 124.959 89.0597C124.817 89.0709 124.674 89.082 124.533 89.0931C124.589 89.0568 124.913 88.9563 124.691 88.9494C124.665 89.0368 124.35 89.0684 124.229 89.1211ZM121.777 88.9428C121.849 88.8502 121.634 88.8505 121.551 88.8566C121.254 88.8782 121.088 88.8116 120.952 88.9065C121.121 88.95 121.253 88.8829 121.339 88.8849C121.527 88.8899 121.523 88.9629 121.777 88.9428ZM95.3832 36.3235C95.3327 36.325 95.2826 36.3272 95.2334 36.3304C95.2403 36.3277 95.2471 36.325 95.254 36.3223C95.1608 36.3207 95.0683 36.3193 94.9751 36.3178C95.0927 36.3047 95.2095 36.2915 95.3261 36.2783C95.3451 36.2934 95.3642 36.3085 95.3832 36.3235ZM108.48 89.6691C108.746 89.7572 109.634 89.6199 109.307 89.5869C109.225 89.592 109.142 89.5971 109.06 89.6022C109.052 89.609 109.043 89.6154 109.014 89.6174C109.014 89.6173 109.013 89.6172 109.013 89.6171C108.938 89.622 108.261 89.596 108.48 89.6691ZM105.903 89.7886C105.364 89.79 104.952 89.9469 105.664 89.8709C105.703 89.8664 105.772 89.7935 105.903 89.7886ZM107.453 89.6965C107.305 89.7144 107.157 89.7326 107.01 89.7507C107.152 89.746 107.295 89.7411 107.437 89.7366C107.442 89.7233 107.447 89.7099 107.453 89.6965ZM115.977 89.1835C115.926 89.1918 115.874 89.2002 115.823 89.2086C115.824 89.2092 115.825 89.2098 115.826 89.2105C115.818 89.2109 115.81 89.2114 115.803 89.2119C115.71 89.2269 115.617 89.2418 115.525 89.2568C115.615 89.2674 115.705 89.2779 115.794 89.2885C115.854 89.2535 115.917 89.2183 115.977 89.1835ZM132.818 48.0885C132.84 48.3396 132.836 48.7425 132.897 48.7928C132.894 48.6032 132.892 48.4134 132.89 48.2238C132.866 48.1791 132.842 48.1333 132.818 48.0885ZM118.959 89.0876C119.125 89.0852 119.334 88.9822 118.952 89.0187C118.935 89.0207 118.792 89.0867 118.684 89.0552C118.659 89.0471 118.651 89.0381 118.646 89.0291C118.609 89.0406 118.571 89.052 118.534 89.0634C118.605 89.0797 118.735 89.0909 118.959 89.0876ZM110.983 35.1699C110.703 35.2294 110.441 35.2483 110.083 35.2545C109.98 35.314 109.877 35.3734 109.775 35.4329C110.327 35.4055 109.926 35.3414 110.407 35.3248C110.469 35.296 110.197 35.3245 110.245 35.3074C110.477 35.2242 110.798 35.2971 111.122 35.2394C111.077 35.2163 111.029 35.1931 110.983 35.1699ZM129.448 87.737C129.264 87.8216 129.077 87.8974 128.889 87.967C128.991 87.8613 129.541 87.6596 129.448 87.737ZM117.226 89.1192C117.438 89.3064 117.899 89.2232 117.88 89.1046C117.754 89.1114 117.627 89.1182 117.501 89.125C117.409 89.123 117.317 89.1211 117.226 89.1192ZM106.751 35.6C106.911 35.5938 107.072 35.5876 107.233 35.5813C107.24 35.57 107.248 35.5587 107.255 35.5475C107.095 35.5538 106.935 35.5598 106.775 35.566C106.768 35.5773 106.759 35.5887 106.751 35.6ZM113.875 89.3328C113.674 89.2915 113.51 89.5203 113.831 89.4056C113.862 89.3945 113.889 89.3363 113.875 89.3328ZM119.769 89.0436C120.064 89.0223 120.348 88.9999 120.644 88.9767C120.608 88.9698 120.599 88.9548 120.588 88.9405C120.409 88.9537 120.23 88.9668 120.052 88.98C119.991 88.9783 119.93 88.9765 119.869 88.9748C119.843 88.9999 119.821 89.027 119.769 89.0436ZM116.19 89.3556C116.219 89.2972 116.208 89.2474 116.033 89.2214C115.99 89.2794 116.084 89.3168 116.19 89.3556ZM103.56 35.7405C103.779 35.7205 104.131 35.7396 104.161 35.6839C103.973 35.6856 103.784 35.6874 103.595 35.6892C103.583 35.7062 103.571 35.7234 103.56 35.7405ZM113.704 35.0307C113.445 35.0368 112.705 35.1783 113.478 35.0892C113.482 35.1057 113.487 35.1221 113.491 35.1386C113.562 35.1027 113.633 35.0666 113.704 35.0307ZM107.217 35.4659C107.322 35.4727 107.426 35.4796 107.529 35.4865C107.632 35.4493 107.737 35.4122 107.841 35.375C107.633 35.4052 107.425 35.4357 107.217 35.4659ZM102.693 35.7741C102.861 35.7565 103.029 35.7391 103.197 35.7215C103.041 35.7221 102.884 35.7223 102.729 35.7229C102.717 35.7399 102.705 35.757 102.693 35.7741ZM123.934 34.5065C123.395 34.4194 123.594 34.4633 123.27 34.498C123.052 34.5239 122.818 34.4803 122.856 34.555C123.233 34.5071 123.872 34.5816 123.934 34.5065ZM116.498 34.9205C116.842 34.8335 115.585 34.8459 115.524 34.9927C115.762 34.9731 116.336 34.9613 116.498 34.9205ZM103.363 90.2292C103.329 90.1918 103.336 90.0763 103.212 90.0678C103.013 90.0547 102.818 90.1168 102.928 90.1661C102.962 90.1809 103.343 90.1905 103.363 90.2292ZM129.365 88.0148C129.567 88.0514 128.9 88.3309 128.622 88.4017C128.685 88.3803 128.749 88.3577 128.812 88.3348C128.779 88.3214 128.75 88.3065 128.717 88.2929C128.785 88.2649 128.853 88.2362 128.921 88.2065C128.835 88.2133 128.756 88.2131 128.674 88.2162C128.825 88.0478 128.853 88.1102 129.108 88.022C129.271 87.9636 129.324 87.9018 129.517 87.8072C130.423 87.3601 131.254 86.7229 131.999 86.0189C132.054 86.089 132.051 86.1246 131.917 86.2661C131.907 86.2395 131.896 86.2136 131.885 86.1876C131.799 86.281 131.713 86.373 131.627 86.4632C131.723 86.4001 131.818 86.3364 131.911 86.2725C131.87 86.3148 131.817 86.3666 131.751 86.4297C131.702 86.4762 131.71 86.5171 131.638 86.5732C131.484 86.6937 131.229 86.76 131.073 86.9104C130.982 86.9971 131.167 86.9868 130.912 87.1343C131.021 86.9677 131.09 86.846 130.733 87.1289C130.979 87.037 130.797 87.1328 130.732 87.2159C130.692 87.2693 131.008 87.0432 130.82 87.2216C130.785 87.2658 130.134 87.7125 130.135 87.6342C130.144 87.4762 130.19 87.4791 129.773 87.782C130.352 87.5322 129.875 87.8935 129.602 87.9798C129.466 88.023 129.67 87.861 129.365 88.0148ZM108.643 89.7959C108.667 89.8032 109.19 89.763 109.2 89.7193C109.11 89.7101 108.48 89.7397 108.643 89.7959ZM114.749 34.997C114.853 34.9503 114.373 34.9747 114.319 34.9891C114.105 35.0462 114.643 35.0437 114.749 34.997ZM129.548 36.8176C129.504 36.7703 129.174 36.4895 129.144 36.4991C129.584 37.0211 129.899 37.1889 129.548 36.8176ZM118.222 89.3878C118.703 89.4476 118.809 89.2713 118.848 89.252C119.048 89.1528 119.085 89.3008 119.129 89.2983C119.337 89.2832 119.105 89.134 119.077 89.1326C118.629 89.1112 118.733 89.2327 118.682 89.274C118.57 89.3637 118.27 89.3118 118.222 89.3878ZM99.3675 90.3806C99.5296 90.4032 99.7832 90.3534 99.6607 90.3211C99.5378 90.2888 99.1671 90.3525 99.3675 90.3806ZM132.718 85.3167C132.907 85.2584 132.431 85.6897 132.381 85.7323C132.246 85.8693 132.248 85.9517 132.121 86.0216C132.109 86.0271 132.163 85.8883 132.225 85.8192C132.292 85.7533 132.702 85.328 132.718 85.3167ZM81.0778 84.4811C81.1711 84.754 81.0451 84.7462 81.0459 84.4359C81.046 84.4244 81.0462 84.4126 81.0462 84.4002C81.0568 84.4232 81.0672 84.4491 81.0778 84.4811ZM106.61 89.9637C106.667 89.9684 106.725 89.9728 106.782 89.9774C106.779 89.9578 106.774 89.9379 106.77 89.9183C106.655 89.9452 106.54 89.9723 106.425 89.9993C106.467 90.0078 106.51 90.0164 106.553 90.0249C106.572 90.0046 106.591 89.984 106.61 89.9637ZM132.785 85.2811C132.934 85.0957 133.076 84.9043 133.21 84.7084C133.21 84.7089 133.21 84.7094 133.209 84.7098C133.214 84.7263 133.218 84.7431 133.222 84.7603C133.083 84.9391 132.937 85.1133 132.785 85.2811ZM108.932 90.334C109.213 90.3583 109.46 90.2208 109.307 90.1782C109.218 90.1535 108.974 90.2488 109.033 90.1587C109.448 90.1747 109.407 90.1026 109.401 90.0898C109.357 89.9982 109.666 89.9518 109.638 89.8748C109.622 89.8315 109.291 89.87 109.164 89.8661C109.111 89.8643 109.105 89.8282 109.095 89.8266C109.095 89.8266 109.094 89.8267 109.094 89.8267C108.969 89.8195 108.898 89.8601 108.772 89.8695C108.714 89.8736 108.674 89.8192 108.596 89.8432C108.518 89.8676 108.282 89.9619 108.268 89.9973C108.243 90.0609 108.479 90.0984 108.672 90.0377C108.766 90.0081 108.702 89.9205 108.975 89.9561C109.011 89.9608 109.16 90.0464 109.296 90.0331C109.126 90.0991 108.58 90.1281 108.35 90.1248C108.326 90.1917 108.711 90.1455 108.858 90.1691C108.983 90.1889 108.909 90.3306 108.932 90.334ZM116.76 89.5023C116.77 89.5278 116.567 89.681 116.889 89.5531C117 89.5089 116.986 89.4709 117.281 89.4493C117.006 89.4756 117.066 89.3654 117.038 89.3587C116.807 89.306 116.526 89.4486 116.564 89.5024C116.575 89.518 116.75 89.477 116.76 89.5023ZM131.911 86.2725C131.913 86.2704 131.915 86.2681 131.917 86.2661C131.917 86.2665 131.918 86.2669 131.918 86.2673C131.916 86.2688 131.913 86.2709 131.911 86.2725ZM121.924 89.1162C121.842 89.064 121.687 89.0914 121.504 89.1102C121.52 89.1295 121.536 89.1486 121.552 89.1679C121.676 89.1508 121.801 89.1333 121.924 89.1162ZM128.198 88.4722C128.2 88.4716 128.203 88.4709 128.205 88.4702C128.203 88.4745 128.199 88.4791 128.197 88.4833C128.197 88.4797 128.198 88.4758 128.198 88.4722ZM93.745 90.9047C93.5941 90.8377 93.0333 90.8451 93.3963 90.9065C93.4885 90.9219 93.6339 90.9065 93.745 90.9047ZM103.266 90.6276C103.526 90.6251 103.476 90.5514 103.412 90.508C103.584 90.4879 103.755 90.4696 103.926 90.4504C103.435 90.4732 103.443 90.382 103.428 90.2683C103.228 90.2641 103.367 90.337 103.158 90.3358C103.084 90.3352 103.085 90.287 103.071 90.2838C102.9 90.2481 102.875 90.3899 102.976 90.3992C103.079 90.4084 103.316 90.3658 103.37 90.4198C103.201 90.4548 103.054 90.4257 102.853 90.4517C102.614 90.4828 102.809 90.5428 102.882 90.5208C103.028 90.4766 102.934 90.4263 103.192 90.4616C103.413 90.4918 103.061 90.6294 103.266 90.6276ZM120.322 89.2463C120.121 89.2791 119.92 89.3118 119.72 89.3445C120.005 89.3197 120.11 89.3057 120.273 89.3671C120.289 89.3269 120.305 89.2865 120.322 89.2463ZM128.173 88.5226C128.212 88.5126 128.251 88.5015 128.288 88.4892C128.284 88.4934 128.279 88.4978 128.275 88.5021C128.348 88.4878 128.421 88.4726 128.495 88.4564C128.407 88.4941 128.319 88.5307 128.231 88.5657C128.211 88.5515 128.193 88.5369 128.173 88.5226ZM105.08 90.1929C105.033 90.1945 104.985 90.196 104.939 90.1974C104.883 90.2224 104.826 90.2476 104.77 90.2727C104.801 90.2814 104.833 90.29 104.865 90.2987C104.937 90.2635 105.007 90.2281 105.08 90.1929ZM112.369 89.7559C112.481 89.7818 112.701 89.8376 112.851 89.7805C112.645 89.7561 112.641 89.7231 112.369 89.7559ZM118.893 89.4878C119.111 89.481 119.257 89.3924 119.227 89.3401C119.08 89.3582 118.932 89.3764 118.785 89.3945C118.821 89.4256 118.857 89.4567 118.893 89.4878ZM110.246 89.9729C109.374 90.1315 110.871 90.0478 110.968 89.999C111.151 89.9064 110.482 89.9873 110.399 89.9716C110.316 89.9556 110.359 89.8529 110.126 89.9106C110.038 89.9325 110.138 89.9732 110.246 89.9729ZM104.624 90.6203C104.882 90.6056 105.291 90.5153 105.58 90.4987C105.751 90.489 105.747 90.5295 105.919 90.5197C106.177 90.5053 106.629 90.4875 106.87 90.4488C106.958 90.4346 106.933 90.3617 106.916 90.3542C106.873 90.3366 106.736 90.3817 106.675 90.3782C106.615 90.3746 106.68 90.3405 106.597 90.3416C106.514 90.3427 106.056 90.3806 106.023 90.3881C105.827 90.4334 106.071 90.4602 105.839 90.4658C105.721 90.2172 106.392 90.3399 106.511 90.319C106.957 90.2405 106.589 90.2405 106.5 90.2237C106.412 90.2069 106.624 90.1629 106.576 90.1444C106.576 90.1445 106.575 90.1446 106.574 90.1448C106.526 90.1261 106.204 90.1378 106.166 90.1579C106.083 90.2015 106.373 90.217 106.142 90.2561C105.851 90.2663 105.552 90.2763 105.258 90.2866C105.269 90.3193 105.281 90.352 105.291 90.3847C105.357 90.3699 105.425 90.3547 105.491 90.3397C105.544 90.3474 105.597 90.3552 105.65 90.3627C105.348 90.5633 104.96 90.3801 104.441 90.492C104.468 90.4519 104.492 90.4104 104.522 90.3712C103.755 90.3639 104.264 90.388 104.253 90.484C104.247 90.539 104.013 90.501 103.96 90.5124C103.597 90.5928 104.365 90.6352 104.624 90.6203ZM119.631 89.3874C119.512 89.3911 119.393 89.3947 119.275 89.3984C119.27 89.4118 119.264 89.4254 119.259 89.4386C119.378 89.4348 119.496 89.4313 119.614 89.4275C119.619 89.4142 119.626 89.4007 119.631 89.3874ZM116.507 89.8033C116.713 89.7388 116.906 89.7222 117.171 89.723C117.246 89.6544 117.321 89.5859 117.395 89.5174C116.986 89.5373 117.286 89.6228 116.929 89.6315C116.884 89.6645 117.085 89.6367 117.05 89.656C116.88 89.7502 116.64 89.6556 116.402 89.717C116.436 89.7457 116.472 89.7745 116.507 89.8033ZM102.275 90.726C102.239 90.6114 101.888 90.7024 101.683 90.6548C101.622 90.6399 101.961 90.5268 101.601 90.5137C101.484 90.5096 101.023 90.5615 100.874 90.5366C100.809 90.5847 101.159 90.7443 101.217 90.7533C101.597 90.8105 101.903 90.6918 102.275 90.726ZM96.5166 91.0243C96.727 90.8592 96.2894 90.9895 96.0777 90.9341C96.0152 90.9173 96.2816 90.8313 95.9901 90.8454C95.8093 90.8763 95.9616 90.9102 95.8761 90.9461C95.7897 90.9819 95.2646 90.9908 95.5724 91.0569C95.6679 91.0773 96.3489 90.9785 96.5166 91.0243ZM94.7251 90.9293C94.3261 90.949 94.2669 91.0403 94.6353 90.9811C94.7139 90.9685 94.7224 90.9491 94.7251 90.9293ZM121.992 89.2938C121.831 89.3125 121.569 89.2814 121.549 89.3471C121.688 89.3495 121.828 89.3518 121.967 89.354C121.976 89.334 121.985 89.3139 121.992 89.2938ZM122.634 89.2735C122.511 89.2907 122.386 89.3077 122.262 89.3248C122.378 89.3277 122.494 89.3309 122.609 89.3339C122.618 89.3138 122.626 89.2936 122.634 89.2735ZM119.289 89.5369C119.212 89.5264 119.135 89.5156 119.058 89.5051C118.982 89.5471 118.906 89.5891 118.83 89.6311C118.983 89.5998 119.136 89.5682 119.289 89.5369ZM114.494 89.9066C114.687 89.905 115.229 89.7535 114.66 89.842C114.656 89.8222 114.652 89.8024 114.648 89.7826C114.597 89.8238 114.546 89.8654 114.494 89.9066ZM94.0484 91.053C93.8629 91.074 93.5645 91.0599 93.5291 91.1311C93.6694 91.1327 93.8097 91.1345 93.95 91.1361C93.9825 91.1084 94.0159 91.0806 94.0484 91.053ZM112.426 89.9733C112.173 90.0693 113.105 90.0841 113.146 89.91C112.97 89.9279 112.546 89.9284 112.426 89.9733ZM113.72 89.9227C113.644 89.976 113.998 89.9581 114.039 89.9422C114.196 89.8789 113.797 89.8693 113.72 89.9227ZM106.984 90.3869C107.364 90.4307 107.222 90.4016 107.444 90.34C107.594 90.2983 107.76 90.3535 107.731 90.2637C107.467 90.3106 107.018 90.2852 106.984 90.3869ZM102.709 90.7199C102.752 90.722 103.054 90.7082 103.063 90.6785C102.587 90.5537 102.353 90.7029 102.709 90.7199Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M122.985 59.8655L113.36 60.4458L121.405 55.1309L119.384 52.0699L111.338 57.3847L115.647 48.7601L112.365 47.1197L108.057 55.7444L107.476 46.1206L103.815 46.3413L104.396 55.966L99.0799 47.9207L96.0198 49.9425L101.335 57.9869L92.7092 53.678L91.0698 56.9589L99.6951 61.2687L90.0707 61.8489L90.2915 65.5102L99.915 64.93L91.8707 70.2448L93.8925 73.3059L101.937 67.9919L97.6271 76.6166L100.909 78.256L105.218 69.6305L105.799 79.2551L109.46 79.0344L108.88 69.4107L114.193 77.4551L117.254 75.4333L111.94 67.388L120.565 71.6978L122.204 68.416L113.58 64.1071L123.203 63.5269L122.983 59.8656L122.985 59.8655ZM106.938 67.6672C104.178 67.8337 101.805 65.7311 101.639 62.9703C101.472 60.2096 103.575 57.8371 106.336 57.6706C109.096 57.5042 111.469 59.607 111.635 62.3677C111.801 65.1284 109.699 67.5008 106.938 67.6672Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M79.8862 43.1973C82.7846 45.0075 84.4952 48.4161 83.9666 52.0133L80.886 72.9769C80.5274 72.0368 80.324 71.0191 80.3072 69.9547L79.8862 43.1973Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M152.163 41.95C152.422 42.1727 157.679 41.5416 156.414 40.7276C156.007 40.3685 155.55 40.383 155.288 40.8755C155.355 39.9005 154.106 41.1453 153.715 40.8078C154.029 40.1402 152.331 41.483 152.754 40.7931C147.444 39.8042 134.971 45.8342 149.285 42.5314C148.017 42.1648 149.336 41.9571 149.903 42.1348C148.852 42.9578 151.526 42.3273 152.055 42.0509C151.274 42.0312 152.697 41.4548 152.161 41.9477L152.163 41.95Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M144.103 33.2987C144.826 33.2902 148.886 28.6898 149.364 28.2563C150.233 27.1752 148.612 27.0082 148.131 27.9422C147.96 28.0977 147.191 29.4236 146.989 28.83C145.525 29.0606 144.786 31.4609 143.573 31.5539C143.69 31.8803 143.187 32.2387 143.235 32.4555C142.892 32.4019 142.593 32.851 142.668 32.8962C140.902 34.0119 142.442 35.5039 143.632 33.8363C143.677 33.9123 144.152 33.631 144.102 33.3032L144.103 33.2987Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M127.951 23.5219C127.133 24.2779 127.365 23.4494 127.768 23.0838C128.184 23.8171 128.556 22.1695 128.459 21.7379C128.385 21.9073 128.074 21.9198 128.207 21.5664C128.861 21.9306 130.489 17.4535 128.262 19.3334C128.24 19.4107 128.809 19.5378 128.599 19.599C127.769 19.307 128.15 20.1124 128.152 20.3224C127.697 20.2448 128.058 20.5024 127.853 20.5223C127.319 20.1801 127.968 21.4947 127.451 21.121C126.178 22.0024 126.739 24.2402 125.63 24.8919C126.478 25.6001 123.857 28.6536 126.237 27.6949C127.149 26.3436 127.783 25.2187 127.951 23.5219Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M141.26 16.6354C139.968 16.0531 139.255 19.1998 138.4 19.9494C137.24 20.8363 130.777 31.3271 134.487 28.9268C136.417 25.7404 138.534 23.3591 140.406 19.293C140.758 18.6458 142.275 16.7035 141.26 16.6354Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M142.897 51.6418C141.713 52.6636 141.02 51.0539 139.942 51.8779C138.193 53.5089 148.442 55.7454 148.714 53.8345C148.718 52.1988 143.419 52.438 142.897 51.6418Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M34.0511 21.4768C34.2527 21.2013 33.2103 16.0093 32.4983 17.3346C32.1723 17.7687 32.2227 18.2234 32.7342 18.4455C31.757 18.4552 33.0961 19.603 32.7904 20.0191C32.1002 19.759 33.5723 21.3456 32.8512 20.9785C32.2828 26.35 39.2746 38.31 34.8569 24.2999C34.5911 25.5931 34.2804 24.2942 34.413 23.7151C35.3161 24.6984 34.4773 22.0823 34.1602 21.5767C34.2019 22.3562 33.5154 20.9832 34.0489 21.4788L34.0511 21.4768Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M26.0595 30.1916C25.9942 29.4715 21.0889 25.7855 20.6193 25.3436C19.4732 24.562 19.4342 26.1915 20.403 26.5975C20.5714 26.7551 21.9537 27.4177 21.3778 27.666C21.7228 29.1074 24.1738 29.6551 24.3617 30.8568C24.678 30.7147 25.0748 31.1878 25.2873 31.1236C25.2607 31.4691 25.7319 31.7319 25.7711 31.6538C27.0221 33.3266 28.3884 31.6739 26.6325 30.6184C26.7047 30.5685 26.3869 30.1163 26.0641 30.1922L26.0595 30.1916Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M17.583 47.0616C18.401 47.8181 17.5568 47.6517 17.1607 47.2789C17.859 46.8064 16.1872 46.5647 15.7646 46.6957C15.9394 46.7564 15.9762 47.0647 15.6134 46.9599C15.9251 46.2791 11.3339 45.0084 13.383 47.0808C13.4619 47.097 13.5438 46.5198 13.6214 46.7245C13.3954 47.5741 14.1684 47.1313 14.3777 47.1132C14.336 47.573 14.5644 47.192 14.6005 47.3953C14.3013 47.9545 15.5608 47.2038 15.2289 47.7488C16.2076 48.9483 18.3943 48.213 19.1312 49.2674C19.7707 48.367 23.0207 50.7398 21.8778 48.4424C20.4591 47.6393 19.2878 47.0962 17.583 47.0616Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M9.67164 34.335C9.19267 35.669 12.3858 36.1327 13.2002 36.9259C14.1755 38.0131 25.1419 43.6314 22.4575 40.1213C19.1292 38.4474 16.5888 36.5239 12.3882 34.9777C11.7153 34.6782 9.65976 33.3177 9.67164 34.335Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M44.4412 29.9519C45.553 31.0521 44.0027 31.8695 44.9089 32.8789C46.6723 34.4945 48.0962 24.1012 46.1699 23.9803C44.539 24.1056 45.1939 29.3686 44.4412 29.9519Z",
                fill: "#101214"
            })
        ]
    });



var $5dK2X = parcelRequire("5dK2X");

const $6b2be4d3f29fcd62$var$fadeIn = null;
const $6b2be4d3f29fcd62$var$styles = {
    loginButtonWrapper: "_19pkxy5q",
    parentDiv: "_1e0c1n7u _4cvr1h6o _6a6z1h6o",
    refreshBannerFade: "_ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k _j7hq1wwu _5sagi11n",
    loomHeading: "_11c8nf1z _k48p1pd9 _syazi7uo",
    loomLoginButton: "_2rko1tm3 _11c81ixg _v5642hjt _1bsb842n _4t3i8vuz _bfhk1856 _syaz15cr _k48p1pd9 _o7ks2hjt _irr3hf2y _1di6g6ey"
};
const $6b2be4d3f29fcd62$var$SUCCESS_URL_SUFFIX = '/wiki/embed/login-confirmation';
const $6b2be4d3f29fcd62$export$f14c0e3f98d164c0 = ({ contentId: contentId, parentProduct: parentProduct, reloadEP: reloadEP, spaceKey: spaceKey, url: url })=>{
    const { locale: locale, formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const { cancelIframeLoadMetrics: cancelIframeLoadMetrics } = (0, $kudeD.usePerformanceMetrics)();
    (0, $42omo.useEffect)(()=>{
        cancelIframeLoadMetrics();
    }, [
        cancelIframeLoadMetrics
    ]);
    const loginUrl = (0, $42omo.useMemo)(()=>{
        const origin = url ? new URL(url).origin : window?.location?.origin;
        const uniqueKeyParam = uniqueKey && (0, $dh538.fg)('platform_deprecate_lp_cc_embed') ? `&uniqueKey=${uniqueKey}` : '';
        return `${origin}/login?application=confluence&dest-url=${encodeURIComponent(`${$6b2be4d3f29fcd62$var$SUCCESS_URL_SUFFIX}?locale=${locale}`)}${uniqueKeyParam}`;
    }, [
        url,
        locale,
        uniqueKey
    ]);
    const isLoomParentProduct = parentProduct === 'loom' && (0, $dh538.fg)('mr2-meeting-recording-notes-confluence');
    const handleClick = ()=>{
        $6b2be4d3f29fcd62$var$openLoginPopup(loginUrl);
        setDisplayRefreshBanner(!displayRefreshBanner);
    };
    const [displayRefreshBanner, setDisplayRefreshBanner] = (0, $42omo.useState)(false);
    return isLoomParentProduct ? /*#__PURE__*/ (0, $l998X.jsx)($6b2be4d3f29fcd62$export$e65dcd3f2d7567ae, {
        contentId: contentId,
        formatMessage: formatMessage,
        handleClick: handleClick,
        displayRefreshBanner: displayRefreshBanner,
        reloadEP: reloadEP,
        spaceKey: spaceKey
    }) : /*#__PURE__*/ (0, $l998X.jsx)($6b2be4d3f29fcd62$export$50083a1d14fa7d72, {
        contentId: contentId,
        formatMessage: formatMessage,
        handleClick: handleClick,
        displayRefreshBanner: displayRefreshBanner,
        reloadEP: reloadEP,
        spaceKey: spaceKey
    });
};
const $6b2be4d3f29fcd62$export$e65dcd3f2d7567ae = ({ contentId: contentId, displayRefreshBanner: displayRefreshBanner, formatMessage: formatMessage, handleClick: handleClick, reloadEP: reloadEP, spaceKey: spaceKey })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        "data-testid": "login-page-test-id",
        className: (0, $gMc0m.default)([
            $6b2be4d3f29fcd62$var$styles.parentDiv
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $9HehF.ExperienceStart), {
                name: (0, $7pThu.ExperienceNames).LOGIN_PAGE,
                id: `${spaceKey}-${contentId}-loom`
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.400",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        space: "space.200",
                        alignInline: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $e7b6f154db87a25a$export$b8ca9c7db864e9fb), {}),
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                space: "space.100",
                                alignInline: "center",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                                        as: "h2",
                                        size: "large",
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            xcss: $6b2be4d3f29fcd62$var$styles.loomHeading,
                                            children: formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).connectToConfluenceHeading)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                        color: "color.text.subtlest",
                                        size: "medium",
                                        children: formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).connectToConfluenceDescription)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                        xcss: $6b2be4d3f29fcd62$var$styles.loomLoginButton,
                        onClick: handleClick,
                        testId: "connect-confluence-button",
                        "aria-label": formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).connectConfluenceButtonAriaLabel),
                        children: formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).connectConfluenceButton)
                    })
                ]
            }),
            displayRefreshBanner && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $6b2be4d3f29fcd62$var$styles.refreshBannerFade
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6035301bc49c38a6$export$2e2bcd8739ae039), {
                    reloadEP: reloadEP,
                    title: formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).refreshBanner),
                    actionLabel: formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).refreshBannerLink)
                })
            })
        ]
    });
};
const $6b2be4d3f29fcd62$export$50083a1d14fa7d72 = ({ contentId: contentId, displayRefreshBanner: displayRefreshBanner, formatMessage: formatMessage, handleClick: handleClick, reloadEP: reloadEP, spaceKey: spaceKey })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        "data-testid": "login-page-test-id",
        className: (0, $gMc0m.default)([
            $6b2be4d3f29fcd62$var$styles.parentDiv
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $9HehF.ExperienceStart), {
                name: (0, $7pThu.ExperienceNames).LOGIN_PAGE,
                id: `${spaceKey}-${contentId}`
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.250",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceLogo), {
                        size: "large",
                        appearance: "brand"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $db080d242cf20bf8$export$ae31f6824db63a1c), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                        as: "h2",
                        size: "large",
                        children: formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).loginText)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $6b2be4d3f29fcd62$var$styles.loginButtonWrapper,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    testId: "login-button",
                    "aria-label": formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).loginAriaLabel),
                    appearance: "primary",
                    onClick: handleClick,
                    children: formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).loginButton)
                })
            }),
            displayRefreshBanner && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $6b2be4d3f29fcd62$var$styles.refreshBannerFade
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6035301bc49c38a6$export$2e2bcd8739ae039), {
                    reloadEP: reloadEP,
                    title: formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).refreshBanner),
                    actionLabel: formatMessage((0, $30be43982da321bc$export$2e2bcd8739ae039).refreshBannerLink)
                })
            })
        ]
    });
};
function $6b2be4d3f29fcd62$var$openLoginPopup(loginUrl) {
    const windowFeatures = 'popup=yes,left=100,top=100,width=640,height=640';
    window.open(loginUrl, '_blank', windowFeatures);
}


/* StorageAccessPage.tsx generated by @compiled/babel-plugin v0.36.1 */ 


























const $99760c79a6ed56be$var$iframeStyles = null;
const $99760c79a6ed56be$export$64a8a56a2c35628c = ({ contentId: contentId, spaceKey: spaceKey, url: url, parentProduct: parentProduct })=>{
    const { locale: locale } = (0, $8C5kA.default)();
    const iframeRef = (0, $42omo.useRef)(null);
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const { cancelIframeLoadMetrics: cancelIframeLoadMetrics } = (0, $kudeD.usePerformanceMetrics)();
    (0, $42omo.useEffect)(()=>{
        cancelIframeLoadMetrics();
    }, [
        cancelIframeLoadMetrics
    ]);
    const src = (0, $42omo.useMemo)(()=>{
        const uniqueKeyParam = uniqueKey && (0, $dh538.fg)('platform_deprecate_lp_cc_embed') ? `&uniqueKey=${uniqueKey}` : '';
        const path = `/wiki/embed/storage-access?parentProduct=${parentProduct}&locale=${locale}${uniqueKeyParam}`;
        const origin = url ? new URL(url).origin : window.location.origin;
        return [
            origin,
            path
        ].join('');
    }, [
        locale,
        parentProduct,
        url,
        uniqueKey
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $9HehF.ExperienceStart), {
                name: (0, $7pThu.ExperienceNames).STORAGE_ACCESS_PAGE,
                id: `${spaceKey}-${contentId}`
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("iframe", {
                "data-testid": "storage-access-page-iframe",
                title: "storage-access-iframe",
                src: src,
                ref: iframeRef,
                className: (0, $gMc0m.default)([
                    "_19itglyw _1bsb1osq _4t3i1osq"
                ])
            })
        ]
    });
};






var $3WsBD = parcelRequire("3WsBD");
















var $dc5325553138ea46$export$29953e2fb702813a = /*#__PURE__*/ function(Subjects) {
    Subjects["STORAGE_ACCESS"] = "storage-access";
    Subjects["LOGIN_CONFIRMATION"] = "login-confirmation";
    Subjects["CONTENT_LOAD"] = "content-load";
    return Subjects;
}({});
var $dc5325553138ea46$export$19d37de7e9a4af59 = /*#__PURE__*/ function(LoadingStatus) {
    LoadingStatus["IFRAME_LOADED"] = "iframe-loaded";
    LoadingStatus["IFRAME_UNLOADED"] = "iframe-unloaded";
    LoadingStatus["CONTENT_LOAD_STARTED"] = "content-load-started";
    LoadingStatus["REDIRECTED_TO_LOGIN"] = "redirected-to-login";
    LoadingStatus["RELOAD_EP"] = "reload-ep";
    return LoadingStatus;
}({});
var $dc5325553138ea46$export$12bf62de6f1fdb01 = /*#__PURE__*/ function(StorageAccessStatus) {
    StorageAccessStatus["GRANTED"] = "granted";
    StorageAccessStatus["REJECTED"] = "rejected";
    StorageAccessStatus["NOT_SUPPORTED"] = "not-supported";
    StorageAccessStatus["ERROR"] = "error";
    return StorageAccessStatus;
}({});
var $dc5325553138ea46$export$889a6bd688f4360e = /*#__PURE__*/ function(UserLoginStatus) {
    UserLoginStatus["SUCCESS"] = "success";
    return UserLoginStatus;
}({});
/* NOTE: (Refer this table for understanding the behavior
  on different browsers: https://hello.atlassian.net/wiki/spaces/~288141084/pages/2154391293/Conditions+to+load+EP)
*/ function $dc5325553138ea46$var$pageLoadValidationReducer(state, action) {
    //NOTE: We assume that storage access and user login is required at the load of the PageLoadValidation component
    switch(action.subject){
        case "storage-access":
            switch(action.status){
                case "granted":
                    /*If storage access is granted, refresh app, if user is logged in, try to load EP. If not, load Login CTA
					 */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskStorageAccess: false
                    };
                case "rejected":
                    /*If storage access is reject, it could mean either of the two things:
          1. (For Safari): User has storage access but may not be logged in, Try loggin user in
          2. (For Firefox, Edge): User may be logged in but storage access is not yet granted by the browser
          In both these case, ask user to login.
          */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskStorageAccess: false,
                        shouldAskToLogin: true
                    };
                case "not-supported":
                    /* This case is specific for Chrome where storage access is not supported.
          So we can skip asking for storage access and direct user to the Login CTA.
          */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskToLogin: true,
                        shouldAskStorageAccess: false
                    };
                case "error":
                    /** To catch any other errors while requesting storage access */ return {
                        ...state
                    };
            }
            break;
        case "login-confirmation":
            switch(action.status){
                case "success":
                    /*
          If user has logged in, it means that storage access is granted. Refresh app, Try loading EP
          */ return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false,
                        shouldAskToLogin: false,
                        iframeUnloaded: false,
                        redirectedToLogin: false
                    };
            }
            break;
        case "content-load":
            //These states are set only when the user has navigated throught the storage access and login flows. So try to load EP
            switch(action.status){
                case "iframe-loaded":
                    return {
                        ...state,
                        iframeLoaded: true
                    };
                case "content-load-started":
                    return {
                        ...state,
                        contentLoadStarted: true
                    };
                case "iframe-unloaded":
                    return {
                        ...state,
                        iframeUnloaded: true
                    };
                case "redirected-to-login":
                    return {
                        ...state,
                        redirectedToLogin: true
                    };
                case "reload-ep":
                    return {
                        ...state,
                        iframeLoaded: false,
                        contentLoadStarted: false
                    };
            }
            break;
    }
}
const $dc5325553138ea46$export$1faa35b5a06780c0 = ()=>{
    const initialState = {
        iframeLoaded: false,
        contentLoadStarted: false,
        shouldAskStorageAccess: true,
        shouldAskToLogin: true,
        redirectedToLogin: false,
        iframeUnloaded: false
    };
    const [state, dispatch] = (0, $42omo.useReducer)($dc5325553138ea46$var$pageLoadValidationReducer, initialState);
    const experienceTracker = (0, $42omo.useContext)((0, $jJf3a.ExperienceTrackerContext));
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const messageListener = (0, $42omo.useCallback)((messageEvent)=>{
        const { subject: subject, result: result, embeddedConfluenceUrl: embeddedConfluenceUrl } = messageEvent.data ?? {};
        const messageKey = embeddedConfluenceUrl && (0, $dh538.fg)('platform_deprecate_lp_cc_embed') ? new URL(embeddedConfluenceUrl).searchParams.get('uniqueKey') : null;
        if (!subject || !result || messageKey && uniqueKey && messageKey !== uniqueKey && (0, $dh538.fg)('platform_deprecate_lp_cc_embed')) return;
        switch(subject){
            case "storage-access":
                switch(result){
                    case "granted":
                        experienceTracker.succeed({
                            name: (0, $7pThu.ExperienceNames).STORAGE_ACCESS_PAGE
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "granted"
                        });
                        break;
                    case "rejected":
                        experienceTracker.abort({
                            name: (0, $7pThu.ExperienceNames).STORAGE_ACCESS_PAGE,
                            reason: (0, $7pThu.ExperienceReasons).STORAGE_ACCESS_REJECTED
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "rejected"
                        });
                        break;
                    case "not-supported":
                        experienceTracker.abort({
                            name: (0, $7pThu.ExperienceNames).STORAGE_ACCESS_PAGE,
                            reason: (0, $7pThu.ExperienceReasons).STORAGE_ACCESS_NOT_SUPPORTED
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "not-supported"
                        });
                        break;
                    case "error":
                        experienceTracker.fail({
                            name: (0, $7pThu.ExperienceNames).STORAGE_ACCESS_PAGE,
                            error: new Error((0, $7pThu.ExperienceReasons).STORAGE_ACCESS_ERROR)
                        });
                        dispatch({
                            subject: "storage-access",
                            status: "error"
                        });
                        break;
                }
                break;
            case "login-confirmation":
                switch(result){
                    case "success":
                        experienceTracker.succeed({
                            name: (0, $7pThu.ExperienceNames).LOGIN_PAGE
                        });
                        dispatch({
                            subject: "login-confirmation",
                            status: "success"
                        });
                        break;
                }
                break;
        }
    }, [
        experienceTracker,
        uniqueKey
    ]);
    (0, $42omo.useEffect)(()=>{
        window.addEventListener('message', messageListener);
        return ()=>window.removeEventListener('message', messageListener);
    }, [
        messageListener
    ]);
    return {
        state: state,
        dispatch: dispatch
    };
};





const $81cee89a8418d895$var$noop = ()=>{};
const $81cee89a8418d895$export$3b0759108d92fe77 = (props)=>{
    const { standaloneConfluenceUrl: standaloneConfluenceUrl, embeddedConfluenceUrl: embeddedConfluenceUrl } = (0, $3WsBD.useUrl)(props);
    const { state: { contentLoadStarted: contentLoadStarted, iframeLoaded: iframeLoaded } } = (0, $dc5325553138ea46$export$1faa35b5a06780c0)();
    const isEmbeddedUrlOnSameDomain = embeddedConfluenceUrl ? window.location.origin === new URL(embeddedConfluenceUrl).origin : false;
    const unusedIframeRef = (0, $42omo.useRef)(null);
    return isEmbeddedUrlOnSameDomain ? props.children({
        isLoading: contentLoadStarted && !iframeLoaded || false,
        iframeLoaded: iframeLoaded || true,
        iframeRef: unusedIframeRef,
        handleIframeOnLoad: $81cee89a8418d895$var$noop,
        handleContentLoadStarted: $81cee89a8418d895$var$noop,
        handleIframeUnload: $81cee89a8418d895$var$noop,
        navigationPolicy: props.navigationPolicy
    }) : /*#__PURE__*/ (0, $l998X.jsx)($81cee89a8418d895$var$CrossDomainErrorValidation, {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl,
        allowedFeatures: props.allowedFeatures,
        ...props
    }, embeddedConfluenceUrl || props.contentId);
};
const $81cee89a8418d895$var$CrossDomainErrorValidation = ({ allowedFeatures: allowedFeatures, children: children, contentId: contentId, embeddedConfluenceUrl: embeddedConfluenceUrl, navigationPolicy: navigationPolicy, parentProduct: parentProduct, spaceKey: spaceKey, standaloneConfluenceUrl: standaloneConfluenceUrl })=>{
    const { state: state, dispatch: dispatch } = (0, $dc5325553138ea46$export$1faa35b5a06780c0)();
    const { iframeLoaded: iframeLoaded, contentLoadStarted: contentLoadStarted, shouldAskStorageAccess: shouldAskStorageAccess, shouldAskToLogin: shouldAskToLogin, redirectedToLogin: redirectedToLogin, iframeUnloaded: iframeUnloaded } = state;
    const iframeRef = (0, $42omo.useRef)(null);
    /* This ref is specifically used for the purpose of recoding whether or not a delayed dispatch of the iframe occured.
		This recorded value is later used to fire analytics if contentLoadStarted arrives after the delayed dispatch, and reset
		once the event has fired or if the users needs to go through login flow.
	*/ const iframeLoadedWithDelayRef = (0, $42omo.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isLoginFlowDisabled = (0, $42omo.useMemo)(()=>allowedFeatures?.includes('disable-login-flow') ?? false, [
        allowedFeatures
    ]);
    const reloadEP = (0, $42omo.useCallback)(()=>{
        dispatch({
            subject: (0, $dc5325553138ea46$export$29953e2fb702813a).CONTENT_LOAD,
            status: (0, $dc5325553138ea46$export$19d37de7e9a4af59).RELOAD_EP
        });
    }, [
        dispatch
    ]);
    const failToLoad = (0, $42omo.useMemo)(()=>iframeLoaded && !contentLoadStarted || /*
      If anonymous access is permitted globally but restricted on a content's parent space,
      the iframe will attempt a login redirect which we intercept.
      To avoid an error in the iframe, we need to wait for the iframe window to unload
      before unmouting the Iframe component.
    */ iframeUnloaded && redirectedToLogin, [
        contentLoadStarted,
        iframeLoaded,
        iframeUnloaded,
        redirectedToLogin
    ]);
    const pageNavigationPolicy = (0, $42omo.useMemo)(()=>({
            navigate (url, modifiers, defaultNavigate) {
                // modifiy the navigationPolicy to intercept login redirects
                // so that login can be handled outside of the iframe
                if (url.includes('/login?application=confluence')) {
                    dispatch({
                        subject: (0, $dc5325553138ea46$export$29953e2fb702813a).CONTENT_LOAD,
                        status: (0, $dc5325553138ea46$export$19d37de7e9a4af59).REDIRECTED_TO_LOGIN
                    });
                    return;
                }
                return navigationPolicy?.navigate ? navigationPolicy.navigate(url, modifiers, defaultNavigate) : defaultNavigate(url, modifiers);
            },
            shimUrl: navigationPolicy?.shimUrl,
            domainNamesToReplace: navigationPolicy?.domainNamesToReplace,
            spaceKeyFilter: navigationPolicy?.spaceKeyFilter
        }), [
        navigationPolicy,
        dispatch
    ]);
    const handleIframeOnLoad = (0, $42omo.useCallback)(()=>{
        const dispatchNow = ()=>{
            dispatch({
                subject: (0, $dc5325553138ea46$export$29953e2fb702813a).CONTENT_LOAD,
                status: (0, $dc5325553138ea46$export$19d37de7e9a4af59).IFRAME_LOADED
            });
        };
        const totalNumberOfTries = 2;
        const iframeOfDispatch = iframeRef.current;
        const iframeSrcOfDispatch = iframeOfDispatch?.src;
        let tries = 0;
        const dispatchWithDelay = ()=>{
            /* We verify whether the iframeRef is current, as our intent is to invoke this only for the Iframe component created within the Content component (embedded-confluence-common/src/content/Content.tsx).
			It's important to note that the same Iframe component is also used by the StorageAccessPage component; however, we do not need to perform that check in this context.
			Additionally, the src of the iframe may change during transitions between view/edit modes or other redirects. Therefore, we must ensure that our invocation is limited to the current src of the iframe.
			*/ if (iframeRef.current !== iframeOfDispatch || iframeOfDispatch?.src !== iframeSrcOfDispatch) return;
            ++tries;
            if (contentLoadStarted || tries > totalNumberOfTries) {
                // If content load arrived after a timeout, failure to load was prevented by the delay
                if (contentLoadStarted && iframeLoadedWithDelayRef.current) {
                    createAnalyticsEvent({
                        action: 'delayedDispatch',
                        actionSubject: 'iframeOnLoad',
                        actionSubjectId: 'crossDomainErrorValidation',
                        source: 'pageLoadValidation',
                        eventType: 'track'
                    }).fire((0, $fuqSI.ANALYTICS_CHANNEL));
                    //reset the ref for now. If the delayed dispatch is triggered again, the event will get fired too
                    iframeLoadedWithDelayRef.current = false;
                }
                dispatchNow();
            } else {
                /* This determines whether to fire a track analytics event
				to log instances where iframe load is delayed to wait for the confluence content to load.*/ if (!iframeLoadedWithDelayRef.current) iframeLoadedWithDelayRef.current = true;
                setTimeout(dispatchWithDelay, 1000);
            }
        };
        dispatchWithDelay();
    }, [
        contentLoadStarted,
        createAnalyticsEvent,
        dispatch
    ]);
    const handleContentLoadStarted = (0, $42omo.useCallback)(()=>{
        dispatch({
            subject: (0, $dc5325553138ea46$export$29953e2fb702813a).CONTENT_LOAD,
            status: (0, $dc5325553138ea46$export$19d37de7e9a4af59).CONTENT_LOAD_STARTED
        });
    }, [
        dispatch
    ]);
    const handleIframeUnload = (0, $42omo.useCallback)(()=>{
        dispatch({
            subject: (0, $dc5325553138ea46$export$29953e2fb702813a).CONTENT_LOAD,
            status: (0, $dc5325553138ea46$export$19d37de7e9a4af59).IFRAME_UNLOADED
        });
    }, [
        dispatch
    ]);
    if (!failToLoad) return children({
        iframeRef: iframeRef,
        isLoading: contentLoadStarted && !iframeLoaded,
        iframeLoaded: iframeLoaded,
        handleIframeOnLoad: handleIframeOnLoad,
        handleContentLoadStarted: handleContentLoadStarted,
        handleIframeUnload: handleIframeUnload,
        navigationPolicy: pageNavigationPolicy,
        redirectedToLogin: redirectedToLogin
    });
    if (!isLoginFlowDisabled) {
        if (shouldAskStorageAccess) return /*#__PURE__*/ (0, $l998X.jsx)((0, $99760c79a6ed56be$export$64a8a56a2c35628c), {
            url: embeddedConfluenceUrl,
            contentId: contentId,
            spaceKey: spaceKey,
            parentProduct: parentProduct
        });
        if (shouldAskToLogin) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6b2be4d3f29fcd62$export$f14c0e3f98d164c0), {
            contentId: contentId,
            parentProduct: parentProduct,
            reloadEP: reloadEP,
            spaceKey: spaceKey,
            url: embeddedConfluenceUrl
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $b67c8ce1deb4b4b8$export$42f84e610f279c31), {
        standaloneConfluenceUrl: standaloneConfluenceUrl
    });
};


var $44JTv = parcelRequire("44JTv");







var $jNfGN = parcelRequire("jNfGN");

const $9092c699d4343515$export$d07da6ac6fc160b0 = ({ experienceTracker: experienceTracker, hasFooter: hasFooter, shouldShowFooter: shouldShowFooter, parentProduct: parentProduct, standaloneConfluenceUrl: standaloneConfluenceUrl })=>{
    const [footerUrl, setFooterUrl] = (0, $42omo.useState)(standaloneConfluenceUrl);
    (0, $42omo.useEffect)(()=>{
        setFooterUrl(standaloneConfluenceUrl);
    }, [
        standaloneConfluenceUrl
    ]);
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = experienceTracker.subscribe((event)=>{
            const { name: name, action: action } = event;
            if (name === (0, $7pThu.ExperienceNames).PAGE_NOT_FOUND && action === 'taskStart') setFooterUrl(standaloneConfluenceUrl ? `${new URL(standaloneConfluenceUrl).origin}/wiki/home` : standaloneConfluenceUrl);
        });
        return ()=>unsubscribe();
    }, [
        experienceTracker,
        standaloneConfluenceUrl
    ]);
    /**
	 * Currently footer is hidden for the JSM Portal view which passes
	 * shouldShowFooter (externally, showFooterLogo) prop as false and shown for all other views
	 *
	 * JSM portal view will provide "JSM-Portal" as the parent product eventually
	 * However, team is still testing this product type for Atlassian and anonymous users so the "JSM-Portal" parentProduct is being feature-flagged
	 * We need to support these two parent product keys to keep backward compatible for the time being.
	 *
	 * Clean-up task in backlog: https://hello.atlassian.net/browse/CBT-1278 to remove "JSM" from the logic
	 *
	 * EDIT 7/17: showFooterLogo has been renamed internally for clarity and is now aliased as shouldShowFooter when used internally.
	 * External API remains unchanged.
	 */ const showFooter = (0, $42omo.useMemo)(()=>{
        const parentProducts = [
            (0, $jNfGN.EMBEDDED_PARENT_PRODUCTS).JSM_PORTAL,
            (0, $jNfGN.EMBEDDED_PARENT_PRODUCTS).JSM,
            (0, $jNfGN.EMBEDDED_PARENT_PRODUCTS).JSW,
            (0, $jNfGN.EMBEDDED_PARENT_PRODUCTS).JWM
        ];
        return !!hasFooter && !(parentProducts.includes(parentProduct) && !shouldShowFooter);
    }, [
        parentProduct,
        shouldShowFooter,
        hasFooter
    ]);
    return {
        showFooter: showFooter,
        footerUrl: footerUrl
    };
};








var $elkSx = parcelRequire("elkSx");




const $f56ea57bc2c8b179$var$messages = (0, $cgtv4.defineMessages)({
    viewInConfluence: {
        id: "embedded.confluence.footer.hover.text",
        defaultMessage: "View in Confluence"
    },
    poweredBy: {
        id: "embedded.confluence.footer.prefix",
        defaultMessage: "Powered by"
    }
});
var $f56ea57bc2c8b179$export$2e2bcd8739ae039 = $f56ea57bc2c8b179$var$messages;





/* IframeLoadingScreen.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




var $d8SNb = parcelRequire("d8SNb");


var $kpYGL = parcelRequire("kpYGL");

const $60b4b6eb3073ac4f$var$visibilityStyles = {
    hidden: "_1e0cglyw",
    invisible: "_tzy4idpf _4t3i1osq",
    visible: "_tzy4kb7n _4t3i1osq"
};
const $60b4b6eb3073ac4f$var$overlayStyles = {
    default: "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _1bsb1osq _4t3i1osq _1e0c1txw _2lx21bp4 _4cvr1h6o _1bahv2br _1pbyb4wl"
};
const $60b4b6eb3073ac4f$var$containerStyles = {
    default: "_kqswh2mm _1bsb1osq _4t3i1osq"
};
const $60b4b6eb3073ac4f$export$666e684aed003bfe = ({ children: children, iframeLoaded: iframeLoaded, isLoading: isLoading })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $60b4b6eb3073ac4f$var$containerStyles.default,
        "aria-busy": isLoading,
        "aria-live": "polite",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $d8SNb.default), {
                gap: "space.400",
                alignItems: "start",
                xcss: isLoading ? $60b4b6eb3073ac4f$var$overlayStyles.default : $60b4b6eb3073ac4f$var$visibilityStyles.hidden,
                "aria-hidden": !isLoading,
                role: "status",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                        width: "100%",
                        height: "250px",
                        isShimmering: true
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                        width: "100%",
                        height: "40px",
                        isShimmering: true
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                        width: "100%",
                        height: "40px",
                        isShimmering: true
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                        width: "100%",
                        height: "40px",
                        isShimmering: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                padding: "space.0",
                "aria-hidden": isLoading,
                xcss: !iframeLoaded ? $60b4b6eb3073ac4f$var$visibilityStyles.invisible : $60b4b6eb3073ac4f$var$visibilityStyles.visible,
                children: children
            })
        ]
    });


const $2b9005daf957887f$var$IframeWrapper = ({ children: children, wrapper: wrapper })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: wrapper?.(children) ?? children
    });
// helper to merge iframe refs
function $2b9005daf957887f$var$mergeIframeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (!ref) return;
            if (typeof ref === 'function') ref(value);
            else ref.current = value;
        });
    };
}
const $2b9005daf957887f$export$7c6e2c02157bb7d2 = (props)=>{
    const { spaceKey: spaceKey, contentId: contentId, contentConfiguration: contentConfiguration, navigationPolicy: navigationPolicy, iframeRef: externalIframeRef, onLoad: onLoad, embeddedConfluenceSource: embeddedConfluenceSource, ...passThroughProps } = props;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { uniqueKey: uniqueKey } = (0, $cGc86.useUniqueKey)();
    const experienceTracker = (0, $iudHJ.useExperienceTracker)();
    const { experience: experience, ccExperience: ccExperience } = contentConfiguration.experiences;
    (0, $b6040bd8c2dd6c87$export$48d5d434479c259e)({
        experienceTracker: experienceTracker,
        contentId: contentId,
        spaceKey: spaceKey,
        experience: experience,
        ccExperience: ccExperience
    });
    const { embeddedConfluenceUrl: embeddedConfluenceUrl, standaloneConfluenceUrl: standaloneConfluenceUrl } = (0, $3WsBD.useUrl)(props);
    /**
   * The difference between hasFooter and hasFooterLogo can be found here
   * https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/40212/cbt-2587-docs-changeset-ux-add-embedded#comment-428798112
   *
   * EDIT 7/17: hasFooterLogo property has been renamed internally for clarity as is now aliased as shouldShowFooter when used internally. Externally, the API remains unchanged.
   */ const shouldShowFooter = props.hasFooterLogo ?? true;
    const { showFooter: showFooter, footerUrl: footerUrl } = (0, $9092c699d4343515$export$d07da6ac6fc160b0)({
        experienceTracker: experienceTracker,
        hasFooter: contentConfiguration.hasFooter,
        shouldShowFooter: shouldShowFooter,
        parentProduct: props.parentProduct,
        standaloneConfluenceUrl: standaloneConfluenceUrl
    });
    const { height: height } = (0, $44JTv.useContentSize)(uniqueKey);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jJf3a.ExperienceTrackerContext).Provider, {
        value: experienceTracker,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2b815948b6973dc0$export$c90b54e658fc4d7c), {
            name: experience,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $81cee89a8418d895$export$3b0759108d92fe77), {
                ...props,
                children: ({ iframeRef: iframeRef, iframeLoaded: iframeLoaded, isLoading: isLoading, handleIframeOnLoad: handleIframeOnLoad, handleContentLoadStarted: handleContentLoadStarted, navigationPolicy: navigationPolicy, handleIframeUnload: handleIframeUnload, redirectedToLogin: redirectedToLogin })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)($2b9005daf957887f$var$IframeWrapper, {
                                wrapper: contentConfiguration.getWrapperElement,
                                children: embeddedConfluenceUrl ? /*#__PURE__*/ (0, $l998X.jsx)((0, $60b4b6eb3073ac4f$export$666e684aed003bfe), {
                                    iframeLoaded: iframeLoaded,
                                    isLoading: isLoading,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $96c652b8f1100cf8$export$5137ec99f248330b), {
                                        ref: $2b9005daf957887f$var$mergeIframeRefs(iframeRef, externalIframeRef),
                                        // https://hello.atlassian.net/wiki/spaces/~142157567/pages/2224394268/Spike+on+CBT-1814
                                        src: redirectedToLogin ? '' : embeddedConfluenceUrl,
                                        ...passThroughProps,
                                        navigationPolicy: navigationPolicy,
                                        style: {
                                            flex: passThroughProps.isHeightSetFromContent ? `1 0 ${height}px` : '0 1 100%'
                                        },
                                        uniqueKey: uniqueKey,
                                        onLoad: (e)=>{
                                            handleIframeOnLoad();
                                            onLoad?.(e);
                                        },
                                        onUnload: handleIframeUnload,
                                        onContentLoadStarted: handleContentLoadStarted
                                    })
                                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $elkSx.PageNotFoundEmptyState), {
                                    embeddedConfluenceSource: embeddedConfluenceSource
                                })
                            }),
                            showFooter && /*#__PURE__*/ (0, $l998X.jsx)((0, $d46b25c378604447$export$a06f1c675e846f6f), {
                                url: footerUrl,
                                linkTooltip: formatMessage((0, $f56ea57bc2c8b179$export$2e2bcd8739ae039).viewInConfluence),
                                label: formatMessage((0, $f56ea57bc2c8b179$export$2e2bcd8739ae039).poweredBy)
                            })
                        ]
                    })
            })
        })
    });
};
module.exports["Content"] = $2b9005daf957887f$export$7c6e2c02157bb7d2;

});

parcelRegister("4HdGj", function(module, exports) {
const $e8b7e85943c161a1$export$16e3f1b03b231b35 = (event)=>event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail';
const $e8b7e85943c161a1$export$57069f5b2ecc9128 = (event, ...names)=>names.includes(event.name);
module.exports["isStop"] = $e8b7e85943c161a1$export$16e3f1b03b231b35;
module.exports["hasName"] = $e8b7e85943c161a1$export$57069f5b2ecc9128;

});

parcelRegister("aPXOP", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(_e) {
                    var n = t[o][1][_e];
                    return s(n ? n : _e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _util = _interopRequireDefault(_dereq_("./util"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var PostMessage = /*#__PURE__*/ function() {
                    function PostMessage(data) {
                        _classCallCheck(this, PostMessage);
                        var d = data || {};
                        this._registerListener(d.listenOn);
                    }
                    _createClass(PostMessage, [
                        {
                            key: "_registerListener",
                            value: function _registerListener(listenOn) {
                                if (!listenOn || !listenOn.addEventListener) listenOn = window;
                                listenOn.addEventListener("message", _util.default._bind(this, this._receiveMessage), false);
                            }
                        },
                        {
                            key: "_receiveMessage",
                            value: function _receiveMessage(event) {
                                var handler = this._messageHandlers[event.data.type], extensionId = event.data.eid, reg;
                                if (extensionId && this._registeredExtensions) reg = this._registeredExtensions[extensionId];
                                if (!handler || !this._checkOrigin(event, reg)) return false;
                                handler.call(this, event, reg);
                            }
                        }
                    ]);
                    return PostMessage;
                }();
                var _default = PostMessage;
                exports.default = _default;
                module1.exports = exports.default;
            },
            {
                "./util": 2
            }
        ],
        2: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                var LOG_PREFIX = "[Simple-XDM] ";
                var nativeBind = Function.prototype.bind;
                var util = {
                    locationOrigin: function locationOrigin() {
                        if (!window.location.origin) return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
                        else return window.location.origin;
                    },
                    randomString: function randomString() {
                        return Math.floor(Math.random() * 1000000000).toString(16);
                    },
                    isString: function isString(str) {
                        return typeof str === "string" || str instanceof String;
                    },
                    argumentsToArray: function argumentsToArray(arrayLike) {
                        return Array.prototype.slice.call(arrayLike);
                    },
                    argumentNames: function argumentNames(fn) {
                        return fn.toString().replace(/((\/\/.*$)|(\/\*[^]*?\*\/))/mg, '') // strip comments
                        .replace(/[^(]+\(([^)]*)[^]+/, '$1') // get signature
                        .match(/([^\s,]+)/g) || [];
                    },
                    hasCallback: function hasCallback(args) {
                        var length = args.length;
                        return length > 0 && typeof args[length - 1] === 'function';
                    },
                    error: function error(msg) {
                        if (window.console && window.console.error) {
                            var outputError = [];
                            if (typeof msg === "string") {
                                outputError.push(LOG_PREFIX + msg);
                                outputError = outputError.concat(Array.prototype.slice.call(arguments, 1));
                            } else {
                                outputError.push(LOG_PREFIX);
                                outputError = outputError.concat(Array.prototype.slice.call(arguments));
                            }
                            window.console.error.apply(null, outputError);
                        }
                    },
                    warn: function warn(msg) {
                        if (window.console) console.warn(LOG_PREFIX + msg);
                    },
                    log: function log(msg) {
                        if (window.console) window.console.log(LOG_PREFIX + msg);
                    },
                    _bind: function _bind(thisp, fn) {
                        if (nativeBind && fn.bind === nativeBind) return fn.bind(thisp);
                        return function() {
                            return fn.apply(thisp, arguments);
                        };
                    },
                    throttle: function throttle(func, wait, context) {
                        var previous = 0;
                        return function() {
                            var now = Date.now();
                            if (now - previous > wait) {
                                previous = now;
                                func.apply(context, arguments);
                            }
                        };
                    },
                    each: function each(list, iteratee) {
                        var length;
                        var key;
                        if (list) {
                            length = list.length;
                            if (length != null && typeof list !== 'function') {
                                key = 0;
                                while(key < length){
                                    if (iteratee.call(list[key], key, list[key]) === false) break;
                                    key += 1;
                                }
                            } else {
                                for(key in list)if (list.hasOwnProperty(key)) {
                                    if (iteratee.call(list[key], key, list[key]) === false) break;
                                }
                            }
                        }
                    },
                    extend: function extend(dest) {
                        var args = arguments;
                        var srcs = [].slice.call(args, 1, args.length);
                        srcs.forEach(function(source) {
                            if (_typeof(source) === "object") Object.getOwnPropertyNames(source).forEach(function(name) {
                                dest[name] = source[name];
                            });
                        });
                        return dest;
                    },
                    sanitizeStructuredClone: function sanitizeStructuredClone(object) {
                        var whiteList = [
                            Boolean,
                            String,
                            Date,
                            RegExp,
                            Blob,
                            File,
                            FileList,
                            ArrayBuffer
                        ];
                        var blackList = [
                            Error,
                            Node
                        ];
                        var warn = util.warn;
                        var visitedObjects = [];
                        function _clone(value) {
                            if (typeof value === 'function') {
                                warn("A function was detected and removed from the message.");
                                return null;
                            }
                            if (blackList.some(function(t) {
                                if (value instanceof t) {
                                    warn("".concat(t.name, " object was detected and removed from the message."));
                                    return true;
                                }
                                return false;
                            })) return {};
                            if (value && _typeof(value) === 'object' && whiteList.every(function(t) {
                                return !(value instanceof t);
                            })) {
                                var newValue;
                                if (Array.isArray(value)) newValue = value.map(function(element) {
                                    return _clone(element);
                                });
                                else {
                                    if (visitedObjects.indexOf(value) > -1) {
                                        warn("A circular reference was detected and removed from the message.");
                                        return null;
                                    }
                                    visitedObjects.push(value);
                                    newValue = {};
                                    for(var name in value)if (value.hasOwnProperty(name)) {
                                        var clonedValue = _clone(value[name]);
                                        if (clonedValue !== null) newValue[name] = clonedValue;
                                    }
                                    visitedObjects.pop();
                                }
                                return newValue;
                            }
                            return value;
                        }
                        return _clone(object);
                    },
                    getOrigin: function getOrigin(url, base) {
                        // everything except IE11
                        if (typeof URL === 'function') try {
                            return new URL(url, base).origin;
                        } catch (e) {}
                         // ie11 + safari 10
                        var doc = document.implementation.createHTMLDocument('');
                        if (base) {
                            var baseElement = doc.createElement('base');
                            baseElement.href = base;
                            doc.head.appendChild(baseElement);
                        }
                        var anchorElement = doc.createElement('a');
                        anchorElement.href = url;
                        doc.body.appendChild(anchorElement);
                        var origin = anchorElement.protocol + '//' + anchorElement.hostname; //ie11, only include port if referenced in initial URL
                        if (url.match(/\/\/[^/]+:[0-9]+\//)) origin += anchorElement.port ? ':' + anchorElement.port : '';
                        return origin;
                    }
                };
                var _default = util;
                exports.default = _default;
                module1.exports = exports.default;
            },
            {}
        ],
        3: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _xdmrpc = _interopRequireDefault(_dereq_("./xdmrpc"));
                var _util = _interopRequireDefault(_dereq_("../common/util"));
                var _featureFlag = _dereq_("./feature-flag");
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var Connect = /*#__PURE__*/ function() {
                    function Connect() {
                        _classCallCheck(this, Connect);
                        this._xdm = new _xdmrpc.default();
                    }
                    /**
         * Send a message to iframes matching the targetSpec. This message is added to
         *  a message queue for delivery to ensure the message is received if an iframe
         *  has not yet loaded
         *
         * @param type The name of the event type
         * @param targetSpec The spec to match against extensions when sending this event
         * @param event The event payload
         * @param callback A callback to be executed when the remote iframe calls its callback
         */ _createClass(Connect, [
                        {
                            key: "dispatch",
                            value: function dispatch(type, targetSpec, event, callback) {
                                this._xdm.queueEvent(type, targetSpec, event, callback);
                                return this.getExtensions(targetSpec);
                            }
                        },
                        {
                            key: "broadcast",
                            value: function broadcast(type, targetSpec, event) {
                                this._xdm.dispatch(type, targetSpec, event, null, null);
                                return this.getExtensions(targetSpec);
                            }
                        },
                        {
                            key: "_createId",
                            value: function _createId(extension) {
                                if (!extension.addon_key || !extension.key) throw Error('Extensions require addon_key and key');
                                return extension.addon_key + '__' + extension.key + '__' + _util.default.randomString();
                            }
                        },
                        {
                            key: "create",
                            value: function create(extension, initCallback, unloadCallback) {
                                var extension_id = this.registerExtension(extension, initCallback, unloadCallback);
                                var options = extension.options || {};
                                options.platformFeatureFlags = (0, _featureFlag.getPlatformFeatureFlags)();
                                var data = {
                                    extension_id: extension_id,
                                    api: this._xdm.getApiSpec(extension.addon_key),
                                    origin: _util.default.locationOrigin(),
                                    options: options
                                };
                                return {
                                    id: extension_id,
                                    name: JSON.stringify(data),
                                    src: extension.url
                                };
                            } // This is called from ACJS
                        },
                        {
                            key: "registerRequestNotifier",
                            value: function registerRequestNotifier(callback) {
                                this._xdm.registerRequestNotifier(callback);
                            }
                        },
                        {
                            key: "registerExtension",
                            value: function registerExtension(extension, initCallback, unloadCallback) {
                                var extension_id = this._createId(extension);
                                this._xdm.registerExtension(extension_id, {
                                    extension: extension,
                                    initCallback: initCallback,
                                    unloadCallback: unloadCallback
                                });
                                return extension_id;
                            }
                        },
                        {
                            key: "registerKeyListener",
                            value: function registerKeyListener(extension_id, key, modifiers, callback) {
                                this._xdm.registerKeyListener(extension_id, key, modifiers, callback);
                            }
                        },
                        {
                            key: "unregisterKeyListener",
                            value: function unregisterKeyListener(extension_id, key, modifiers, callback) {
                                this._xdm.unregisterKeyListener(extension_id, key, modifiers, callback);
                            }
                        },
                        {
                            key: "registerClickHandler",
                            value: function registerClickHandler(callback) {
                                this._xdm.registerClickHandler(callback);
                            }
                        },
                        {
                            key: "unregisterClickHandler",
                            value: function unregisterClickHandler() {
                                this._xdm.unregisterClickHandler();
                            }
                        },
                        {
                            key: "defineModule",
                            value: function defineModule(moduleName, module1, options) {
                                this._xdm.defineAPIModule(module1, moduleName, options);
                            }
                        },
                        {
                            key: "isModuleDefined",
                            value: function isModuleDefined(moduleName) {
                                return this._xdm.isAPIModuleDefined(moduleName);
                            }
                        },
                        {
                            key: "defineGlobals",
                            value: function defineGlobals(module1) {
                                this._xdm.defineAPIModule(module1);
                            }
                        },
                        {
                            key: "getExtensions",
                            value: function getExtensions(filter) {
                                return this._xdm.getRegisteredExtensions(filter);
                            }
                        },
                        {
                            key: "unregisterExtension",
                            value: function unregisterExtension(filter) {
                                return this._xdm.unregisterExtension(filter);
                            }
                        },
                        {
                            key: "returnsPromise",
                            value: function returnsPromise(wrappedMethod) {
                                wrappedMethod.returnsPromise = true;
                            }
                        },
                        {
                            key: "setFeatureFlagGetter",
                            value: function setFeatureFlagGetter(getBooleanFeatureFlag) {
                                this._xdm.setFeatureFlagGetter(getBooleanFeatureFlag);
                            }
                        },
                        {
                            key: "registerExistingExtension",
                            value: function registerExistingExtension(extension_id, data) {
                                return this._xdm.registerExtension(extension_id, data);
                            }
                        }
                    ]);
                    return Connect;
                }();
                var _default = Connect;
                exports.default = _default;
                module1.exports = exports.default;
            },
            {
                "../common/util": 2,
                "./feature-flag": 4,
                "./xdmrpc": 6
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getPlatformFeatureFlags = getPlatformFeatureFlags;
                var allowedPlatformFeatureFlags = [
                    'platform-visual-refresh-icons'
                ];
                function getPlatformFeatureFlags() {
                    var flags = {};
                    if (window.connectHost && window.connectHost.getBooleanFeatureFlag) allowedPlatformFeatureFlags.forEach(function(key) {
                        return flags[key] = window.connectHost.getBooleanFeatureFlag(key);
                    });
                    return flags;
                }
            },
            {}
        ],
        5: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _connect = _interopRequireDefault(_dereq_("./connect"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                var _default = new _connect.default();
                exports.default = _default;
                module1.exports = exports.default;
            },
            {
                "./connect": 3
            }
        ],
        6: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _util = _interopRequireDefault(_dereq_("../common/util"));
                var _postmessage = _interopRequireDefault(_dereq_("../common/postmessage"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _construct(Parent, args, Class) {
                    if (_isNativeReflectConstruct()) _construct = Reflect.construct;
                    else _construct = function _construct(Parent, args, Class) {
                        var a = [
                            null
                        ];
                        a.push.apply(a, args);
                        var Constructor = Function.bind.apply(Parent, a);
                        var instance = new Constructor();
                        if (Class) _setPrototypeOf(instance, Class.prototype);
                        return instance;
                    };
                    return _construct.apply(null, arguments);
                }
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self);
                }
                function _assertThisInitialized(self) {
                    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                var VALID_EVENT_TIME_MS = 30000; //30 seconds
                var XDMRPC = /*#__PURE__*/ function(_PostMessage) {
                    _inherits(XDMRPC, _PostMessage);
                    var _super = _createSuper(XDMRPC);
                    function XDMRPC(config) {
                        var _this;
                        _classCallCheck(this, XDMRPC);
                        config = config || {};
                        _this = _super.call(this, config);
                        _this._registeredExtensions = config.extensions || {};
                        _this._registeredAPIModules = {};
                        _this._registeredAPIModules._globals = {};
                        _this._pendingCallbacks = {};
                        _this._keycodeCallbacks = {};
                        _this._clickHandlers = [];
                        _this._pendingEvents = {};
                        _this._messageHandlers = {
                            init: _this._handleInit,
                            req: _this._handleRequest,
                            resp: _this._handleResponse,
                            broadcast: _this._handleBroadcast,
                            event_query: _this._handleEventQuery,
                            key_triggered: _this._handleKeyTriggered,
                            addon_clicked: _this._handleAddonClick,
                            get_host_offset: _this._getHostOffset,
                            unload: _this._handleUnload
                        };
                        return _this;
                    }
                    _createClass(XDMRPC, [
                        {
                            key: "_padUndefinedArguments",
                            value: function _padUndefinedArguments(array, length) {
                                return array.length >= length ? array : array.concat(new Array(length - array.length));
                            }
                        },
                        {
                            key: "_verifyAPI",
                            value: function _verifyAPI(event, reg) {
                                var untrustedTargets = event.data.targets;
                                if (!untrustedTargets) return;
                                var trustedSpec = this.getApiSpec();
                                var tampered = false;
                                function check(trusted, untrusted) {
                                    Object.getOwnPropertyNames(untrusted).forEach(function(name) {
                                        if (_typeof(untrusted[name]) === 'object' && trusted[name]) check(trusted[name], untrusted[name]);
                                        else if (untrusted[name] === 'parent' && trusted[name]) tampered = true;
                                    });
                                }
                                check(trustedSpec, untrustedTargets);
                                if (event.source && event.source.postMessage) // only post a message if the source of the event still exists
                                event.source.postMessage({
                                    type: 'api_tamper',
                                    tampered: tampered
                                }, reg.extension.url);
                                else console.warn("_verifyAPI postMessage skipped as event source missing.");
                            }
                        },
                        {
                            key: "_handleInit",
                            value: function _handleInit(event, reg) {
                                if (event.source && event.source.postMessage) // only post a message if the source of the event still exists
                                event.source.postMessage({
                                    type: 'init_received'
                                }, reg.extension.url);
                                else console.warn("_handleInit postMessage skipped as event source missing.");
                                this._registeredExtensions[reg.extension_id].source = event.source;
                                if (reg.initCallback) {
                                    reg.initCallback(event.data.eid);
                                    delete reg.initCallback;
                                }
                                if (event.data.targets) this._verifyAPI(event, reg);
                            }
                        },
                        {
                            key: "_getHostOffset",
                            value: function _getHostOffset(event, _window) {
                                var hostWindow = event.source;
                                var hostFrameOffset = null;
                                var windowReference = _window || window; // For testing
                                if (windowReference === windowReference.top && typeof windowReference.getHostOffsetFunctionOverride === 'function') hostFrameOffset = windowReference.getHostOffsetFunctionOverride(hostWindow);
                                if (typeof hostFrameOffset !== 'number') {
                                    hostFrameOffset = 0; // Find the closest frame that has the same origin as event source
                                    while(!this._hasSameOrigin(hostWindow)){
                                        // Climb up the iframe tree 1 layer
                                        hostFrameOffset++;
                                        hostWindow = hostWindow.parent;
                                    }
                                }
                                if (event.source && event.source.postMessage) // only post a message if the source of the event still exists
                                event.source.postMessage({
                                    hostFrameOffset: hostFrameOffset
                                }, event.origin);
                                else console.warn("_getHostOffset postMessage skipped as event source missing.");
                            }
                        },
                        {
                            key: "_hasSameOrigin",
                            value: function _hasSameOrigin(window1) {
                                if (window1 === window1.top) return true;
                                try {
                                    // Try set & read a variable on the given window
                                    // If we can successfully read the value then it means the given window has the same origin
                                    // as the window that is currently executing the script
                                    var testVariableName = 'test_var_' + Math.random().toString(16).substr(2);
                                    window1[testVariableName] = true;
                                    return window1[testVariableName];
                                } catch (e) {}
                                return false;
                            }
                        },
                        {
                            key: "_handleResponse",
                            value: function _handleResponse(event) {
                                var data = event.data;
                                var pendingCallback = this._pendingCallbacks[data.mid];
                                if (pendingCallback) {
                                    delete this._pendingCallbacks[data.mid];
                                    pendingCallback.apply(window, data.args);
                                }
                            }
                        },
                        {
                            key: "registerRequestNotifier",
                            value: function registerRequestNotifier(cb) {
                                this._registeredRequestNotifier = cb;
                            }
                        },
                        {
                            key: "_handleRequest",
                            value: function _handleRequest(event, reg) {
                                function sendResponse() {
                                    var args = _util.default.sanitizeStructuredClone(_util.default.argumentsToArray(arguments));
                                    if (event.source && event.source.postMessage) // only post a message if the source of the event still exists
                                    event.source.postMessage({
                                        mid: event.data.mid,
                                        type: 'resp',
                                        forPlugin: true,
                                        args: args
                                    }, reg.extension.url);
                                    else console.warn("_handleRequest postMessage skipped as event source missing.");
                                }
                                var data = event.data;
                                var module1 = this._registeredAPIModules[data.mod];
                                var extension = this.getRegisteredExtensions(reg.extension)[0];
                                if (module1) {
                                    var fnName = data.fn;
                                    if (data._cls) {
                                        var Cls = module1[data._cls];
                                        var ns = data.mod + '-' + data._cls + '-';
                                        sendResponse._id = data._id;
                                        if (fnName === 'constructor') {
                                            if (!Cls._construct) {
                                                Cls.constructor.prototype._destroy = function() {
                                                    delete this._context._proxies[ns + this._id];
                                                };
                                                Cls._construct = function() {
                                                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                                                    var inst = _construct(Cls.constructor, args);
                                                    var callback = args[args.length - 1];
                                                    inst._id = callback._id;
                                                    inst._context = callback._context;
                                                    inst._context._proxies[ns + inst._id] = inst;
                                                    return inst;
                                                };
                                            }
                                            module1 = Cls;
                                            fnName = '_construct';
                                        } else module1 = extension._proxies[ns + data._id];
                                    }
                                    var method = module1[fnName];
                                    if (method) {
                                        var methodArgs = data.args;
                                        var padLength = method.length - 1;
                                        if (fnName === '_construct') padLength = module1.constructor.length - 1;
                                        sendResponse._context = extension;
                                        methodArgs = this._padUndefinedArguments(methodArgs, padLength);
                                        methodArgs.push(sendResponse);
                                        var promiseResult = method.apply(module1, methodArgs);
                                        if (method.returnsPromise) {
                                            if (!(_typeof(promiseResult) === 'object' || typeof promiseResult === 'function') || typeof promiseResult.then !== 'function') sendResponse('Defined module method did not return a promise.');
                                            else promiseResult.then(function(result) {
                                                sendResponse(undefined, result);
                                            }).catch(function(err) {
                                                err = err instanceof Error ? err.message : err;
                                                sendResponse(err);
                                            });
                                        }
                                        if (this._registeredRequestNotifier) this._registeredRequestNotifier.call(null, {
                                            module: data.mod,
                                            fn: data.fn,
                                            type: data.type,
                                            args: methodArgs,
                                            addon_key: reg.extension.addon_key,
                                            key: reg.extension.key,
                                            extension_id: reg.extension_id
                                        });
                                    }
                                }
                            }
                        },
                        {
                            key: "_handleBroadcast",
                            value: function _handleBroadcast(event, reg) {
                                var event_data = event.data;
                                var targetSpec = function targetSpec(r) {
                                    return r.extension.addon_key === reg.extension.addon_key && r.extension_id !== reg.extension_id;
                                };
                                this.dispatch(event_data.etyp, targetSpec, event_data.evnt, null, null);
                            }
                        },
                        {
                            key: "_handleKeyTriggered",
                            value: function _handleKeyTriggered(event, reg) {
                                var eventData = event.data;
                                var keycodeEntry = this._keycodeKey(eventData.keycode, eventData.modifiers, reg.extension_id);
                                var listeners = this._keycodeCallbacks[keycodeEntry];
                                if (listeners) listeners.forEach(function(listener) {
                                    listener.call(null, {
                                        addon_key: reg.extension.addon_key,
                                        key: reg.extension.key,
                                        extension_id: reg.extension_id,
                                        keycode: eventData.keycode,
                                        modifiers: eventData.modifiers
                                    });
                                }, this);
                            }
                        },
                        {
                            key: "defineAPIModule",
                            value: function defineAPIModule(module1, moduleName) {
                                moduleName = moduleName || '_globals';
                                this._registeredAPIModules[moduleName] = _util.default.extend({}, this._registeredAPIModules[moduleName] || {}, module1);
                                return this._registeredAPIModules;
                            }
                        },
                        {
                            key: "isAPIModuleDefined",
                            value: function isAPIModuleDefined(moduleName) {
                                return typeof this._registeredAPIModules[moduleName] !== 'undefined';
                            }
                        },
                        {
                            key: "_pendingEventKey",
                            value: function _pendingEventKey(targetSpec, time) {
                                var key = targetSpec.addon_key || 'global';
                                if (targetSpec.key) key = "".concat(key, "@@").concat(targetSpec.key);
                                key = "".concat(key, "@@").concat(time);
                                return key;
                            }
                        },
                        {
                            key: "queueEvent",
                            value: function queueEvent(type, targetSpec, event, callback) {
                                var loaded_frame, targets = this._findRegistrations(targetSpec);
                                loaded_frame = targets.some(function(target) {
                                    return target.registered_events !== undefined;
                                }, this);
                                if (loaded_frame) this.dispatch(type, targetSpec, event, callback);
                                else {
                                    this._cleanupInvalidEvents();
                                    var time = new Date().getTime();
                                    this._pendingEvents[this._pendingEventKey(targetSpec, time)] = {
                                        type: type,
                                        targetSpec: targetSpec,
                                        event: event,
                                        callback: callback,
                                        time: time,
                                        uid: _util.default.randomString()
                                    };
                                }
                            }
                        },
                        {
                            key: "_cleanupInvalidEvents",
                            value: function _cleanupInvalidEvents() {
                                var _this2 = this;
                                var now = new Date().getTime();
                                var keys = Object.keys(this._pendingEvents);
                                keys.forEach(function(index) {
                                    var element = _this2._pendingEvents[index];
                                    var eventIsValid = now - element.time <= VALID_EVENT_TIME_MS;
                                    if (!eventIsValid) delete _this2._pendingEvents[index];
                                });
                            }
                        },
                        {
                            key: "_handleEventQuery",
                            value: function _handleEventQuery(message, extension) {
                                var _this3 = this;
                                var executed = {};
                                var now = new Date().getTime();
                                var keys = Object.keys(this._pendingEvents);
                                keys.forEach(function(index) {
                                    var element = _this3._pendingEvents[index];
                                    var eventIsValid = now - element.time <= VALID_EVENT_TIME_MS;
                                    var isSameTarget = !element.targetSpec || _this3._findRegistrations(element.targetSpec).length !== 0;
                                    if (isSameTarget && element.targetSpec.key) isSameTarget = element.targetSpec.addon_key === extension.extension.addon_key && element.targetSpec.key === extension.extension.key;
                                    if (eventIsValid && isSameTarget) {
                                        executed[index] = element;
                                        element.targetSpec = element.targetSpec || {};
                                        _this3.dispatch(element.type, element.targetSpec, element.event, element.callback, message.source);
                                    } else if (!eventIsValid) delete _this3._pendingEvents[index];
                                });
                                this._registeredExtensions[extension.extension_id].registered_events = message.data.args;
                                return executed;
                            }
                        },
                        {
                            key: "_handleUnload",
                            value: function _handleUnload(event, reg) {
                                if (!reg) return;
                                if (reg.extension_id && this._registeredExtensions[reg.extension_id]) delete this._registeredExtensions[reg.extension_id].source;
                                if (reg.unloadCallback) reg.unloadCallback(event.data.eid);
                            }
                        },
                        {
                            key: "dispatch",
                            value: function dispatch(type, targetSpec, event, callback, source) {
                                function sendEvent(reg, evnt) {
                                    if (reg.source && reg.source.postMessage) {
                                        var mid;
                                        if (callback) {
                                            mid = _util.default.randomString();
                                            this._pendingCallbacks[mid] = callback;
                                        }
                                        reg.source.postMessage({
                                            type: 'evt',
                                            mid: mid,
                                            etyp: type,
                                            evnt: evnt
                                        }, reg.extension.url);
                                    }
                                }
                                var registrations = this._findRegistrations(targetSpec || {});
                                registrations.forEach(function(reg) {
                                    if (source && !reg.source) reg.source = source;
                                    if (reg.source) _util.default._bind(this, sendEvent)(reg, event);
                                }, this);
                            }
                        },
                        {
                            key: "_findRegistrations",
                            value: function _findRegistrations(targetSpec) {
                                var _this4 = this;
                                if (this._registeredExtensions.length === 0) {
                                    _util.default.error('no registered extensions', this._registeredExtensions);
                                    return [];
                                }
                                var keys = Object.getOwnPropertyNames(targetSpec);
                                var registrations = Object.getOwnPropertyNames(this._registeredExtensions).map(function(key) {
                                    return _this4._registeredExtensions[key];
                                });
                                if (targetSpec instanceof Function) return registrations.filter(targetSpec);
                                else return registrations.filter(function(reg) {
                                    return keys.every(function(key) {
                                        return reg.extension[key] === targetSpec[key];
                                    });
                                });
                            }
                        },
                        {
                            key: "registerExtension",
                            value: function registerExtension(extension_id, data) {
                                data._proxies = {};
                                data.extension_id = extension_id;
                                this._registeredExtensions[extension_id] = data;
                            }
                        },
                        {
                            key: "_keycodeKey",
                            value: function _keycodeKey(key, modifiers, extension_id) {
                                var code = key;
                                if (modifiers) {
                                    if (typeof modifiers === "string") modifiers = [
                                        modifiers
                                    ];
                                    modifiers.sort();
                                    modifiers.forEach(function(modifier) {
                                        code += '$$' + modifier;
                                    }, this);
                                }
                                return code + '__' + extension_id;
                            }
                        },
                        {
                            key: "registerKeyListener",
                            value: function registerKeyListener(extension_id, key, modifiers, callback) {
                                if (typeof modifiers === "string") modifiers = [
                                    modifiers
                                ];
                                var reg = this._registeredExtensions[extension_id];
                                var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
                                if (!this._keycodeCallbacks[keycodeEntry]) {
                                    this._keycodeCallbacks[keycodeEntry] = [];
                                    reg.source.postMessage({
                                        type: 'key_listen',
                                        keycode: key,
                                        modifiers: modifiers,
                                        action: 'add'
                                    }, reg.extension.url);
                                }
                                this._keycodeCallbacks[keycodeEntry].push(callback);
                            }
                        },
                        {
                            key: "unregisterKeyListener",
                            value: function unregisterKeyListener(extension_id, key, modifiers, callback) {
                                var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
                                var potentialCallbacks = this._keycodeCallbacks[keycodeEntry];
                                var reg = this._registeredExtensions[extension_id];
                                if (potentialCallbacks) {
                                    if (callback) {
                                        var index = potentialCallbacks.indexOf(callback);
                                        this._keycodeCallbacks[keycodeEntry].splice(index, 1);
                                    } else delete this._keycodeCallbacks[keycodeEntry];
                                    if (reg.source && reg.source.postMessage) reg.source.postMessage({
                                        type: 'key_listen',
                                        keycode: key,
                                        modifiers: modifiers,
                                        action: 'remove'
                                    }, reg.extension.url);
                                }
                            }
                        },
                        {
                            key: "registerClickHandler",
                            value: function registerClickHandler(callback) {
                                if (typeof callback !== 'function') throw new Error('callback must be a function');
                                this._clickHandlers.push(callback);
                            }
                        },
                        {
                            key: "_handleAddonClick",
                            value: function _handleAddonClick(event, reg) {
                                for(var i = 0; i < this._clickHandlers.length; i++)if (typeof this._clickHandlers[i] === 'function') this._clickHandlers[i]({
                                    addon_key: reg.extension.addon_key,
                                    key: reg.extension.key,
                                    extension_id: reg.extension_id
                                });
                            }
                        },
                        {
                            key: "unregisterClickHandler",
                            value: function unregisterClickHandler() {
                                this._clickHandlers = [];
                            }
                        },
                        {
                            key: "getApiSpec",
                            value: function getApiSpec(addonKey) {
                                var _this5 = this;
                                function getModuleDefinition(mod) {
                                    return Object.getOwnPropertyNames(mod).reduce(function(accumulator, memberName) {
                                        var member = mod[memberName];
                                        switch(_typeof(member)){
                                            case 'function':
                                                accumulator[memberName] = {
                                                    args: _util.default.argumentNames(member),
                                                    returnsPromise: member.returnsPromise || false
                                                };
                                                break;
                                            case 'object':
                                                if (member.hasOwnProperty('constructor')) accumulator[memberName] = getModuleDefinition(member);
                                                break;
                                        }
                                        return accumulator;
                                    }, {});
                                }
                                return Object.getOwnPropertyNames(this._registeredAPIModules).reduce(function(accumulator, moduleName) {
                                    var module1 = _this5._registeredAPIModules[moduleName];
                                    if (typeof module1.addonKey === 'undefined' || module1.addonKey === addonKey) accumulator[moduleName] = getModuleDefinition(module1);
                                    return accumulator;
                                }, {});
                            }
                        },
                        {
                            key: "_originEqual",
                            value: function _originEqual(url, origin) {
                                function strCheck(str) {
                                    return typeof str === 'string' && str.length > 0;
                                }
                                var urlOrigin = _util.default.getOrigin(url); // check strings are strings and they contain something
                                if (!strCheck(url) || !strCheck(origin) || !strCheck(urlOrigin)) return false;
                                return origin === urlOrigin;
                            } // validate origin of postMessage
                        },
                        {
                            key: "_checkOrigin",
                            value: function _checkOrigin(event, reg) {
                                var no_source_types = [
                                    'init'
                                ];
                                var isNoSourceType = reg && no_source_types.includes(event.data.type);
                                var sourceTypeMatches = reg && event.source === reg.source;
                                var hasExtensionUrl = reg && this._originEqual(reg.extension.url, event.origin);
                                var isValidOrigin = hasExtensionUrl && (isNoSourceType || sourceTypeMatches); // get_host_offset fires before init
                                if (event.data.type === 'get_host_offset' && window === window.top) isValidOrigin = true;
                                 // check undefined for chromium (Issue 395010)
                                if (event.data.type === 'unload' && (sourceTypeMatches || event.source === undefined)) isValidOrigin = true;
                                return isValidOrigin;
                            }
                        },
                        {
                            key: "getRegisteredExtensions",
                            value: function getRegisteredExtensions(filter) {
                                if (filter) return this._findRegistrations(filter);
                                return this._registeredExtensions;
                            }
                        },
                        {
                            key: "unregisterExtension",
                            value: function unregisterExtension(filter) {
                                var registrations = this._findRegistrations(filter);
                                if (registrations.length !== 0) registrations.forEach(function(registration) {
                                    var _this6 = this;
                                    var keys = Object.keys(this._pendingEvents);
                                    keys.forEach(function(index) {
                                        var element = _this6._pendingEvents[index];
                                        var targetSpec = element.targetSpec || {};
                                        if (targetSpec.addon_key === registration.extension.addon_key && targetSpec.key === registration.extension.key) delete _this6._pendingEvents[index];
                                    });
                                    delete this._registeredExtensions[registration.extension_id];
                                }, this);
                            }
                        },
                        {
                            key: "setFeatureFlagGetter",
                            value: function setFeatureFlagGetter(getBooleanFeatureFlag) {
                                this._getBooleanFeatureFlag = getBooleanFeatureFlag;
                            }
                        }
                    ]);
                    return XDMRPC;
                }(_postmessage.default);
                var _default = XDMRPC;
                exports.default = _default;
                module1.exports = exports.default;
            },
            {
                "../common/postmessage": 1,
                "../common/util": 2
            }
        ]
    }, {}, [
        5
    ])(5);
});

});

parcelRegister("8RVyV", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(_e) {
                    var n = t[o][1][_e];
                    return s(n ? n : _e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _util = _dereq_("./util");
                var _util2 = _interopRequireDefault(_util);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                var PostMessage = function() {
                    function PostMessage(data) {
                        _classCallCheck(this, PostMessage);
                        var d = data || {};
                        this._registerListener(d.listenOn);
                    }
                    _createClass(PostMessage, [
                        {
                            key: "_registerListener",
                            value: function _registerListener(listenOn) {
                                if (!listenOn || !listenOn.addEventListener) listenOn = window;
                                listenOn.addEventListener("message", _util2.default._bind(this, this._receiveMessage), false);
                            }
                        },
                        {
                            key: "_receiveMessage",
                            value: function _receiveMessage(event) {
                                var handler = this._messageHandlers[event.data.type], extensionId = event.data.eid, reg = void 0;
                                if (extensionId && this._registeredExtensions) reg = this._registeredExtensions[extensionId];
                                if (!handler || !this._checkOrigin(event, reg)) return false;
                                handler.call(this, event, reg);
                            }
                        }
                    ]);
                    return PostMessage;
                }();
                exports.default = PostMessage;
                module1.exports = exports["default"];
            },
            {
                "./util": 2
            }
        ],
        2: [
            function(_dereq_, module1, exports) {
                "use strict";
                var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function(obj) {
                    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                };
                var LOG_PREFIX = "[Simple-XDM] ";
                var nativeBind = Function.prototype.bind;
                var util = {
                    locationOrigin: function locationOrigin() {
                        if (!window.location.origin) return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
                        else return window.location.origin;
                    },
                    randomString: function randomString() {
                        return Math.floor(Math.random() * 1000000000).toString(16);
                    },
                    isString: function isString(str) {
                        return typeof str === "string" || str instanceof String;
                    },
                    argumentsToArray: function argumentsToArray(arrayLike) {
                        return Array.prototype.slice.call(arrayLike);
                    },
                    argumentNames: function argumentNames(fn) {
                        return fn.toString().replace(/((\/\/.*$)|(\/\*[^]*?\*\/))/mg, '') // strip comments
                        .replace(/[^(]+\(([^)]*)[^]+/, '$1') // get signature
                        .match(/([^\s,]+)/g) || [];
                    },
                    hasCallback: function hasCallback(args) {
                        var length = args.length;
                        return length > 0 && typeof args[length - 1] === 'function';
                    },
                    error: function error(msg) {
                        if (window.console && window.console.error) {
                            var outputError = [];
                            if (typeof msg === "string") {
                                outputError.push(LOG_PREFIX + msg);
                                outputError = outputError.concat(Array.prototype.slice.call(arguments, 1));
                            } else {
                                outputError.push(LOG_PREFIX);
                                outputError = outputError.concat(Array.prototype.slice.call(arguments));
                            }
                            window.console.error.apply(null, outputError);
                        }
                    },
                    warn: function warn(msg) {
                        if (window.console) console.warn(LOG_PREFIX + msg);
                    },
                    log: function log(msg) {
                        if (window.console) window.console.log(LOG_PREFIX + msg);
                    },
                    _bind: function _bind(thisp, fn) {
                        if (nativeBind && fn.bind === nativeBind) return fn.bind(thisp);
                        return function() {
                            return fn.apply(thisp, arguments);
                        };
                    },
                    throttle: function throttle(func, wait, context) {
                        var previous = 0;
                        return function() {
                            var now = Date.now();
                            if (now - previous > wait) {
                                previous = now;
                                func.apply(context, arguments);
                            }
                        };
                    },
                    each: function each(list, iteratee) {
                        var length;
                        var key;
                        if (list) {
                            length = list.length;
                            if (length != null && typeof list !== 'function') {
                                key = 0;
                                while(key < length){
                                    if (iteratee.call(list[key], key, list[key]) === false) break;
                                    key += 1;
                                }
                            } else {
                                for(key in list)if (list.hasOwnProperty(key)) {
                                    if (iteratee.call(list[key], key, list[key]) === false) break;
                                }
                            }
                        }
                    },
                    extend: function extend(dest) {
                        var args = arguments;
                        var srcs = [].slice.call(args, 1, args.length);
                        srcs.forEach(function(source) {
                            if ((typeof source === "undefined" ? "undefined" : _typeof(source)) === "object") Object.getOwnPropertyNames(source).forEach(function(name) {
                                dest[name] = source[name];
                            });
                        });
                        return dest;
                    },
                    sanitizeStructuredClone: function sanitizeStructuredClone(object) {
                        var whiteList = [
                            Boolean,
                            String,
                            Date,
                            RegExp,
                            Blob,
                            File,
                            FileList,
                            ArrayBuffer
                        ];
                        var blackList = [
                            Error,
                            Node
                        ];
                        var warn = util.warn;
                        var visitedObjects = [];
                        function _clone(value) {
                            if (typeof value === 'function') {
                                warn("A function was detected and removed from the message.");
                                return null;
                            }
                            if (blackList.some(function(t) {
                                if (value instanceof t) {
                                    warn(t.name + " object was detected and removed from the message.");
                                    return true;
                                }
                                return false;
                            })) return {};
                            if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object' && whiteList.every(function(t) {
                                return !(value instanceof t);
                            })) {
                                var newValue = void 0;
                                if (Array.isArray(value)) newValue = value.map(function(element) {
                                    return _clone(element);
                                });
                                else {
                                    if (visitedObjects.indexOf(value) > -1) {
                                        warn("A circular reference was detected and removed from the message.");
                                        return null;
                                    }
                                    visitedObjects.push(value);
                                    newValue = {};
                                    for(var name in value)if (value.hasOwnProperty(name)) {
                                        var clonedValue = _clone(value[name]);
                                        if (clonedValue !== null) newValue[name] = clonedValue;
                                    }
                                    visitedObjects.pop();
                                }
                                return newValue;
                            }
                            return value;
                        }
                        return _clone(object);
                    },
                    getOrigin: function getOrigin(url, base) {
                        // everything except IE11
                        if (typeof URL === 'function') try {
                            return new URL(url, base).origin;
                        } catch (e) {}
                        // ie11 + safari 10
                        var doc = document.implementation.createHTMLDocument('');
                        if (base) {
                            var baseElement = doc.createElement('base');
                            baseElement.href = base;
                            doc.head.appendChild(baseElement);
                        }
                        var anchorElement = doc.createElement('a');
                        anchorElement.href = url;
                        doc.body.appendChild(anchorElement);
                        var origin = anchorElement.protocol + '//' + anchorElement.hostname;
                        //ie11, only include port if referenced in initial URL
                        if (url.match(/\/\/[^/]+:[0-9]+\//)) origin += anchorElement.port ? ':' + anchorElement.port : '';
                        return origin;
                    }
                };
                exports.default = util;
                module1.exports = exports["default"];
            },
            {}
        ],
        3: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _xdmrpc = _dereq_('./xdmrpc');
                var _xdmrpc2 = _interopRequireDefault(_xdmrpc);
                var _util = _dereq_('../common/util');
                var _util2 = _interopRequireDefault(_util);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                var Connect = function() {
                    function Connect() {
                        _classCallCheck(this, Connect);
                        this._xdm = new _xdmrpc2.default();
                    }
                    /**
         * Send a message to iframes matching the targetSpec. This message is added to
         *  a message queue for delivery to ensure the message is received if an iframe
         *  has not yet loaded
         *
         * @param type The name of the event type
         * @param targetSpec The spec to match against extensions when sending this event
         * @param event The event payload
         * @param callback A callback to be executed when the remote iframe calls its callback
         */ _createClass(Connect, [
                        {
                            key: 'dispatch',
                            value: function dispatch(type, targetSpec, event, callback) {
                                this._xdm.queueEvent(type, targetSpec, event, callback);
                                return this.getExtensions(targetSpec);
                            }
                        },
                        {
                            key: 'broadcast',
                            value: function broadcast(type, targetSpec, event) {
                                this._xdm.dispatch(type, targetSpec, event, null, null);
                                return this.getExtensions(targetSpec);
                            }
                        },
                        {
                            key: '_createId',
                            value: function _createId(extension) {
                                if (!extension.addon_key || !extension.key) throw Error('Extensions require addon_key and key');
                                return extension.addon_key + '__' + extension.key + '__' + _util2.default.randomString();
                            }
                        },
                        {
                            key: 'create',
                            value: function create(extension, initCallback, unloadCallback) {
                                var extension_id = this.registerExtension(extension, initCallback, unloadCallback);
                                var options = extension.options || {};
                                var data = {
                                    extension_id: extension_id,
                                    api: this._xdm.getApiSpec(extension.addon_key),
                                    origin: _util2.default.locationOrigin(),
                                    options: options
                                };
                                return {
                                    id: extension_id,
                                    name: JSON.stringify(data),
                                    src: extension.url
                                };
                            }
                        },
                        {
                            key: 'registerRequestNotifier',
                            value: function registerRequestNotifier(callback) {
                                this._xdm.registerRequestNotifier(callback);
                            }
                        },
                        {
                            key: 'registerExtension',
                            value: function registerExtension(extension, initCallback, unloadCallback) {
                                var extension_id = this._createId(extension);
                                this._xdm.registerExtension(extension_id, {
                                    extension: extension,
                                    initCallback: initCallback,
                                    unloadCallback: unloadCallback
                                });
                                return extension_id;
                            }
                        },
                        {
                            key: 'registerKeyListener',
                            value: function registerKeyListener(extension_id, key, modifiers, callback) {
                                this._xdm.registerKeyListener(extension_id, key, modifiers, callback);
                            }
                        },
                        {
                            key: 'unregisterKeyListener',
                            value: function unregisterKeyListener(extension_id, key, modifiers, callback) {
                                this._xdm.unregisterKeyListener(extension_id, key, modifiers, callback);
                            }
                        },
                        {
                            key: 'registerClickHandler',
                            value: function registerClickHandler(callback) {
                                this._xdm.registerClickHandler(callback);
                            }
                        },
                        {
                            key: 'unregisterClickHandler',
                            value: function unregisterClickHandler() {
                                this._xdm.unregisterClickHandler();
                            }
                        },
                        {
                            key: 'defineModule',
                            value: function defineModule(moduleName, module1, options) {
                                this._xdm.defineAPIModule(module1, moduleName, options);
                            }
                        },
                        {
                            key: 'isModuleDefined',
                            value: function isModuleDefined(moduleName) {
                                return this._xdm.isAPIModuleDefined(moduleName);
                            }
                        },
                        {
                            key: 'defineGlobals',
                            value: function defineGlobals(module1) {
                                this._xdm.defineAPIModule(module1);
                            }
                        },
                        {
                            key: 'getExtensions',
                            value: function getExtensions(filter) {
                                return this._xdm.getRegisteredExtensions(filter);
                            }
                        },
                        {
                            key: 'unregisterExtension',
                            value: function unregisterExtension(filter) {
                                return this._xdm.unregisterExtension(filter);
                            }
                        },
                        {
                            key: 'returnsPromise',
                            value: function returnsPromise(wrappedMethod) {
                                wrappedMethod.returnsPromise = true;
                            }
                        },
                        {
                            key: 'setFeatureFlagGetter',
                            value: function setFeatureFlagGetter(getBooleanFeatureFlag) {
                                this._xdm.setFeatureFlagGetter(getBooleanFeatureFlag);
                            }
                        },
                        {
                            key: 'registerExistingExtension',
                            value: function registerExistingExtension(extension_id, data) {
                                return this._xdm.registerExtension(extension_id, data);
                            }
                        }
                    ]);
                    return Connect;
                }();
                exports.default = Connect;
                module1.exports = exports['default'];
            },
            {
                "../common/util": 2,
                "./xdmrpc": 5
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                'use strict';
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _connect = _dereq_('./connect');
                var _connect2 = _interopRequireDefault(_connect);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                exports.default = new _connect2.default();
                module1.exports = exports['default'];
            },
            {
                "./connect": 3
            }
        ],
        5: [
            function(_dereq_, module1, exports) {
                'use strict';
                var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function(obj) {
                    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                };
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                var _util = _dereq_('../common/util');
                var _util2 = _interopRequireDefault(_util);
                var _postmessage = _dereq_('../common/postmessage');
                var _postmessage2 = _interopRequireDefault(_postmessage);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _possibleConstructorReturn(self, call) {
                    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return call && ((typeof call === "undefined" ? "undefined" : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof2(superClass)));
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
                } /**
        * Postmessage format:
        *
        * Initialization
        * --------------
        * {
        *   type: 'init',
        *   eid: 'my-addon__my-module-xyz'  // the extension identifier, unique across iframes
        * }
        *
        * Request
        * -------
        * {
        *   type: 'req',
        *   eid: 'my-addon__my-module-xyz',  // the extension identifier, unique for iframe
        *   mid: 'xyz',  // a unique message identifier, required for callbacks
        *   mod: 'cookie',  // the module name
        *   fn: 'read',  // the method name
        *   args: [arguments]  // the method arguments
        * }
        *
        * Response
        * --------
        * {
        *   type: 'resp'
        *   eid: 'my-addon__my-module-xyz',  // the extension identifier, unique for iframe
        *   mid: 'xyz',  // a unique message identifier, obtained from the request
        *   args: [arguments]  // the callback arguments
        * }
        *
        * Event
        * -----
        * {
        *   type: 'evt',
        *   etyp: 'some-event',
        *   evnt: { ... }  // the event data
        *   mid: 'xyz', // a unique message identifier for the event
        * }
        **/ 
                var VALID_EVENT_TIME_MS = 30000; //30 seconds
                var XDMRPC = function(_PostMessage) {
                    _inherits(XDMRPC, _PostMessage);
                    _createClass(XDMRPC, [
                        {
                            key: '_padUndefinedArguments',
                            value: function _padUndefinedArguments(array, length) {
                                return array.length >= length ? array : array.concat(new Array(length - array.length));
                            }
                        }
                    ]);
                    function XDMRPC(config) {
                        _classCallCheck(this, XDMRPC);
                        config = config || {};
                        var _this = _possibleConstructorReturn(this, (XDMRPC.__proto__ || Object.getPrototypeOf(XDMRPC)).call(this, config));
                        _this._registeredExtensions = config.extensions || {};
                        _this._registeredAPIModules = {};
                        _this._registeredAPIModules._globals = {};
                        _this._pendingCallbacks = {};
                        _this._keycodeCallbacks = {};
                        _this._clickHandler = null;
                        _this._pendingEvents = {};
                        _this._messageHandlers = {
                            init: _this._handleInit,
                            req: _this._handleRequest,
                            resp: _this._handleResponse,
                            broadcast: _this._handleBroadcast,
                            event_query: _this._handleEventQuery,
                            key_triggered: _this._handleKeyTriggered,
                            addon_clicked: _this._handleAddonClick,
                            get_host_offset: _this._getHostOffset,
                            unload: _this._handleUnload,
                            sub: _this._handleSubInit
                        };
                        return _this;
                    }
                    _createClass(XDMRPC, [
                        {
                            key: '_verifyAPI',
                            value: function _verifyAPI(event, reg) {
                                var untrustedTargets = event.data.targets;
                                if (!untrustedTargets) return;
                                var trustedSpec = this.getApiSpec();
                                var tampered = false;
                                function check(trusted, untrusted) {
                                    Object.getOwnPropertyNames(untrusted).forEach(function(name) {
                                        if (_typeof(untrusted[name]) === 'object' && trusted[name]) check(trusted[name], untrusted[name]);
                                        else if (untrusted[name] === 'parent' && trusted[name]) tampered = true;
                                    });
                                }
                                check(trustedSpec, untrustedTargets);
                                event.source.postMessage({
                                    type: 'api_tamper',
                                    tampered: tampered
                                }, reg.extension.url);
                            }
                        },
                        {
                            key: '_handleInit',
                            value: function _handleInit(event, reg) {
                                event.source.postMessage({
                                    type: 'init_received'
                                }, reg.extension.url);
                                this._registeredExtensions[reg.extension_id].source = event.source;
                                if (reg.initCallback) {
                                    reg.initCallback(event.data.eid);
                                    delete reg.initCallback;
                                }
                                if (event.data.targets) this._verifyAPI(event, reg);
                            }
                        },
                        {
                            key: '_handleSubInit',
                            value: function _handleSubInit(event, reg) {
                                var blocked = reg.extension.options.noSub || this._getBooleanFeatureFlag && this._getBooleanFeatureFlag('com.atlassian.connect.resolve_inner_iframe_url');
                                var data = event.data;
                                if (blocked) _util2.default.error("Sub-Extension requested by [" + reg.extension.addon_key + "] but feature is disabled");
                                else this.registerExtension(data.ext.id, {
                                    extension: data.ext
                                });
                                if (this._registeredRequestNotifier) this._registeredRequestNotifier.call(null, {
                                    sub: data.ext,
                                    type: data.type,
                                    addon_key: reg.extension.addon_key,
                                    key: reg.extension.key,
                                    extension_id: reg.extension_id,
                                    blocked: blocked
                                });
                            }
                        },
                        {
                            key: '_getHostOffset',
                            value: function _getHostOffset(event, _window) {
                                var hostWindow = event.source;
                                var hostFrameOffset = null;
                                var windowReference = _window || window; // For testing
                                if (windowReference === windowReference.top && typeof windowReference.getHostOffsetFunctionOverride === 'function') hostFrameOffset = windowReference.getHostOffsetFunctionOverride(hostWindow);
                                if (typeof hostFrameOffset !== 'number') {
                                    hostFrameOffset = 0;
                                    // Find the closest frame that has the same origin as event source
                                    while(!this._hasSameOrigin(hostWindow)){
                                        // Climb up the iframe tree 1 layer
                                        hostFrameOffset++;
                                        hostWindow = hostWindow.parent;
                                    }
                                }
                                event.source.postMessage({
                                    hostFrameOffset: hostFrameOffset
                                }, event.origin);
                            }
                        },
                        {
                            key: '_hasSameOrigin',
                            value: function _hasSameOrigin(window1) {
                                if (window1 === window1.top) return true;
                                try {
                                    // Try set & read a variable on the given window
                                    // If we can successfully read the value then it means the given window has the same origin
                                    // as the window that is currently executing the script
                                    var testVariableName = 'test_var_' + Math.random().toString(16).substr(2);
                                    window1[testVariableName] = true;
                                    return window1[testVariableName];
                                } catch (e) {
                                // A exception will be thrown if the windows doesn't have the same origin
                                }
                                return false;
                            }
                        },
                        {
                            key: '_handleResponse',
                            value: function _handleResponse(event) {
                                var data = event.data;
                                var pendingCallback = this._pendingCallbacks[data.mid];
                                if (pendingCallback) {
                                    delete this._pendingCallbacks[data.mid];
                                    pendingCallback.apply(window, data.args);
                                }
                            }
                        },
                        {
                            key: 'registerRequestNotifier',
                            value: function registerRequestNotifier(cb) {
                                this._registeredRequestNotifier = cb;
                            }
                        },
                        {
                            key: '_handleRequest',
                            value: function _handleRequest(event, reg) {
                                function sendResponse() {
                                    var args = _util2.default.sanitizeStructuredClone(_util2.default.argumentsToArray(arguments));
                                    event.source.postMessage({
                                        mid: event.data.mid,
                                        type: 'resp',
                                        forPlugin: true,
                                        args: args
                                    }, reg.extension.url);
                                }
                                var data = event.data;
                                var module1 = this._registeredAPIModules[data.mod];
                                var extension = this.getRegisteredExtensions(reg.extension)[0];
                                if (module1) {
                                    var fnName = data.fn;
                                    if (data._cls) {
                                        var Cls = module1[data._cls];
                                        var ns = data.mod + '-' + data._cls + '-';
                                        sendResponse._id = data._id;
                                        if (fnName === 'constructor') {
                                            if (!Cls._construct) {
                                                Cls.constructor.prototype._destroy = function() {
                                                    delete this._context._proxies[ns + this._id];
                                                };
                                                Cls._construct = function() {
                                                    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                                                    var inst = new (Function.prototype.bind.apply(Cls.constructor, [
                                                        null
                                                    ].concat(args)))();
                                                    var callback = args[args.length - 1];
                                                    inst._id = callback._id;
                                                    inst._context = callback._context;
                                                    inst._context._proxies[ns + inst._id] = inst;
                                                    return inst;
                                                };
                                            }
                                            module1 = Cls;
                                            fnName = '_construct';
                                        } else module1 = extension._proxies[ns + data._id];
                                    }
                                    var method = module1[fnName];
                                    if (method) {
                                        var methodArgs = data.args;
                                        var padLength = method.length - 1;
                                        if (fnName === '_construct') padLength = module1.constructor.length - 1;
                                        sendResponse._context = extension;
                                        methodArgs = this._padUndefinedArguments(methodArgs, padLength);
                                        methodArgs.push(sendResponse);
                                        var promiseResult = method.apply(module1, methodArgs);
                                        if (method.returnsPromise) {
                                            if (!((typeof promiseResult === 'undefined' ? 'undefined' : _typeof(promiseResult)) === 'object' || typeof promiseResult === 'function') || typeof promiseResult.then !== 'function') sendResponse('Defined module method did not return a promise.');
                                            else promiseResult.then(function(result) {
                                                sendResponse(undefined, result);
                                            }).catch(function(err) {
                                                err = err instanceof Error ? err.message : err;
                                                sendResponse(err);
                                            });
                                        }
                                        if (this._registeredRequestNotifier) this._registeredRequestNotifier.call(null, {
                                            module: data.mod,
                                            fn: data.fn,
                                            type: data.type,
                                            addon_key: reg.extension.addon_key,
                                            key: reg.extension.key,
                                            extension_id: reg.extension_id
                                        });
                                    }
                                }
                            }
                        },
                        {
                            key: '_handleBroadcast',
                            value: function _handleBroadcast(event, reg) {
                                var event_data = event.data;
                                var targetSpec = function targetSpec(r) {
                                    return r.extension.addon_key === reg.extension.addon_key && r.extension_id !== reg.extension_id;
                                };
                                this.dispatch(event_data.etyp, targetSpec, event_data.evnt, null, null);
                            }
                        },
                        {
                            key: '_handleKeyTriggered',
                            value: function _handleKeyTriggered(event, reg) {
                                var eventData = event.data;
                                var keycodeEntry = this._keycodeKey(eventData.keycode, eventData.modifiers, reg.extension_id);
                                var listeners = this._keycodeCallbacks[keycodeEntry];
                                if (listeners) listeners.forEach(function(listener) {
                                    listener.call(null, {
                                        addon_key: reg.extension.addon_key,
                                        key: reg.extension.key,
                                        extension_id: reg.extension_id,
                                        keycode: eventData.keycode,
                                        modifiers: eventData.modifiers
                                    });
                                }, this);
                            }
                        },
                        {
                            key: 'defineAPIModule',
                            value: function defineAPIModule(module1, moduleName) {
                                moduleName = moduleName || '_globals';
                                this._registeredAPIModules[moduleName] = _util2.default.extend({}, this._registeredAPIModules[moduleName] || {}, module1);
                                return this._registeredAPIModules;
                            }
                        },
                        {
                            key: 'isAPIModuleDefined',
                            value: function isAPIModuleDefined(moduleName) {
                                return typeof this._registeredAPIModules[moduleName] !== 'undefined';
                            }
                        },
                        {
                            key: '_pendingEventKey',
                            value: function _pendingEventKey(targetSpec, time) {
                                var key = targetSpec.addon_key || 'global';
                                if (targetSpec.key) key = key + '@@' + targetSpec.key;
                                key = key + '@@' + time;
                                return key;
                            }
                        },
                        {
                            key: 'queueEvent',
                            value: function queueEvent(type, targetSpec, event, callback) {
                                var loaded_frame, targets = this._findRegistrations(targetSpec);
                                loaded_frame = targets.some(function(target) {
                                    return target.registered_events !== undefined;
                                }, this);
                                if (loaded_frame) this.dispatch(type, targetSpec, event, callback);
                                else {
                                    this._cleanupInvalidEvents();
                                    var time = new Date().getTime();
                                    this._pendingEvents[this._pendingEventKey(targetSpec, time)] = {
                                        type: type,
                                        targetSpec: targetSpec,
                                        event: event,
                                        callback: callback,
                                        time: time,
                                        uid: _util2.default.randomString()
                                    };
                                }
                            }
                        },
                        {
                            key: '_cleanupInvalidEvents',
                            value: function _cleanupInvalidEvents() {
                                var _this2 = this;
                                var now = new Date().getTime();
                                var keys = Object.keys(this._pendingEvents);
                                keys.forEach(function(index) {
                                    var element = _this2._pendingEvents[index];
                                    var eventIsValid = now - element.time <= VALID_EVENT_TIME_MS;
                                    if (!eventIsValid) delete _this2._pendingEvents[index];
                                });
                            }
                        },
                        {
                            key: '_handleEventQuery',
                            value: function _handleEventQuery(message, extension) {
                                var _this3 = this;
                                var executed = {};
                                var now = new Date().getTime();
                                var keys = Object.keys(this._pendingEvents);
                                keys.forEach(function(index) {
                                    var element = _this3._pendingEvents[index];
                                    var eventIsValid = now - element.time <= VALID_EVENT_TIME_MS;
                                    var isSameTarget = !element.targetSpec || _this3._findRegistrations(element.targetSpec).length !== 0;
                                    if (isSameTarget && element.targetSpec.key) isSameTarget = element.targetSpec.addon_key === extension.extension.addon_key && element.targetSpec.key === extension.extension.key;
                                    if (eventIsValid && isSameTarget) {
                                        executed[index] = element;
                                        element.targetSpec = element.targetSpec || {};
                                        _this3.dispatch(element.type, element.targetSpec, element.event, element.callback, message.source);
                                    } else if (!eventIsValid) delete _this3._pendingEvents[index];
                                });
                                this._registeredExtensions[extension.extension_id].registered_events = message.data.args;
                                return executed;
                            }
                        },
                        {
                            key: '_handleUnload',
                            value: function _handleUnload(event, reg) {
                                if (!reg) return;
                                if (reg.extension_id && this._registeredExtensions[reg.extension_id]) delete this._registeredExtensions[reg.extension_id].source;
                                if (reg.unloadCallback) reg.unloadCallback(event.data.eid);
                            }
                        },
                        {
                            key: 'dispatch',
                            value: function dispatch(type, targetSpec, event, callback, source) {
                                function sendEvent(reg, evnt) {
                                    if (reg.source && reg.source.postMessage) {
                                        var mid;
                                        if (callback) {
                                            mid = _util2.default.randomString();
                                            this._pendingCallbacks[mid] = callback;
                                        }
                                        reg.source.postMessage({
                                            type: 'evt',
                                            mid: mid,
                                            etyp: type,
                                            evnt: evnt
                                        }, reg.extension.url);
                                    }
                                }
                                var registrations = this._findRegistrations(targetSpec || {});
                                registrations.forEach(function(reg) {
                                    if (source && !reg.source) reg.source = source;
                                    if (reg.source) _util2.default._bind(this, sendEvent)(reg, event);
                                }, this);
                            }
                        },
                        {
                            key: '_findRegistrations',
                            value: function _findRegistrations(targetSpec) {
                                var _this4 = this;
                                if (this._registeredExtensions.length === 0) {
                                    _util2.default.error('no registered extensions', this._registeredExtensions);
                                    return [];
                                }
                                var keys = Object.getOwnPropertyNames(targetSpec);
                                var registrations = Object.getOwnPropertyNames(this._registeredExtensions).map(function(key) {
                                    return _this4._registeredExtensions[key];
                                });
                                if (targetSpec instanceof Function) return registrations.filter(targetSpec);
                                else return registrations.filter(function(reg) {
                                    return keys.every(function(key) {
                                        return reg.extension[key] === targetSpec[key];
                                    });
                                });
                            }
                        },
                        {
                            key: 'registerExtension',
                            value: function registerExtension(extension_id, data) {
                                data._proxies = {};
                                data.extension_id = extension_id;
                                this._registeredExtensions[extension_id] = data;
                            }
                        },
                        {
                            key: '_keycodeKey',
                            value: function _keycodeKey(key, modifiers, extension_id) {
                                var code = key;
                                if (modifiers) {
                                    if (typeof modifiers === "string") modifiers = [
                                        modifiers
                                    ];
                                    modifiers.sort();
                                    modifiers.forEach(function(modifier) {
                                        code += '$$' + modifier;
                                    }, this);
                                }
                                return code + '__' + extension_id;
                            }
                        },
                        {
                            key: 'registerKeyListener',
                            value: function registerKeyListener(extension_id, key, modifiers, callback) {
                                if (typeof modifiers === "string") modifiers = [
                                    modifiers
                                ];
                                var reg = this._registeredExtensions[extension_id];
                                var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
                                if (!this._keycodeCallbacks[keycodeEntry]) {
                                    this._keycodeCallbacks[keycodeEntry] = [];
                                    reg.source.postMessage({
                                        type: 'key_listen',
                                        keycode: key,
                                        modifiers: modifiers,
                                        action: 'add'
                                    }, reg.extension.url);
                                }
                                this._keycodeCallbacks[keycodeEntry].push(callback);
                            }
                        },
                        {
                            key: 'unregisterKeyListener',
                            value: function unregisterKeyListener(extension_id, key, modifiers, callback) {
                                var keycodeEntry = this._keycodeKey(key, modifiers, extension_id);
                                var potentialCallbacks = this._keycodeCallbacks[keycodeEntry];
                                var reg = this._registeredExtensions[extension_id];
                                if (potentialCallbacks) {
                                    if (callback) {
                                        var index = potentialCallbacks.indexOf(callback);
                                        this._keycodeCallbacks[keycodeEntry].splice(index, 1);
                                    } else delete this._keycodeCallbacks[keycodeEntry];
                                    if (reg.source && reg.source.postMessage) reg.source.postMessage({
                                        type: 'key_listen',
                                        keycode: key,
                                        modifiers: modifiers,
                                        action: 'remove'
                                    }, reg.extension.url);
                                }
                            }
                        },
                        {
                            key: 'registerClickHandler',
                            value: function registerClickHandler(callback) {
                                if (typeof callback !== 'function') throw new Error('callback must be a function');
                                if (this._clickHandler !== null) throw new Error('ClickHandler already registered');
                                this._clickHandler = callback;
                            }
                        },
                        {
                            key: '_handleAddonClick',
                            value: function _handleAddonClick(event, reg) {
                                if (typeof this._clickHandler === 'function') this._clickHandler({
                                    addon_key: reg.extension.addon_key,
                                    key: reg.extension.key,
                                    extension_id: reg.extension_id
                                });
                            }
                        },
                        {
                            key: 'unregisterClickHandler',
                            value: function unregisterClickHandler() {
                                this._clickHandler = null;
                            }
                        },
                        {
                            key: 'getApiSpec',
                            value: function getApiSpec(addonKey) {
                                var _this5 = this;
                                function getModuleDefinition(mod) {
                                    return Object.getOwnPropertyNames(mod).reduce(function(accumulator, memberName) {
                                        var member = mod[memberName];
                                        switch(typeof member === 'undefined' ? 'undefined' : _typeof(member)){
                                            case 'function':
                                                accumulator[memberName] = {
                                                    args: _util2.default.argumentNames(member),
                                                    returnsPromise: member.returnsPromise || false
                                                };
                                                break;
                                            case 'object':
                                                if (member.hasOwnProperty('constructor')) accumulator[memberName] = getModuleDefinition(member);
                                                break;
                                        }
                                        return accumulator;
                                    }, {});
                                }
                                return Object.getOwnPropertyNames(this._registeredAPIModules).reduce(function(accumulator, moduleName) {
                                    var module1 = _this5._registeredAPIModules[moduleName];
                                    if (typeof module1.addonKey === 'undefined' || module1.addonKey === addonKey) accumulator[moduleName] = getModuleDefinition(module1);
                                    return accumulator;
                                }, {});
                            }
                        },
                        {
                            key: '_originEqual',
                            value: function _originEqual(url, origin) {
                                function strCheck(str) {
                                    return typeof str === 'string' && str.length > 0;
                                }
                                var urlOrigin = _util2.default.getOrigin(url);
                                // check strings are strings and they contain something
                                if (!strCheck(url) || !strCheck(origin) || !strCheck(urlOrigin)) return false;
                                return origin === urlOrigin;
                            }
                        },
                        {
                            key: '_checkOrigin',
                            value: function _checkOrigin(event, reg) {
                                var no_source_types = [
                                    'init'
                                ];
                                var isNoSourceType = reg && !reg.source && no_source_types.indexOf(event.data.type) > -1;
                                var sourceTypeMatches = reg && event.source === reg.source;
                                var hasExtensionUrl = reg && this._originEqual(reg.extension.url, event.origin);
                                var isValidOrigin = hasExtensionUrl && (isNoSourceType || sourceTypeMatches);
                                // get_host_offset fires before init
                                if (event.data.type === 'get_host_offset' && window === window.top) isValidOrigin = true;
                                // check undefined for chromium (Issue 395010)
                                if (event.data.type === 'unload' && (sourceTypeMatches || event.source === undefined)) isValidOrigin = true;
                                return isValidOrigin;
                            }
                        },
                        {
                            key: 'getRegisteredExtensions',
                            value: function getRegisteredExtensions(filter) {
                                if (filter) return this._findRegistrations(filter);
                                return this._registeredExtensions;
                            }
                        },
                        {
                            key: 'unregisterExtension',
                            value: function unregisterExtension(filter) {
                                var registrations = this._findRegistrations(filter);
                                if (registrations.length !== 0) registrations.forEach(function(registration) {
                                    var _this6 = this;
                                    var keys = Object.keys(this._pendingEvents);
                                    keys.forEach(function(index) {
                                        var element = _this6._pendingEvents[index];
                                        var targetSpec = element.targetSpec || {};
                                        if (targetSpec.addon_key === registration.extension.addon_key && targetSpec.key === registration.extension.key) delete _this6._pendingEvents[index];
                                    });
                                    delete this._registeredExtensions[registration.extension_id];
                                }, this);
                            }
                        },
                        {
                            key: 'setFeatureFlagGetter',
                            value: function setFeatureFlagGetter(getBooleanFeatureFlag) {
                                this._getBooleanFeatureFlag = getBooleanFeatureFlag;
                            }
                        }
                    ]);
                    return XDMRPC;
                }(_postmessage2.default);
                exports.default = XDMRPC;
                module1.exports = exports['default'];
            },
            {
                "../common/postmessage": 1,
                "../common/util": 2
            }
        ]
    }, {}, [
        4
    ])(4);
});

});

parcelRegister("9HehF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jJf3a = parcelRequire("jJf3a");

function $6886c403abc3e03b$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $42omo.useContext)((0, $jJf3a.ExperienceTrackerContext));
    const wasCalledRef = (0, $42omo.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $6886c403abc3e03b$export$f20b867e738a222c;

});

parcelRegister("6wQcp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4eu1q = parcelRequire("4eu1q");

// Add debounce to the scroll handler to ensure that it is executed only once after X ms of delay
const $6aa9e7f0f2c931d4$var$handleScrollDeboubced = (scrollHandler, delay)=>{
    let timeoutId;
    return (...args)=>{
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            scrollHandler(...args);
        }, delay);
    };
};
const $6aa9e7f0f2c931d4$export$4d8f561c32665bbe = (isHeightSetFromContent)=>{
    const [scrollPosition, setScrollPosition] = (0, $42omo.useState)(0);
    const defaultScrollPosition = (0, $42omo.useRef)(0); // mutable ref to 0 - return this value when the media is open
    const prevScrollPosition = (0, $42omo.useRef)(0);
    const { isMediaOpen: isMediaOpen } = (0, $4eu1q.useMediaViewerListener)();
    (0, $42omo.useEffect)(()=>{
        const handleScroll = $6aa9e7f0f2c931d4$var$handleScrollDeboubced(()=>{
            if (!isMediaOpen) {
                /*
					Saving the previous scroll position is essential because, by the time we receive the state of the media viewer,
					it may already have been opened or closed, and we do not have control over the actions that occur
					just before the media viewer is activated (which happens in a different package that we do not manage).
					Consequently, it is possible for the variable isMediaOpen to be false even when the media viewer is indeed open.
					This situation results in saving of an incorrect value for the scroll position when the media viewer is already active,
					which is misleading since the container height will have been reduced at this point.
					To mitigate this inaccuracy, we continuously track the scroll position when the media viewer is not open.
					When the media is subsequently clicked to open, retrieving the previous scroll position helps to offset the
					inaccuracies associated with saving the scroll position under the conditions of a condensed height.
				*/ prevScrollPosition.current = scrollPosition;
                setScrollPosition(window.scrollY);
            }
        }, 100); // Call the handler only once scroll event has stopped firing for a delay of 100ms.
        window.addEventListener('scroll', handleScroll);
        return ()=>{
            window.removeEventListener('scroll', handleScroll);
        };
    }, [
        isMediaOpen,
        scrollPosition
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isHeightSetFromContent) // Restore the scroll position back to the value saved before any media file was open
        window.scrollTo(0, isMediaOpen ? defaultScrollPosition.current : prevScrollPosition.current);
    }, [
        isHeightSetFromContent,
        isMediaOpen
    ]);
};
module.exports["useGetCurrentScrollPosition"] = $6aa9e7f0f2c931d4$export$4d8f561c32665bbe;

});

parcelRegister("aiCKw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");








var $7pThu = parcelRequire("7pThu");


var $9tQM5 = parcelRequire("9tQM5");

var $kFwgS = parcelRequire("kFwgS");


var $1oYQ9 = parcelRequire("1oYQ9");

const $7677bd876355e476$var$IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED = 'auto_closed';
const $7677bd876355e476$export$1fea75498367c4ac = (props)=>{
    const { allowedFeatures: allowedFeatures } = props;
    const contentConfiguration = (0, $42omo.useMemo)(()=>{
        const isTemplateBrowserEnabled = allowedFeatures === 'all' || allowedFeatures?.find((feature)=>feature === 'template-browser' || feature.hasOwnProperty('template-browser')) !== undefined;
        const queryParams = isTemplateBrowserEnabled ? {
            inEditorTemplatesPanel: $7677bd876355e476$var$IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED
        } : undefined;
        return {
            experiences: {
                experience: (0, $7pThu.ExperienceNames).EDIT_PAGE,
                ccExperience: (0, $7pThu.ExperienceNames).CC_EDIT_PAGE_EMBED
            },
            queryParams: queryParams
        };
    }, [
        allowedFeatures
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1oYQ9.Content), {
        ...props,
        contentType: (0, $9tQM5.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE,
        mode: (0, $kFwgS.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE,
        contentConfiguration: contentConfiguration
    });
};



var $elkSx = parcelRequire("elkSx");


var $I1nNR = parcelRequire("I1nNR");


var $gt5FF = parcelRequire("gt5FF");


var $kudeD = parcelRequire("kudeD");


var $cGc86 = parcelRequire("cGc86");

const $9310c72c080a483b$export$1fea75498367c4ac = (props)=>{
    const { markIframeLoadMetrics: markIframeLoadMetrics } = (0, $kudeD.usePerformanceMetrics)();
    (0, $42omo.useLayoutEffect)(()=>{
        markIframeLoadMetrics('lazy-load-end');
        markIframeLoadMetrics('common-load-start');
    }, [
        markIframeLoadMetrics
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $I1nNR.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $gt5FF.default),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cGc86.UniqueKeyProvider), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $elkSx.PageNotFoundEmptyState), {}),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7677bd876355e476$export$1fea75498367c4ac), {
                    ...props
                })
            })
        })
    });
};
module.exports["EditPage"] = $9310c72c080a483b$export$1fea75498367c4ac;

});

parcelRegister("8ce0W", function(module, exports) {
$parcel$export(module.exports, "Action", () => $5f7a50a9018faa6a$export$e19cd5f9376f8cee);
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $5f7a50a9018faa6a$var$_extends() {
    $5f7a50a9018faa6a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5f7a50a9018faa6a$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $5f7a50a9018faa6a$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($5f7a50a9018faa6a$export$e19cd5f9376f8cee || ($5f7a50a9018faa6a$export$e19cd5f9376f8cee = {}));
const $5f7a50a9018faa6a$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $5f7a50a9018faa6a$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $5f7a50a9018faa6a$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $5f7a50a9018faa6a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $5f7a50a9018faa6a$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $5f7a50a9018faa6a$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $5f7a50a9018faa6a$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $5f7a50a9018faa6a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $5f7a50a9018faa6a$export$fe53371bee54353d(to);
    }
    return $5f7a50a9018faa6a$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $5f7a50a9018faa6a$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $5f7a50a9018faa6a$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $5f7a50a9018faa6a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $5f7a50a9018faa6a$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $5f7a50a9018faa6a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $5f7a50a9018faa6a$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $5f7a50a9018faa6a$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $5f7a50a9018faa6a$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $5f7a50a9018faa6a$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $5f7a50a9018faa6a$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $5f7a50a9018faa6a$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $5f7a50a9018faa6a$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $5f7a50a9018faa6a$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $5f7a50a9018faa6a$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $5f7a50a9018faa6a$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $5f7a50a9018faa6a$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $5f7a50a9018faa6a$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($5f7a50a9018faa6a$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Push;
        let location = $5f7a50a9018faa6a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $5f7a50a9018faa6a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Replace;
        let location = $5f7a50a9018faa6a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $5f7a50a9018faa6a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $5f7a50a9018faa6a$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $5f7a50a9018faa6a$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($5f7a50a9018faa6a$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($5f7a50a9018faa6a$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $5f7a50a9018faa6a$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($5f7a50a9018faa6a$var$ResultType || ($5f7a50a9018faa6a$var$ResultType = {}));
const $5f7a50a9018faa6a$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $5f7a50a9018faa6a$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $5f7a50a9018faa6a$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $5f7a50a9018faa6a$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $5f7a50a9018faa6a$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($5f7a50a9018faa6a$var$isIndexRoute(route)) {
            let indexRoute = $5f7a50a9018faa6a$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $5f7a50a9018faa6a$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $5f7a50a9018faa6a$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $5f7a50a9018faa6a$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $5f7a50a9018faa6a$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $5f7a50a9018faa6a$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $5f7a50a9018faa6a$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $5f7a50a9018faa6a$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $5f7a50a9018faa6a$var$flattenRoutes(routes);
    $5f7a50a9018faa6a$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $5f7a50a9018faa6a$export$30d21fd6d7295f52(pathname);
        matches = $5f7a50a9018faa6a$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $5f7a50a9018faa6a$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $5f7a50a9018faa6a$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $5f7a50a9018faa6a$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $5f7a50a9018faa6a$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $5f7a50a9018faa6a$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $5f7a50a9018faa6a$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $5f7a50a9018faa6a$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $5f7a50a9018faa6a$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $5f7a50a9018faa6a$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $5f7a50a9018faa6a$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $5f7a50a9018faa6a$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $5f7a50a9018faa6a$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $5f7a50a9018faa6a$var$paramRe = /^:[\w-]+$/;
const $5f7a50a9018faa6a$var$dynamicSegmentValue = 3;
const $5f7a50a9018faa6a$var$indexRouteValue = 2;
const $5f7a50a9018faa6a$var$emptySegmentValue = 1;
const $5f7a50a9018faa6a$var$staticSegmentValue = 10;
const $5f7a50a9018faa6a$var$splatPenalty = -2;
const $5f7a50a9018faa6a$var$isSplat = (s)=>s === "*";
function $5f7a50a9018faa6a$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($5f7a50a9018faa6a$var$isSplat)) initialScore += $5f7a50a9018faa6a$var$splatPenalty;
    if (index) initialScore += $5f7a50a9018faa6a$var$indexRouteValue;
    return segments.filter((s)=>!$5f7a50a9018faa6a$var$isSplat(s)).reduce((score, segment)=>score + ($5f7a50a9018faa6a$var$paramRe.test(segment) ? $5f7a50a9018faa6a$var$dynamicSegmentValue : segment === "" ? $5f7a50a9018faa6a$var$emptySegmentValue : $5f7a50a9018faa6a$var$staticSegmentValue), initialScore);
}
function $5f7a50a9018faa6a$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $5f7a50a9018faa6a$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $5f7a50a9018faa6a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $5f7a50a9018faa6a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $5f7a50a9018faa6a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $5f7a50a9018faa6a$export$a5c6d149b50c1d86($5f7a50a9018faa6a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $5f7a50a9018faa6a$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $5f7a50a9018faa6a$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $5f7a50a9018faa6a$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $5f7a50a9018faa6a$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $5f7a50a9018faa6a$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $5f7a50a9018faa6a$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $5f7a50a9018faa6a$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $5f7a50a9018faa6a$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $5f7a50a9018faa6a$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $5f7a50a9018faa6a$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $5f7a50a9018faa6a$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $5f7a50a9018faa6a$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $5f7a50a9018faa6a$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $5f7a50a9018faa6a$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $5f7a50a9018faa6a$var$normalizeSearch(search),
        hash: $5f7a50a9018faa6a$var$normalizeHash(hash)
    };
}
function $5f7a50a9018faa6a$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $5f7a50a9018faa6a$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $5f7a50a9018faa6a$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $5f7a50a9018faa6a$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $5f7a50a9018faa6a$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $5f7a50a9018faa6a$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $5f7a50a9018faa6a$export$8ccf933b0513f8d0(toArg);
    else {
        to = $5f7a50a9018faa6a$var$_extends({}, toArg);
        $5f7a50a9018faa6a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $5f7a50a9018faa6a$var$getInvalidPathError("?", "pathname", "search", to));
        $5f7a50a9018faa6a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $5f7a50a9018faa6a$var$getInvalidPathError("#", "pathname", "hash", to));
        $5f7a50a9018faa6a$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $5f7a50a9018faa6a$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $5f7a50a9018faa6a$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $5f7a50a9018faa6a$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $5f7a50a9018faa6a$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $5f7a50a9018faa6a$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $5f7a50a9018faa6a$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $5f7a50a9018faa6a$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $5f7a50a9018faa6a$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $5f7a50a9018faa6a$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $5f7a50a9018faa6a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $5f7a50a9018faa6a$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $5f7a50a9018faa6a$export$4051a07651545597(data, init) {
    return new $5f7a50a9018faa6a$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $5f7a50a9018faa6a$export$42a99a7a4bc0e76a extends Error {
}
class $5f7a50a9018faa6a$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $5f7a50a9018faa6a$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $5f7a50a9018faa6a$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $5f7a50a9018faa6a$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $5f7a50a9018faa6a$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $5f7a50a9018faa6a$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $5f7a50a9018faa6a$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $5f7a50a9018faa6a$var$unwrapTrackedPromise(value) {
    if (!$5f7a50a9018faa6a$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $5f7a50a9018faa6a$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $5f7a50a9018faa6a$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $5f7a50a9018faa6a$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $5f7a50a9018faa6a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $5f7a50a9018faa6a$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $5f7a50a9018faa6a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $5f7a50a9018faa6a$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $5f7a50a9018faa6a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $5f7a50a9018faa6a$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $5f7a50a9018faa6a$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $5f7a50a9018faa6a$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $5f7a50a9018faa6a$var$validMutationMethods = new Set($5f7a50a9018faa6a$var$validMutationMethodsArr);
const $5f7a50a9018faa6a$var$validRequestMethodsArr = [
    "get",
    ...$5f7a50a9018faa6a$var$validMutationMethodsArr
];
const $5f7a50a9018faa6a$var$validRequestMethods = new Set($5f7a50a9018faa6a$var$validRequestMethodsArr);
const $5f7a50a9018faa6a$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $5f7a50a9018faa6a$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $5f7a50a9018faa6a$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $5f7a50a9018faa6a$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $5f7a50a9018faa6a$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $5f7a50a9018faa6a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $5f7a50a9018faa6a$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $5f7a50a9018faa6a$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $5f7a50a9018faa6a$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $5f7a50a9018faa6a$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $5f7a50a9018faa6a$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $5f7a50a9018faa6a$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $5f7a50a9018faa6a$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $5f7a50a9018faa6a$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $5f7a50a9018faa6a$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $5f7a50a9018faa6a$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $5f7a50a9018faa6a$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$5f7a50a9018faa6a$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$5f7a50a9018faa6a$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $5f7a50a9018faa6a$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $5f7a50a9018faa6a$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $5f7a50a9018faa6a$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $5f7a50a9018faa6a$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$5f7a50a9018faa6a$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($5f7a50a9018faa6a$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $5f7a50a9018faa6a$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $5f7a50a9018faa6a$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $5f7a50a9018faa6a$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $5f7a50a9018faa6a$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $5f7a50a9018faa6a$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($5f7a50a9018faa6a$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $5f7a50a9018faa6a$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $5f7a50a9018faa6a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $5f7a50a9018faa6a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $5f7a50a9018faa6a$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $5f7a50a9018faa6a$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $5f7a50a9018faa6a$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $5f7a50a9018faa6a$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $5f7a50a9018faa6a$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $5f7a50a9018faa6a$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $5f7a50a9018faa6a$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $5f7a50a9018faa6a$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $5f7a50a9018faa6a$var$findNearestBoundary(matches).route.id,
            {
                type: $5f7a50a9018faa6a$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $5f7a50a9018faa6a$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($5f7a50a9018faa6a$var$isErrorResult(result) && $5f7a50a9018faa6a$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $5f7a50a9018faa6a$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $5f7a50a9018faa6a$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $5f7a50a9018faa6a$var$_extends({
            matches: updatedMatches || matches
        }, $5f7a50a9018faa6a$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $5f7a50a9018faa6a$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $5f7a50a9018faa6a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $5f7a50a9018faa6a$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $5f7a50a9018faa6a$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $5f7a50a9018faa6a$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $5f7a50a9018faa6a$var$ResultType.error,
            error: $5f7a50a9018faa6a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($5f7a50a9018faa6a$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $5f7a50a9018faa6a$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($5f7a50a9018faa6a$var$isDeferredResult(result)) throw $5f7a50a9018faa6a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($5f7a50a9018faa6a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $5f7a50a9018faa6a$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $5f7a50a9018faa6a$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $5f7a50a9018faa6a$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($5f7a50a9018faa6a$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $5f7a50a9018faa6a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $5f7a50a9018faa6a$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $5f7a50a9018faa6a$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $5f7a50a9018faa6a$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $5f7a50a9018faa6a$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $5f7a50a9018faa6a$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $5f7a50a9018faa6a$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $5f7a50a9018faa6a$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $5f7a50a9018faa6a$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $5f7a50a9018faa6a$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$5f7a50a9018faa6a$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $5f7a50a9018faa6a$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $5f7a50a9018faa6a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $5f7a50a9018faa6a$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $5f7a50a9018faa6a$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $5f7a50a9018faa6a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $5f7a50a9018faa6a$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $5f7a50a9018faa6a$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $5f7a50a9018faa6a$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $5f7a50a9018faa6a$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $5f7a50a9018faa6a$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $5f7a50a9018faa6a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $5f7a50a9018faa6a$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($5f7a50a9018faa6a$var$isRedirectResult(actionResult) || $5f7a50a9018faa6a$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $5f7a50a9018faa6a$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($5f7a50a9018faa6a$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $5f7a50a9018faa6a$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $5f7a50a9018faa6a$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($5f7a50a9018faa6a$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($5f7a50a9018faa6a$var$isDeferredResult(actionResult)) throw $5f7a50a9018faa6a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $5f7a50a9018faa6a$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $5f7a50a9018faa6a$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $5f7a50a9018faa6a$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $5f7a50a9018faa6a$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $5f7a50a9018faa6a$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $5f7a50a9018faa6a$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $5f7a50a9018faa6a$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $5f7a50a9018faa6a$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $5f7a50a9018faa6a$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $5f7a50a9018faa6a$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $5f7a50a9018faa6a$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $5f7a50a9018faa6a$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $5f7a50a9018faa6a$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $5f7a50a9018faa6a$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $5f7a50a9018faa6a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $5f7a50a9018faa6a$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($5f7a50a9018faa6a$var$isDeferredResult(result)) result = await $5f7a50a9018faa6a$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $5f7a50a9018faa6a$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($5f7a50a9018faa6a$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $5f7a50a9018faa6a$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($5f7a50a9018faa6a$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $5f7a50a9018faa6a$export$3e9cee6b33872309(!$5f7a50a9018faa6a$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $5f7a50a9018faa6a$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $5f7a50a9018faa6a$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $5f7a50a9018faa6a$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $5f7a50a9018faa6a$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($5f7a50a9018faa6a$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $5f7a50a9018faa6a$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Replace : $5f7a50a9018faa6a$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $5f7a50a9018faa6a$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($5f7a50a9018faa6a$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $5f7a50a9018faa6a$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $5f7a50a9018faa6a$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $5f7a50a9018faa6a$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $5f7a50a9018faa6a$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $5f7a50a9018faa6a$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($5f7a50a9018faa6a$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $5f7a50a9018faa6a$var$ResultType.redirect,
                response: $5f7a50a9018faa6a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $5f7a50a9018faa6a$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $5f7a50a9018faa6a$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $5f7a50a9018faa6a$var$ResultType.error,
                    error: $5f7a50a9018faa6a$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $5f7a50a9018faa6a$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $5f7a50a9018faa6a$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $5f7a50a9018faa6a$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $5f7a50a9018faa6a$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $5f7a50a9018faa6a$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $5f7a50a9018faa6a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $5f7a50a9018faa6a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $5f7a50a9018faa6a$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $5f7a50a9018faa6a$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $5f7a50a9018faa6a$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $5f7a50a9018faa6a$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $5f7a50a9018faa6a$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $5f7a50a9018faa6a$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $5f7a50a9018faa6a$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$5f7a50a9018faa6a$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $5f7a50a9018faa6a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $5f7a50a9018faa6a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $5f7a50a9018faa6a$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $5f7a50a9018faa6a$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $5f7a50a9018faa6a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $5f7a50a9018faa6a$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $5f7a50a9018faa6a$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $5f7a50a9018faa6a$export$4d0306f8f6a4585b = Symbol("deferred");
function $5f7a50a9018faa6a$export$3336b097a6fbc59a(routes, opts) {
    $5f7a50a9018faa6a$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $5f7a50a9018faa6a$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $5f7a50a9018faa6a$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $5f7a50a9018faa6a$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $5f7a50a9018faa6a$var$createLocation("", $5f7a50a9018faa6a$export$fe53371bee54353d(url), null, "default");
        let matches = $5f7a50a9018faa6a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$5f7a50a9018faa6a$var$isValidMethod(method) && method !== "HEAD") {
            let error = $5f7a50a9018faa6a$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $5f7a50a9018faa6a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $5f7a50a9018faa6a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $5f7a50a9018faa6a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($5f7a50a9018faa6a$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $5f7a50a9018faa6a$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $5f7a50a9018faa6a$var$createLocation("", $5f7a50a9018faa6a$export$fe53371bee54353d(url), null, "default");
        let matches = $5f7a50a9018faa6a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$5f7a50a9018faa6a$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $5f7a50a9018faa6a$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $5f7a50a9018faa6a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $5f7a50a9018faa6a$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $5f7a50a9018faa6a$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $5f7a50a9018faa6a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($5f7a50a9018faa6a$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$5f7a50a9018faa6a$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $5f7a50a9018faa6a$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($5f7a50a9018faa6a$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $5f7a50a9018faa6a$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $5f7a50a9018faa6a$var$isResponse(result) ? result : $5f7a50a9018faa6a$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($5f7a50a9018faa6a$var$isDataStrategyResult(e) && $5f7a50a9018faa6a$var$isResponse(e.result)) {
                if (e.type === $5f7a50a9018faa6a$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($5f7a50a9018faa6a$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $5f7a50a9018faa6a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $5f7a50a9018faa6a$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $5f7a50a9018faa6a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($5f7a50a9018faa6a$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($5f7a50a9018faa6a$var$isDeferredResult(result)) {
            let error = $5f7a50a9018faa6a$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $5f7a50a9018faa6a$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($5f7a50a9018faa6a$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($5f7a50a9018faa6a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $5f7a50a9018faa6a$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $5f7a50a9018faa6a$var$_extends({}, context, {
                statusCode: $5f7a50a9018faa6a$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $5f7a50a9018faa6a$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $5f7a50a9018faa6a$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $5f7a50a9018faa6a$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $5f7a50a9018faa6a$var$isErrorResult(pendingActionResult[1]) ? $5f7a50a9018faa6a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $5f7a50a9018faa6a$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $5f7a50a9018faa6a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $5f7a50a9018faa6a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $5f7a50a9018faa6a$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $5f7a50a9018faa6a$var$callDataStrategyImpl(dataStrategy || $5f7a50a9018faa6a$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($5f7a50a9018faa6a$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $5f7a50a9018faa6a$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($5f7a50a9018faa6a$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $5f7a50a9018faa6a$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $5f7a50a9018faa6a$export$fec11da027c70692(routes, context, error) {
    let newContext = $5f7a50a9018faa6a$var$_extends({}, context, {
        statusCode: $5f7a50a9018faa6a$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $5f7a50a9018faa6a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $5f7a50a9018faa6a$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $5f7a50a9018faa6a$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $5f7a50a9018faa6a$export$cae722b0cc860f13(to ? to : ".", $5f7a50a9018faa6a$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $5f7a50a9018faa6a$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $5f7a50a9018faa6a$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $5f7a50a9018faa6a$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $5f7a50a9018faa6a$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $5f7a50a9018faa6a$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$5f7a50a9018faa6a$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$5f7a50a9018faa6a$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $5f7a50a9018faa6a$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $5f7a50a9018faa6a$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $5f7a50a9018faa6a$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$5f7a50a9018faa6a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$5f7a50a9018faa6a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $5f7a50a9018faa6a$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $5f7a50a9018faa6a$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $5f7a50a9018faa6a$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $5f7a50a9018faa6a$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $5f7a50a9018faa6a$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($5f7a50a9018faa6a$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $5f7a50a9018faa6a$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $5f7a50a9018faa6a$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $5f7a50a9018faa6a$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $5f7a50a9018faa6a$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $5f7a50a9018faa6a$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $5f7a50a9018faa6a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $5f7a50a9018faa6a$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $5f7a50a9018faa6a$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $5f7a50a9018faa6a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $5f7a50a9018faa6a$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($5f7a50a9018faa6a$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $5f7a50a9018faa6a$var$shouldRevalidateLoader(match, $5f7a50a9018faa6a$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $5f7a50a9018faa6a$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $5f7a50a9018faa6a$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $5f7a50a9018faa6a$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $5f7a50a9018faa6a$var$shouldRevalidateLoader(fetcherMatch, $5f7a50a9018faa6a$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $5f7a50a9018faa6a$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $5f7a50a9018faa6a$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $5f7a50a9018faa6a$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $5f7a50a9018faa6a$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $5f7a50a9018faa6a$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $5f7a50a9018faa6a$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$5f7a50a9018faa6a$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $5f7a50a9018faa6a$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $5f7a50a9018faa6a$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$5f7a50a9018faa6a$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $5f7a50a9018faa6a$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $5f7a50a9018faa6a$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $5f7a50a9018faa6a$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$5f7a50a9018faa6a$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $5f7a50a9018faa6a$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $5f7a50a9018faa6a$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $5f7a50a9018faa6a$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $5f7a50a9018faa6a$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $5f7a50a9018faa6a$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $5f7a50a9018faa6a$var$ResultType.data,
                result: undefined
            });
        };
        return $5f7a50a9018faa6a$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $5f7a50a9018faa6a$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $5f7a50a9018faa6a$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $5f7a50a9018faa6a$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $5f7a50a9018faa6a$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $5f7a50a9018faa6a$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $5f7a50a9018faa6a$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $5f7a50a9018faa6a$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($5f7a50a9018faa6a$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $5f7a50a9018faa6a$var$ResultType.error,
                error: e
            };
        }
        if (type === $5f7a50a9018faa6a$var$ResultType.error) return {
            type: $5f7a50a9018faa6a$var$ResultType.error,
            error: new $5f7a50a9018faa6a$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $5f7a50a9018faa6a$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $5f7a50a9018faa6a$var$ResultType.error) {
        if ($5f7a50a9018faa6a$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $5f7a50a9018faa6a$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $5f7a50a9018faa6a$var$ResultType.error,
                error: new $5f7a50a9018faa6a$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $5f7a50a9018faa6a$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $5f7a50a9018faa6a$var$ResultType.error,
            error: result,
            statusCode: $5f7a50a9018faa6a$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($5f7a50a9018faa6a$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $5f7a50a9018faa6a$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($5f7a50a9018faa6a$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $5f7a50a9018faa6a$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $5f7a50a9018faa6a$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $5f7a50a9018faa6a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $5f7a50a9018faa6a$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$5f7a50a9018faa6a$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $5f7a50a9018faa6a$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $5f7a50a9018faa6a$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($5f7a50a9018faa6a$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $5f7a50a9018faa6a$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $5f7a50a9018faa6a$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($5f7a50a9018faa6a$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $5f7a50a9018faa6a$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $5f7a50a9018faa6a$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $5f7a50a9018faa6a$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $5f7a50a9018faa6a$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $5f7a50a9018faa6a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $5f7a50a9018faa6a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $5f7a50a9018faa6a$export$3e9cee6b33872309(!$5f7a50a9018faa6a$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($5f7a50a9018faa6a$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $5f7a50a9018faa6a$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $5f7a50a9018faa6a$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($5f7a50a9018faa6a$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $5f7a50a9018faa6a$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $5f7a50a9018faa6a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $5f7a50a9018faa6a$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($5f7a50a9018faa6a$var$isErrorResult(result)) {
            let boundaryMatch = $5f7a50a9018faa6a$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $5f7a50a9018faa6a$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($5f7a50a9018faa6a$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $5f7a50a9018faa6a$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($5f7a50a9018faa6a$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $5f7a50a9018faa6a$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $5f7a50a9018faa6a$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $5f7a50a9018faa6a$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $5f7a50a9018faa6a$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $5f7a50a9018faa6a$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $5f7a50a9018faa6a$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $5f7a50a9018faa6a$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $5f7a50a9018faa6a$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $5f7a50a9018faa6a$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $5f7a50a9018faa6a$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $5f7a50a9018faa6a$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($5f7a50a9018faa6a$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $5f7a50a9018faa6a$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $5f7a50a9018faa6a$export$8ccf933b0513f8d0(path) : path;
    return $5f7a50a9018faa6a$export$fe53371bee54353d($5f7a50a9018faa6a$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $5f7a50a9018faa6a$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $5f7a50a9018faa6a$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $5f7a50a9018faa6a$var$ResultType.data || result.type === $5f7a50a9018faa6a$var$ResultType.error);
}
function $5f7a50a9018faa6a$var$isRedirectDataStrategyResultResult(result) {
    return $5f7a50a9018faa6a$var$isResponse(result.result) && $5f7a50a9018faa6a$var$redirectStatusCodes.has(result.result.status);
}
function $5f7a50a9018faa6a$var$isDeferredResult(result) {
    return result.type === $5f7a50a9018faa6a$var$ResultType.deferred;
}
function $5f7a50a9018faa6a$var$isErrorResult(result) {
    return result.type === $5f7a50a9018faa6a$var$ResultType.error;
}
function $5f7a50a9018faa6a$var$isRedirectResult(result) {
    return (result && result.type) === $5f7a50a9018faa6a$var$ResultType.redirect;
}
function $5f7a50a9018faa6a$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $5f7a50a9018faa6a$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $5f7a50a9018faa6a$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $5f7a50a9018faa6a$var$isRedirectResponse(result) {
    if (!$5f7a50a9018faa6a$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $5f7a50a9018faa6a$var$isValidMethod(method) {
    return $5f7a50a9018faa6a$var$validRequestMethods.has(method.toLowerCase());
}
function $5f7a50a9018faa6a$var$isMutationMethod(method) {
    return $5f7a50a9018faa6a$var$validMutationMethods.has(method.toLowerCase());
}
async function $5f7a50a9018faa6a$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$5f7a50a9018faa6a$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($5f7a50a9018faa6a$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $5f7a50a9018faa6a$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $5f7a50a9018faa6a$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($5f7a50a9018faa6a$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $5f7a50a9018faa6a$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $5f7a50a9018faa6a$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $5f7a50a9018faa6a$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $5f7a50a9018faa6a$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $5f7a50a9018faa6a$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $5f7a50a9018faa6a$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $5f7a50a9018faa6a$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $5f7a50a9018faa6a$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $5f7a50a9018faa6a$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $5f7a50a9018faa6a$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $5f7a50a9018faa6a$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $5f7a50a9018faa6a$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $5f7a50a9018faa6a$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $5f7a50a9018faa6a$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $5f7a50a9018faa6a$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $5f7a50a9018faa6a$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $5f7a50a9018faa6a$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $5f7a50a9018faa6a$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($5f7a50a9018faa6a$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $5f7a50a9018faa6a$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($5f7a50a9018faa6a$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $5f7a50a9018faa6a$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}
module.exports["createMemoryHistory"] = $5f7a50a9018faa6a$export$2b76ad033c6e6d08;
module.exports["createPath"] = $5f7a50a9018faa6a$export$fe53371bee54353d;
module.exports["parsePath"] = $5f7a50a9018faa6a$export$8ccf933b0513f8d0;
module.exports["UNSAFE_invariant"] = $5f7a50a9018faa6a$export$3e9cee6b33872309;
module.exports["matchRoutes"] = $5f7a50a9018faa6a$export$2708184779ceb39d;
module.exports["stripBasename"] = $5f7a50a9018faa6a$export$b69e3301ce081aa3;
module.exports["UNSAFE_decodePath"] = $5f7a50a9018faa6a$export$30d21fd6d7295f52;
module.exports["UNSAFE_convertRouteMatchToUiMatch"] = $5f7a50a9018faa6a$export$b3fac024fad9e8ff;
module.exports["joinPaths"] = $5f7a50a9018faa6a$export$86d9a7913e44197e;
module.exports["matchPath"] = $5f7a50a9018faa6a$export$81336c211d5ff295;
module.exports["UNSAFE_getResolveToMatches"] = $5f7a50a9018faa6a$export$a5784978eca585fa;
module.exports["resolveTo"] = $5f7a50a9018faa6a$export$cae722b0cc860f13;
module.exports["AbortedDeferredError"] = $5f7a50a9018faa6a$export$42a99a7a4bc0e76a;
module.exports["isRouteErrorResponse"] = $5f7a50a9018faa6a$export$972111febbeef05b;
module.exports["IDLE_BLOCKER"] = $5f7a50a9018faa6a$export$386d57f03f0b2883;
module.exports["createRouter"] = $5f7a50a9018faa6a$export$baddd0131ee8c05b;

});

parcelRegister("j2dMW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $7pThu = parcelRequire("7pThu");


var $kquTo = parcelRequire("kquTo");


var $fuqSI = parcelRequire("fuqSI");

const $680949b428819f6f$export$e955abb82869dc84 = (experienceTracker)=>{
    const unsubscribeRef = (0, $42omo.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (!unsubscribeRef.current && experienceTracker) unsubscribeRef.current = experienceTracker.subscribe((event)=>{
        if (event.name.startsWith((0, $7pThu.EXPERIENCE_NAME_PREFIX))) // Fire the analytic event to dedicated ANALYTICS_CHANNEL channel for EP analytics.
        createAnalyticsEvent((0, $kquTo.createExperienceTrackerAnalyticsEventPayload)(event)).fire((0, $fuqSI.ANALYTICS_CHANNEL));
    });
    (0, $42omo.useEffect)(()=>unsubscribeRef.current, []);
};
module.exports["useAnalytics"] = $680949b428819f6f$export$e955abb82869dc84;

});

parcelRegister("fuqSI", function(module, exports) {

var $j2dMW = parcelRequire("j2dMW");

const $de3afe872335897b$export$85183a312807388d = 'embeddedConfluence';
module.exports["ANALYTICS_CHANNEL"] = $de3afe872335897b$export$85183a312807388d;

});

parcelRegister("jNfGN", function(module, exports) {
const $b46edb367a256dec$export$e63a462ee45b57cf = {
    name: 'EDIT_PAGE_EMBED',
    pattern: '/wiki/spaces/:spaceKey/pages/edit-embed/:contentId/:contentSlug?'
};
const $b46edb367a256dec$export$7b1285e36c635f1f = {
    name: 'EDIT_PAGE_V2',
    pattern: '/wiki/spaces/:spaceKey/pages/edit-v2/:contentId/:contentSlug?'
};
const $b46edb367a256dec$export$65b723bb995d4fb6 = {
    name: 'SPACE_OVERVIEW',
    pattern: '/wiki/spaces/:spaceKey/overview'
};
const $b46edb367a256dec$export$9257b5b55c8e2555 = {
    name: 'VIEW_PAGE',
    pattern: '/wiki/spaces/:spaceKey/pages/:contentId/:contentSlug?'
};
const $b46edb367a256dec$export$91f49e7b30a9d34 = {
    name: 'VIEW_BLOG',
    pattern: '/wiki/spaces/:spaceKey/blog/:contentId/:contentSlug?'
};
const $b46edb367a256dec$export$bd2c9bb170b3681d = {
    name: 'VIEW_BLOG_DATE_LEGACY',
    pattern: '/wiki/spaces/:spaceKey/blog/:year/:month/:day/:contentId/:contentSlug?'
};
const $b46edb367a256dec$export$fbefbcc1445e8d74 = {
    name: 'WHITEBOARD',
    pattern: '/wiki/spaces/:spaceKey/whiteboard/:contentId/:contentSlug?'
};
const $b46edb367a256dec$export$d4971375353d0454 = {
    EDIT_PAGE_EMBED: $b46edb367a256dec$export$e63a462ee45b57cf,
    EDIT_PAGE_V2: $b46edb367a256dec$export$7b1285e36c635f1f,
    SPACE_OVERVIEW: $b46edb367a256dec$export$65b723bb995d4fb6,
    VIEW_PAGE: $b46edb367a256dec$export$9257b5b55c8e2555,
    VIEW_BLOG: $b46edb367a256dec$export$91f49e7b30a9d34,
    VIEW_BLOG_DATE_LEGACY: $b46edb367a256dec$export$bd2c9bb170b3681d,
    WHITEBOARD: $b46edb367a256dec$export$fbefbcc1445e8d74
};
const $b46edb367a256dec$export$5c59aa0922e65f1a = {
    JSM_PORTAL: 'JSM-Portal',
    JSM: 'JSM',
    JSW: 'JSW',
    JWM: 'JWM'
};
module.exports["EDIT_PAGE_EMBED"] = $b46edb367a256dec$export$e63a462ee45b57cf;
module.exports["EDIT_PAGE_V2"] = $b46edb367a256dec$export$7b1285e36c635f1f;
module.exports["VIEW_PAGE"] = $b46edb367a256dec$export$9257b5b55c8e2555;
module.exports["VIEW_BLOG"] = $b46edb367a256dec$export$91f49e7b30a9d34;
module.exports["VIEW_BLOG_DATE_LEGACY"] = $b46edb367a256dec$export$bd2c9bb170b3681d;
module.exports["WHITEBOARD"] = $b46edb367a256dec$export$fbefbcc1445e8d74;
module.exports["namedRoutes"] = $b46edb367a256dec$export$d4971375353d0454;
module.exports["EMBEDDED_PARENT_PRODUCTS"] = $b46edb367a256dec$export$5c59aa0922e65f1a;

});

parcelRegister("4eu1q", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $5c5762ed3f356c35$export$6d8905296959d5f5 = ()=>{
    const [isMediaOpen, setIsMediaOpen] = (0, $42omo.useState)(false);
    const mediaMessageListener = (0, $42omo.useCallback)((messageEvent)=>{
        const { source: source, event: event } = messageEvent.data ?? {};
        if (!source || !event) return;
        if (source === 'media') switch(event){
            case 'mediaViewerOpened':
                setIsMediaOpen(true);
                break;
            case 'mediaViewerClosed':
                setIsMediaOpen(false);
                break;
            default:
                return;
        }
    }, [
        setIsMediaOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        window.addEventListener('message', mediaMessageListener);
        return ()=>window.removeEventListener('message', mediaMessageListener);
    }, [
        mediaMessageListener
    ]);
    return {
        isMediaOpen: isMediaOpen
    };
};
module.exports["useMediaViewerListener"] = $5c5762ed3f356c35$export$6d8905296959d5f5;

});


$parcel$global.rlb("8bZKp")
//# sourceMappingURL=component-lazy.f2571322.js.map
